/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 95);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

function formatNumber(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '');
}

function formatCurrency (amount, n, x, currencySymbol) {
    amount = Number(amount);
    var re = '(\\d)(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
    if (typeof currencySymbol === 'undefined') {
        currencySymbol = true;
    }
    return (currencySymbol ? "$" : '') + amount.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$1,');
}

const Constants = {
    DOB_CHANGE_MESSAGE: `You have updated your date of birth and that may affect your selected life insurance quote - we will need to provide you with a new quote. 
                         <br/><br/>Would you like to continue and get your new quote?`,

    STATE_CHANGE_MESSAGE: `You have updated your state of residence and that may affect your selected life insurance quote - we will need to provide you with a new quote. 
                         <br/><br/>Would you like to continue and get your new quote?`,

    DOB_STATE_CHANGE_MESSAGE: `You have updated your date of birth and your state of residence and that may affect your selected life insurance quote - we will need to provide you with a new quote. 
                         <br/><br/>Would you like to continue and get your new quote?`,

    INVALID_EMAIL_MESSAGE: 'Sorry we are not able to confirm that this is an active email address. Please check the email address you entered and try again.',
    INVALID_PHONE_MESSAGE: 'Sorry we are not able to confirm that this is an active or valid phone number. Please check the phone number you entered and try again.',
    COMPLETE_CANCEL_FORM_MESSAGE: 'Please complete form or cancel.',
    INVALID_ALTERNATEPHONE_MESSAGE: 'Sorry It cannot be the same as the primary phone number. Please enter alternate phone number.',
    COVERAGE_VALIDATION_MESSAGE: "'Please tell us how much coverage you need.'",
    COVERAGE_TITLE: 'How Much Coverage Do You Need?',
    TERMLENGTH_TITLE: 'How Long Do You Want to Be Covered?',
    REQUOTE_CONFIRMATION_MESSAGE: '<br/>Would you like to continue and get your new quote?',
    //'constantName': 'constant value',
    REQUOTE_CHANGED_FIELDS_KEY: 'REQUOTE_CHANGED_FIELDS',
    INTRO_SHOWN: 'INTRO_SHOWN',
    PAGE_ID: {
        LANDING: 'home',
        QUOTE: 'quotes',
        ADVISOR_QUICK_QUOTE: 'quickquote',
        ADVISOR_NEW_APPLICATION: 'home',
        PERSONAL_INFO_1: 'personalinfo1',
        SIGN: 'sign',
        APP_REVIEW: 'appreview'
    },
    REGEX: {
        SSN: '^[0-9]{3}-[0-9]{2}-[0-9]{4}$',
        PASTYEAR_UNTIL_CURRENTYEAR: function () {
            var current_year = new Date().getFullYear().toString().split("");
            const secondLastDigit = +current_year[2];
            const lastDigit = +current_year[3];
            const firstTwoDigit = current_year[0] + '' + current_year[1];

            let temp = '';
            for (var number = 1; number < secondLastDigit; number++) {
                temp += firstTwoDigit + '[0-' + number + '][0-9]|';
            }
            const subPattern = temp + '' + firstTwoDigit + '[' + secondLastDigit + '][0-' + lastDigit + '])';
            var reg = new RegExp('^(19[0-9][0-9]|200[0-9]|' + subPattern + '$');
            return reg.source;
        },
        CC_VISA: '^(?:4[0-9]{15})$',
        CC_AMEX: '^(?:3[47][0-9]{13})$',
        CC_MASTER_CARD: '^(?:5[1-5][0-9]{2}|222[1-9]{1}|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$'
    },
    PROCESSSING_MESSAGE_KEY:'processing_message',
    VISA_KEY: 'VISA',
    MASTERCARD_KEY: 'MasterCard',
    AMEX_KEY: 'American Express',
    CCTYPE_KEY: 'ccType',
    PAGE_ID_KEY: 'PAGE_ID',
    APPREVIEW_PAGE_ID_KEY: 'appreview',
    COVERAGE_AMOUNT_KEY: 'Insured_CoverageAmount',
    TERM_LENGTH_KEY: 'Insured_TermLength',
    COMPANYID_KEY: 'companyId',
    PRODUCT_ID_KEY: 'productId',
    PRODUCT_TYPE_KEY: 'ProductType',
    PAYMENT_FREQUENCY_KEY: 'frequency',
    PAYMENT_AMOUNT_KEY: 'amount',
    DIYPATH_KEY: 'Insured_DIYPath',
    SALUTATION_KEY: 'Insured_Salutation',
    GENDER_KEY: 'Insured_Gender',
    DOB_KEY: 'Insured_BirthDate',
    JOBDESCRIPTON_KEY: 'Employment_JobDuties',
    PRIMARY_PHONE_KEY: 'Insured_PrimaryPhone',
    SECONDARY_PHONE_KEY: 'Insured_SecondaryPhone',
    CHECK_FOR_NEEDSANALYSIS: 'CheckForNeedsAnalysis',
    STATE_KEY: 'Insured_State',
    PLAN_TYPE_KEY: 'PlanType',
    SPOUSE_BIRTHDATE_KEY: 'Spouse_BirthDate',
    SPOUSE_GENDER_KEY: 'Spouse_Gender',
    BANNER_COMPANYID: 19,
    WILLIAMPENN_COMPANYID: 49,
    TRANSAMERICA_COMPANYID: 15,
    TRANSAMERICA_NY_COMPANYID: 14,
    QOL_PRODUCTTYPEID: 19,
    TRANSAMERICA_PRODUCTNAME: 'Trendsetter\xAE Super',
    PAYMENT_COMPONENT_KEY: "Payment",
    PAYMENT_METHOD_KEY: "paymentMethod",
    SKIP_PAYMENT_DETAIL_KEY: "Skip_Payment_Detail",
    ADD_SPOUSE_COVERAGE_KEY: 'Insured_Add_Spouse_Coverage',
    ADD_CHILDREN_COVERAGE_KEY: 'Insured_Add_Children_Coverage',
    INCLUDE_ROP_RIDER_KEY: 'Insured_Include_RopRider',
    ROP_RIDER_APPLICABLE_KEY: 'RopRider_Applicable',
    PREMIUM_DEDUCTION_DAY: 'premiumDeductionDay',
    IS_APP_SAVED_KEY: 'IsAppSaved',
    SESSION_KEYS: {
        REQUIRE_CONFIRMATION: 'RequireConfirmation',
        LAST_SAVED_TIME: 'LAST_SAVED_TIME',
        PAYMENT_AUTHORIZED: 'paymentAuthorized',
        APP_SUBMIT_SUCCESS : 'appSubmitSuccess'
    },
    ADDRESS_FIELDS: {
        ADDRESS1_KEY: '_Address1',
        ADDRESS2_KEY: '_Address2',
        CITY_KEY: '_City',
        STATE_KEY: '_State',
        ZIP_KEY: '_Zip',
        IS_VALIDATED_KEY: '_IsValidated'
    },
    PAYMENT_FREQUENCY: {
        Monthly: 'Monthly',
        Quarterly: 'Quarterly',
        SemiAnnual: 'Semi-Annual',
        Annual: 'Annual'
    },
    ADD_PLAN_TYPE: {
        Individual: 'Individual',
        Family: 'Family',
        Individual_Children: 'Individual + Children',
        Individual_Spouse: 'Individual + Spouse'
    },
    QUOTE_PAYMENT_FREQUENCY_KEY: 'paymentFrequency',
    EMPLOYMENT_OCCUPATION_KEY: 'Employment_Occupation',
    INSURED_EMPLOYED_KEY: 'Insured_Employed',
    INSURED_DRIVERSLICENSE_NUMBER_KEY: 'Insured_DriversLicense_Num',
    ACTION_EVENTS: {
        VALIDATION_ERROR: 'VALIDATION_ERROR',
        SERVER_ERROR: 'SERVER_ERROR',
        ACTION_IN_PROGRESS: 'ACTION_IN_PROGRESS',
        ACTION_COMPLETED: 'ACTION_COMPLETED',
    },
    NAVIGATION_EVENTS: {
        NAVIGATE_NEXT: 'NAVIGATE_NEXT',
        NAVIGATE_PREV: 'NAVIGATE_PREV',
        NAVIGATE_NEXT_FEEDBACK: 'NAVIGATE_NEXT_FEEDBACK',
        NAVIGATE_PREV_FEEDBACK: 'NAVIGATE_PREV_FEEDBACK',
        FORM_SUBMITTED: 'FORM_SUBMITTED',
        VALIDATE_ON_NEXT: 'VALIDATE_ON_NEXT',
        VALIDATE_ON_NEXT_COMPLETED: 'VALIDATE_ON_NEXT_COMPLETED',
        REGISTER_COMPONENT_FOR_VALIDATION_ON_NEXT: 'REGISTER_COMPONENT_FOR_VALIDATION_ON_NEXT',
        COMPONENT_NAVIGATE_NEXT: 'COMPONENT_NAVIGATE_NEXT',
        FIELD_ENTER_KEY:'FIELD_ENTER_KEY'
    },
    NAVIGATION_EVENT_DATA: {
        NAVIGATED: 'NAVIGATED',
        NOT_NAVIGATED: 'NOT_NAVIGATED',
        SUPPRESS_VALIDATION_ON_NEXT: 'suppressValidationOnNext'
    },
    NAVIGATE_CONFIRM_EVENT_DATA: {
        CONFIRMED: 'CONFIRMED',
        NOT_CONFIRMED: 'NOT_CONFIRMED'
    },

    AUTH_EVENTS: {
        LOGIN: 'LOGIN',
        LOGIN_COMPLETED: 'LOGIN_COMPLETED',
        REGISTER: 'REGISTER',
        LOAD_SAVED_APPLICATION: 'LOAD_SAVED_APPLICATION',
        CONTINUE_CURRENT_APPLICATION: 'CONTINUE_CURRENT_APPLICATION',
        START_NEW_APPLICATION: 'START_NEW_APPLICATION',
        SAVE_FOR_LATER: 'SAVE_FOR_LATER',
        //DELETE_SAVED_APPLICATION: 'DELETE_SAVED_APPLICATION',
        REQUOTE_SAVED_APPLICATION: 'REQUOTE_SAVED_APPLICATION',
    },
    AUTH_EVENTS_DATA: {
        LOGIN: {
            CONTINUE_WITH_SAVED_APP: 'continueWithSavedApp',
            SAVE_APP: 'saveApp'
        }
    },
    APPLICATION_EVENTS: {
        PAGE_LOADED: 'PAGE_LOADED',
        PAGE_LOADING: 'PAGE_LOADING',
        SIGNING_COMPLETED: 'SIGNING_COMPLETED',
        SIGNING_NOT_COMPLETED: 'SIGNING_NOT_COMPLETED',
        FIELD_VALUE_CHANGE: 'FIELD_VALUE_CHANGE',
        SAVE_IN_PROGRESS: 'SAVE_IN_PROGRESS',
        SAVE_COMPLETED: 'SAVE_STARTED',
        ANSWER_CHANGE: 'ANSWER_CHANGE',
    },
    EVENTS_DATA: {
        DELETE_SAVED_APPLICATION: {
            START_NEW: 'START_NEW'
        }
    },
    FIELD_EVENTS: {
        FIELD_LOADED: 'FIELD_LOADED',
    },
    USER_APPLICATION_STATUS:
    {
        EXPIRED: 'expired',
        NOT_FOUND: 'not-found',
        EXISTS: 'exists',
        REQUOTE_REQUIRED: 'requote-required'
    },

    RENDER_MODE: {
        STACKED: 'stacked',
        REPLACE: 'replace',
        DEFAULT: 'all'
    },

    YES_NO_OPTION: {
        YES: 'Yes',
        NO: 'No',
    },

    BENEFICIARY: {
        PERSON: 'Person',
        TRUST: 'Trust',
    },
    BENEFICIARY_TYPE: {
        PRIMARY: 'Primary',
        CONTINGENT: 'Contingent',
    },

    PAYMENT_TYPE: {
        BANK_ACCOUNT: 'BANK_ACCOUNT',
        CREDIT_CARD: 'CREDIT_CARD',
    },
    CALL_TYPE: {
        CALL_ME_NOW: "1",
        SCHEDULE_CALL: "2"
    },

    PAYMENT_METHODS: {
        EF: 'EF',//Elec Fund Trans
        CC: 'CC',//Credit Card
        PW: 'PW',//PAW - Pre Authorized Withdrawal from bank
        CD: 'CD',//COD - Cash on delivery
        CK: 'CK',//Check
        PD: 'PD',//Payroll deduction,
        DB: 'DB',//Direct billing
        MO: 'MO',//Direct billing
    },

    ONE_TO_NINETYNINE_AGE_LIST: function () {
        var list = [];

        for (var age = 1; age < 100; age++) {
            list.push({ value: age, text: age });
        }
        return list;
    },

    GIWL_BENEFICIARY_LIST: function () {
        return [
            { value: "Husband", text: "Husband" },
            { value: "Wife", text: "Wife" },
            { value: "Father", text: "Father" },
            { value: "Mother", text: "Mother" },
            { value: "Son", text: "Son" },
            { value: "Daughter", text: "Daughter" },
            { value: "Brother", text: "Brother" },
            { value: "Sister", text: "Sister" },
            { value: "Other", text: "Other" }
        ];
    },

    ADD_BENEFICIARY_LIST: function () {
        return [
            { value: "Attorney", text: "Attorney" },
            { value: "Auditor", text: "Auditor" },
            { value: "Aunt", text: "Aunt" },
            { value: "Bookkeeper", text: "Bookkeeper" },
            { value: "Brother", text: "Brother" },
            { value: "Brother-in-law", text: "Brother-in-law" },
            { value: "Business", text: "Business" },
            { value: "Business Associate", text: "Business Associate" },
            { value: "Chairman of the Board", text: "Chairman of the Board" },
            { value: "Charity", text: "Charity" },
            { value: "Chief Executive Officer", text: "Chief Executive Officer" },
            { value: "Chief Financial Officer", text: "Chief Financial Officer" },
            { value: "Chief Information Officer", text: "Chief Information Officer" },
            { value: "Chief Operating Officer", text: "Chief Operating Officer" },
            { value: "Consignee Agent", text: "Consignee Agent" },
            { value: "Consultant", text: "Consultant" },
            { value: "Cousin", text: "Cousin" },
            { value: "Creditor", text: "Creditor" },
            { value: "Custodian", text: "Custodian" },
            { value: "Daughter", text: "Daughter" },
            { value: "Daughter-in-law", text: "Daughter-in-law" },
            { value: "Employee", text: "Employee" },
            { value: "Employer", text: "Employer" },
            { value: "Estate Agent", text: "Estate Agent" },
            { value: "Ex-husband", text: "Ex-husband" },
            { value: "Ex-wife", text: "Ex-wife" },
            { value: "Executive", text: "Executive" },
            { value: "Father", text: "Father" },
            { value: "Father-in-law", text: "Father-in-law" },
            { value: "Fiancee", text: "Fiancee" },
            { value: "Friend", text: "Friend" },
            { value: "General Manager", text: "General Manager" },
            { value: "God Daughter", text: "God Daughter" },
            { value: "God Father", text: "God Father" },
            { value: "God Mother", text: "God Mother" },
            { value: "God Son", text: "God Son" },
            { value: "Granddaughter", text: "Granddaughter" },
            { value: "Grandfather", text: "Grandfather" },
            { value: "Grandmother", text: "Grandmother" },
            { value: "Grandson", text: "Grandson" },
            { value: "Guardian", text: "Guardian" },
            { value: "Half Brother", text: "Half Brother" },
            { value: "Half Sister", text: "Half Sister" },
            { value: "Husband", text: "Husband" },
            { value: "Legal Agent", text: "Legal Agent" },
            { value: "Mother", text: "Mother" },
            { value: "Mother-in-law", text: "Mother-in-law" },
            { value: "Nephew", text: "Nephew" },
            { value: "Niece", text: "Niece" },
            { value: "Owner of Cash Value", text: "Owner of Cash Value" },
            { value: "Owner of cash value and death benefit", text: "Owner of cash value and death benefit" },
            { value: "Owner of Death Benefit", text: "Owner of Death Benefit" },
            { value: "President", text: "President" },
            { value: "Secretary", text: "Secretary" },
            { value: "Self", text: "Self" },
            { value: "Significant Other", text: "Significant Other" },
            { value: "Sister", text: "Sister" },
            { value: "Sister-in-law", text: "Sister-in-law" },
            { value: "Son", text: "Son" },
            { value: "Son-in-law", text: "Son-in-law" },
            { value: "Spouse", text: "Spouse" },
            { value: "Step Brother", text: "Step Brother" },
            { value: "Step Daughter", text: "Step Daughter" },
            { value: "Step Father", text: "Step Father" },
            { value: "Step Mother", text: "Step Mother" },
            { value: "Step Sister", text: "Step Sister" },
            { value: "Step Son", text: "Step Son" },
            { value: "Tax Agent", text: "Tax Agent" },
            { value: "Trust", text: "Trust" },
            { value: "Unborn", text: "Unborn" },
            { value: "Uncle", text: "Uncle" },
            { value: "Unknown", text: "Unknown" },
            { value: "Vice President", text: "Vice President" },
            { value: "Wife", text: "Wife" },
            { value: "Other", text: "Other" }

        ];
    },

    RELATIVE_BENEFICIARY_LIST: function () {
        return [
            { value: "Husband", text: "Husband", group: "Frequently used" },
            { value: "Wife", text: "Wife", group: "Frequently used" },
            { value: "Fiancee", text: "Fiancee", group: "Frequently used" },
            { value: "Significant Other", text: "Significant Other", group: "Frequently used" },
            { value: "Son", text: "Son", group: "Frequently used" },
            { value: "Daughter", text: "Daughter", group: "Frequently used" },
            { value: "Brother", text: "Brother", group: "Frequently used" },
            { value: "Sister", text: "Sister", group: "Frequently used" },
            { value: "Father", text: "Father", group: "Frequently used" },
            { value: "Mother", text: "Mother", group: "Frequently used" },
            { value: "Aunt", text: "Aunt" },
            { value: "Brother-in-law", text: "Brother-in-law" },
            { value: "Cousin", text: "Cousin" },
            { value: "Daughter-in-law", text: "Daughter-in-law" },
            { value: "Ex-husband", text: "Ex-husband" },
            { value: "Ex-wife", text: "Ex-wife" },
            { value: "Father-in-law", text: "Father-in-law" },
            { value: "Friend", text: "Friend" },
            { value: "God Daughter", text: "God Daughter" },
            { value: "God Father", text: "God Father" },
            { value: "God Mother", text: "God Mother" },
            { value: "God Son", text: "God Son" },
            { value: "Granddaughter", text: "Granddaughter" },
            { value: "Grandfather", text: "Grandfather" },
            { value: "Grandmother", text: "Grandmother" },
            { value: "Grandson", text: "Grandson" },
            { value: "Guardian", text: "Guardian" },
            { value: "Half Brother", text: "Half Brother" },
            { value: "Half Sister", text: "Half Sister" },
            { value: "Legal Agent", text: "Legal Agent" },
            { value: "Mother-in-law", text: "Mother-in-law" },
            { value: "Nephew", text: "Nephew" },
            { value: "Niece", text: "Niece" },
            { value: "Sister-in-law", text: "Sister-in-law" },
            { value: "Son-in-law", text: "Son-in-law" },
            { value: "Spouse", text: "Spouse" },
            { value: "Step Brother", text: "Step Brother" },
            { value: "Step Daughter", text: "Step Daughter" },
            { value: "Step Father", text: "Step Father" },
            { value: "Step Mother", text: "Step Mother" },
            { value: "Step Sister", text: "Step Sister" },
            { value: "Step Son", text: "Step Son" },
            { value: "Unborn", text: "Unborn" },
            { value: "Uncle", text: "Uncle" }
        ];
    },


    MONTH_LIST: function () {
        return [
            { value: "1", text: "January" },
            { value: "2", text: "February" },
            { value: "3", text: "March" },
            { value: "4", text: "April" },
            { value: "5", text: "May" },
            { value: "6", text: "June" },
            { value: "7", text: "July" },
            { value: "8", text: "August" },
            { value: "9", text: "September" },
            { value: "10", text: "October" },
            { value: "11", text: "November" },
            { value: "12", text: "December" }
        ];
    },

    PAST_YEAR_UNTILL_CURRENT_YEAR_LIST: function () {
        var list = [];
        var currentYear = new Date().getFullYear();

        for (var year = currentYear; year >= 1900; year--) {
            list.push({ value: year, text: year });
        }
        return list;
    },

    STATE_LIST: function () {
        return [
            { value: "AL", text: "Alabama" },
            { value: "AK", text: "Alaska" },
            { value: "AZ", text: "Arizona" },
            { value: "AR", text: "Arkansas" },
            { value: "CA", text: "California" },
            { value: "CO", text: "Colorado" },
            { value: "CT", text: "Connecticut" },
            { value: "DE", text: "Delaware" },
            { value: "DC", text: "Dist. of Columbia" },
            { value: "FL", text: "Florida" },
            { value: "GA", text: "Georgia" },
            { value: "HI", text: "Hawaii" },
            { value: "ID", text: "Idaho" },
            { value: "IL", text: "Illinois" },
            { value: "IN", text: "Indiana" },
            { value: "IA", text: "Iowa" },
            { value: "KS", text: "Kansas" },
            { value: "KY", text: "Kentucky" },
            { value: "LA", text: "Louisiana" },
            { value: "ME", text: "Maine" },
            { value: "MD", text: "Maryland" },
            { value: "MA", text: "Massachusetts" },
            { value: "MI", text: "Michigan" },
            { value: "MN", text: "Minnesota" },
            { value: "MS", text: "Mississippi" },
            { value: "MO", text: "Missouri" },
            { value: "MT", text: "Montana" },
            { value: "NE", text: "Nebraska" },
            { value: "NV", text: "Nevada" },
            { value: "NH", text: "New Hampshire" },
            { value: "NJ", text: "New Jersey" },
            { value: "NM", text: "New Mexico" },
            { value: "NY", text: "New York" },
            { value: "NC", text: "North Carolina" },
            { value: "ND", text: "North Dakota" },
            { value: "OH", text: "Ohio" },
            { value: "OK", text: "Oklahoma" },
            { value: "OR", text: "Oregon" },
            { value: "PA", text: "Pennsylvania" },
            { value: "RI", text: "Rhode Island" },
            { value: "SC", text: "South Carolina" },
            { value: "SD", text: "South Dakota" },
            { value: "TN", text: "Tennessee" },
            { value: "TX", text: "Texas" },
            { value: "UT", text: "Utah" },
            { value: "VT", text: "Vermont" },
            { value: "VA", text: "Virginia" },
            { value: "WA", text: "Washington" },
            { value: "WV", text: "West Virginia" },
            { value: "WI", text: "Wisconsin" },
            { value: "WY", text: "Wyoming" }
        ];
    },

    COUNTRY_LIST: function () {
        return [
            { value: "USA", text: "UNITED STATES OF AMERICA" },
            { value: "AFG", text: "AFGHANISTAN" },
            { value: "ALB", text: "ALBANIA" },
            { value: "DZA", text: "ALGERIA" },
            { value: "ASM", text: "AMERICAN SAMOA" },
            { value: "AND", text: "ANDORRA" },
            { value: "AGO", text: "ANGOLA" },
            { value: "AIA", text: "ANGUILLA" },
            { value: "ATA", text: "ANTARCTICA" },
            { value: "ATG", text: "ANTIGUA AND BARBUDA" },
            { value: "ARG", text: "ARGENTINA" },
            { value: "ARM", text: "ARMENIA" },
            { value: "ABW", text: "ARUBA" },
            { value: "AUS", text: "AUSTRALIA" },
            { value: "AUT", text: "AUSTRIA" },
            { value: "AZE", text: "AZERBAIJAN" },
            { value: "BHS", text: "BAHAMAS" },
            { value: "BHR", text: "BAHRAIN" },
            { value: "BGD", text: "BANGLADESH" },
            { value: "BRB", text: "BARBADOS" },
            { value: "BLR", text: "BELARUS" },
            { value: "BEL", text: "BELGIUM" },
            { value: "BLZ", text: "BELIZE" },
            { value: "BEN", text: "BENIN" },
            { value: "BMU", text: "BERMUDA" },
            { value: "BTN", text: "BHUTAN" },
            { value: "BOL", text: "BOLIVIA" },
            { value: "BIH", text: "BOSNIA AND HERZEGOWINA" },
            { value: "BWA", text: "BOTSWANA" },
            { value: "BVT", text: "BOUVET ISLAND" },
            { value: "BRA", text: "BRAZIL" },
            { value: "IOT", text: "BRITISH INDIAN OCEAN TERRITORY" },
            { value: "BRN", text: "BRUNEI DARUSSALAM" },
            { value: "BGR", text: "BULGARIA" },
            { value: "BFA", text: "BURKINA FASO" },
            { value: "BRM", text: "BURMA" },
            { value: "BDI", text: "BURUNDI" },
            { value: "KHM", text: "CAMBODIA" },
            { value: "CMR", text: "CAMEROON" },
            { value: "CAN", text: "CANADA" },
            { value: "CPV", text: "CAPE VERDE" },
            { value: "CYM", text: "CAYMAN ISLANDS" },
            { value: "CAF", text: "CENTRAL AFRICAN REPUBLIC" },
            { value: "TCD", text: "CHAD" },
            { value: "CHL", text: "CHILE" },
            { value: "CHN", text: "CHINA" },
            { value: "CXR", text: "CHRISTMAS ISLAND" },
            { value: "CCK", text: "COCOS - KEELING ISLANDS" },
            { value: "COL", text: "COLOMBIA" },
            { value: "COM", text: "COMOROS" },
            { value: "COD", text: "CONGO, THE DEMOCRATIC REPUBLIC OF THE" },
            { value: "COK", text: "COOK ISLANDS" },
            { value: "CRI", text: "COSTA RICA" },
            { value: "CIV", text: "COTE D'IVOIRE" },
            { value: "HRV", text: "CROATIA - local name: Hrvatska" },
            { value: "CUB", text: "CUBA" },
            { value: "CYP", text: "CYPRUS" },
            { value: "CZE", text: "CZECH REPUBLIC" },
            { value: "DNK", text: "DENMARK" },
            { value: "DJI", text: "DJIBOUTI" },
            { value: "DMA", text: "DOMINICA" },
            { value: "DOM", text: "DOMINICAN REPUBLIC" },
            { value: "TMP", text: "EAST TIMOR" },
            { value: "ECU", text: "ECUADOR" },
            { value: "EGY", text: "EGYPT" },
            { value: "SLV", text: "EL SALVADOR" },
            { value: "GNQ", text: "EQUATORIAL GUINEA" },
            { value: "ERI", text: "ERITREA" },
            { value: "EST", text: "ESTONIA" },
            { value: "ETH", text: "ETHIOPIA" },
            { value: "FLK", text: "FALKLAND ISLANDS - MALVINAS" },
            { value: "FRO", text: "FAROE ISLANDS" },
            { value: "FJI", text: "FIJI" },
            { value: "FIN", text: "FINLAND" },
            { value: "FRA", text: "FRANCE" },
            { value: "GUF", text: "FRENCH GUIANA" },
            { value: "PYF", text: "FRENCH POLYNESIA" },
            { value: "ATF", text: "FRENCH SOUTHERN TERRITORIES" },
            { value: "GAB", text: "GABON" },
            { value: "GMB", text: "GAMBIA" },
            { value: "GEO", text: "GEORGIA" },
            { value: "DEU", text: "GERMANY" },
            { value: "GHA", text: "GHANA" },
            { value: "GIB", text: "GIBRALTAR" },
            { value: "GRC", text: "GREECE" },
            { value: "GRL", text: "GREENLAND" },
            { value: "GRD", text: "GRENADA" },
            { value: "GLP", text: "GUADELOUPE" },
            { value: "GUM", text: "GUAM" },
            { value: "GTM", text: "GUATEMALA" },
            { value: "GIN", text: "GUINEA" },
            { value: "GNB", text: "GUINEA-BISSAU" },
            { value: "GUY", text: "GUYANA" },
            { value: "HTI", text: "HAITI" },
            { value: "HMD", text: "HEARD AND MC DONALD ISLANDS" },
            { value: "VAT", text: "HOLY SEE - VATICAN CITY STATE" },
            { value: "HND", text: "HONDURAS" },
            { value: "HKG", text: "HONG KONG" },
            { value: "HUN", text: "HUNGARY" },
            { value: "ISL", text: "ICELAND" },
            { value: "IND", text: "INDIA" },
            { value: "IDN", text: "INDONESIA" },
            { value: "IRN", text: "IRAN" },
            { value: "IRQ", text: "IRAQ" },
            { value: "IRL", text: "IRELAND" },
            { value: "ISR", text: "ISRAEL" },
            { value: "ITA", text: "ITALY" },
            { value: "JAM", text: "JAMAICA" },
            { value: "JPN", text: "JAPAN" },
            { value: "JOR", text: "JORDAN" },
            { value: "KAZ", text: "KAZAKHSTAN" },
            { value: "KEN", text: "KENYA" },
            { value: "KIR", text: "KIRIBATI" },
            { value: "KWT", text: "KUWAIT" },
            { value: "KGZ", text: "KYRGYZSTAN" },
            { value: "LAO", text: "LAO PEOPLE'S DEMOCRATIC REPUBLIC" },
            { value: "LVA", text: "LATVIA" },
            { value: "LBN", text: "LEBANON" },
            { value: "LSO", text: "LESOTHO" },
            { value: "LBR", text: "LIBERIA" },
            { value: "LBY", text: "LIBYA" },
            { value: "LIE", text: "LIECHTENSTEIN" },
            { value: "LTU", text: "LITHUANIA" },
            { value: "LUX", text: "LUXEMBOURG" },
            { value: "MAC", text: "MACAU" },
            { value: "MKD", text: "MACEDONIA, THE FORMER YUGOSLAV REPUBLIC OF" },
            { value: "MDG", text: "MADAGASCAR" },
            { value: "MWI", text: "MALAWI" },
            { value: "MYS", text: "MALAYSIA" },
            { value: "MDV", text: "MALDIVES" },
            { value: "MLI", text: "MALI" },
            { value: "MLT", text: "MALTA" },
            { value: "MHL", text: "MARSHALL ISLANDS" },
            { value: "MTQ", text: "MARTINIQUE" },
            { value: "MRT", text: "MAURITANIA" },
            { value: "MUS", text: "MAURITIUS" },
            { value: "MYT", text: "MAYOTTE" },
            { value: "MEX", text: "MEXICO" },
            { value: "FSM", text: "MICRONESIA, FEDERATED STATES OF" },
            { value: "MDA", text: "MOLDOVA" },
            { value: "MCO", text: "MONACO" },
            { value: "MNG", text: "MONGOLIA" },
            { value: "MSR", text: "MONTSERRAT" },
            { value: "MAR", text: "MOROCCO" },
            { value: "MOZ", text: "MOZAMBIQUE" },
            { value: "MMR", text: "MYANMAR" },
            { value: "NAM", text: "NAMIBIA" },
            { value: "NRU", text: "NAURU" },
            { value: "NPL", text: "NEPAL" },
            { value: "NLD", text: "NETHERLANDS" },
            { value: "ANT", text: "NETHERLANDS ANTILLES" },
            { value: "NCL", text: "NEW CALEDONIA" },
            { value: "NZL", text: "NEW ZEALAND" },
            { value: "NIC", text: "NICARAGUA" },
            { value: "NER", text: "NIGER" },
            { value: "NGA", text: "NIGERIA" },
            { value: "NIU", text: "NIUE" },
            { value: "NFK", text: "NORFOLK ISLAND" },
            { value: "PRK", text: "NORTH KOREA" },
            { value: "MNP", text: "NORTHERN MARIANA ISLANDS" },
            { value: "NOR", text: "NORWAY" },
            { value: "OMN", text: "OMAN" },
            { value: "PAK", text: "PAKISTAN" },
            { value: "PLW", text: "PALAU" },
            { value: "PAN", text: "PANAMA" },
            { value: "PNG", text: "PAPUA NEW GUINEA" },
            { value: "PRY", text: "PARAGUAY" },
            { value: "PER", text: "PERU" },
            { value: "PHL", text: "PHILIPPINES" },
            { value: "PCN", text: "PITCAIRN" },
            { value: "POL", text: "POLAND" },
            { value: "PRT", text: "PORTUGAL" },
            { value: "PRI", text: "PUERTO RICO" },
            { value: "QAT", text: "QATAR" },
            { value: "REU", text: "REUNION" },
            { value: "ROM", text: "ROMANIA" },
            { value: "RUS", text: "RUSSIA" },
            { value: "RWA", text: "RWANDA" },
            { value: "KNA", text: "SAINT KITTS AND NEVIS" },
            { value: "LCA", text: "SAINT LUCIA" },
            { value: "VCT", text: "SAINT VINCENT AND THE GRENADINES" },
            { value: "WSM", text: "SAMOA" },
            { value: "SMR", text: "SAN MARINO" },
            { value: "STP", text: "SAO TOME AND PRINCIPE" },
            { value: "SAU", text: "SAUDI ARABIA" },
            { value: "SEN", text: "SENEGAL" },
            { value: "SYC", text: "SEYCHELLES" },
            { value: "SLE", text: "SIERRA LEONE" },
            { value: "SGP", text: "SINGAPORE" },
            { value: "SVK", text: "SLOVAKIA - Slovak Republic" },
            { value: "SVN", text: "SLOVENIA" },
            { value: "SLB", text: "SOLOMON ISLANDS" },
            { value: "SOM", text: "SOMALIA" },
            { value: "ZAF", text: "SOUTH AFRICA" },
            { value: "SGS", text: "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS" },
            { value: "KOR", text: "SOUTH KOREA" },
            { value: "ESP", text: "SPAIN" },
            { value: "LKA", text: "SRI LANKA" },
            { value: "SHN", text: "ST. HELENA" },
            { value: "SPM", text: "ST. PIERRE AND MIQUELON" },
            { value: "SDN", text: "SUDAN" },
            { value: "SUR", text: "SURINAME" },
            { value: "SJM", text: "SVALBARD AND JAN MAYEN ISLANDS" },
            { value: "SWZ", text: "SWAZILAND" },
            { value: "SWE", text: "SWEDEN" },
            { value: "CHE", text: "SWITZERLAND" },
            { value: "SYR", text: "SYRIAN ARAB REPUBLIC" },
            { value: "TWN", text: "TAIWAN, ROC" },
            { value: "TJK", text: "TAJIKISTAN" },
            { value: "TZA", text: "TANZANIA, UNITED REPUBLIC OF" },
            { value: "THA", text: "THAILAND" },
            { value: "TGO", text: "TOGO" },
            { value: "TKL", text: "TOKELAU" },
            { value: "TON", text: "TONGA" },
            { value: "TTO", text: "TRINIDAD AND TOBAGO" },
            { value: "TUN", text: "TUNISIA" },
            { value: "TUR", text: "TURKEY" },
            { value: "TKM", text: "TURKMENISTAN" },
            { value: "TCA", text: "TURKS AND CAICOS ISLANDS" },
            { value: "TUV", text: "TUVALU" },
            { value: "UGA", text: "UGANDA" },
            { value: "UKR", text: "UKRAINE" },
            { value: "ARE", text: "UNITED ARAB EMIRATES" },
            { value: "GBR", text: "UNITED KINGDOM" },
            { value: "UMI", text: "UNITED STATES MINOR OUTLYING ISLANDS" },
            { value: "ZOO", text: "UNKNOWN" },
            { value: "URY", text: "URUGUAY" },
            { value: "UZB", text: "UZBEKISTAN" },
            { value: "VUT", text: "VANUATU" },
            { value: "VEN", text: "VENEZUELA" },
            { value: "VNM", text: "VIET NAM" },
            { value: "VGB", text: "VIRGIN ISLANDS - BRITISH" },
            { value: "VIR", text: "VIRGIN ISLANDS - U.S." },
            { value: "WLF", text: "WALLIS AND FUTUNA ISLANDS" },
            { value: "ESH", text: "WESTERN SAHARA" },
            { value: "YEM", text: "YEMEN" },
            { value: "YUG", text: "YUGOSLAVIA" },
            { value: "COG", text: "ZAIRE" },
            { value: "ZMB", text: "ZAMBIA" },
            { value: "ZWE", text: "ZIMBABWE" }
        ];
    },

    HEIGHT_LIST: function () {
        const START_INCHES = 4 * 12;
        const END_INCHES = 8 * 12;
        var values = [];
        for (var inches = START_INCHES; inches < END_INCHES; inches++) {
            var feet = parseInt(inches / 12);
            var currentInch = inches % 12;
            var text = feet + "'" + currentInch + "\"";
            //format {value:"67", text:"5'7""
            values.push({ value: inches, text: text });
        }
        return values;
    },

    HEIGHT_LIST_FEET_INCHES: function () {
        const START_INCHES = 4*12;
        const END_INCHES = 8 * 12;
        var values = [];
        for (var inches = START_INCHES; inches < END_INCHES; inches++) {
            var feet = parseInt(inches / 12);
            var currentInch = inches % 12;
            var val = String(feet).padStart(2, '0') + '-' + String(currentInch).padStart(2, '0');
            var text = feet + '\' ' + currentInch + '"';
            //format {value:"05-07", text:"5' 7""
            values.push({ value: val, text: text });
        }
        return values;
    },

    TOBACCO_USAGE: function () {
        return [
            { value: "Current User", text: "Current User" },
            { value: "Within the past year", text: "Quit Within the Past Year" },
            { value: "Over 1 year ago", text: "Quit Over One Year Ago" },
            { value: "Over 2 years ago", text: "Quit Over Two Years Ago" },
            { value: "Over 3 years ago", text: "Quit Over Three Years Ago" },
            { value: "Over 5 years ago", text: "Quit Over Five Years Ago" }
        ];
    },

    TOBACCO_CIGARETTE_FREQUENCY: function () {
        return [
            { value: "< 1", text: "< 1 Pack/day" },
            { value: "1", text: "= 1 Pack/day" },
            { value: "> 1", text: "> 1 Pack/day" }
        ];
    },

    TOBACCO_CIGAR_FREQUENCY: function () {
        return [
            { value: "< 4", text: "< 4/year" },
            { value: "< 6", text: "< 6/year" },
            { value: "< 8", text: "< 8/year" },
            { value: "< 10", text: "< 10/year" },
            { value: "< 12", text: "< 12/year" },
            { value: "> 12", text: "> 12/year" }
        ];
    },

    TOBACCO_CHEWINGTOBACCO_FREQUENCY: function () {
        return [
            { value: "> 1/day", text: "> 1/day" },
            { value: "> 1/week", text: "> 1/week" },
            { value: "> 1/month", text: "> 1/month" },
            { value: "> 1/year", text: "> 1/year" },
        ];
    },

    HEALTH_ALCOHOL_CURRENT_USAGE: function () {
        return [
            { value: "currentuser", text: "Current User" },
            { value: "< 5 Year of Complete Abstinence", text: "< 5 Years of Complete Abstinence" },
            { value: "5 - 10 Years of Complete Abstinence", text: "5 - 10 Years of Complete Abstinence" },
            { value: "> 10 Years of Complete Abstinence", text: "> 10 Years of Complete Abstinence" }
        ];
    },

    HEALTH_DRUG_CURRENT_USAGE: function () {
        return [
            { value: "currentuser", text: "Current User" },
            { value: "< 6 Year of Complete Abstinence", text: "< 6 Years sof Complete Abstinence" },
            { value: "6+ Years of Complete Abstinence", text: "6+ Years of Complete Abstinence" }
        ];
    },

    HEALTH_DRUG_AND_ALCOHOL_CURRENT_USAGE: function () {
        return [
            { value: "currentuser", text: "Current User" },
            { value: "< 15 Year of Complete Abstinence", text: "< 15 Years of Complete Abstinence" },
            { value: "15+ Years of Complete Abstinence", text: "15+ Years of Complete Abstinence" }
        ];
    },

    DRIVING_VIOLATIONS: function () {
        return [
            { value: "DUI", text: "Driving Under the Influence(DUI)" },
            { value: "DWI", text: "Driving while Intoxicated(DWI)" },
            { value: "Reckless", text: "Reckless Driving" },
            { value: "Other", text: "Other" }
        ];
    },

    MISDEMEANOR_VIOLATIONS: function () {
        return [
            { value: "1 Misdemeanor", text: "1 Misdemeanor" },
            { value: "2 Misdemeanor", text: "2 Misdemeanors" },
            { value: "3+ Misdemeanor", text: "3+ Misdemeanors" }
        ];
    },

    FELONY_VIOLATIONS: function () {
        return [
            { value: "1 Felony", text: "1 Felony" },
            { value: "2+ Felonies", text: "2+ Felonies" }
        ];
    },

    FELONY_PROBATION: function () {
        return [
            { value: "Currrently on Probation", text: "Currrently on Probation" },
            { value: "1-5 Years Off Probation", text: "1-5 Years Off Probation" },
            { value: "5-7 Years Off Probation", text: "5-7 Years Off Probation" },
            { value: ">7 Off Probation", text: ">7 Years Off Probation" }
        ];
    },

    BANKRUPTCY_OUTCOME: function () {
        return [
            { value: "discharged", text: "My bankruptcy was discharged / completed" },
            { value: "unresolved", text: "I am still making payments" },
            { value: "unresolved/dismissed", text: "My bankruptcy was dismissed / not completed" }
        ];
    },

    BANKRUPTCY_CHAPTER_FILED: function () {
        return [
            { value: "7", text: "Chapter 7 (liquidation, the most common filing)" },
            { value: "11", text: "Chapter 11 (reorganization, typically used by corporations)" },
            { value: "13", text: "Chapter 13 (adjustment of debts of an individual with regular income)" }
        ];
    },

    BANKRUPTCY_REASON: function () {
        return [
            { value: "Personal - Debt Consolidation or Credit Problems", text: "Personal - Debt Consolidation or Credit Problems" },
            { value: "Personal - Divorce/Child Support/Alimony", text: "Personal - Divorce/Child Support/Alimony" },
            { value: "Personal - Death of a Spouse", text: "Personal - Death of a Spouse" },
            { value: "Personal - Loss of Employment", text: "Personal - Loss of Employment" },
            { value: "Personal - Loss of Investment Income", text: "Personal - Loss of Investment Income" },
            { value: "Personal - Loss Due to Natural Disaster", text: "Personal - Loss Due to Natural Disaster" },
            { value: "Personal - Mortgage Losses or Foreclosure", text: "Personal - Mortgage Losses or Foreclosure" },
            { value: "Personal - Lawsuit or Adverse Court Settlement", text: "Personal - Lawsuit or Adverse Court Settlement" },
            { value: "Personal - Gambling Losses", text: "Personal - Gambling Losses" },
            { value: "Medical - Personal Medical Bills", text: "Medical - Personal Medical Bills" },
            { value: "Medical - Medical Bills of a Spouse or Family Member", text: "Medical - Medical Bills of a Spouse or Family Member" },
            { value: "Business - Business Failure", text: "Business - Business Failure" },
            { value: "Business - Lawsuit or Adverse Court Settlement", text: "Business - Lawsuit or Adverse Court Settlement" },
            { value: "Other", text: "Other" }
        ];
    },

    HIGH_BLOOD_PRESSURE_MEDICATION: function () {
        return [
            { value: "Never Treated", text: "Never Treated" },
            { value: "Controlled < 3 Months", text: "Controlled < 3 Months" },
            { value: "Controlled > 3 Months", text: "Controlled > 3 Months" },
            { value: "Controlled > 6 Months", text: "Controlled > 6 Months" },
            { value: "Controlled > 12 Months", text: "Controlled > 12 Months" },
            { value: "Controlled > 24 Months", text: "Controlled > 24 Months" }
        ];
    },

    DEPRESSION_SYMPTOMS: function () {
        return [
            { value: "Mild/Short Term", text: "Mild/Short Term" },
            { value: "Mild-Moderate/Reactive", text: "Mild-Moderate/Reactive" },
            { value: "Chronic", text: "Chronic" },
            { value: "Severe", text: "Severe" }
        ];
    },

    DIABETES_TYPES: function () {
        return [
            { value: "Gestational Diabetes", text: "Gestational Diabetes" },
            { value: "Type 1", text: "Type 1" },
            { value: "Type 2", text: "Type 2" }
        ];
    },

    HIGH_CHOLESTEROL_MEDICATION: function () {
        return [
            { value: "Never Treated", text: "Never Treated" },
            { value: "Controlled < 3 Months", text: "Controlled < 3 Months" },
            { value: "Controlled > 3 Months", text: "Controlled > 3 Months" },
            { value: "Controlled > 6 Months", text: "Controlled > 6 Months" },
            { value: "Controlled > 12 Months", text: "Controlled > 12 Months" },
            { value: "Controlled > 24 Months", text: "Controlled > 24 Months" }
        ];
    },

    ANXIETY_SYMPTOMS: function () {
        return [
            { value: "Mild", text: "Mild" },
            { value: "Moderate", text: "Moderate" },
            { value: "Severe", text: "Severe" }
        ];
    },
    ARTHRITIS_TYPES: function () {
        return [
            { value: "Osteoarthritis", text: "Osteoarthritis" },
            { value: "Psoriatic", text: "Psoriatic" },
            { value: "Rheumatoid", text: "Rheumatoid" }
        ];
    },

    ARTHRITIS_SEVERITY: function () {
        return [
            { value: "Mild", text: "Mild" },
            { value: "Very Moderate", text: "Very Moderate" },
            { value: "Moderate", text: "Moderate" },
            { value: "Severe", text: "Severe" },
            { value: "Joint Replacement", text: "Joint Replacement" },
            { value: "Narcotic Medications", text: "Narcotic Medications" }
        ];
    },

    ARTHRITIS_SEVERITY_OSTEOARTHRITIS: function () {
        return [
            { value: "Mild", text: "Mild" },
            { value: "Very Moderate", text: "Very Moderate" },
            { value: "Moderate", text: "Moderate" },
            { value: "Severe", text: "Severe" },
            { value: "Joint Replacement", text: "Joint Replacement" },
            { value: "Narcotic Medications", text: "Narcotic Medications" }
        ];
    },

    ARTHRITIS_SEVERITY_PSORIATIC: function () {
        return [
            { value: "Mild", text: "Mild" },
            { value: "Moderate", text: "Moderate" },
        ];
    },

    ARTHRITIS_SEVERITY_RHEUMATOID: function () {
        return [
            { value: "Mild", text: "Mild" },
            { value: "Very Moderate", text: "Very Moderate" },
            { value: "Moderate", text: "Moderate" },
            { value: "Severe", text: "Severe" },
            { value: "Joint Replacement", text: "Joint Replacement" },
            { value: "Narcotic Medications", text: "Narcotic Medications" }
        ];
    },

    FAMILY_MEMBERS: function () {
        return [
            { value: "Father", text: "Father" },
            { value: "Mother", text: "Mother" },
            { value: "Sibling 1", text: "Sibling 1" },
            { value: "Sibling 2", text: "Sibling 2" }
        ]
    },

    HEART_DISEASES_LIST: function () {
        return [
            { value: "Angina", text: "Angina" },
            { value: "Angioplasty/Stents", text: "Angioplasty/Stents" },
            { value: "Aortic Insufficiency", text: "Aortic Insufficiency" },
            { value: "Aortic Stenosis", text: "Aortic Stenosis" },
            { value: "Atrial Fibrillation", text: "Atrial Fibrillation" },
            { value: "Atrial Flutter", text: "Atrial Flutter" },
            { value: "Atrial Septal Defect (ASD)", text: "Atrial Septal Defect (ASD)" },
            { value: "Arrhythmia", text: "Arrhythmia" },
            { value: "Arteriosclerosis", text: "Arteriosclerosis" },
            { value: "Heart & Alcohol Abuse", text: "Heart & Alcohol Abuse" },
            { value: "Bypass Graft Surgery", text: "Bypass Graft Surgery" },
            { value: "Cardiac Arrest", text: "Cardiac Arrest" },
            { value: "Cardiomyopathy", text: "Cardiomyopathy" },
            { value: "Coronary Artery Disease", text: "Coronary Artery Disease" },
            { value: "Congestive Heart Failure", text: "Congestive Heart Failure" },
            { value: "Heart & Diabetes", text: "Heart & Diabetes" },
            { value: "Eisenmenger’s Complex", text: "Eisenmenger’s Complex" },
            { value: "Enlarged Heart", text: "Enlarged Heart" },
            { value: "Heart Failure / Congestive Heart Failure (CHF)", text: "Heart Failure / Congestive Heart Failure (CHF)" },
            { value: "Heart Attack (Myocardial Infarction)", text: "Heart Attack (Myocardial Infarction)" },
            { value: "Mitral Stenosis", text: "Mitral Stenosis" },
            { value: "Murmur", text: "Murmur" },
            { value: "Pacemaker", text: "Pacemaker" },
            { value: "Patent Ductus Arteriosus", text: "Patent Ductus Arteriosus" },
            { value: "Pulmonary Stenosis", text: "Pulmonary Stenosis" },
            { value: "Left Bundle Branch Block (LBBB)", text: "Left Bundle Branch Block (LBBB)" },
            { value: "Ventricular Sepal Defect (VSD)", text: "Ventricular Sepal Defect (VSD)" },
            { value: "Heart Transplant", text: "Heart Transplant" },
            { value: "Other", text: "Other" }
        ]
    },

    LUNG_DISORDER_LIST: function () {
        return [
            { value: "Asthma", text: "Asthma" },
            { value: "COPD – Chronic Obstructive Pulmonary Disease", text: "COPD – Chronic Obstructive Pulmonary Disease" },
            { value: "Bronchitis", text: "Bronchitis" },
            { value: "Emphysema", text: "Emphysema" },
            { value: "Sleep Apnea", text: "Sleep Apnea" }
        ]
    },

    CANCER_LIST: function () {
        return [
            { value: "Melanoma In Situ", text: "Melanoma In Situ" },
            { value: "Seminoma", text: "Seminoma" },
            { value: "Basal Cell Carcinoma", text: "Basal Cell Carcinoma" },
            { value: "Squamous Cell Carcinoma", text: "Squamous Cell Carcinoma" },
            { value: "Atypical (dysplastic) Nevi", text: "Atypical (dysplastic) Nevi" },
            { value: "Breast Cancer", text: "Breast Cancer" },
            { value: "Colon Cancer", text: "Colon Cancer" },
            { value: "Hodgkins Disease", text: "Hodgkin's Disease" },
            { value: "Non-Hodgkins Lymphoma", text: "Non-Hodgkin's Lymphoma" },
            { value: "Malignant Melanoma", text: "Malignant Melanoma" },
            { value: "Prostate Cancer", text: "Prostate Cancer" }
        ]
    },

    GIWL_COVERAGE_LIST: function () {
        var coverageList = [];
        var step = 1000;
        for (var amount = 5000; amount <= 25000; amount += step) {
            coverageList.push({ value: amount, text: formatCurrency(amount) });
        }
        return coverageList;
    },

    ADD_COVERAGE_AMOUNT_LIST: function () {
        return [
            { value: "100000", text: "100,000" },
            { value: "150000", text: "150,000" },
            { value: "200000", text: "200,000" },
            { value: "250000", text: "250,000" },
            { value: "300000", text: "300,000" },
            { value: "350000", text: "350,000" },
            { value: "400000", text: "400,000" },
            { value: "450000", text: "450,000" },
            { value: "500000", text: "500,000" }
        ];
    },

    NUFIC_ADD_COVERAGE_AMOUNT_LIST: function () {
        return [
            { value: "50000", text: "50,000" },
            { value: "100000", text: "100,000" },
            { value: "250000", text: "250,000" },
            { value: "500000", text: "500,000" }
        ];
    },

    COVERAGE_AMOUNT_LIST: function () {
        var list = [];

        var scale = 50000;      // start at $50,000 increments until over a million
        var count = 0;          // needed so we can jump to the previous selected value

        for (var i = 100000; i < (10000000 + 1); i += scale) {
            var faceAmount = Number(i).toLocaleString('en');
            if (faceAmount.indexOf('.') != -1) {
                faceAmount = faceAmount.substring(0, faceAmount.indexOf('.'));
            }

            list.push({ value: i, text: faceAmount });

            count++;
            if (i >= 1000000 && i < 3000000)       // over million, change scale
            {
                scale = 250000;     // $250,000 increments
            }
            else if (i >= 3000000 && i < 5000000) {
                scale = 500000;     // $500,000 increments
            }
            else if (i >= 5000000) {
                scale = 1000000;    // $1,000,000 increments
            }
        }
        return list;
    },

    TERM_LENGTH_LIST: function () {
        return [
            { value: "10", text: "10 Years" },
            { value: "15", text: "15 Years" },
            { value: "20", text: "20 Years" },
            { value: "25", text: "25 Years" },
            { value: "30", text: "30 Years" }
        ];
    },

    VIP_TERM_LENGTH_LIST: function () {
        return [
            { value: "10", text: "10 Years" },
            { value: "20", text: "20 Years" },
            { value: "30", text: "30 Years" }
        ];
    },

    GIWL_PAYMENT_FREQUENCY_LIST: function () {
        return [
            { value: "monthly", text: "Monthly" },
            { value: "quarterly", text: "Quarterly" },
            { value: "semiAnnual", text: "Semi-Annual" },
            { value: "annual", text: "Annual" }
        ];
    },

    PAYMENT_FREQUENCY_MAP: [
        { durationKey: 1, values: ["Monthly", "Month"] },
        { durationKey: 3, values: ["Quarterly", "Quarter"] },
        { durationKey: 6, values: ["Semi-Annual", "Semi-Annually"] },
        { durationKey: 12, values: ["Annual", "Annually"] },
    ],

    PAYMENT_FREQUENCY_LIST: function () {
        return [
            { value: "Monthly", text: "Monthly" },
            { value: "Quarterly", text: "Quarterly" },
            { value: "Semi-Annual", text: "Semi-Annual" },
            { value: "Annual", text: "Annual" }
        ];
    },

    INSURED_SALUTATION: function () {
        return [
            { value: "Mr.", text: "Mr." },
            { value: "Ms.", text: "Ms." },
            { value: "Mrs.", text: "Mrs." },
            { value: "Miss", text: "Miss" },
            { value: "Dr.", text: "Dr." },
            { value: "Rev.", text: "Rev." }
        ];
    },
    INSURED_SUFFIX: function () {
        return [
            { value: "Jr", text: "Jr." },
            { value: "Sr", text: "Sr." },
            { value: "II", text: "II" },
            { value: "III", text: "III" },
            { value: "IV", text: "IV" },
            { value: "V", text: "V" },
            { value: "VI", text: "VI" },
            { value: "VII", text: "VII" },
            { value: "VIII", text: "VIII" },
            { value: "IX", text: "IX" },
            { value: "X", text: "X" }
        ];
    },

    EMPLOYMENT_STATUS: function () {
        return [
            { value: "Homemaker", text: "Homemaker" },
            { value: "Student", text: "Student" },
            { value: "Retired", text: "Retired" },
            { value: "Unemployed", text: "Unemployed" },
            { value: "Disabled", text: "Disabled" }
        ];
    },


    INSURED_MARITAL_STATUS: function () {
        return [
            { value: "Single", text: "Single" },
            { value: "Separated", text: "Separated" },
            { value: "Divorced", text: "Divorced" },
            { value: "Widowed", text: "Widowed" }
        ];
    },

    INSURED_MARITAL_STATUS_WITH_MARRIED: function () {
        return [
            { value: "Single", text: "Single" },
            { value: "Separated", text: "Separated" },
            { value: "Divorced", text: "Divorced" },
            { value: "Widowed", text: "Widowed" },
            { value: "Married", text: "Married" }
        ];
    },

    INSURED_INSURANCE_REASON: function () {
        return [
            { value: "Income Replacement", text: "Income Replacement" },
            { value: "Family Protection", text: "Family Protection" },
            { value: "Burial", text: "Burial" },
            { value: "Final Expenses", text: "Final Expenses" },
            { value: "Debt", text: "Debt" },
            { value: "Buy/Sell", text: "Buy/Sell" },
            { value: "Charitable Gifts", text: "Charitable Gifts" },
            { value: "College", text: "College" },
            { value: "Court Ordered", text: "Court Ordered" },
            { value: "Creditor", text: "Creditor" },
            { value: "Deferred Compensation", text: "Deferred Compensation" },
            { value: "Education", text: "Education" },
            { value: "Employee Benefits", text: "Employee Benefits" },
            { value: "Estate Planning", text: "Estate Planning" },
            { value: "Guaranteed Future Insurability", text: "Guaranteed Future Insurability" },
            { value: "Key Person", text: "Key Person" },
            { value: "Split Dollar", text: "Split Dollar" }
        ];
    },

    INSURED_VISA: function () {
        return [
            { value: "E-1", text: "E-1" },
            { value: "E-2", text: "E-2" },
            { value: "H-1B", text: "H-1B" },
            { value: "H4", text: "H4" },
            { value: "K1", text: "K1" },
            { value: "K2", text: "K2" },
            { value: "L1", text: "L1" },
            { value: "L2", text: "L2" },
            { value: "O", text: "O" },
            { value: "V1", text: "V1" },
            { value: "V2", text: "V2" }
        ];
    },

    TRAVEL_PURPOSE_LIST: function () {
        return [
            { value: "Business", text: "Business" },
            { value: "Cruise", text: "Cruise" },
            { value: "Education", text: "Education" },
            { value: "Family Visit", text: "Family Visit" },
            { value: "Foreign Exchange Student", text: "Foreign Exchange Student" },
            { value: "Foreign Orders", text: "Foreign Orders" },
            { value: "Honeymoon", text: "Honeymoon" },
            { value: "Job", text: "Job" },
            { value: "Live Abroad", text: "Live Abroad" },
            { value: "Military", text: "Military" },
            { value: "Missionary", text: "Missionary" },
            { value: "Preaching", text: "Preaching" },
            { value: "Relocation", text: "Relocation" },
            { value: "Reside", text: "Reside" },
            { value: "Vacation", text: "Vacation" },
            { value: "Volunteer Work", text: "Volunteer Work" },
            { value: "Work", text: "Work" },
            { value: "Other", text: "Other" }
        ];
    },

    DAYS_WEEKS_MONTHS_YEARS: function () {
        return [
            { value: "Days", text: "Days" },
            { value: "Weeks", text: "Weeks" },
            { value: "Months", text: "Months" },
            { value: "Years", text: "Years" }
        ];
    },





    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER
    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER
    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER

    CARRIER_LIST: function () {
        return [
            { companyId: 27, value: "American General Life Insurance Company", text: "American General" },
            { companyId: 38, value: "Prudential", text: "Prudential" },
            { companyId: 0, value: "Gerber Life", text: "Gerber Life" },
            { companyId: 15, value: "Transamerica", text: "Transamerica" },
            { companyId: 29, value: "US Life", text: "US Life" },
        ];
    },

    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER
    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER
    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER





    PRODUCT_TYPE_LIST: function () {
        return [
            { value: "Term", text: "Term" },
            { value: "Return of Premium", text: "Return of Premium" },
            { value: "Group Policy", text: "Group Policy" },
            { value: "Universal Life", text: "Universal Life" },
            { value: "Variable Life", text: "Variable Life" },
            { value: "Whole Life", text: "Whole Life" },
            { value: "Annuity", text: "Annuity" },
            { value: "Health", text: "Health" },
            { value: "Disability", text: "Disability" },
            { value: "Long-term Care", text: "Long-term Care" },
            { value: "Accidental Death", text: "Accidental Death" }
        ];
    },

    MILITARY_RANK: function () {
        return [
            { value: "Academy or ROTC Cadet", text: "Academy or ROTC Cadet" },
            { value: "E1-E2", text: "E1-E2" },
            { value: "E3-E5", text: "E3-E5" },
            { value: "E6-E7", text: "E6-E7" },
            { value: "E8-E9", text: "E8-E9" },
            { value: "WO1-WO2", text: "WO1-WO2" },
            { value: "WO3-WO4", text: "WO3-WO4" },
            { value: "WO5", text: "WO5" },
            { value: "O1-O3", text: "O1-O3" },
            { value: "O4-O6", text: "O4-O6" },
            { value: "O7 and up", text: "O7 and up" },
            { value: "Dependent", text: "Dependent" }
        ];
    },

    RELATIONSHIP: function () {
        return [
            { value: "Attorney", text: "Attorney" },
            { value: "Aunt", text: "Aunt" },
            { value: "Brother", text: "Brother" },
            { value: "Brother-in-law", text: "Brother-in-law" },
            { value: "Cousin", text: "Cousin" },
            { value: "Custodian", text: "Custodian" },
            { value: "Daughter", text: "Daughter" },
            { value: "Daughter-in-law", text: "Daughter-in-law" },
            { value: "Ex-husband", text: "Ex-husband" },
            { value: "Ex-wife", text: "Ex-wife" },
            { value: "Father", text: "Father" },
            { value: "Father-in-law", text: "Father-in-law" },
            { value: "Fiancee", text: "Fiancee" },
            { value: "Friend", text: "Friend" },
            { value: "God Daughter", text: "God Daughter" },
            { value: "God Father", text: "God Father" },
            { value: "God Mother", text: "God Mother" },
            { value: "God Son", text: "God Son" },
            { value: "Granddaughter", text: "Granddaughter" },
            { value: "Grandfather", text: "Grandfather" },
            { value: "Grandmother", text: "Grandmother" },
            { value: "Grandson", text: "Grandson" },
            { value: "Guardian", text: "Guardian" },
            { value: "Half Brother", text: "Half Brother" },
            { value: "Half Sister", text: "Half Sister" },
            { value: "Husband", text: "Husband" },
            { value: "Mother", text: "Mother" },
            { value: "Mother-in-law", text: "Mother-in-law" },
            { value: "Nephew", text: "Nephew" },
            { value: "Niece", text: "Niece" },
            { value: "Self", text: "Self" },
            { value: "Sister", text: "Sister" },
            { value: "Sister-in-law", text: "Sister-in-law" },
            { value: "Son", text: "Son" },
            { value: "Son-in-law", text: "Son-in-law" },
            { value: "Spouse", text: "Spouse" },
            { value: "Step Brother", text: "Step Brother" },
            { value: "Step Daughter", text: "Step Daughter" },
            { value: "Step Father", text: "Step Father" },
            { value: "Step Mother", text: "Step Mother" },
            { value: "Step Sister", text: "Step Sister" },
            { value: "Step Son", text: "Step Son" },
            { value: "Trust", text: "Trust" },
            { value: "Unborn", text: "Unborn" },
            { value: "Uncle", text: "Uncle" },
            { value: "Unknown", text: "Unknown" },
            { value: "Wife", text: "Wife" },
            { value: "Other", text: "Other" }
        ];
    },

    EMPLOYMENT_LENGTH: function () {
        return [
            { value: "0-1", text: "< 1 Year" },
            { value: "1-3", text: "1 - 3 Years" },
            { value: "3-5", text: "3 - 5 Years" },
            { value: "5", text: "> 5 Years" }
        ];
    },






    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER
    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER
    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER

    EMPLOYMENT_OCCUPATION: function () {
        return [

            { value: "Abrader", text: "Abrader" },
            { value: "Account Collector", text: "Account Collector" },
            { value: "Accountant", text: "Accountant" },
            { value: "Acrobat", text: "Acrobat" },
            { value: "Actor", text: "Actor" },
            { value: "Actuary", text: "Actuary" },
            { value: "Adjuster", text: "Adjuster" },
            { value: "Adjuster, not insurance", text: "Adjuster, not insurance" },
            { value: "Admin Protective Services", text: "Admin Protective Services" },
            { value: "Administrative Support", text: "Administrative Support" },
            { value: "Administrator", text: "Administrator" },
            { value: "Advertising Sales", text: "Advertising Sales" },
            { value: "Agent", text: "Agent" },
            { value: "Agriculture", text: "Agriculture" },
            { value: "Air Traffic Controller", text: "Air Traffic Controller" },
            { value: "Aircraft", text: "Aircraft" },
            { value: "Aircraft Mechanic", text: "Aircraft Mechanic" },
            { value: "Airline Navigator", text: "Airline Navigator" },
            { value: "Airplane Pilot", text: "Airplane Pilot" },
            { value: "Amusement", text: "Amusement" },
            { value: "Analyst", text: "Analyst" },
            { value: "Animal Caretaker", text: "Animal Caretaker" },
            { value: "Animal Trainer", text: "Animal Trainer" },
            { value: "Announcer", text: "Announcer" },
            { value: "Appliance Repair", text: "Appliance Repair" },
            { value: "Apprentice", text: "Apprentice" },
            { value: "Architect", text: "Architect" },
            { value: "Archivist", text: "Archivist" },
            { value: "Arranger", text: "Arranger" },
            { value: "Artisan", text: "Artisan" },
            { value: "Artist", text: "Artist" },
            { value: "Assembler", text: "Assembler" },
            { value: "Astronaut", text: "Astronaut" },
            { value: "Astronomer", text: "Astronomer" },
            { value: "Athlete", text: "Athlete" },
            { value: "Attendant", text: "Attendant" },
            { value: "Auctioneer", text: "Auctioneer" },
            { value: "Auditor", text: "Auditor" },
            { value: "Author", text: "Author" },
            { value: "Auto Body Repairer", text: "Auto Body Repairer" },
            { value: "Auto Mechanic", text: "Auto Mechanic" },
            { value: "Baggage", text: "Baggage" },
            { value: "Bagger", text: "Bagger" },
            { value: "Baker", text: "Baker" },
            { value: "Bank Teller", text: "Bank Teller" },
            { value: "Barber", text: "Barber" },
            { value: "Bartender", text: "Bartender" },
            { value: "Bellhop", text: "Bellhop" },
            { value: "Bench Carpenter", text: "Bench Carpenter" },
            { value: "Billing Clerk", text: "Billing Clerk" },
            { value: "Biological Technician", text: "Biological Technician" },
            { value: "Boilermaker", text: "Boilermaker" },
            { value: "Bookbinder", text: "Bookbinder" },
            { value: "Bookkeeper ", text: "Bookkeeper " },
            { value: "Brazer", text: "Brazer" },
            { value: "Brick Mason", text: "Brick Mason" },
            { value: "Bridge Tender", text: "Bridge Tender" },
            { value: "Broadcast Equip Oper.", text: "Broadcast Equip Oper." },
            { value: "Buffer", text: "Buffer" },
            { value: "Bus Driver", text: "Bus Driver" },
            { value: "Business Agent", text: "Business Agent" },
            { value: "Butcher", text: "Butcher" },
            { value: "Butler", text: "Butler" },
            { value: "Buyer", text: "Buyer" },
            { value: "Cabinetmaker ", text: "Cabinetmaker " },
            { value: "Calibrator", text: "Calibrator" },
            { value: "Camera Repairer ", text: "Camera Repairer " },
            { value: "Captain", text: "Captain" },
            { value: "Carpenter", text: "Carpenter" },
            { value: "Carpet Installer", text: "Carpet Installer" },
            { value: "Cashier", text: "Cashier" },
            { value: "Caster", text: "Caster" },
            { value: "Cementer", text: "Cementer" },
            { value: "Chairman", text: "Chairman" },
            { value: "Chauffeur", text: "Chauffeur" },
            { value: "Checker", text: "Checker" },
            { value: "Chef", text: "Chef" },
            { value: "Chemical Technician", text: "Chemical Technician" },
            { value: "Chemist", text: "Chemist" },
            { value: "Chief Executive Officer", text: "Chief Executive Officer" },
            { value: "Chief Financial Officer", text: "Chief Financial Officer" },
            { value: "Child", text: "Child" },
            { value: "Child Care Worker", text: "Child Care Worker" },
            { value: "Chiropractor", text: "Chiropractor" },
            { value: "Classified Ad Clerk", text: "Classified Ad Clerk" },
            { value: "Cleaner", text: "Cleaner" },
            { value: "Cleaning Machine Oper.", text: "Cleaning Machine Oper." },
            { value: "Clergy", text: "Clergy" },
            { value: "Clerk", text: "Clerk" },
            { value: "Clinical Laboratory Tech", text: "Clinical Laboratory Tech" },
            { value: "Commodity Trader", text: "Commodity Trader" },
            { value: "Communications Equip Oper.", text: "Communications Equip Oper." },
            { value: "Compacter", text: "Compacter" },
            { value: "Compliance Officer", text: "Compliance Officer" },
            { value: "Composer", text: "Composer" },
            { value: "Computer Operator", text: "Computer Operator" },
            { value: "Computer Programmer", text: "Computer Programmer" },
            { value: "Computer Scientist", text: "Computer Scientist" },
            { value: "Computer Systems Analyst", text: "Computer Systems Analyst" },
            { value: "Concrete Finisher", text: "Concrete Finisher" },
            { value: "Construction", text: "Construction" },
            { value: "Construction Inspector", text: "Construction Inspector" },
            { value: "Construction Laborer", text: "Construction Laborer" },
            { value: "Construction Trade", text: "Construction Trade" },
            { value: "Consultant", text: "Consultant" },
            { value: "Cook", text: "Cook" },
            { value: "Corrections Officer", text: "Corrections Officer" },
            { value: "Correspondence Clerk", text: "Correspondence Clerk" },
            { value: "Cosmetologist", text: "Cosmetologist" },
            { value: "Counselor, educational ", text: "Counselor, educational " },
            { value: "Counselor, vocational", text: "Counselor, vocational" },
            { value: "Crane Oper.", text: "Crane Oper." },
            { value: "Critic", text: "Critic" },
            { value: "Crossing Guard", text: "Crossing Guard" },
            { value: "Curator", text: "Curator" },
            { value: "Cutter", text: "Cutter" },
            { value: "Dancer", text: "Dancer" },
            { value: "Data Entry Keyer", text: "Data Entry Keyer" },
            { value: "Deckhand", text: "Deckhand" },
            { value: "Decorating Occupation", text: "Decorating Occupation" },
            { value: "Demonstrator, sales", text: "Demonstrator, sales" },
            { value: "Dental Assistant", text: "Dental Assistant" },
            { value: "Dental Hygienist", text: "Dental Hygienist" },
            { value: "Dental Laboratory Tech", text: "Dental Laboratory Tech" },
            { value: "Dentist", text: "Dentist" },
            { value: "Department", text: "Department" },
            { value: "Designer", text: "Designer" },
            { value: "Dietician", text: "Dietician" },
            { value: "Director", text: "Director" },
            { value: "Disabled", text: "Disabled" },
            { value: "Dishwasher", text: "Dishwasher" },
            { value: "Dispatcher", text: "Dispatcher" },
            { value: "Distributor", text: "Distributor" },
            { value: "Diver", text: "Diver" },
            { value: "Doctor", text: "Doctor" },
            { value: "Domestic", text: "Domestic" },
            { value: "Door-to-Door Sales", text: "Door-to-Door Sales" },
            { value: "Dozer Oper.", text: "Dozer Oper." },
            { value: "Drafting Occupation", text: "Drafting Occupation" },
            { value: "Dressmaker", text: "Dressmaker" },
            { value: "Driller", text: "Driller" },
            { value: "Driller, earth", text: "Driller, earth" },
            { value: "Driller, oil well", text: "Driller, oil well" },
            { value: "Driver", text: "Driver" },
            { value: "Dry-Cleaner", text: "Dry-Cleaner" },
            { value: "Drywall Installer", text: "Drywall Installer" },
            { value: "Economist", text: "Economist" },
            { value: "Editor", text: "Editor" },
            { value: "Electrical Power Installer", text: "Electrical Power Installer" },
            { value: "Electrical Power Repairer", text: "Electrical Power Repairer" },
            { value: "Electrical Tech", text: "Electrical Tech" },
            { value: "Electrician", text: "Electrician" },
            { value: "Electronic Repair", text: "Electronic Repair" },
            { value: "Elevator Installer", text: "Elevator Installer" },
            { value: "Elevator Operator", text: "Elevator Operator" },
            { value: "Elevator Repairer", text: "Elevator Repairer" },
            { value: "Eligibility Clerk, welfare", text: "Eligibility Clerk, welfare" },
            { value: "Embalmer", text: "Embalmer" },
            { value: "Emergency Rescue", text: "Emergency Rescue" },
            { value: "Engineer", text: "Engineer" },
            { value: "Engineer, aerospace", text: "Engineer, aerospace" },
            { value: "Engineer, agricultural", text: "Engineer, agricultural" },
            { value: "Engineer, chemical ", text: "Engineer, chemical " },
            { value: "Engineer, civil ", text: "Engineer, civil " },
            { value: "Engineer, electrical", text: "Engineer, electrical" },
            { value: "Engineer, industrial", text: "Engineer, industrial" },
            { value: "Engineer, marine ", text: "Engineer, marine " },
            { value: "Engineer, materials ", text: "Engineer, materials " },
            { value: "Engineer, mechanical", text: "Engineer, mechanical" },
            { value: "Engineer, mining", text: "Engineer, mining" },
            { value: "Engineer, nuclear", text: "Engineer, nuclear" },
            { value: "Engineer, operating ", text: "Engineer, operating " },
            { value: "Engineer, sales", text: "Engineer, sales" },
            { value: "Engineer, stationary", text: "Engineer, stationary" },
            { value: "Engineering Tech", text: "Engineering Tech" },
            { value: "Engineering Tech, industrial ", text: "Engineering Tech, industrial " },
            { value: "Engineering Tech, mech", text: "Engineering Tech, mech" },
            { value: "Engraver", text: "Engraver" },
            { value: "Equipment Cleaner", text: "Equipment Cleaner" },
            { value: "Examiner", text: "Examiner" },
            { value: "Expeditor", text: "Expeditor" },
            { value: "Family Child Care Provider", text: "Family Child Care Provider" },
            { value: "Farm Equipment Mechanic", text: "Farm Equipment Mechanic" },
            { value: "Farm Worker", text: "Farm Worker" },
            { value: "Farmer", text: "Farmer" },
            { value: "File Clerk", text: "File Clerk" },
            { value: "Filtering Machine Oper.", text: "Filtering Machine Oper." },
            { value: "Financial Manager", text: "Financial Manager" },
            { value: "Finisher", text: "Finisher" },
            { value: "Fire Prevention", text: "Fire Prevention" },
            { value: "Firefighting", text: "Firefighting" },
            { value: "Fisher", text: "Fisher" },
            { value: "Flight Attendant", text: "Flight Attendant" },
            { value: "Florist", text: "Florist" },
            { value: "Food Batch-Maker", text: "Food Batch-Maker" },
            { value: "Food Broker", text: "Food Broker" },
            { value: "Food Counter Occupation", text: "Food Counter Occupation" },
            { value: "Foreign Service Officer", text: "Foreign Service Officer" },
            { value: "Foreman", text: "Foreman" },
            { value: "Forestry", text: "Forestry" },
            { value: "Forger", text: "Forger" },
            { value: "Framer", text: "Framer" },
            { value: "Freight Handler", text: "Freight Handler" },
            { value: "Funeral Director", text: "Funeral Director" },
            { value: "Furnace or Kiln Oper.", text: "Furnace or Kiln Oper." },
            { value: "Gambler", text: "Gambler" },
            { value: "Garbage Collector", text: "Garbage Collector" },
            { value: "Gardener", text: "Gardener" },
            { value: "General Administrator", text: "General Administrator" },
            { value: "General Office Clerk", text: "General Office Clerk" },
            { value: "Geodesist", text: "Geodesist" },
            { value: "Geologist", text: "Geologist" },
            { value: "Glazier", text: "Glazier" },
            { value: "Grader", text: "Grader" },
            { value: "Grinder", text: "Grinder" },
            { value: "Grocer", text: "Grocer" },
            { value: "Groundskeeper", text: "Groundskeeper" },
            { value: "Guide", text: "Guide" },
            { value: "Hairdresser", text: "Hairdresser" },
            { value: "Hand Caster", text: "Hand Caster" },
            { value: "Hand Cutter", text: "Hand Cutter" },
            { value: "Hand Engraver", text: "Hand Engraver" },
            { value: "Hand Molder, not jeweler", text: "Hand Molder, not jeweler" },
            { value: "Hand Packer or Packager", text: "Hand Packer or Packager" },
            { value: "Hand Painter", text: "Hand Painter" },
            { value: "Hand Shaper, not jeweler", text: "Hand Shaper, not jeweler" },
            { value: "Handler", text: "Handler" },
            { value: "Hardware", text: "Hardware" },
            { value: "Health Aide, not nursing", text: "Health Aide, not nursing" },
            { value: "Health Record Technician", text: "Health Record Technician" },
            { value: "Health Technician", text: "Health Technician" },
            { value: "Heating or AC Mechanic", text: "Heating or AC Mechanic" },
            { value: "Heavy Equipment Mechanic", text: "Heavy Equipment Mechanic" },
            { value: "Heavy Equipment Operator", text: "Heavy Equipment Operator" },
            { value: "Helper", text: "Helper" },
            { value: "Hoist or Winch Oper.", text: "Hoist or Winch Oper." },
            { value: "Homemaker", text: "Homemaker" },
            { value: "Hotel", text: "Hotel" },
            { value: "Hotel Clerk", text: "Hotel Clerk" },
            { value: "Housekeeper", text: "Housekeeper" },
            { value: "Houseman", text: "Houseman" },
            { value: "Housewife", text: "Housewife" },
            { value: "Hunter ", text: "Hunter " },
            { value: "Importer", text: "Importer" },
            { value: "Industrial Machinery Repairer", text: "Industrial Machinery Repairer" },
            { value: "Industrial Tractor Oper.", text: "Industrial Tractor Oper." },
            { value: "Industrial Truck Oper.", text: "Industrial Truck Oper." },
            { value: "Information Clerk", text: "Information Clerk" },
            { value: "Inspector", text: "Inspector" },
            { value: "Installer", text: "Installer" },
            { value: "Insulation Worker", text: "Insulation Worker" },
            { value: "Insurance Adjustor ", text: "Insurance Adjustor " },
            { value: "Insurance Examiner", text: "Insurance Examiner" },
            { value: "Insurance Investigator", text: "Insurance Investigator" },
            { value: "Insurance Sales", text: "Insurance Sales" },
            { value: "Internal Revenue", text: "Internal Revenue" },
            { value: "Interviewer", text: "Interviewer" },
            { value: "Investigator", text: "Investigator" },
            { value: "Investor", text: "Investor" },
            { value: "Janitor", text: "Janitor" },
            { value: "Judge", text: "Judge" },
            { value: "Kitchen Worker", text: "Kitchen Worker" },
            { value: "Laboratory", text: "Laboratory" },
            { value: "Laborer", text: "Laborer" },
            { value: "Landscaper", text: "Landscaper" },
            { value: "Launderer or Ironer", text: "Launderer or Ironer" },
            { value: "Law Enforcement Officer", text: "Law Enforcement Officer" },
            { value: "Lawyer", text: "Lawyer" },
            { value: "Lay-out Worker", text: "Lay-out Worker" },
            { value: "Legal Assistant", text: "Legal Assistant" },
            { value: "Legislator", text: "Legislator" },
            { value: "Librarian", text: "Librarian" },
            { value: "Library Clerk", text: "Library Clerk" },
            { value: "Lighthouse Tender", text: "Lighthouse Tender" },
            { value: "Lithographer", text: "Lithographer" },
            { value: "Lock Tender", text: "Lock Tender" },
            { value: "Locksmith", text: "Locksmith" },
            { value: "Locomotive Oper.", text: "Locomotive Oper." },
            { value: "Longshoreman", text: "Longshoreman" },
            { value: "Lumber Industry", text: "Lumber Industry" },
            { value: "Machine Feeder", text: "Machine Feeder" },
            { value: "Machine Operator", text: "Machine Operator" },
            { value: "Machinery Maintainer", text: "Machinery Maintainer" },
            { value: "Machinist", text: "Machinist" },
            { value: "Machinist Apprentice", text: "Machinist Apprentice" },
            { value: "Maid", text: "Maid" },
            { value: "Mail Carrier", text: "Mail Carrier" },
            { value: "Mail Clerk", text: "Mail Clerk" },
            { value: "Mail Superintendent", text: "Mail Superintendent" },
            { value: "Maintenance", text: "Maintenance" },
            { value: "Management Analyst", text: "Management Analyst" },
            { value: "Management Occupation", text: "Management Occupation" },
            { value: "Manager, farm", text: "Manager, farm" },
            { value: "Manager, food service", text: "Manager, food service" },
            { value: "Manager, labor relations ", text: "Manager, labor relations " },
            { value: "Manager, lodging", text: "Manager, lodging" },
            { value: "Manager, marketing", text: "Manager, marketing" },
            { value: "Manager, medical", text: "Manager, medical" },
            { value: "Manager, public relations", text: "Manager, public relations" },
            { value: "Manager, purchasing", text: "Manager, purchasing" },
            { value: "Manager, real estate", text: "Manager, real estate" },
            { value: "Manager, service org.", text: "Manager, service org." },
            { value: "Manicurist", text: "Manicurist" },
            { value: "Manufacturer", text: "Manufacturer" },
            { value: "Marine or Naval Architect", text: "Marine or Naval Architect" },
            { value: "Mason", text: "Mason" },
            { value: "Mason Apprentice", text: "Mason Apprentice" },
            { value: "Material Distributing Clerk", text: "Material Distributing Clerk" },
            { value: "Material Handler", text: "Material Handler" },
            { value: "Measurer", text: "Measurer" },
            { value: "Meat Cutter", text: "Meat Cutter" },
            { value: "Mechanic", text: "Mechanic" },
            { value: "Mechanical Controls Repairer", text: "Mechanical Controls Repairer" },
            { value: "Medical Tech", text: "Medical Tech" },
            { value: "Merchant", text: "Merchant" },
            { value: "Messenger", text: "Messenger" },
            { value: "Metal Worker", text: "Metal Worker" },
            { value: "Meter Reader", text: "Meter Reader" },
            { value: "Millwright", text: "Millwright" },
            { value: "Mining - strip", text: "Mining - strip" },
            { value: "Mining - underground", text: "Mining - underground" },
            { value: "Misc. Electronics Repairer", text: "Misc. Electronics Repairer" },
            { value: "Misc. Fabric Worker", text: "Misc. Fabric Worker" },
            { value: "Misc. Food Prep Occupation", text: "Misc. Food Prep Occupation" },
            { value: "Misc. Hand Working", text: "Misc. Hand Working" },
            { value: "Misc. Machine Oper.", text: "Misc. Machine Oper." },
            { value: "Misc. Mechanic or Repairer", text: "Misc. Mechanic or Repairer" },
            { value: "Misc. Moving Equip Oper.", text: "Misc. Moving Equip Oper." },
            { value: "Misc. Plant Oper.", text: "Misc. Plant Oper." },
            { value: "Misc. Precision Metal Worker", text: "Misc. Precision Metal Worker" },
            { value: "Misc. Precision Woodworker", text: "Misc. Precision Woodworker" },
            { value: "Misc. Precision Worker", text: "Misc. Precision Worker" },
            { value: "Misc. Printing Machine Oper.", text: "Misc. Printing Machine Oper." },
            { value: "Misc. System Oper.", text: "Misc. System Oper." },
            { value: "Misc. Textile Machine Oper.", text: "Misc. Textile Machine Oper." },
            { value: "Misc. Woodworking", text: "Misc. Woodworking" },
            { value: "Mixer", text: "Mixer" },
            { value: "Model Maker, metal", text: "Model Maker, metal" },
            { value: "Model Maker, wood", text: "Model Maker, wood" },
            { value: "Model, sales", text: "Model, sales" },
            { value: "Molder", text: "Molder" },
            { value: "Motor Transport", text: "Motor Transport" },
            { value: "Movie Industry", text: "Movie Industry" },
            { value: "Musical Instrument Repairer", text: "Musical Instrument Repairer" },
            { value: "Musician", text: "Musician" },
            { value: "Nailer", text: "Nailer" },
            { value: "Navigator", text: "Navigator" },
            { value: "News Vendor", text: "News Vendor" },
            { value: "Not in list", text: "Not in list" },
            { value: "Numerical Control", text: "Numerical Control" },
            { value: "Nurse, LPN", text: "Nurse, LPN" },
            { value: "Nurse, RN", text: "Nurse, RN" },
            { value: "Nursery Worker", text: "Nursery Worker" },
            { value: "Nursing Aide", text: "Nursing Aide" },
            { value: "Occupational Therapist", text: "Occupational Therapist" },
            { value: "Office", text: "Office" },
            { value: "Office Assistant", text: "Office Assistant" },
            { value: "Office Manager", text: "Office Manager" },
            { value: "Officer", text: "Officer" },
            { value: "Oil Industry", text: "Oil Industry" },
            { value: "Operations Analyst", text: "Operations Analyst" },
            { value: "Operations Researcher", text: "Operations Researcher" },
            { value: "Operator", text: "Operator" },
            { value: "Ophthalmologist", text: "Ophthalmologist" },
            { value: "Optical Goods Worker", text: "Optical Goods Worker" },
            { value: "Optometrist", text: "Optometrist" },
            { value: "Order Clerk", text: "Order Clerk" },
            { value: "Orderly", text: "Orderly" },
            { value: "Owner", text: "Owner" },
            { value: "Packer", text: "Packer" },
            { value: "Painter", text: "Painter" },
            { value: "Paperhanger", text: "Paperhanger" },
            { value: "Paramedic", text: "Paramedic" },
            { value: "Parking Lot Attendant", text: "Parking Lot Attendant" },
            { value: "Pattern Maker, metal", text: "Pattern Maker, metal" },
            { value: "Pattern Maker, wood", text: "Pattern Maker, wood" },
            { value: "Patternmaker", text: "Patternmaker" },
            { value: "Paver", text: "Paver" },
            { value: "Payroll Clerk", text: "Payroll Clerk" },
            { value: "Peeler", text: "Peeler" },
            { value: "Performer", text: "Performer" },
            { value: "Personal Service Occupation", text: "Personal Service Occupation" },
            { value: "Personnel Clerk", text: "Personnel Clerk" },
            { value: "Pest Control", text: "Pest Control" },
            { value: "Pharmacist", text: "Pharmacist" },
            { value: "Photoengraver", text: "Photoengraver" },
            { value: "Photographer", text: "Photographer" },
            { value: "Photographic Processor", text: "Photographic Processor" },
            { value: "Physical Therapist", text: "Physical Therapist" },
            { value: "Physician", text: "Physician" },
            { value: "Physician Assistant", text: "Physician Assistant" },
            { value: "Physicist", text: "Physicist" },
            { value: "Pipe Fitter", text: "Pipe Fitter" },
            { value: "Pipefitter Apprentice", text: "Pipefitter Apprentice" },
            { value: "Planner", text: "Planner" },
            { value: "Plasterer", text: "Plasterer" },
            { value: "Plastic Processor", text: "Plastic Processor" },
            { value: "Plumber", text: "Plumber" },
            { value: "Plumber Apprentice", text: "Plumber Apprentice" },
            { value: "Podiatrist", text: "Podiatrist" },
            { value: "Police", text: "Police" },
            { value: "Polisher", text: "Polisher" },
            { value: "Porter", text: "Porter" },
            { value: "Postal Clerk", text: "Postal Clerk" },
            { value: "Postmaster", text: "Postmaster" },
            { value: "Power Plant", text: "Power Plant" },
            { value: "Power Tool Repairer", text: "Power Tool Repairer" },
            { value: "Precious Metals Worker", text: "Precious Metals Worker" },
            { value: "Precious Stones Worker", text: "Precious Stones Worker" },
            { value: "Precision Assembler", text: "Precision Assembler" },
            { value: "Precision Grinder or Filer ", text: "Precision Grinder or Filer " },
            { value: "President", text: "President" },
            { value: "Presser", text: "Presser" },
            { value: "Principal", text: "Principal" },
            { value: "Printer", text: "Printer" },
            { value: "Private Household Cleaner", text: "Private Household Cleaner" },
            { value: "Processor", text: "Processor" },
            { value: "Producer", text: "Producer" },
            { value: "Production Coordinator", text: "Production Coordinator" },
            { value: "Production Helper", text: "Production Helper" },
            { value: "Production Inspector", text: "Production Inspector" },
            { value: "Production Sampler", text: "Production Sampler" },
            { value: "Production Tester", text: "Production Tester" },
            { value: "Production Weigher", text: "Production Weigher" },
            { value: "Professor", text: "Professor" },
            { value: "Projectionist", text: "Projectionist" },
            { value: "Promoter, sales", text: "Promoter, sales" },
            { value: "Promotion Agent", text: "Promotion Agent" },
            { value: "Proofreader", text: "Proofreader" },
            { value: "Proprietor", text: "Proprietor" },
            { value: "Prospector", text: "Prospector" },
            { value: "Protective Service Worker", text: "Protective Service Worker" },
            { value: "Psychiatrist", text: "Psychiatrist" },
            { value: "Psychologist", text: "Psychologist" },
            { value: "Public Relations", text: "Public Relations" },
            { value: "Public Relations Specialist", text: "Public Relations Specialist" },
            { value: "Public Transport Attendant", text: "Public Transport Attendant" },
            { value: "Publisher", text: "Publisher" },
            { value: "Purchasing Agent", text: "Purchasing Agent" },
            { value: "Purchasing Agent, farm", text: "Purchasing Agent, farm" },
            { value: "Pyrotechnist", text: "Pyrotechnist" },
            { value: "Race Car Driver", text: "Race Car Driver" },
            { value: "Radio Logic Technician", text: "Radio Logic Technician" },
            { value: "Radiology Technician", text: "Radiology Technician" },
            { value: "Raftsman", text: "Raftsman" },
            { value: "Rail Vehicle Oper.", text: "Rail Vehicle Oper." },
            { value: "Railroad Brakeman", text: "Railroad Brakeman" },
            { value: "Railroad Conductor", text: "Railroad Conductor" },
            { value: "Railroad Signalman", text: "Railroad Signalman" },
            { value: "Railroad Switchman", text: "Railroad Switchman" },
            { value: "Railroad Yardmaster", text: "Railroad Yardmaster" },
            { value: "Rancher", text: "Rancher" },
            { value: "Real Estate", text: "Real Estate" },
            { value: "Receptionist", text: "Receptionist" },
            { value: "Records Clerk", text: "Records Clerk" },
            { value: "Recreation Worker", text: "Recreation Worker" },
            { value: "Refrigeration Mechanic", text: "Refrigeration Mechanic" },
            { value: "Registrar", text: "Registrar" },
            { value: "Repairman", text: "Repairman" },
            { value: "Reporter", text: "Reporter" },
            { value: "Representative", text: "Representative" },
            { value: "Respiratory Therapist", text: "Respiratory Therapist" },
            { value: "Restaurant", text: "Restaurant" },
            { value: "Retired", text: "Retired" },
            { value: "Roasting Machine Oper.", text: "Roasting Machine Oper." },
            { value: "Rolling machine Oper.", text: "Rolling machine Oper." },
            { value: "Roofer", text: "Roofer" },
            { value: "Safe Repairer", text: "Safe Repairer" },
            { value: "Sailor", text: "Sailor" },
            { value: "Sales", text: "Sales" },
            { value: "Sales Counter Clerk", text: "Sales Counter Clerk" },
            { value: "Sales Occupation, other", text: "Sales Occupation, other" },
            { value: "Sales Rep", text: "Sales Rep" },
            { value: "Sales Rep, manufacturing ", text: "Sales Rep, manufacturing " },
            { value: "Sales Rep, mining", text: "Sales Rep, mining" },
            { value: "Sales Rep, wholesale", text: "Sales Rep, wholesale" },
            { value: "Sales Support", text: "Sales Support" },
            { value: "Sales Worker, appliances", text: "Sales Worker, appliances" },
            { value: "Sales Worker, boats", text: "Sales Worker, boats" },
            { value: "Sales Worker, commodities", text: "Sales Worker, commodities" },
            { value: "Sales Worker, furniture", text: "Sales Worker, furniture" },
            { value: "Sales Worker, hardware", text: "Sales Worker, hardware" },
            { value: "Sales Worker, parts", text: "Sales Worker, parts" },
            { value: "Sales Worker, shoes", text: "Sales Worker, shoes" },
            { value: "Sales Worker, vehicles", text: "Sales Worker, vehicles" },
            { value: "Sampler", text: "Sampler" },
            { value: "Sanitation", text: "Sanitation" },
            { value: "Science Technician", text: "Science Technician" },
            { value: "Scientist", text: "Scientist" },
            { value: "Scientist, agricultural", text: "Scientist, agricultural" },
            { value: "Scientist, atmospheric", text: "Scientist, atmospheric" },
            { value: "Scientist, biological or life ", text: "Scientist, biological or life " },
            { value: "Scientist, food", text: "Scientist, food" },
            { value: "Scientist, mapping", text: "Scientist, mapping" },
            { value: "Scientist, mathematical", text: "Scientist, mathematical" },
            { value: "Scientist, medical", text: "Scientist, medical" },
            { value: "Scientist, physical", text: "Scientist, physical" },
            { value: "Scientist, social", text: "Scientist, social" },
            { value: "Scientist, space", text: "Scientist, space" },
            { value: "Scientist, surveying", text: "Scientist, surveying" },
            { value: "Scraper", text: "Scraper" },
            { value: "Seamstress", text: "Seamstress" },
            { value: "Secretary", text: "Secretary" },
            { value: "Security Officer", text: "Security Officer" },
            { value: "Self Employed", text: "Self Employed" },
            { value: "Service Station Occupation", text: "Service Station Occupation" },
            { value: "Shaper", text: "Shaper" },
            { value: "Sheet Metal Worker", text: "Sheet Metal Worker" },
            { value: "Sheriff", text: "Sheriff" },
            { value: "Ship Officer", text: "Ship Officer" },
            { value: "Shipping or Receiving Clerk", text: "Shipping or Receiving Clerk" },
            { value: "Shoe Repairer", text: "Shoe Repairer" },
            { value: "Small Engine Repairer", text: "Small Engine Repairer" },
            { value: "Social Security", text: "Social Security" },
            { value: "Social Worker", text: "Social Worker" },
            { value: "Sociologist", text: "Sociologist" },
            { value: "Solderer", text: "Solderer" },
            { value: "Sorter", text: "Sorter" },
            { value: "Speech Therapist", text: "Speech Therapist" },
            { value: "Stationary Engine Mechanic", text: "Stationary Engine Mechanic" },
            { value: "Statistical Clerk", text: "Statistical Clerk" },
            { value: "Statistician", text: "Statistician" },
            { value: "Steamfitter", text: "Steamfitter" },
            { value: "Steamfitter Apprentice", text: "Steamfitter Apprentice" },
            { value: "Stenographer", text: "Stenographer" },
            { value: "Stevedore", text: "Stevedore" },
            { value: "Stock Clerk", text: "Stock Clerk" },
            { value: "Stock Handler", text: "Stock Handler" },
            { value: "Stockbroker", text: "Stockbroker" },
            { value: "Street Sales Worker", text: "Street Sales Worker" },
            { value: "Structural Metal Worker", text: "Structural Metal Worker" },
            { value: "Student", text: "Student" },
            { value: "Stuntman", text: "Stuntman" },
            { value: "Superintendent", text: "Superintendent" },
            { value: "Supervisor", text: "Supervisor" },
            { value: "Supervisor, agricultural ", text: "Supervisor, agricultural " },
            { value: "Supervisor, brick masons", text: "Supervisor, brick masons" },
            { value: "Supervisor, building services", text: "Supervisor, building services" },
            { value: "Supervisor, carpenters", text: "Supervisor, carpenters" },
            { value: "Supervisor, clerks", text: "Supervisor, clerks" },
            { value: "Supervisor, construction", text: "Supervisor, construction" },
            { value: "Supervisor, electricians ", text: "Supervisor, electricians " },
            { value: "Supervisor, equip cleaners", text: "Supervisor, equip cleaners" },
            { value: "Supervisor, extraction", text: "Supervisor, extraction" },
            { value: "Supervisor, farm workers", text: "Supervisor, farm workers" },
            { value: "Supervisor, financial records", text: "Supervisor, financial records" },
            { value: "Supervisor, fire prevention", text: "Supervisor, fire prevention" },
            { value: "Supervisor, firefighting", text: "Supervisor, firefighting" },
            { value: "Supervisor, food preparation", text: "Supervisor, food preparation" },
            { value: "Supervisor, food service", text: "Supervisor, food service" },
            { value: "Supervisor, forestry workers", text: "Supervisor, forestry workers" },
            { value: "Supervisor, guards", text: "Supervisor, guards" },
            { value: "Supervisor, laborers", text: "Supervisor, laborers" },
            { value: "Supervisor, logging workers", text: "Supervisor, logging workers" },
            { value: "Supervisor, material moving", text: "Supervisor, material moving" },
            { value: "Supervisor, mechanics", text: "Supervisor, mechanics" },
            { value: "Supervisor, motor vehicles", text: "Supervisor, motor vehicles" },
            { value: "Supervisor, personal service", text: "Supervisor, personal service" },
            { value: "Supervisor, pipe fitters", text: "Supervisor, pipe fitters" },
            { value: "Supervisor, plumbers", text: "Supervisor, plumbers" },
            { value: "Supervisor, police", text: "Supervisor, police" },
            { value: "Supervisor, production", text: "Supervisor, production" },
            { value: "Supervisor, sales", text: "Supervisor, sales" },
            { value: "Supervisor, sales, salaried", text: "Supervisor, sales, salaried" },
            { value: "Supervisor, stonemasons", text: "Supervisor, stonemasons" },
            { value: "Supervisor, tile setters", text: "Supervisor, tile setters" },
            { value: "Surgeon", text: "Surgeon" },
            { value: "Surveying or Mapping Tech", text: "Surveying or Mapping Tech" },
            { value: "Surveyor", text: "Surveyor" },
            { value: "Swat Team", text: "Swat Team" },
            { value: "Systems Analyst", text: "Systems Analyst" },
            { value: "Systems Researcher", text: "Systems Researcher" },
            { value: "Tacker", text: "Tacker" },
            { value: "Tailor", text: "Tailor" },
            { value: "Taxicab Driver ", text: "Taxicab Driver " },
            { value: "Teacher", text: "Teacher" },
            { value: "Teacher's Aide", text: "Teacher's Aide" },
            { value: "Teacher, agricultural", text: "Teacher, agricultural" },
            { value: "Teacher, art", text: "Teacher, art" },
            { value: "Teacher, biological science ", text: "Teacher, biological science " },
            { value: "Teacher, business", text: "Teacher, business" },
            { value: "Teacher, chemistry", text: "Teacher, chemistry" },
            { value: "Teacher, computer science ", text: "Teacher, computer science " },
            { value: "Teacher, drama", text: "Teacher, drama" },
            { value: "Teacher, earth science", text: "Teacher, earth science" },
            { value: "Teacher, economics", text: "Teacher, economics" },
            { value: "Teacher, elementary school", text: "Teacher, elementary school" },
            { value: "Teacher, engineering", text: "Teacher, engineering" },
            { value: "Teacher, english", text: "Teacher, english" },
            { value: "Teacher, enviro science", text: "Teacher, enviro science" },
            { value: "Teacher, foreign language", text: "Teacher, foreign language" },
            { value: "Teacher, forestry ", text: "Teacher, forestry " },
            { value: "Teacher, health specialty", text: "Teacher, health specialty" },
            { value: "Teacher, history", text: "Teacher, history" },
            { value: "Teacher, home economics", text: "Teacher, home economics" },
            { value: "Teacher, law ", text: "Teacher, law " },
            { value: "Teacher, marine science", text: "Teacher, marine science" },
            { value: "Teacher, marketing ", text: "Teacher, marketing " },
            { value: "Teacher, math", text: "Teacher, math" },
            { value: "Teacher, medical science", text: "Teacher, medical science" },
            { value: "Teacher, music ", text: "Teacher, music " },
            { value: "Teacher, natural science", text: "Teacher, natural science" },
            { value: "Teacher, physical education", text: "Teacher, physical education" },
            { value: "Teacher, physics", text: "Teacher, physics" },
            { value: "Teacher, political science", text: "Teacher, political science" },
            { value: "Teacher, post secondary", text: "Teacher, post secondary" },
            { value: "Teacher, pre-K and K", text: "Teacher, pre-K and K" },
            { value: "Teacher, psychology", text: "Teacher, psychology" },
            { value: "Teacher, science", text: "Teacher, science" },
            { value: "Teacher, secondary school", text: "Teacher, secondary school" },
            { value: "Teacher, social science", text: "Teacher, social science" },
            { value: "Teacher, social work", text: "Teacher, social work" },
            { value: "Teacher, sociology", text: "Teacher, sociology" },
            { value: "Teacher, special education", text: "Teacher, special education" },
            { value: "Teacher, theology", text: "Teacher, theology" },
            { value: "Teacher, trade or industrial", text: "Teacher, trade or industrial" },
            { value: "Technical Writer", text: "Technical Writer" },
            { value: "Technician", text: "Technician" },
            { value: "Telephone Installer", text: "Telephone Installer" },
            { value: "Telephone Line Installer", text: "Telephone Line Installer" },
            { value: "Telephone Line Repairer", text: "Telephone Line Repairer" },
            { value: "Telephone Repairer", text: "Telephone Repairer" },
            { value: "Terrazzo Finisher", text: "Terrazzo Finisher" },
            { value: "Textiles", text: "Textiles" },
            { value: "Therapist", text: "Therapist" },
            { value: "Ticket Agent", text: "Ticket Agent" },
            { value: "Tile Setter", text: "Tile Setter" },
            { value: "Tiller", text: "Tiller" },
            { value: "Timekeeper", text: "Timekeeper" },
            { value: "Tool or Die Maker", text: "Tool or Die Maker" },
            { value: "Tool Programmer", text: "Tool Programmer" },
            { value: "Tool Sharpener", text: "Tool Sharpener" },
            { value: "Trainer", text: "Trainer" },
            { value: "Trapper", text: "Trapper" },
            { value: "Traveler", text: "Traveler" },
            { value: "Treasurer", text: "Treasurer" },
            { value: "Trimmer", text: "Trimmer" },
            { value: "Truck Driver", text: "Truck Driver" },
            { value: "Truck Mechanic", text: "Truck Mechanic" },
            { value: "Typesetter", text: "Typesetter" },
            { value: "Typist", text: "Typist" },
            { value: "Underwriter", text: "Underwriter" },
            { value: "Unemployed", text: "Unemployed" },
            { value: "Upholsterer", text: "Upholsterer" },
            { value: "Urban Planner", text: "Urban Planner" },
            { value: "US Air Force", text: "US Air Force" },
            { value: "US Army", text: "US Army" },
            { value: "US Coast Guard", text: "US Coast Guard" },
            { value: "US Marine Corp", text: "US Marine Corp" },
            { value: "US National Guard", text: "US National Guard" },
            { value: "US Navy", text: "US Navy" },
            { value: "Usher", text: "Usher" },
            { value: "Utilityman", text: "Utilityman" },
            { value: "Valve Repairer", text: "Valve Repairer" },
            { value: "Vehicle Washer ", text: "Vehicle Washer " },
            { value: "Veterinarian (Large Animals)", text: "Veterinarian (Large Animals)" },
            { value: "Veterinarian (Small Animals)", text: "Veterinarian (Small Animals)" },
            { value: "Vice President", text: "Vice President" },
            { value: "Waiter or Waitress", text: "Waiter or Waitress" },
            { value: "Watch Repairer", text: "Watch Repairer" },
            { value: "Water Treatment Plant", text: "Water Treatment Plant" },
            { value: "Weapons Expert", text: "Weapons Expert" },
            { value: "Weaver", text: "Weaver" },
            { value: "Weigher", text: "Weigher" },
            { value: "Welder", text: "Welder" },
            { value: "Welfare Service Aide", text: "Welfare Service Aide" },
            { value: "Wood Finisher", text: "Wood Finisher" },
            { value: "Woodchopper", text: "Woodchopper" },
            { value: "Writer", text: "Writer" },

        ];
    },

    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER
    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER
    //  NEED TO GET DYNAMIC LIST FORM CLIENT MANAGER


    CREDIT_CARD_YEAR_LIST: function () {
        var list = [];
        var currentYear = new Date().getFullYear();

        for (var index = 0; index < 10; index++) {
            var year = currentYear + index;
            list.push({ value: year, text: year });
        }
        return list;
    },

    SCHEDULE_A_CALL_TIME_LIST: function () {

        var list = [];

        for (var h = 9; h < 17; h++) {
            for (var m = 0; m < 60; m += 15) {
                var displayHour = h;
                var ampm = "AM";
                if (h >= 12) {
                    if (h > 12) {
                        displayHour -= 12;
                    }
                    ampm = "PM";
                }

                var valTime = h + ":" + m;
                var displayTime = displayHour + ":" + (m == 0 ? "00" : m) + " " + ampm;

                list.push({ value: valTime, text: displayTime });

            }
        }

        return list;

    },

    //SCHEDULE_A_CALL_DATE_LIST: function () {
    //    var list = [];
    //    var monthNames = [
    //        "January", "February", "March",
    //        "April", "May", "June", "July",
    //        "August", "September", "October",
    //        "November", "December"
    //    ];
    //    var currentDate = new Date();
    //    var now = new Date();
    //    now.setDate(now.getDate() + 5);
    //    for (var currentDate; currentDate <= now; currentDate.setDate(currentDate.getDate() + 1)) {
    //        var formattedDate = currentDate.getDate() + "," + monthNames[currentDate.getMonth()];
    //        list.push({ value: currentDate.toLocaleDateString(), text: formattedDate });
    //    }
    //    return list;
    //},

    QUOTE_CARRIER_LOGO_LIST: function () {
        return [
            {
                companyId: 27,
                imageName: 'american_general_logo.png'
            },
            {
                companyId: 29,
                imageName: 'us_life.png'
            },
            {
                companyId: 19,
                imageName: 'bannerlife_logo.png'
            },
            {
                companyId: 49,
                imageName: 'william_penn.png'
            },
            {
                companyId: 38,
                imageName: 'prudential_logo.png'
            },
            {
                companyId: 39,
                imageName: 'prudential_logo.png'
            },
            {
                companyId: 14,//TA NY
                imageName: 'TFLIC-logo.png'
            },
            {
                companyId: 15,//TA
                imageName: 'transamerica_logo.png'
            },
            {
                companyId: 11,//Mutual of Omaha
                imageName: 'moo_logo.png'
            },
            {
                companyId: 58,//NUFIC
                imageName: 'american_general_logo.png'
            }
        ];
    },

    QUOTE_CARRIER_RATECLASS_LIST: function () {
        return [
            {
                companyId: 27,//AIG
                rateClass: [
                    {
                        shortRateClass: 'Pref Plus',
                        fullRateClass: 'Preferred Plus'
                    },
                    {
                        shortRateClass: 'Preferred',
                        fullRateClass: 'Preferred Non-tobacco'
                    },
                    {
                        shortRateClass: 'Stan Plus',
                        fullRateClass: 'Standard Plus'
                    },
                    {
                        shortRateClass: 'Standard',
                        fullRateClass: 'Standard Non-tobacco'
                    },
                    {
                        shortRateClass: 'Pref / Tbco',
                        fullRateClass: 'Preferred Tobacco'
                    },
                    {
                        shortRateClass: 'Stan / Tbco',
                        fullRateClass: 'Standard Tobacco'
                    },
                ]

            },
            {
                companyId: 29,//AIG NY
                rateClass: [
                    {
                        shortRateClass: 'Pref Plus',
                        fullRateClass: 'Preferred Plus'
                    },
                    {
                        shortRateClass: 'Preferred',
                        fullRateClass: 'Preferred Non-tobacco'
                    },
                    {
                        shortRateClass: 'Stan Plus',
                        fullRateClass: 'Standard Plus'
                    },
                    {
                        shortRateClass: 'Standard',
                        fullRateClass: 'Standard Non-tobacco'
                    },
                    {
                        shortRateClass: 'Pref / Tbco',
                        fullRateClass: 'Preferred Tobacco'
                    },
                    {
                        shortRateClass: 'Stan / Tbco',
                        fullRateClass: 'Standard Tobacco'
                    },
                ]
            },
            {
                companyId: 19,// Banner (Legal)
                rateClass: [
                    {
                        shortRateClass: 'Pref Plus',
                        fullRateClass: 'Preferred Plus Non-Tobacco'
                    },
                    {
                        shortRateClass: 'Preferred',
                        fullRateClass: 'Preferred Non-Tobacco'
                    },
                    {
                        shortRateClass: 'Stan Plus',
                        fullRateClass: 'Standard Plus Non-Tobacco'
                    },
                    {
                        shortRateClass: 'Standard',
                        fullRateClass: 'Standard Non-Tobacco'
                    },
                    {
                        shortRateClass: 'Pref / Tbco',
                        fullRateClass: 'Preferred Tobacco'
                    },
                    {
                        shortRateClass: 'Stan / Tbco',
                        fullRateClass: 'Standard Tobacco'
                    },
                ]
            },
            {
                companyId: 49,// William Penn
                rateClass: [
                    {
                        shortRateClass: 'Pref Plus',
                        fullRateClass: 'Preferred Plus Non-Tobacco'
                    },
                    {
                        shortRateClass: 'Preferred',
                        fullRateClass: 'Preferred Non-Tobacco'
                    },
                    {
                        shortRateClass: 'Stan Plus',
                        fullRateClass: 'Standard Plus Non-Tobacco'
                    },
                    {
                        shortRateClass: 'Standard',
                        fullRateClass: 'Standard Non-Tobacco'
                    },
                    {
                        shortRateClass: 'Pref / Tbco',
                        fullRateClass: 'Preferred Tobacco'
                    },
                    {
                        shortRateClass: 'Stan / Tbco',
                        fullRateClass: 'Standard Tobacco'
                    },
                ]
            },
            {
                companyId: 38,//PRU
                rateClass: [
                    {
                        shortRateClass: 'Pref Best',
                        fullRateClass: 'Preferred Best'
                    },
                    {
                        shortRateClass: 'Preferred',
                        fullRateClass: 'Preferred Non-Tobacco'
                    },
                    {
                        shortRateClass: 'Stan Plus',
                        fullRateClass: 'Non-Smoker Plus'
                    },
                    {
                        shortRateClass: 'Standard',
                        fullRateClass: 'Non-Smoker'
                    },
                    {
                        shortRateClass: 'Pref / Tbco',
                        fullRateClass: 'Preferred Smoker'
                    },
                    {
                        shortRateClass: 'Stan / Tbco',
                        fullRateClass: 'Smoker'
                    },
                ]
            },
            {
                companyId: 39,//PRU NY
                rateClass: [
                    {
                        shortRateClass: 'Pref Best',
                        fullRateClass: 'Preferred Best'
                    },
                    {
                        shortRateClass: 'Preferred',
                        fullRateClass: 'Preferred Non-Tobacco'
                    },
                    {
                        shortRateClass: 'Stan Plus',
                        fullRateClass: 'Non-Smoker Plus'
                    },
                    {
                        shortRateClass: 'Standard',
                        fullRateClass: 'Non-Smoker'
                    },
                    {
                        shortRateClass: 'Pref / Tbco',
                        fullRateClass: 'Preferred Smoker'
                    },
                    {
                        shortRateClass: 'Stan / Tbco',
                        fullRateClass: 'Smoker'
                    },
                ]
            },
            {
                companyId: 14,//TA NY
                rateClass: [
                    {
                        shortRateClass: 'Pref Plus',
                        fullRateClass: 'Preferred Plus'
                    },
                    {
                        shortRateClass: 'Preferred',
                        fullRateClass: 'Preferred Nonsmoker'
                    },
                    {
                        shortRateClass: 'Stan Plus',
                        fullRateClass: 'Standard Plus'
                    },
                    {
                        shortRateClass: 'Standard',
                        fullRateClass: 'Standard Nonsmoker'
                    },
                    {
                        shortRateClass: 'Pref / Tbco',
                        fullRateClass: 'Preferred Smoker'
                    },
                    {
                        shortRateClass: 'Stan / Tbco',
                        fullRateClass: 'Standard Smoker'
                    },
                ]
            },
            {
                companyId: 15,//TA
                rateClass: [
                    {
                        shortRateClass: 'Pref Plus',
                        fullRateClass: 'Preferred Plus'
                    },
                    {
                        shortRateClass: 'Preferred',
                        fullRateClass: 'Preferred Nonsmoker'
                    },
                    {
                        shortRateClass: 'Stan Plus',
                        fullRateClass: 'Standard Plus'
                    },
                    {
                        shortRateClass: 'Standard',
                        fullRateClass: 'Standard Nonsmoker'
                    },
                    {
                        shortRateClass: 'Pref / Tbco',
                        fullRateClass: 'Preferred Smoker'
                    },
                    {
                        shortRateClass: 'Stan / Tbco',
                        fullRateClass: 'Standard Smoker'
                    },
                ]
            }
        ];
    },

    QUOTE_CARRIER_DISCLAIMERID_LIST: function () {
        return [
            {
                companyId: 19,//Legal
                modalId: 'legalProductDisclosureModal'
            },
            {
                companyId: 49,//Legal NY
                modalId: 'legalNYProductDisclosureModal'
            },
            {
                companyId: 14,//TA NY
                modalId: 'taNYProductDisclosureModal'
            },
            {
                companyId: 15,//TA
                modalId: 'taProductDisclosureModal'
            }
        ];
    },

    PRODUCT_TYPE_TITLE_LIST: function () {
        return [
            {
                productType: 1,// Term Life Product
                productTitle: 'Term Life Insurance'
            },
            {
                productType: 19, // QOL Product
                productTitle: 'Quality of Life Insurance'
            }
        ];
    },

    CHILD_AGE_LIST: function () {
        var list = [];
        list.push({ value: '0', text: '< 1' });
        for (var age = 1; age <= 18; age++) {
            list.push({ value: age, text: age });
        }
        return list;
    }
}
/* harmony export (immutable) */ __webpack_exports__["a"] = Constants;


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "dev" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "dev" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (true) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if ("dev" !== 'production' && !config.async) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if ("dev" !== 'production' && customSetter) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if ("dev" !== 'production' &&
    (isUndef(target) || isPrimitive(target))
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "dev" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if ("dev" !== 'production' &&
    (isUndef(target) || isPrimitive(target))
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "dev" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (true) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "dev" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "dev" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (true) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "dev" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (true) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (true) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (true) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (true) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if ("dev" !== 'production' && warnMissing && !res) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    true
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if ("dev" !== 'production' && isObject(def)) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (true) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (true) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (true) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "dev" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (true) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (true) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (true) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if ("dev" !== 'production' && !isObject(bindObject)) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "dev" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "dev" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if ("dev" !== 'production' && key !== '' && key !== null) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (true) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (true) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "dev" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if ("dev" !== 'production' &&
    isDef(data) && isDef(data.key) && !isPrimitive(data.key)
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if ("dev" !== 'production' && isDef(data) && isDef(data.nativeOn)) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (true) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if ("dev" !== 'production' && vm.$options.renderError) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if ("dev" !== 'production' && Array.isArray(vnode)) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "dev" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 true
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (true) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (true) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if ("dev" !== 'production' && config.performance && mark) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (true) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (true) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (true) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if ("dev" !== 'production' && has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if ("dev" !== 'production' && !config.async) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  true
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "dev" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (true) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "dev" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (true) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "dev" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if ("dev" !== 'production' && getter == null) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (true) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if ("dev" !== 'production' &&
      sharedPropertyDefinition.set === noop) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (true) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (true) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if ("dev" !== 'production' && config.performance && mark) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (true) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if ("dev" !== 'production' && config.performance && mark) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if ("dev" !== 'production' &&
    !(this instanceof Vue)
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if ("dev" !== 'production' && name) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if ("dev" !== 'production' && type === 'component') {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (true) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "dev" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (true) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if ("dev" !== 'production' && data && data.pre) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (true) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (true) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (true) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (true) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if ("dev" !== 'production' &&
                typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if ("dev" !== 'production' &&
                typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (true) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    "dev" !== 'production' && warn &&
    modifiers.prevent && modifiers.passive
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (true) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (true) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (true) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if ("dev" !== 'production' && explicitEnterDuration != null) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if ("dev" !== 'production' && isDef(explicitLeaveDuration)) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "dev" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if ("dev" !== 'production' && children.length > 1) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if ("dev" !== 'production' &&
      mode && mode !== 'in-out' && mode !== 'out-in'
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (true) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        true
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if ("dev" !== 'production' &&
      "dev" !== 'test' &&
      config.productionTip !== false &&
      typeof console !== 'undefined'
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if ("dev" !== 'production' && staticClass) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (true) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if ("dev" !== 'production' && !stack.length && options.warn) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if ("dev" !== 'production' && options.outputSourceRange) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if ("dev" !== 'production' &&
          (i > pos || !tagName) &&
          options.warn
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (true) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (true) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (true) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "dev" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (true) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if ("dev" !== 'production' && options.outputSourceRange) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (true) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if ("dev" !== 'production' && options.outputSourceRange) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if ("dev" !== 'production' && options.outputSourceRange) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (true) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (true) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (true) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if ("dev" !== 'production' && children[i].text !== ' ') {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if ("dev" !== 'production' && slotScope) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if ("dev" !== 'production' && el.attrsMap['v-for']) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (true) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (true) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (true) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if ("dev" !== 'production' && el.key) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          "dev" !== 'production' &&
          value.trim().length === 0
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if ("dev" !== 'production' && name === 'model') {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (true) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      "dev" !== 'production' &&
      map[attrs[i].name] && !isIE && !isEdge
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if ("dev" !== 'production' && dir.modifiers) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "dev" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if ("dev" !== 'production' &&
    state.maybeComponent(el) &&
    el.tag !== 'slot' &&
    el.tag !== 'template' &&
    !el.key
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if ("dev" !== 'production' && (
    el.children.length !== 1 || ast.type !== 1
  )) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (true) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (true) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (true) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if ("dev" !== 'production' && options.outputSourceRange) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (true) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "dev" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if ("dev" !== 'production' && !template) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (true) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if ("dev" !== 'production' && config.performance && mark) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "dev" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if ("dev" !== 'production' && config.performance && mark) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(16), __webpack_require__(234).setImmediate))

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export arrayAll */
/* harmony export (immutable) */ __webpack_exports__["c"] = sanitizeUrl;
/* harmony export (immutable) */ __webpack_exports__["a"] = httpGet;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(1);
﻿

const Utility = {
    newGuid: function (hyphenate = false) {
        var hypen = hyphenate ? '-' : ''
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + hypen + s4() + hypen + s4() + hypen +
            s4() + hypen + s4() + s4() + s4();
    },

    assignKey(item) {
        //assign uniqueKey to group
        if (!item.key) {
            item.key = this.newGuid();
        }
    },

    merge(original, source) {
        if (!source) {
            return original;
        }
        //make target copy
        var target = Object.assign({}, original);
        //target = target || {};
        Object.keys(source).forEach(p => {
            if (typeof source[p] === "object" && !Array.isArray(source[p])) {
                target[p] = this.merge(target[p], source[p]);
            }
            else if (source[p] !== undefined && source[p] !== null) {
                target[p] = source[p]
            }
        });
        return target;
    },

    mergeLists(list1, list2, targetList, listItemKey = "key") {
        list1 = list1 || []
        list2 = list2 || []
        targetList = targetList || []
        if (targetList.length > 0) {
            targetList.splice(0, targetList.length)
        }
 
        //if the array item are object
        const itemKeys = []
        //add all source1 array item key
        list1.forEach((item) => {
            if (item[listItemKey] && itemKeys.indexOf(item[listItemKey]) < 0) {
                itemKeys.push(item[listItemKey])
            }
        })
        //add all source2 array item key
        list2.forEach((item) => {
            if (item[listItemKey] && itemKeys.indexOf(item[listItemKey]) < 0) {
                itemKeys.push(item[listItemKey])
            }
        })

        itemKeys.forEach(ckey => {
            const s1Item = list1.find(i => i[listItemKey] == ckey) || {}
            const s2Item = list2.find(i => i[listItemKey] == ckey) || {}
            const mergedItem = Object.assign({}, s1Item, s2Item)
            if (Object.keys(mergedItem).length > 0) {
                targetList.push(mergedItem)
            }
        })

        //if array item are not object but rather simple type
        if (itemKeys.length == 0) {
            targetList.push(...list1)
            targetList.push(...list2)
        }
        return targetList
    },

    deepMerge(source1, source2, arrayItemKey='key') {
        // Create a new object that combines the properties of both input objects
        const s1 = Object.assign({}, source1);
        const s2 = Object.assign({}, source2);;
        const merged = Object.assign({}, s1, s2);
        // Loop through the properties of the merged object
        for (const key of Object.keys(merged)) {
            if (Array.isArray(merged[key])) {
                const s1l = [...(s1[key] || [])]
                const s2l = [...(s2[key] || [])]
                //if any of the list is empty there is noting to merge
                if ((s1l.length == 0 || s2l.length == 0)) {
                    const mergedList = merged[key];
                    if (mergedList.length > 0) {
                        mergedList.splice(0, mergedList.length)
                    }
                    const lisItems = this.mergeLists(s1l, s2l, [], arrayItemKey)
                    mergedList.push(...lisItems)
                }
            }
            // Check if the property is an object
            else if (typeof merged[key] === 'object' && merged[key] !== null) {
                // If the property is an object, recursively merge the objects
                merged[key] = this.deepMerge(s1[key], s2[key], arrayItemKey);
            }
        }
        return merged;
    },

    formatCurrency: function (amount, n, x, currencySymbol) {
        amount = (amount + '').replaceAll(',', '').replaceAll('$', '');
        amount = Number(amount);
        var re = '(\\d)(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\.' : '$') + ')';
        if (typeof currencySymbol === 'undefined') {
            currencySymbol = true;
        }
        return (currencySymbol ? "$" : '') + amount.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, 'g'), '$1,');
    },

    addYearToDate: function (date, year) {

        var minDateString = (date.getMonth() + 1) + '/' + date.getDate() + '/' + parseInt(date.getFullYear() + year);
        return new Date(minDateString);
    },

    getLeafRoute(path) {
        var routes = [];
        var leafRoute = '';

        if (path) {
            routes = path.split('/');

            routes = routes.filter(function (item) {
                return item != null && item != '';
            });

            leafRoute = routes.length > 0 ? routes[routes.length - 1] : '';
        }
        return leafRoute;
    },
    getRootRoute(router) {
        var routes = [];
        var rootRoute = '';

        if (router && router.currentRoute) {
            routes = router.currentRoute.path.split('/');

            routes = routes.filter(function (item) {
                return item != null && item != '';
            });

            //if (routes && routes.length > 1) {
            //    rootRoute = routes[1];
            //}
            //else if (routes && routes.length > 0) {
            //    rootRoute = routes[0];
            //}
        }
        return routes;
    },
    isValidDate(dateString, seperator) {
        var tdate = Date.parse(dateString, seperator);

        if (isNaN(tdate)) {
            return false;
        }
        var comp = dateString.split(seperator);
        if (comp.length !== 3) {
            return false;
        }
        var m = parseInt(comp[0], 10);
        var d = parseInt(comp[1], 10);
        var y = parseInt(comp[2], 10);
        var date = new Date(y, m - 1, d);
        return (date.getFullYear() == y && date.getMonth() + 1 == m && date.getDate() == d);
    },
    getDateRangeNew(dateRange) {
        if (dateRange) {
            var ranges = dateRange.split('|');
            if (ranges && ranges.length === 2) {

                var value = ranges[1].trim();
                var maxDayOffset = 0;
                var maxMonthOffset = 0;
                var maxYearOffset = 0;

                //check for max range day/year
                var maxLastCharacter = (value.substr(value.length - 1) || '').toLowerCase();
                if (maxLastCharacter === 'd') {
                    maxDayOffset = value.substr(0, value.length - 1); //get all char but last
                    maxDayOffset = parseInt(maxDayOffset);
                }
                else if (maxLastCharacter === 'm') {
                    maxMonthOffset = value.substr(0, value.length - 1); //get all char but last
                    maxMonthOffset = parseInt(maxMonthOffset);
                }
                else if (maxLastCharacter === 'y') {
                    maxYearOffset = value.substr(0, value.length - 1); //get all char but last
                    maxYearOffset = parseInt(maxYearOffset);
                }
                else {
                    maxYearOffset = parseInt(ranges[1]);
                }


                value = ranges[0].trim();
                var minDayOffset = 0;
                var minMonthOffset = 0;
                var minYearOffset = 0;

                //check for max range day/year
                var minLastCharacter = (value.substr(value.length - 1) || '').toLowerCase();
                if (minLastCharacter === 'd') {
                    minDayOffset = value.substr(0, value.length - 1); //get all char but last
                    minDayOffset = parseInt(minDayOffset);
                }
                else if (minLastCharacter === 'm') {
                    minMonthOffset = value.substr(0, value.length - 1); //get all char but last
                    minMonthOffset = parseInt(minMonthOffset);
                }
                else if (minLastCharacter === 'y') {
                    minMonthOffset = value.substr(0, value.length - 1); //get all char but last
                    minMonthOffset = parseInt(minMonthOffset);
                }
                else {
                    minYearOffset = parseInt(ranges[0]);
                }

                // Calculate minimum and maximum dates for the birthdate field
                var today = new Date();
                let maxDate = new Date(today.getFullYear() + maxYearOffset, today.getMonth() + maxMonthOffset, today.getDate() + maxDayOffset);
                let minDate = new Date(today.getFullYear() + minYearOffset, today.getMonth() + minMonthOffset, today.getDate() + minDayOffset);

                return {
                    maxDate: maxDate,
                    minDate: minDate
                };
            }
        }
        return { minDate: null, maxDate: null };
    },
    getDateRange(dateYearRange) {

        if (dateYearRange) {
            var ranges = dateYearRange.split('|');
            if (ranges && ranges.length == 2) {

                var value = ranges[1];
                var maxDayValue = 0;
                var maxMonthValue = 0;
                var birthdateMaxYear = 0;

                //check for max range day/year
                var maxLastCharacter = (value.substr(value.length - 1) || '').toLowerCase();
                if (maxLastCharacter == 'd') {
                    maxDayValue = value.substr(0, value.length - 1); //get all char but last
                    maxDayValue = parseInt(maxDayValue);
                }
                else if (maxLastCharacter == 'm') {
                    maxMonthValue = value.substr(0, value.length - 1); //get all char but last
                    maxMonthValue = parseInt(maxMonthValue);
                }
                else {
                    birthdateMaxYear = parseInt(ranges[1]);
                }


                value = ranges[0];
                var minDayValue = 0;
                var minMonthValue = 0;
                var birthdateMinYear = 0;

                //check for max range day/year
                var minLastCharacter = (value.substr(value.length - 1) || '').toLowerCase();
                if (minLastCharacter == 'd') {
                    minDayValue = value.substr(0, value.length - 1); //get all char but last
                    minDayValue = parseInt(minDayValue);
                }
                else if (minLastCharacter == 'm') {
                    minMonthValue = value.substr(0, value.length - 1); //get all char but last
                    minMonthValue = parseInt(minMonthValue);
                }
                else {
                    birthdateMinYear = parseInt(ranges[0]);
                }


                // Calculate minimum and maximum dates for the birthdate field
                var today = new Date();

                var daysInMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();

                var maxMonthSeed = 1;
                var maxDaySeed = 0;
                if ((today.getDate() + maxDayValue) > daysInMonth) {
                    maxDaySeed = ((today.getDate() + maxDayValue) - daysInMonth);
                    maxMonthSeed++;
                } else {
                    maxDaySeed = ((today.getDate() + maxDayValue));
                }

                var minMonthSeed = 1;
                var minDaySeed = 0;
                if ((today.getDate() + minDayValue) > daysInMonth) {
                    minDaySeed = ((today.getDate() + minDayValue) - daysInMonth);
                    minMonthSeed++;
                } else {
                    minDaySeed = ((today.getDate() + minDayValue));
                }

                var maxYearSeed = 0;
                var minYearSeed = 0;

                var calcMinMonth = (today.getMonth() + minMonthSeed + minMonthValue);
                if (calcMinMonth > 12) {
                    minYearSeed++;
                    calcMinMonth -= 12;
                }

                var calcMaxMonth = (today.getMonth() + maxMonthSeed + maxMonthValue);
                if (calcMaxMonth > 12) {
                    maxYearSeed++;
                    calcMaxMonth -= 12;
                }

                var minDateString = calcMinMonth + '/' + minDaySeed + '/' + parseInt(today.getFullYear() + birthdateMinYear + minYearSeed);
                var minDate = new Date(minDateString);

                var maxDateString = calcMaxMonth + '/' + maxDaySeed + '/' + parseInt(today.getFullYear() + birthdateMaxYear + maxYearSeed);
                var maxDate = new Date(maxDateString);

                return {
                    maxDate: maxDate,
                    minDate: minDate
                };
            }
        }
        return { minDate: null, maxDate: null };
    },
    getAddPlanType(addSpouse, addChildren) {

        var selectedPlan = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* Constants */].ADD_PLAN_TYPE.Individual;
        if (addSpouse == __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* Constants */].YES_NO_OPTION.YES
            && addChildren == __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* Constants */].YES_NO_OPTION.YES) {
            selectedPlan = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* Constants */].ADD_PLAN_TYPE.Family;
        }
        else if (addSpouse == __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* Constants */].YES_NO_OPTION.NO
            && addChildren == __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* Constants */].YES_NO_OPTION.YES) {
            selectedPlan = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* Constants */].ADD_PLAN_TYPE.Individual_Children;
        }
        else if (addSpouse == __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* Constants */].YES_NO_OPTION.YES
            && addChildren == __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* Constants */].YES_NO_OPTION.NO) {
            selectedPlan = __WEBPACK_IMPORTED_MODULE_0__Constants__["a" /* Constants */].ADD_PLAN_TYPE.Individual_Spouse;
        }
        return selectedPlan;
    },

    calculatePlanTypeValue(planString) {
        return (planString || '').split('_').join(' + ');
    },

    getRandomInt(max) {
        return Math.floor(Math.random() * Math.floor(max));
    },

    listItemContainPropertyValue(list, propertyName, value) {
        var retVal = false;
        if (list && list.length > 0 && propertyName && value) {
            for (var itemIndex = 0; itemIndex < list.length; itemIndex++) {
                var item = list[itemIndex];
                if (item[propertyName] === value) {
                    retVal = true;
                    break;
                }
            }
        }
        return retVal;
    },
    getHostName() {
        var hostName = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
        return hostName;
    },
    isLocalHost() {
        const isLocal = (location.hostname + '' || '').toLocaleLowerCase() === 'localhost';
        console.log('isLocalHost', isLocal);
        return isLocal;
    },
    getClientTimeZoneOffset() {
        var dt = new Date();
        var offset = dt.getTimezoneOffset();
        return offset;
    },
    getPlaceholders(template, placeholderMark = '#') {
        const regexPattern = RegExp(placeholderMark + '(\\w+\\d?(.)?\\w+\\d?)+' + placeholderMark, 'g');
        var placeholders = [];
        let list;
        while ((list = regexPattern.exec(template)) !== null) {
            if (list.length > 1) {
                placeholders.push(list[1]);
            }
        }
        return placeholders;
    },
    replacePlaceholders(template, data, placeholderCharacter = '#') {
        var result = template;
        data = data || {};
        var placeHolders = this.getPlaceholders(template, placeholderCharacter) || [];
        placeHolders.forEach(field => {
            const searchKey = placeholderCharacter + field + placeholderCharacter;
            const value = getDataFieldValue(data, field);
            result = result.replace(searchKey, value || '');
        })
        return result;
    },

    calculateAge(dob) {
        // birthday is a date
        var ageDiff = Date.now() - Date.parse(dob);
        var ageDate = new Date(ageDiff); // miliseconds from epoch
        var age = Math.abs(ageDate.getUTCFullYear() - 1970);
        return age;
    }
}
/* harmony export (immutable) */ __webpack_exports__["b"] = Utility;


function getDataFieldValue(data, field) {
    if (field && data) {
        const parts = field.split(".");
        let currentData = data;
        parts.forEach(part => {
            currentData = currentData ? currentData[part] : undefined;
        })
        return currentData || '';
    }
    return '';
}

const toLowerCase =
    function toLowerCase(value) {
        if (value) {
            return (value || '').toLowerCase();
        }
        else {
            return value;
        }
    };
/* unused harmony export toLowerCase */


function arrayAll(items, callback) {
    items = items || [];
    let result = false;
    if (!callback || !items || items.length === 0) {
        return result;
    }

    for (let index = 0; index < items.length; index++) {
        const value = callback(items[index], index, items);
        //if its first item result then take that else AND it with previous result;
        result = index === 0 ? value : result && value;
    }
    return result;
}

function sanitizeUrl(url) {
    return window.encodeURI(url);
}

function httpGet(url) {
    if (url) {
        window.location = sanitizeUrl(url);
    }
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_bind_js__ = __webpack_require__(52);




// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
}

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
}

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  const pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : global)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  }

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_bind_js__["a" /* default */])(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
}

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
}

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    if (reducer(descriptor, name, obj) !== false) {
      reducedDescriptors[name] = descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
}

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
}

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  }

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
}

const noop = () => {}

const toFiniteNumber = (value, defaultValue) => {
  value = +value;
  return Number.isFinite(value) ? value : defaultValue;
}

const ALPHA = 'abcdefghijklmnopqrstuvwxyz'

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
}

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0]
  }

  return str;
}

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  }

  return visit(obj, 0);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(16)))

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Application_services_HttpCommunicationService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Application_services_dialogService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(1);
﻿





const FormFieldComponentBaseMixin = {
    props: {
        //question data for rendering
        questionData: {
            type: Object,
            required: true
        },
        //databag containing saved data
        dataBag: {
            type: Object,
            required: true
        },
        //form state for validation
        state: {
            type: Object,
            required: true
        },
        fieldInteractionCallback: {
            type: Function,
            required: false
        },
        readMode: {
            type: Boolean,
            required: false,
            default: false
        },
        pageSchema: {
            type: Object,
            required: false
        }
    },
    data: function () {
        return {
            defaultFocusPlaceholder: '',
            placeholder: this.questionData.placeholder || this.questionData.text,
            focusPlaceholder: this.questionData.focusPlaceholder,
            saving: false,
            originalValue: '',
            defaultValue: '',
            fieldRef: null,
            readonly: this.questionData.readOnly || false,
            isFocused: false,
        }
    },
    destroyed() {
        if (this.dataBag && this.questionData.questionKey && !this.questionData.disableDestroyAction) {
            //console.log('destroyed-' + this.questionData.questionKey)
            this.$set(this.dataBag, this.questionData.questionKey, '')
        }
    },
    mounted() {
        //copy original value
        if (this.dataBag) {
            this.originalValue = this.dataBag[this.questionData.questionKey];
        }
        //set focus on field
        if (this.questionData && this.questionData.focus && !this.questionData.readonly) {
            console.log('setfocus', this.questionData)
            this.setFocus();
            //reset focus
            this.questionData.focus = false;
            this.isFocused = true;
        }

        const fieldRef = this.getFieldRef();
        if (this.questionData.tabIndex && fieldRef) {
            console.log('FormComponentBase=>setting tabindex');
            if (Array.isArray(fieldRef)) {
                fieldRef.forEach(fRef => { fRef.tabIndex = -1; });
            }
            else {
                fieldRef.tabIndex = -1;
            }
        }
        this.bindTooltip();
        this.notifyFieldLoaded();
        console.log('FormFieldComponentBaseMixin:Mounted', this.questionData);
        //trigger blur event for floating label;
        const self = this;
        window.setTimeout(() => {
            self.triggerFloatingLabelVisibility();
        }, 200);
    },
    watch: {
        readMode: function (newValue, oldValue) {
            console.log('FormFieldComponent:watch::readMode', { newValue, oldValue });
            //trigger for readMode/newValue = false
            if (!newValue) {
                const self = this;
                window.setTimeout(() => {
                    self.triggerFloatingLabelVisibility();
                }, 200);
            }
        }
    },
    methods: {
        enterKeyHandler() {
            if (this.questionData.enterKey) {
                this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].NAVIGATION_EVENTS.FIELD_ENTER_KEY,
                    this.questionData.questionKey);
            }
        },
        getFieldRef() {
            //console.log('FormFieldComponentBaseMixin=>getFieldRef');
        },
        bindTooltip() {
            this.$nextTick(function () {
                var tt = $('[data-toggle="tooltip"]');
                if (tt && tt.tooltip) {
                    tt.tooltip();
                }
            });
        },
        broadCastFieldValueChange(fieldData) {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].APPLICATION_EVENTS.FIELD_VALUE_CHANGE, fieldData);
        },
        broadCastAnswerChange(data) {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].APPLICATION_EVENTS.ANSWER_CHANGE, data);
        },
        isNotEmpty(value) {
            return value !== null && value !== undefined && value !== '';
        },
        isNotNullOrEmpty(value) {
            return value != '' && value != null && value != undefined;
        },
        isNullOrEmpty(value) {
            return value == '' || value == null || value == undefined;
        },
        triggerFloatingLabelVisibility(fRef) {
            const fieldRef = fRef || this.getFieldRef();
            if ($ && fieldRef && !this.isFocused) {
                //console.log('triggerFloatingLabelVisibility', this.questionData.questionKey);
                if (Array.isArray(fieldRef)) {
                    fieldRef.forEach(fRef => { $(fRef).trigger('blur') });
                }
                else {
                    $(fieldRef).trigger('blur');
                }
            }
        },
        touchField() {
            const self = this;
            this.focus();
            window.setTimeout(() => {
                self.triggerBlur();
            }, 100);
        },
        triggerBlur(fRef) {
            const fieldRef = fRef || this.getFieldRef();
            const hasBlur = fieldRef.blur;
            if (Array.isArray(fieldRef)) {
                fieldRef.forEach(fRef => {
                    if (fRef.blur) {
                        fRef.blur();
                    }
                    else {
                        $(fRef).trigger('blur')
                    }
                });
            }
            else if (hasBlur) {
                fieldRef.blur();
            }
            else if ($) {
                $(fieldRef).trigger('blur');
            }
        },
        focus() {
            const fieldRef = this.getFieldRef();
            console.log('focus', fieldRef)
            if (Array.isArray(fieldRef)) {
                //fieldRef.forEach(fRef => { fRef.focus(); });
                if (fieldRef.length > 0) { fieldRef[0].focus(); }
            }
            else if (fieldRef && fieldRef.focus) {
                fieldRef.focus();
            }
            else if ($) {
                console.log('setfocus', this.questionData.questionKey);
                var ele = $('#' + this.questionData.questionKey);
                ele.focus();
            }
        },
        initializeFieldView() {
            var fState = this.getFieldState();
            if (fState && fState.$valid) {
                //notify that field is need not be interacted as field already has value
                this.notifyFieldInteraction();
            }
        },
        notifyFieldLoaded() {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].FIELD_EVENTS.FIELD_LOADED, { id: this.questionData.questionKey });
        },
        saveFieldData(inputData) {
            const $this = this;
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
                var autoSave = true;
                if ($this.questionData.autoSave != undefined) {
                    autoSave = $this.questionData.autoSave;
                };
                //const saveRequired = (value != null && value != $this.dataBag[$this.questionData.questionKey]);

                if (autoSave == true && !$this.saving) {
                    $this.saving = true;
                    var data = inputData || {
                        [$this.questionData.questionKey]: $this.dataBag[$this.questionData.questionKey]
                    };

                    //check if validatable field
                    if ($this.fieldStateValid()) {
                        //save only if it is valid
                        __WEBPACK_IMPORTED_MODULE_1__Application_services_HttpCommunicationService__["a" /* default */].postFieldData(data);
                    }
                    $this.saving = false;
                }
                else {
                    console.log('not saving')
                }
            })
        },
        notifyFieldInteraction() {
            const $this = this;
            //call fieldInteractionCallback on next update
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
                //call field interaction callback handler passing field key
                var myState = $this.state[$this.questionData.questionKey];

                //if the field is validatable then check its valid
                if (myState) {
                    if ($this.fieldInteractionCallback && myState.$valid) {
                        $this.fieldInteractionCallback($this.questionData.questionKey);
                    }
                } //else just check for callback
                else {
                    if ($this.fieldInteractionCallback) {
                        $this.fieldInteractionCallback($this.questionData.questionKey);
                    }
                }
            })
        },
        applyBlurPlaceholder(fieldRef) {
            //restore placeholder to static placeholder text
            const fRef = fieldRef || this.getFieldRef();
            this.setFieldAttribute(fRef, 'placeholder', this.placeholder);
        },
        applyFocusPlaceholder(fieldRef) {
            //set focusPlaceholder
            const fRef = fieldRef || this.getFieldRef();
            var phText = this.focusPlaceholder || this.defaultFocusPlaceholder || this.placeholder;
            this.setFieldAttribute(fRef, 'placeholder', phText);
        },
        setFieldAttribute(fieldRef, attrName, attrValue) {
            if (attrName) {
                if (fieldRef && fieldRef.setAttribute) {
                    fieldRef.setAttribute(attrName, attrValue);
                }
                else {
                    var $ = window.jQuery || window.jquery;
                    $(fieldRef).attr(attrName, attrValue);
                }
            }
        },
        setFocus() {
            this.focus();
        },
        hasValueChanged() {
            var oldValue = this.originalValue;
            var newValue = this.dataBag[this.questionData.questionKey];

            //value changed if its not same as old and not same as default value
            var changed = (this.isNullOrEmpty(oldValue) && oldValue != newValue && newValue != '' && newValue != this.defaultValue)
                || (this.isNotNullOrEmpty(oldValue) && oldValue != newValue);

            return changed;
        },
        revertValueChange() {
            const $this = this;
            //individual component will do actual implementation
            console.log('FormFieldComponentBaseMixin=>revertValueChange');
            //reset value to old here
            let oldValue = this.originalValue;
            if (oldValue === undefined) {
                oldValue = this.defaultValue;
            }
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
                $this.dataBag[$this.questionData.questionKey] = oldValue;
                if ($this.processChange) {
                    $this.processChange();
                }
            });
        },
        alertValueChange(callbackFn) {
            var $this = this;
            //show alert popup to inform that quote may change
            var oldValue = this.originalValue;
            var newValue = this.dataBag[this.questionData.questionKey];

            //value changed if its not same as old and not same as default value
            var alert = this.hasValueChanged();

            var msg = this.questionData.alertMessage || __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */][this.questionData.alertMessageKey];

            const showChangeAlertOnNext = this.questionData.showChangeAlertOnNext;

            if (showChangeAlertOnNext) {
                //record changes and inform page
                const data = {
                    fieldKey: this.questionData.questionKey,
                    alertMessage: msg,
                    oldValue: oldValue,
                    newValue: newValue,
                    changed: alert,
                    valueRevertFn: this.revertValueChange
                };
                this.broadCastFieldValueChange(data);
            }

            if (alert && !showChangeAlertOnNext) {
                const message = msg + __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].REQUOTE_CONFIRMATION_MESSAGE;
                __WEBPACK_IMPORTED_MODULE_2__Application_services_dialogService__["a" /* default */].confirmAdvanced(message, function (result) {
                    //user want to continue with date change
                    if (result) {
                        if (callbackFn) {
                            callbackFn();
                        }
                    }
                    //when cancel, revert value to original
                    else {
                        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
                            $this.dataBag[$this.questionData.questionKey] = oldValue;
                            $this.saveFieldData();
                        });
                    }
                }, "Continue");
            }
            else if (callbackFn) {
                callbackFn();
            }
        },
        getModeClass() {
            return this.readMode ? 'read-mode' : '';
        }
    }
}
/* harmony export (immutable) */ __webpack_exports__["a"] = FormFieldComponentBaseMixin;


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(1);
﻿


const ViewValidationHelperMixin = {
    data: function () {
        return {
            //setup data properties
            submitCount: 0,
            validating:false,
        }
    },
    computed: {
        fieldStateTouched() {
            var myState = this.getFieldState();
            if (myState && myState.$touched) {
                this.increaseSubmitCount();
            }
            return myState ? myState.$touched : false;
        },
        submitTried() {

            var myState = this.getFieldState();
            return myState ? myState.$submitted && this.submitCount > 0 : false;
        }
    },
    created() {
        this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENTS.FORM_SUBMITTED, this.formSubmitted);
    },
    destroyed() {
        this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENTS.FORM_SUBMITTED, this.formSubmitted);
    },
    methods: {
        formSubmitted() {
            console.log("formSubmitted" + this.questionData.questionKey)
            this.increaseSubmitCount(1);
            var field = this.getFieldState();
            if (field) {
                this.$set(field, 'submitCount', this.submitCount);
            }
        },
        increaseSubmitCount() {
            this.submitCount += 1;
        },
        getAnyPattern() {
            return '.*'
        },
        getValidationMessage(key) {
            const validators = this.questionData.validators || {};
            return validators[key];
        },
        getValidatorValue(key) {
            var value = '';
            const validators = this.questionData.validators || {};
            var validatorData = validators[key];
            if (key == 'maxlength') {
                value = validatorData
                    && validatorData != ''
                    && validatorData > 0
                    ? validatorData : 999999;
            }
            else if (key == 'minlength') {
                value = validatorData
                    && validatorData != ''
                    && validatorData > 0
                    ? validatorData : 0;
            }
            else if (key === 'min') {
                value = validatorData && validatorData !== '' ? validatorData : -99999999999;
            }
            else if (key === 'max') {
                value = validatorData && validatorData !== '' ? validatorData : 99999999999;
            }
            else if (key == 'required') {
                console.log('validatorData', validatorData)
                value = (validatorData && validatorData != '' && (validatorData + '').toLowerCase() == 'true')
                    ? true : false;
            }
            else if (key == 'pattern') {
                value = validatorData
                    && validatorData != ''
                    ? validatorData : this.getAnyPattern();
            }
            else {
                value = validatorData;
            }
            return value;
        },
        _getFieldStates: function (fieldKeys) {
            var fStates = [];
            var $states = this.state;

            if ($states && fieldKeys && fieldKeys.length > 0) {
                fieldKeys.forEach(function (key) {
                    fStates.push($states[key]);
                })
            }
            return fStates;
        },
        getFieldState: function () {
            var key = this.questionData.questionKey
            if (this.isGroupValidator) {
                key = this.questionData.groupName
            }
            var states = this._getFieldStates([key]);
            const fState = (states && states.length > 0) ? states[0] : null;
            return fState;
        },
        fieldStateValid() {
            var valid = true;
            var myState = this.getFieldState();

            if (myState) {
                valid = myState.$valid;
            }
            return valid;
        },
        validateField() {
            var myState = this.getFieldState();
            if (myState) {
                myState._validate();
            }
        },
        getValidationClassName: function () {
            const field = this.getFieldState();
            //console.log("getValidationClassName called for " + this.questionData.questionKey, this.submitCount);
            var validForm = this.submitCount > 0;

            let className = '';
            if (!field) {
                className = '';
            }
            else if ((field.$touched || field.$submitted) && field.$valid) {
                className = 'has-success';
                this.showRequiredError = false;
            }
            else if ((field.$touched || field.$submitted) && validForm && field.$invalid) {
                className = 'has-danger shake';
                this.showRequiredError = true;
            }
            return className;
        },

        validateInputWithServer(input, type) {
            var promise = window.Promise;
            if (promise == undefined) {
                promise = __WEBPACK_IMPORTED_MODULE_0_es6_promise___default.a.Promise;
            }
            const self = this;
            const valService = this.$validationService;
            return new promise(function (resolve, reject) {
                //make call with httpService
                if (type == "phone") {
                    self.validating = true;
                    valService.validatePhone(input, function (data) {
                        self.validating = false;
                        resolve(data === true);
                    })
                }
                else if (type == "email") {
                    self.validating = true;
                    valService.validateEmail(input, function (data) {
                        self.validating = false;
                        resolve(data === true);
                    })
                }
            });
        },
    }
}
/* harmony export (immutable) */ __webpack_exports__["a"] = ViewValidationHelperMixin;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(36);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var $documentAll = __webpack_require__(61);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DynamicContentMixin__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ValidateOnNextMixin__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComponentInterfaceMixin__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Utilities_actionRunnerUtil__ = __webpack_require__(104);
﻿/*import httpService from './../services/HttpCommunicationService'*/








const ComponentBaseMixin = {
    mixins: [__WEBPACK_IMPORTED_MODULE_4__ComponentInterfaceMixin__["a" /* ComponentInterfaceMixin */], __WEBPACK_IMPORTED_MODULE_2__DynamicContentMixin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__ValidateOnNextMixin__["a" /* ValidateOnNextMixin */]],
    props: {
        dataKey: [String, Object],
        settings: {
            type: Object,
            required: false
        },
        questionGroupList: {
            type: Array,
            required: false,
            default: function () { return []; }
        },
        extra: {
            type: Object,
            required: false,
            default: function () { return {}; }
        },
        readMode: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function () {
        return {
            self: this,
            componentState: {},
            componentDataBag: {},
            componentKey: '',
            cancelCompleteFormMessage: __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].COMPLETE_CANCEL_FORM_MESSAGE,
            dataKeyObject: {
                dataKey: ''
            },
            normalized: false,
            dataKeyParsed: false,
            validateOnNext: false,
            defaultOptions: {
            },
            processingMessage: '',
            default_processingMessage: ''
        };
    },
    created() {
        console.log('ComponentBaseMixin:created');
        //this will parse dataKey content json/string
        this.ensureDateKeyNormalization();
        if (!this.componentKey) {
            this.componentKey = __WEBPACK_IMPORTED_MODULE_1__Shared_Utilities_Utility__["b" /* Utility */].newGuid();
        }
        this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.FORM_SUBMITTED, this.formSubmitted);
    },
    mounted() {
        console.log('ComponentBaseMixin:mounted');
        //bind component field events
        this.bindFieldListener();
        this.processingMessage = this.getMessage(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].PROCESSSING_MESSAGE_KEY) || this.default_processingMessage;
    },
    updated() {
        console.log('ComponentBaseMixin:updated');
        //bind component field events
        this.bindFieldListener();
    },
    destroyed() {
        console.log('ComponentBaseMixin:destroyed');

        this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.FORM_SUBMITTED, this.formSubmitted);

        var keys = Object.keys(this.componentDataBag);
        this.clearFormState(keys);
    },
    computed: {
        settingConfig() {
            return this.dataKeyObject || {};
        },
        internalDataKey() {
            return (this.dataKeyObject || {}).dataKey || this.dataKey;
        },

        pageMessages() {
            let messageDict = {};
            if (this.pageSchema) {
                (this.pageSchema.messages || [] || []).forEach(m => {
                    if (m.key) {
                        messageDict[m.key] = m.value;
                    }
                });
            }
            console.log('messages', messageDict);
            return messageDict;
        },
        componentErrorCount() {
            var errObj = this.componentState.$error;
            var count = 0;
            if (errObj) {
                Object.keys(errObj).forEach((key) => {
                    //exclude build-in properties begin with '$'
                    if (key && key.indexOf('$') == -1) {
                        //get error from error object by key
                        const error = errObj[key];
                        if (error && typeof error == 'object') {
                            //test condition & push to collection if condition is met
                            if (error.$touched) {
                                count++;
                            }
                        }
                    }
                })
            }
            return count;
        },
        isComponentStateValid() {
            return this.componentState.$valid;
        },
        extraProps() {
            const eProps = Object.assign({}, this.defaultOptions, this.extra);
            console.log('extraProps', eProps);
            return eProps;
        }
    },
    watch: {
        //componentDataBag() {
        //    //this.bindFieldListener();
        //}
    },
    methods: {
        getDataBagValue(key) {
            return this.dataBag ? this.dataBag[key] : '';
        },
        assignKey(items) {
            items = items || [];
            for (var itemIndex = 0; itemIndex < items.length; itemIndex++) {
                __WEBPACK_IMPORTED_MODULE_1__Shared_Utilities_Utility__["b" /* Utility */].assignKey(items[itemIndex]);
            }
            return items;
        },

        setGroupKey(grp, keyField = 'groupKey') {
            if (grp && !grp[keyField]) {
                grp[keyField] = __WEBPACK_IMPORTED_MODULE_1__Shared_Utilities_Utility__["b" /* Utility */].newGuid();
            }
        },

        getMessage(key) {
            const message = this.getMessageDetail(key);
            return message ? message.value : '';
        },

        getMessageDetail(key) {
            return ((this.pageSchema || {}).messages || []).find(m => m.key === key);
        },

        getFormSchema(formKey, questionKeyPrefix) {
            //httpService.loadFormSchema({ formKey: formKey }, successCallback, failureCallback)
            const origForm = (this.pageSchema.forms || [])
                .find(f => f.key === formKey || (f.formRef && f.formRef.formKey === formKey));
            //make copy of schema
            var formSchema = null;
            if (origForm) {
                formSchema = JSON.parse(JSON.stringify(origForm));
                //apply prefix
                if (questionKeyPrefix) {
                    this.applyQuestionKeyPrefix(formSchema.groups, questionKeyPrefix);
                }
            }

            console.log('getFormSchema', formSchema);
            return formSchema;
        },

        getFormGroups(formKey, questionKeyPrefix) {
            var formSchema = this.getFormSchema(formKey, questionKeyPrefix);
            var groups = (formSchema || {}).groups || [];
            return groups;
        },

        applyQuestionKeyPrefix(groups, prefix) {
            const self = this;
            groups = groups || [];
            if (groups.length === 0) {
                return;
            }
            //iterate over question in schema
            groups.forEach(g => {
                (g.questions || []).forEach(rowQ => {
                    (rowQ || []).forEach(colQ => {
                        var question = colQ.question;
                        if (question && question.questionKey) {
                            question.questionKey = prefix + question.questionKey;
                        }
                        if (question && question.validators
                            && question.validators.compareFieldKey
                            && question.validators.compareFieldKey.indexOf('##PREFIX##') > -1) {
                            question.validators.compareFieldKey = question.validators.compareFieldKey.replace('##PREFIX##', prefix);
                        }
                        //apply prefix to inner groups
                        self.applyQuestionKeyPrefix(colQ.groups, prefix);
                    })
                })
            })
        },

        getQuestionFromGroups(groups, questionKey) {
            let foundQuestion = undefined;
            const self = this;
            groups = groups || [];
            if (groups.length === 0) {
                return foundQuestion;
            }
            groups.forEach(g => {
                (g.questions || []).forEach(rowQ => {
                    var colQuestion = (rowQ || []).find(colQ => colQ.question !== undefined && colQ.question.questionKey === questionKey);
                    if (colQuestion) {
                        foundQuestion = colQuestion.question;
                        return foundQuestion;
                    }
                    else {
                        (rowQ || []).forEach(colQ => {
                            //apply prefix to inner groups
                            if (foundQuestion === undefined) {
                                foundQuestion = self.getQuestionFromGroups(colQ.groups, questionKey);
                            }
                        })
                    }
                })
            })
            return foundQuestion;
        },

        setGroupQuestionProperties(groups, propertiesProvider) {
            const self = this;
            const hasProvider = propertiesProvider != undefined && typeof propertiesProvider == 'function';
            groups = groups || [];

            if (groups.length === 0 || !hasProvider) {
                return;
            }

            //iterate over question in schema
            groups.forEach(g => {
                (g.questions || []).forEach(rowQ => {
                    (rowQ || []).forEach(colQ => {
                        var question = colQ.question;
                        if (question) {
                            const props = propertiesProvider(question) || {};
                            for (var key in props) {
                                question[key] = props[key]
                            }
                        }
                        //apply prefix to inner groups
                        self.setGroupQuestionProperties(colQ.groups, propertiesProvider);
                    })
                })
            })
        },

        setQuestionProperties(groups, keyValues) {
            const self = this;

            groups = groups || [];
            keyValues = keyValues || {};
            let keyCount = Object.keys(keyValues).length;

            if (groups.length === 0 || keyCount === 0) {
                return;
            }

            //iterate over question in schema
            groups.forEach(g => {
                (g.questions || []).forEach(rowQ => {
                    (rowQ || []).forEach(colQ => {
                        var question = colQ.question;
                        if (question) {
                            Object.keys(keyValues).forEach(key => {
                                question[key] = keyValues[key]
                            })
                        }
                        //apply prefix to inner groups
                        self.setQuestionProperties(colQ.groups, keyValues);
                    })
                })
            })
        },

        setComponentSettings(groups, settings) {
            const self = this;
            groups = groups || [];
            if (groups.length === 0 || !settings) {
                return;
            }

            //iterate over components in schema
            groups.forEach(g => {
                (g.components || []).forEach(component => {
                    if (component) {
                        component.settings = __WEBPACK_IMPORTED_MODULE_1__Shared_Utilities_Utility__["b" /* Utility */].deepMerge(settings, component.settings);
                    }
                })
            })
        },

        runManualActions(callback) {
            const schema = this.pageSchema || {};
            //get only manual action
            const actions = (schema.runActions || []).filter(a => a.enabled && !a.auto);
            if (actions && actions.length > 0) {
                __WEBPACK_IMPORTED_MODULE_5__Shared_Utilities_actionRunnerUtil__["a" /* default */].runActions(actions, callback);
            }
            else {
                if (callback) { callback(); }
            }
        },

        isNotEmpty(text) {
            return text != null && text != undefined && text != '';
        },
        bindFieldListener() {
            const $this = this;
            Object.keys($this.componentDataBag).forEach((key) => {
                var element = $("#" + key)[0];
                if (element) {
                    if (!element.binded) {
                        element.binded = true;
                        //var type = (element.nodeName || '').toLowerCase();
                        element.addEventListener('blur', function (evt) {
                            $this.updateFormState(this.id)
                        })
                    }
                }
            });
        },
        saveComponentData() {
            //var value = this.dataBag[this.dataKey];

            //if (value == null || value == undefined) {
            //    return;
            //}
            //var data = {
            //    [this.dataKey]: value
            //}
            //httpService.postComponentData(data);
        },
        clearFormState(keys) {
            var formKeys = keys || Object.keys(this.componentState);
            console.log('clearFormState', keys);
            formKeys.forEach((key) => {
                this.clearStateItem(key);
            })
        },

        updateFormState(updateKey) {
            //add components state to root state collection;
            if (this.state.$error && this.componentState.$error) {
                if (updateKey) {
                    this.updateOrClearStateItem(updateKey)
                }
                else {
                    Object.keys(this.componentState).forEach((key) => {
                        this.updateOrClearStateItem(key)
                    })
                }
            }
        },
        updateOrClearStateItem(itemKey) {
            if (this.isUpdatableKey(itemKey)) {
                var state = this.componentState.$error[itemKey]
                if (state && this.state.$error) {
                    this.$set(this.state.$error, itemKey, state);
                }
                else {
                    this.clearStateItem(itemKey);
                }
            }
        },
        clearStateItem(itemKey) {
            if (!this.state.$error) {
                return;
            }
            if (this.isUpdatableKey(itemKey)) {
                this.$set(this.state.$error, itemKey, undefined);
            }
        },
        isUpdatableKey(key) {
            //ignore all build-in props beginning with '$' or '_'
            var update = key.indexOf('$') != 1 && key.indexOf('_') != 1
            return update;
        },

        formSubmitted() {
            console.debug('component form submit', this.componentState);
            if (this.componentState) {
                this.touchComponentState();
            }
        },

        validateState(state) {
            var valid = false;
            if (!state) {
                return valid;
            }
            //check component state for val
            this.$set(state, '$submitted', true)
            //touch component states to highlight field
            this.touchState(state);
            if (state.$valid) {
                this.$set(state, '$submitted', false);
                valid = true;
            }
            console.log('validateState', state, valid);
            return valid;
        },

        touchState(state) {
            if (state) {
                var errors = state.$error;
                var self = this;
                if (errors) {
                    Object.keys(errors).forEach(function (key) {
                        var fieldState = errors[key]
                        if (fieldState) {
                            self.$set(fieldState, '$touched', true);
                        }
                    })
                }
            }
        },

        touchComponentState() {
            if (this.componentState) {
                var errors = this.componentState.$error;
                var $this = this;
                if (errors) {
                    this.touchState(this.componentState);
                    this.updateFormState()
                }
            }
        },

        resetFormState(state) {
            state = state || this.componentState;
            if (state && state._reset) {
                console.debug('resetFormState', state);
                state._reset();
            }
        },
        isComplexDataKey() {
            return this.dataKeyObject != undefined && typeof this.dataKeyObject === "object";
        },
        mergeDataKeyObject(newOptions) {
            if (typeof this.dataKeyObject === "object") {
                this.dataKeyObject = Object.assign(this.dataKeyObject, newOptions);
            }
            return this.dataKeyObject;
        },
        ensureDateKeyNormalization(defaultOptions) {
            this.ensureDataKeyParsing(defaultOptions);
        },
        ensureDataKeyParsing(options) {
            const self = this;
            options = options || this.defaultOptions;
            if (!this.dataKeyParsed) {

                if ((this.dataKey === undefined || this.dataKey === null || this.dataKey === '')
                    && !this.settings) {
                    return;
                }

                //check if setting is there
                if (typeof this.settings === "object") {
                    this.dataKeyObject = this.settings;
                }
                else if (typeof this.dataKey === "object") {
                    this.dataKeyObject = this.dataKey;
                }
                else if (typeof this.dataKey === "string") {
                    try {
                        //if datakey is json string, parse and assigned to dataKeyObject
                        this.dataKeyObject = JSON.parse(this.dataKey);
                    } catch (e) {
                        console.log('parseDataKey->parsing error', e);
                        //if datakey is simple string
                        this.dataKeyObject = {
                            dataKey: this.dataKey
                        };
                    }
                }

                this.dataKeyObject = Object.assign({}, options, this.dataKeyObject);
                this.validateOnNext = this.dataKeyObject.validateOnNext || false;
                if (this.dataKeyObject.validationOrder) {
                    this.validationOrder = Number(this.dataKeyObject.validationOrder);
                }

                //converting boolean string  to boolean/true/fals
                Object.keys(this.dataKeyObject).forEach(key => {
                    var v = self.dataKeyObject[key];
                    v = v !== undefined ? (v + '').toLowerCase() : '';
                    if (v === 'false') {
                        self.dataKeyObject[key] = false;
                    }
                    else if (v === 'true') {
                        self.dataKeyObject[key] = true;
                    }
                });

                this.dataKeyParsed = this.normalized = true;
                console.log("parseDataKey->dataKeyObject", this.dataKeyObject);
            }
        },
    }
}
/* harmony export (immutable) */ __webpack_exports__["a"] = ComponentBaseMixin;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RequestResponseFormatter__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_services_userConfirmation__ = __webpack_require__(114);
﻿






const Promise = typeof window.Promise === 'function' ? window.Promise : __WEBPACK_IMPORTED_MODULE_2_es6_promise___default.a.Promise;

/* harmony default export */ __webpack_exports__["a"] = ({
    getJQuery() {
        return window.jQuery || window.jquery || $;
    },
    getVueInstance() {
        return new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({});
    },
    __setPageDataInternal(data) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$__internalDatabag = data ? data.dataBag : {};
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$__internalPageSchema = data ? data.pageSchema : {};
    },
    getDataBag() {
        const dataBag = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$__internalDatabag;
        return dataBag;
    },
    getPageSchema() {
        const schema = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$__internalPageSchema;
        return schema;
    },
    getServiceBaseUrl() {
        var serviceUrl = "/api/PageService";
        return serviceUrl;
    },
    getSessionId() {
        var sessionId = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.sessionId;
        console.log('sessionId', sessionId);
        return sessionId;
    },
    getExperience() {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData ? __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.experience : '';
    },
    getRoutePrefix() {
        var routePrefix = (__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData || {}).routePrefix || '';
        console.log('routePrefix', routePrefix);
        return routePrefix;
    },
    getSessionInfo() {
        const self = this;
        return {
            sessionId: self.getSessionId(),
            experience: self.getExperience(),
            browserSessionId: self.getBrowserSessionId()
        };
    },
    getProgressSteps() {
        return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.progressSteps;
    },

    getConfigSettingUrl(settingKey) {
        //http://localhost:56663/api/PageService/config/dev/DsuAuthConfigJson
        const serviceUrl = this.getServiceBaseUrl();
        const experience = this.getExperience();
        const domain = __WEBPACK_IMPORTED_MODULE_3__Shared_Utilities_Utility__["b" /* Utility */].getHostName();

        return `${domain}${serviceUrl}/config/${experience}/${settingKey}`;
    },
    errorHandler(errorCallback) {
        if (errorCallback) {
            errorCallback();
        }
    },

    getLoggedInUserId() {
        const $this = this;
        return new Promise(function (resolve, reject) {

            //default set value from userId
            let userId = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.userId;
            try {
                let vueInstance = $this.getVueInstance();
                console.log('getLoggedInUserId ', { Vue: vueInstance, auth: vueInstance.$auth })
                if (vueInstance.$auth) {
                    vueInstance.$auth.getUserId().then(function (userId) {
                        resolve(userId);
                    }).catch(function (e) {
                        console.log('User is not authenticated', e);
                        reject(e);
                    });
                }
                else {
                    resolve(userId || '');
                }
            } catch (e) {
                console.error('Error retrieving user ', e);
                reject(e);
            }
        });
    },
    getBrowserSessionId() {
        var browserSessionId = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.browserSessionId;
        return browserSessionId;
    },
    getAntiforgeryTokenHeader() {
        var token = $('[name=__RequestVerificationToken]').val();
        var header = { "XSRF-TOKEN": token };
        return header;
    },
    getRouteSettings(successCallback, errorCallback) {
        const serviceUrl = this.serviceBaseUrl();

        if (serviceUrl) {
            this.getJQuery().get(serviceUrl + "/routes")
                .done(successCallback)
                .fail(errorCallback);
        }
    },
    getOktaConfig() {
        var oktaConfig = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.oktaConfig;
        return oktaConfig;
    },

    getDsuConfig() {
        const baseConfig = __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.dsuAuthConfig;
        const expConfig = {
            dataConfigPath: this.getConfigSettingUrl(baseConfig.dataConfigKey),
            appConfigPath: this.getConfigSettingUrl(baseConfig.appConfigKey)
        };

        const config = Object.assign({}, baseConfig, expConfig);
        console.log('baseConfig', baseConfig);
        console.log('dsuConfig', config);
        return config;
    },

    startNewSession() {

    },

    loadUserApplication(successCallback, errorCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        const experience = this.getExperience();
        const $this = this;

        if (!__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.authEnabled) {
            //dont load data;
            let message = `User application can not be loaded since 
                        authentication is not enabled for ${experience}`;
            console.log(message);
            errorCallback(message);
            return;
        }
        //load user application
        $this.getLoggedInUserId().then(function (userId) {
            console.log('loadUserApplicationSummary for userId ', userId);

            if (serviceUrl && userId) {
                //api/PageService/loadApplication/{userId}/{experience}
                var url = serviceUrl + "/loadUserApplicationSummary/" + userId + "/" + experience + "?v=" + Math.random().toString(36).substring(7);
                //response {SiteId:'',SessionId:"",BrowserSessionId:"",UserId:""}
                $this.getJQuery().get(url, function (data) {
                    console.log(data);
                    //set Vue.$applicationData to new session/browser/site/userId
                    if (data && !data.expired && data.sessionId !== '') {
                        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.sessionId = data.sessionId;
                        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.userId = data.userId;
                        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.siteId = data.siteId;
                        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.browserSessionId = data.browserSessionId;
                        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.lastPageId = data.lastPageId;
                    }
                    successCallback(data);
                }).fail(errorCallback);
            }
            else {
                console.error("Service url or sessionId value is null");
            }

        }, (reason) => {
            errorCallback(reason);
        });
    },

    getUserApplication(successCallback, errorCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        const experience = this.getExperience();
        const $this = this;

        //load user application
        $this.getLoggedInUserId().then(function (userId) {
            console.log('userApplicationSummary for userId ', userId);

            if (serviceUrl && userId) {
                //api/PageService/application/{userId}/{experience}
                var url = serviceUrl + "/userApplicationSummary/" + userId + "/" + experience + "?v=" + Math.random().toString(36).substring(7);
                $this.getJQuery().get(url, function (data) {
                    console.log(data);
                    successCallback(data);
                }).fail(errorCallback);
            }
            else {
                console.error("Service url or sessionId value is null");
            }

        }, (reason) => {
            errorCallback(reason);
        });
    },

    deleteUserApplications(removeCurrentApp, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        const experience = this.getExperience();
        const $this = this;

        //load user application
        $this.getLoggedInUserId().then(function (userId) {
            console.log('deleteUserApplications for userId ', userId);

            if (serviceUrl && userId) {
                //api/PageService/deleteUserApplication/{userId}/{experience}
                var url = serviceUrl + "/deleteUserApplications/" + userId + "/" + experience + "/" + removeCurrentApp + "?v=" + Math.random().toString(36).substring(7);
                var antiForgeryHeader = $this.getAntiforgeryTokenHeader();

                $this.getJQuery().ajax({
                    url: url,
                    method: "POST",
                    data: {},
                    headers: antiForgeryHeader,
                    dataType: 'json',
                    contentType: "application/json",
                    success: function (data, status, jqXHR) {
                        console.log('deleteUserApplications', data);
                        successCallback(data);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        failureCallback(textStatus)
                    }
                });
            }
            else {
                console.error("Service url or userId value is null");
            }

        }, (reason) => {
            failureCallback(reason);
        });
    },

    getPageData(request, successCallback, errorCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();
        var $this = this;
        const pageId = request.pageId;
        const onlyMeta = request.onlyMetadata ? 1 : 0;

        console.log("getPageData:loading data for page: " + pageId);
        if (serviceUrl && sessionId) {
            //api/PageService/pageData/{sessionId}/{experience}/{pageId}
            var url = serviceUrl + "/pageData/" + sessionId + "/" + experience + "/" + pageId + "?meta=" + onlyMeta + "&v=" + Math.random().toString(36).substring(7);

            this.getJQuery().get(url, function (data) {
                console.log('getPageData:loaded data for page: ' + pageId, data);
                data.dataBag = __WEBPACK_IMPORTED_MODULE_0__RequestResponseFormatter__["a" /* default */].ConvertSessionDataToDataBag(data.dataBag)
                //save databag to Vue instance for accessing
                $this.__setPageDataInternal(data);
                $this.setPageSequence(data.pageSchema);
                successCallback(data);
            }).fail(errorCallback);
        }
        else {
            console.error("Service url or sessionId value is null");
        }
    },
    getFormSchema(request, successCallback, errorCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();
        const formKey = request.formKey;
        const pageId = request.pageId;

        if (serviceUrl && sessionId) {
            //api/PageService/formSchema/{sessionId}/{experience}/{formKey}/{pageId?}
            var url = serviceUrl + "/formSchema/" + sessionId + "/" + experience + "/" + formKey + "/" + pageId + "?v=" + Math.random().toString(36).substring(7);

            this.getJQuery().get(url, function (data) {
                console.log(data);
                successCallback(data);
            }).fail(errorCallback);
        }
        else {
            console.error("Service url or sessionId value is null");
        }
    },
    getAppData(experience, successCallback, errorCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var $this = this;
        if (serviceUrl) {
            var url = serviceUrl + "/appData/" + experience;

            this.getJQuery().get(url, function (data) {
                console.log(data);
                //add data to $applicationData
                __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData = data;
                console.log('Global Vue getApplicationData', __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData);
                successCallback();
            }).fail(errorCallback);
        }
        else {
            console.error("getAppData:Service url value is null");
        }
    },
    setPageSequence(pageSchema) {
        pageSchema = pageSchema || {};
        const sequences = (pageSchema.navigation || {}).pageSequences || [];
        if (pageSchema.reloadPageSequence && sequences.length > 0) {
            //set pageSequences
            __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.pageSequence = sequences;
        }
    },
    postFieldData(data, forced) {
        console.log('saving field data..', data);
        if (forced) {
            this.postPageData(data, null, null, null);
        }
    },
    postComponentData(data) {
        console.log('saving component data..', data);
    },
    postPageData(dataBag, pageId, successCallback, failureCallback) {
        //1. get page session data
        console.log('saving field data..', dataBag);
        const $this = this;

        if (__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData.authEnabled) {
            this.getLoggedInUserId().then(function (userId) {
                console.log('postPageData for userId ', userId);
                $this._saveSessionData(dataBag, pageId, successCallback, failureCallback, userId);
            }, (reason) => {
                failureCallback(reason);
            });
        }
        else {
            //still proceed with save without userId
            $this._saveSessionData(dataBag, pageId, successCallback, failureCallback, '');
        }
    },
    __preProcecssDatabag(dataBag) {
        if (dataBag) {
            //add time stamp
            dataBag[__WEBPACK_IMPORTED_MODULE_4__Shared_Constants__["a" /* Constants */].SESSION_KEYS.LAST_SAVED_TIME] = new Date().toISOString();
            //check for confirmation flag
            if (__WEBPACK_IMPORTED_MODULE_5__Shared_services_userConfirmation__["a" /* default */].isConfirmed()) {
                dataBag[__WEBPACK_IMPORTED_MODULE_4__Shared_Constants__["a" /* Constants */].SESSION_KEYS.REQUIRE_CONFIRMATION] = __WEBPACK_IMPORTED_MODULE_4__Shared_Constants__["a" /* Constants */].YES_NO_OPTION.NO;
            }
        }
    },
    _saveSessionData(dataBag, pageId, successCallback, failureCallback, userId) {
        userId = userId || '';
        successCallback = successCallback || function () { };
        failureCallback = failureCallback || function () { };

        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        var browserSessionId = this.getBrowserSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            var url = serviceUrl + "/sessionData/";
            //add timestamp
            this.__preProcecssDatabag(dataBag);
            //2. ConvertDataBagToSessionData
            var answers = __WEBPACK_IMPORTED_MODULE_0__RequestResponseFormatter__["a" /* default */].ConvertDataBagToSessionData(dataBag)
            var sessionData = {
                sessionId: sessionId,
                browserSessionId: browserSessionId,
                data: answers,
                currentPageId: pageId,
                experience: experience,
                userId: userId
            };
            //3. send post session data to server.
            //4. call successCallback or failureCallback
            var antiForgeryHeader = this.getAntiforgeryTokenHeader();
            this.getJQuery().ajax({
                url: url,
                method: "POST",
                data: JSON.stringify(sessionData),
                headers: antiForgeryHeader,
                dataType: 'json',
                contentType: "application/json",
                success: function (data, status, jqXHR) {
                    console.log('_saveSessionData', data);
                    successCallback(data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    failureCallback(textStatus)
                }
            });
        }
    },
    getQuote(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //quote/{sessionId}/{experience}/{coverageAmount:double}/{termLength:int}
            var url = serviceUrl + "/quote/" + sessionId + "/" + experience + "/" + data.coverageAmount + "/" + data.termLength;

            this.getJQuery().get(url)
                .done(successCallback)
                .fail(failureCallback);
        }
    },
    getAddQuote(postData, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            var url = serviceUrl + "/addQuote/" + sessionId + "/" + experience;
            var antiForgeryHeader = this.getAntiforgeryTokenHeader();

            this.postRequest(url, postData, antiForgeryHeader, successCallback, failureCallback);
        }
    },
    getGiwlQuote(postData, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            var url = serviceUrl + "/giwlQuote/" + sessionId + "/" + experience;
            var antiForgeryHeader = this.getAntiforgeryTokenHeader();

            this.postRequest(url, postData, antiForgeryHeader, successCallback, failureCallback);
        }
    },

    postRequest(url, data, headers, successCallback, failureCallback) {
        this.getJQuery().ajax({
            url: url,
            method: "POST",
            data: JSON.stringify(data),
            headers: headers,
            dataType: 'json',
            contentType: "application/json",
            success: function (data, status, jqXHR) {
                successCallback(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                failureCallback(textStatus);
            }
        });
    },
    getQuoteSummary(successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //QuoteSummary/{sessionId}/{experience}
            var url = serviceUrl + "/QuoteSummary/" + sessionId + "/" + experience + "?includePaymentOption=1";
            this.getJQuery().get(url)
                .done(successCallback)
                .fail(failureCallback);
        }
    },
    getRecommendationEngineData(data, successCallback, failureCallback) {
        //const serviceUrl = this.getServiceBaseUrl();
        //var sessionId = this.getSessionId();

        //if (serviceUrl && sessionId) {
        //    var url = serviceUrl + "/recommendationengine/" + sessionId + "/" + data.coverageAmount + "/" + data.termLength;

        //    this.getJQuery().get(url)
        //        .done(successCallback)
        //        .fail(failureCallback);
        //} 
        data = {
            ResultsRounded: '150,000',
            TermLength: 10
        };
        successCallback(data);
    },
    getMedicalExamData(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //medicalexam/{sessionId}/{experience}
            var url = serviceUrl + "/medicalexam/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    getAvailableAppointments(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //appointment/{sessionId}/{experience}?reservationDate=&locationType=
            var url = serviceUrl + "/appointment/" + sessionId + "/" + experience
                + "?reservationDate=" + data.reservationDate + "&locationType=" + data.locationType;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    scheduleAppointment(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {

            var appointmentData = {
                sessionId: sessionId,
                experience: experience,
                reservationDate: data.ReservationDate,
                reservationTime: data.Time,
                examinerId: data.ExaminerID,
                locationType: data.LocationType,
                zipCode: data.PostCode
            };

            //scheduleappointment
            var url = serviceUrl + "/scheduleappointment";

            var antiForgeryHeader = this.getAntiforgeryTokenHeader();
            this.getJQuery().ajax({
                url: url,
                method: "POST",
                data: JSON.stringify(appointmentData),
                headers: antiForgeryHeader,
                dataType: 'json',
                contentType: "application/json",
                success: function (data, status, jqXHR) {
                    successCallback(data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    failureCallback(textStatus)
                }
            });
        }
    },
    cancelAppointment(uniqueKey, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //cancelappointment/{sessionId}/{experience}/{uniqueKey}
            var url = serviceUrl + "/cancelappointment/" + sessionId + "/" + experience + "/" + uniqueKey;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    getPaymentOptions(successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //payment/{sessionId}/{experience}
            var url = serviceUrl + "/payment/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    getBankName(routingNumber, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //bank/{routingNo}/{sessionId}/{experience}
            var url = serviceUrl + "/bank/" + routingNumber + "/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    validateEmail(email, callback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //validate/email/{emailId}/{sessionId}/{experience}
            var url = serviceUrl + "/validate/email/" + email + "/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                callback(data);
            }).fail(function () {
                callback(false)
            });
        }
    },
    validatePhone(phone, callback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //validate/phone/{phoneNo}/{sessionId}/{experience}
            var url = serviceUrl + "/validate/phone/" + phone + "/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                callback(data);
            }).fail(function () {
                callback(false)
            });
        }
    },
    getRecommendTermLength(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //recommendtermlength/{sessionId}/{experience}
            var url = serviceUrl + "/RecommendTermLength/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    getRecommendCoverageAmount(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //recommendcoverageamount/{sessionId}/{experience}
            var url = serviceUrl + "/RecommendCoverageAmount/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    AutoAddress(address, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //AddressSuggestion/{address}/{sessionId}/{experience}
            var url = serviceUrl + "/AddressSuggestion/" + address + "/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    validateAddress(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        data.experience = this.getExperience();

        data.sessionId = sessionId;
        if (serviceUrl && sessionId) {
            //validate/Address
            var url = serviceUrl + "/validate/Address/" + data.experience;
            var antiForgeryHeader = this.getAntiforgeryTokenHeader();
            //console.log(token);
            this.getJQuery().ajax({
                url: url,
                method: "POST",
                data: JSON.stringify(data),
                headers: antiForgeryHeader,
                dataType: 'json',
                contentType: "application/json",
                success: function (data, status, jqXHR) {
                    successCallback(data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    failureCallback(textStatus)
                }
            });
        }
    },
    getDisqualificationReasons(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //DisqualificationReasons/{sessionId}/{experience}
            var url = serviceUrl + "/DisqualificationReasons/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    getSffOffers(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //offers/{sessionId}/{experience}
            var url = serviceUrl + "/offers/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    getAuthToken(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();

        if (serviceUrl && sessionId) {
            //AuthToken/{sessionId}
            var url = serviceUrl + "/AuthToken/" + sessionId;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    GetListItems(searchText, callback) {
        console.log('start at http');
        const serviceUrl = this.getServiceBaseUrl();
        if (serviceUrl) {
            var url = serviceUrl + "/listitems?searchText=" + searchText;
            this.getJQuery().get(url, function (data) {
                callback(data);
            }).fail(function () {
                callback(false)
            });
        }
    },
    processApplication(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //processapplication/{sessionId}/{experience}
            var url = serviceUrl + "/processapplication/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },

    initiatePayConnectPayment(deleteExistingAccount, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        var qs = '';
        if (deleteExistingAccount) {
            qs = '/1';
        }
        if (serviceUrl && sessionId) {
            //authorizePayment/{sessionId}/{experience}
            var url = serviceUrl + "/initiatePayment/" + sessionId + "/" + experience + qs;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },

    getExistingPayAccount(successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            var url = serviceUrl + "/payAccount/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },

    savePayConnectSessionTransferResponse(paymentData, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();
        var browserSessionId = this.getBrowserSessionId();

        if (serviceUrl && sessionId) {
            var url = serviceUrl + "/payConnect/saveSessionTransferResponse";
            var antiForgeryHeader = this.getAntiforgeryTokenHeader();

            var answers = __WEBPACK_IMPORTED_MODULE_0__RequestResponseFormatter__["a" /* default */].ConvertDataBagToSessionData(paymentData);

            var sessionData = {
                sessionId: sessionId,
                browserSessionId: browserSessionId,
                data: answers,
                experience: experience
            };
            this.postRequest(url, sessionData, antiForgeryHeader, successCallback, failureCallback);
        }
    },

    authorizePayment(successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();
        var browserSessionId = this.getBrowserSessionId();

        if (serviceUrl && sessionId) {
            var url = serviceUrl + "/authorizePayment";
            var antiForgeryHeader = this.getAntiforgeryTokenHeader();

            var sessionData = {
                sessionId: sessionId,
                browserSessionId: browserSessionId,
                data: [],
                experience: experience
            };
            this.postRequest(url, sessionData, antiForgeryHeader, successCallback, failureCallback);
        }
    },


    dataToQuestionAnswers(data) {
        var answers = [];
        data = data || {};
        for (var prop in data) {
            //{ ID: "ProductID", Value: postData.ProductId, Type: "string" }
            answers.push({ ID: prop, Value: data[prop], Type: "string" })
        }
        return answers;
    },

    clearCookies(data, successCallback, failureCallback) {
        const self = this;
        const serviceUrl = this.getServiceBaseUrl();
        if (serviceUrl) {
            var url = serviceUrl + "/clearcookies";

            this.getJQuery().get(url, function (data) {
                successCallback(data);
                self.clearSession();
            }).fail(failureCallback);
        }
    },

    clearSession() {
        __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].$applicationData = {};
    },

    signApplication(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //signApplication/{sessionId}/{experience}
            var url = serviceUrl + "/signApplication/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },

    getSigningSummary(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //signApplication/{sessionId}/{experience}
            var url = serviceUrl + "/signingSummary/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },

    makeCall(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            var url = serviceUrl + "/call";

            var antiForgeryHeader = this.getAntiforgeryTokenHeader();

            data.SessionId = sessionId;
            data.Experience = experience;

            this.getJQuery().ajax({
                url: url,
                method: "POST",
                data: JSON.stringify(data),
                headers: antiForgeryHeader,
                dataType: 'json',
                contentType: "application/json",
                success: function (data, status, jqXHR) {
                    successCallback(data);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    failureCallback(textStatus)
                }
            });
        }
    },
    getNextNthBusinessDays(successCallback, failureCallback) {
        console.log('getNextNthBusinessDays');
        const serviceUrl = this.getServiceBaseUrl();

        if (serviceUrl) {
            var url = serviceUrl + "/5/nthbusinessday";

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    getSupportedPaymentMethods(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();

        if (serviceUrl && data) {
            //payment/method/{sessionId}/{experience}
            var url = serviceUrl + "/payment/method/" + data.stateCode + "/" + data.productId;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },

    getAppSubmissionSummary(data, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //AppSubmissionSummary/{sessionId}/{experience}
            var url = serviceUrl + "/AppSubmissionSummary/" + sessionId + "/" + experience;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },

    getDynamicContent(postData, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();
        console.log('getDynamicContent', { serviceUrl, sessionId });

        if (serviceUrl && sessionId) {
            var url = serviceUrl + "/dynamicContent/" + sessionId + "/" + experience + "/" + postData.key + "?properties=" + postData.properties;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
    },
    loadClientApplications(postData, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();
        console.log('loadClientApplications', { serviceUrl, sessionId });
        const mock = false;
        postData.advisorKey = 'advisor-dummy-user'

        if (!mock && serviceUrl && sessionId) {
            var url = serviceUrl + "/clientApplications/" + sessionId + "/" + experience + "/" + postData.advisorKey;

            this.getJQuery().get(url, function (data) {
                successCallback(data);
            }).fail(failureCallback);
        }
        else {
            successCallback({});
        }
    },
    InAgentCallWindow(successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var url = serviceUrl + "/InAgentCallWindow/";

        this.getJQuery().get(url, function (data) {
            successCallback(data);
        }).fail(failureCallback);
    },
    getApplicationPdfLink() {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();
        const browserSessionId = this.getBrowserSessionId();
        console.log('generate application pdf', { serviceUrl, sessionId });
        //{experience}/application/{sessionId}
        return '/' + this.getRoutePrefix() + "/" + experience + "/downloadApplicationPdf/" + sessionId + '/' + browserSessionId;
    },
    downloadCompletedApplicationPdf(downloadLink) {
        window.location.href = downloadLink;
    },
    verifyQuote(successCallback, failureCallback) {

        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //QuoteSummary/{sessionId}/{experience}
            var url = serviceUrl + "/verifyquote/" + sessionId + "/" + experience;
            this.getJQuery().get(url)
                .done(successCallback)
                .fail(failureCallback);
        }
    },
    processDropinAction(actionKey, successCallback, failureCallback) {

        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //QuoteSummary/{sessionId}/{experience}
            var url = serviceUrl + "/dropinAction/" + sessionId + "/" + experience + "/" + actionKey;
            this.getJQuery().get(url)
                .done(successCallback)
                .fail(failureCallback);
        }
    },
    getFaqs(faqKey, successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //QuoteSummary/{sessionId}/{experience}
            var url = serviceUrl + "/faqs/" + experience + "/" + sessionId + "/" + faqKey;
            this.getJQuery().get(url)
                .done(successCallback)
                .fail(failureCallback);
        }
    },
    getPresalesForms(successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //QuoteSummary/{sessionId}/{experience}
            var url = serviceUrl + "/presalesForms/" + experience + "/" + sessionId;
            this.getJQuery().get(url)
                .done(successCallback)
                .fail(failureCallback);
        }
    },
    getPaymentReviewInfo(successCallback, failureCallback) {
        const serviceUrl = this.getServiceBaseUrl();
        var sessionId = this.getSessionId();
        const experience = this.getExperience();

        if (serviceUrl && sessionId) {
            //QuoteSummary/{sessionId}/{experience}
            var url = serviceUrl + "/paymentReview/" + experience + "/" + sessionId;
            this.getJQuery().get(url)
                .done(successCallback)
                .fail(failureCallback);
        }
    },

    download(url, successCallback) {
        this.getJQuery().get(url, function (data) {
            console.log('downloading from url: ', url);
            successCallback(data);
        }).fail((error) => {
            console.log('Download fail for url ', url, error)
        });
    }
});



/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility__ = __webpack_require__(25);




const createAndSubmitForm = (path, method, params) => {
    method = method || "post";

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    params = params || {};

    for (var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
}

const redirectToUrl = (url) => {
    if (url) {
        window.location.href = url;
    }
}

const transform = (mapping, data) => {
    var itemMap = {};
    if (mapping && Array.isArray(mapping)) {
        const items = mapping || []
        data = data || {};

        console.log('getting transform', items);
        items.forEach((item) => {
            itemMap[item.to] = data[item.from];
        });
    }
    return itemMap;
}

const postForm = (request, data, successCallback, errorCallback, completionCb, additionalData) => {
    const { endpoint, method, headers, formData } = request;

    successCallback = successCallback || function (res) { console.log('success callback', res) }
    errorCallback = errorCallback || function (errors) { console.log('errors callback', errors) };

    console.log('postForm', headers, formData);
    //headers
    var reqHeaders = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utility__["a" /* buildMap */])(headers, additionalData);

    //data
    //remove empty/undefined/null value
    for (var key in data) {
        if (!data[key]) {
            delete data[key];
        }
    }

    var tempPostDataMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utility__["a" /* buildMap */])(formData, additionalData);
    var postData = Object.assign({}, tempPostDataMap, data);
    var qsEle = document.getElementById('qs_value');
    if (qsEle && qsEle.value) {
        postData.queryStrings = qsEle.value;
    }

    const formatters = request.formatters || {};

    for (var dataKey in formatters) {
        const fmt = formatters[dataKey]
        const dataValue = postData[dataKey];

        if (fmt && fmt.fn && dataValue) {
            var fn = dataValue[fmt.fn];
            if (fn && typeof fn == 'function') {
                var formattedDataValue = dataValue;
                if (fmt.args && Array.isArray(fmt.args)) {
                    formattedDataValue = fn.apply(dataValue, fmt.args)
                }
                else {
                    formattedDataValue = fn.apply(dataValue)
                }
                postData[dataKey] = formattedDataValue;
            }
        }
    }

    //if (request.transformation) {
    //    var transformed = transform(request.transformation, postData);
    //    postData = Object.assign(postData, transformed);
    //}

    // Send a POST request
    console.log('request', endpoint, reqHeaders, postData)
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_axios__["a" /* default */])({
        method: method,
        url: endpoint,
        headers: reqHeaders,
        data: postData
    })
        .then(function (response) {
            console.log('postForm success', response)
            const data = response.data;
            successCallback(data);
        })
        .catch(error => {
            console.log('postForm catch/error', error)
            errorCallback(error);
        })
        .finally(() => {
            console.log('postForm completed')
            if (completionCb) {
                completionCb();
            }
        });
}

const httpGet = (url, params, headers, successCallback, errorCallback, completionCb) => {
    const config = {
        headers: headers || {},
        params: params || {}
    };

    __WEBPACK_IMPORTED_MODULE_0_axios__["a" /* default */].get(url, config)
        .then(function (response) {
            console.log('axios then response', response)
            const data = response.data;
            successCallback(data);
        })
        .catch(error => {
            console.log('axios catch', error)
            errorCallback(error);
        })
        .finally(() => {
            console.log('axios finally')
            if (completionCb) {
                completionCb();
            }
        });
}

const loadFormSchema = (endpoint, successCallback, errorCallback) => {

    errorCallback = errorCallback || function (errors) { console.log('errors callback', errors) };

    // Send a get request
    console.log('request', endpoint)
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_axios__["a" /* default */])({
        method: 'get',
        url: endpoint
    })
        .then(function (response) {
            console.log('axios then response', response)
            successCallback(response.data);
        })
        .catch(error => {
            errorCallback(error);
        })
        .finally(() => console.log('axios finally'));
}

/* harmony default export */ __webpack_exports__["a"] = ({
    postForm,
    loadFormSchema,
    createAndSubmitForm,
    httpGet,
    redirectToUrl
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);




/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

const prototype = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype);

  __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

/* harmony default export */ __webpack_exports__["a"] = (AxiosError);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(11);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 16 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({

    available() { return window.bootbox; },

    modalDialog(title) {
        window.bootbox.dialog({
            message: '<p class="text-center">' + title + '</p>',
            closeButton: false
        });
    },

    modalDialogAdvanced(title, message, classNamme) {
        var dialog = window.bootbox.dialog({
            title: '<h4 class="modal-title">' + title + '</h4>',
            closeButton: true,
            message: message,
            className: classNamme,
            buttons: {
                cancel: {
                    label: 'Close',
                    className: 'btn btn-default'
                }
            }
        });
        return dialog;
    },

    showRescheduleDialog() {

        var dialog = window.bootbox.dialog({
            title:
                '<div class="processing-box text-center">Processing your request.</div>',
            closeButton: false,
            message: '<div class="processing-box text-center"><img src="/images/loading.gif" /><p>Please wait...</p></div>',
            className: "my-modal",
        }).on('hidden.bs.modal', function () {
            $('body').removeAttr("style");
        });
        return dialog;
    },

    showProcessingDialog(message) {
        message = message || 'Please wait...';

        var dialog = window.bootbox.dialog({
            title:
                '<div class="processing-box text-center">Processing your request.</div>',
            closeButton: false,
            message: '<div class="processing-box text-center"><p>' + message + '</p><img src="/images/loading.gif" /></div>',
            className: "my-modal"
        }).on('hidden.bs.modal', function () {
            $('body').removeAttr("style");
        });
        return dialog;
    },

    showWaitDialog(title, message) {
        message = message || 'Please wait...';

        var dialog = window.bootbox.dialog({
            title: '<div class="processing-box text-center">' + title + '</div>',
            closeButton: false,
            message: '<div class="processing-box text-center"><img src="/images/loading.gif" /><p>' + message + '</p></div>',
            className: "my-modal"
        });
        return dialog;
    },

    confirmAdvanced(message, callback, okText) {
        var okLabel = okText || "OK";

        if (!window.bootbox) {
            if (window.confirm(message)) {
                callback(true);
            }
            return;
        }

        window.bootbox.confirm({
            title:
                '<span class="glyphicon glyphicon-exclamation-sign text-error" aria-hidden="true"></span><span class="error-title">&nbsp;&nbsp;Attention</span>',
            closeButton: true,
            onEscape: false,
            message: message,
            className: "my-modal confirm-modal",
            buttons: {
                "confirm": {
                    label: okLabel,
                    className: "btn-secondary pull-right"
                },
                cancel: {
                    label: "Cancel",
                    className: "btn-link",
                }
            },
            callback: callback
        }).on('shown.bs.modal', function () {
            $(this).find('.modal-footer .btn-secondary').attr('title', okLabel);
            $(this).find('.modal-footer .btn-link').attr('title', 'Cancel');
        });
    },

    ///options = {confirmCallback:callback Function, denyCallback:callback Function,confirmButtonLabel:<text>, denyButtonLabel:<text>};
    confirmDialogWithOptions(message, options) {
        const title = '<span class="glyphicon glyphicon-exclamation-sign text-error" aria-hidden="true"></span><span class="error-title">&nbsp;&nbsp;Attention</span>';
        this.advancedConfirmPopupDialog(message,
            options.confirmCallback,
            options.denyCallback,
            options.confirmButtonLabel,
            options.denyButtonLabel,
            title);
    },

    advancedConfirmPopupDialog(message, continueCallback, cancelCallback, continueButtonLabel, cancelButtonLabel, title) {
        const TITLE = '<span class="glyphicon glyphicon-exclamation-sign text-error" aria-hidden="true"></span><span class="error-title">&nbsp;&nbsp;Oops - we found some items that need your attention.</span>';
        const mainButtonLabel = continueButtonLabel || 'CONTINUE';
        const cancelBtnLabel = cancelButtonLabel || 'Cancel';
        title = title || TITLE;

        window.bootbox.dialog({
            title: title,
            closeButton: false,
            message: message,
            onEscape: false,
            className: "my-modal confirm-modal",
            buttons: {
                main: {
                    label: mainButtonLabel,
                    className: "btn-secondary pull-right",
                    callback: continueCallback
                },
                cancel: {
                    label: cancelBtnLabel,
                    className: "btn-link",
                    callback: cancelCallback
                }
            }
        }).on('shown.bs.modal', function () {
            $(this).find('.modal-footer .btn-secondary').attr('title', mainButtonLabel);
            $(this).find('.modal-footer .btn-link').attr('title', cancelBtnLabel);
        });
    },

    showTechnicalErrorDialog(okCallback) {
        okCallback = okCallback || function () { };
        window.bootbox.dialog({
            title:
                '<span class="glyphicon glyphicon-exclamation-sign text-error" aria-hidden="true"></span><span class="error-title">&nbsp;&nbsp;Oops - we found some items that need your attention.</span>',
            message:
                '<div class="row modalerrorbox"><div class="col-sm-4 col-md-4 col-lg-4 modalbg"><img src="/images/ERROR_large.jpg" class="img-responsive"></div><div class="col-sm-8 col-md-8 col-lg-8 errbody"><span class="errorcopyone">We are currently experiencing technical difficulties...</span><br /><br /> <span class="errorcopytwo">Please try again.</span></div></div><div class="errorfooter">For urgent matters or to speak to someone in person, please call us<br/>at <strong>1-800-323-1967</strong> or email <u><a href="mailto:csr.status@aigdirect.com">csr.status@aigdirect.com</a></u>.</div>',
            closeButton: false,
            className: "my-modal",
            buttons: {
                main: {
                    label: "OK",
                    className: "btn-secondary custom-btn",
                    callback: okCallback
                }
            }
        }).on('shown.bs.modal', function () {
            $(this).find('.modal-footer .btn-secondary').attr('title', 'OK');
        });

    },

    showSessionExpiredDialog() {

        window.bootbox.dialog({
            title:
                '<span class="glyphicon glyphicon-exclamation-sign text-error" aria-hidden="true"></span><span class="error-title">&nbsp;&nbsp;Oops - we found some items that need your attention.</span>',
            message:
                '<div class="row modalerrorbox"><div class="col-sm-4 col-md-4 col-lg-4 modalbg"><img src="/images/ERROR_large.jpg" class="img-responsive"></div><div class="col-sm-8 col-md-8 col-lg-8 errbody"><span class="errorcopyone">Your Session has Expired...</span><br /><br /> <span class="errorcopytwo"></span></div></div><div class="errorfooter">Your Session has Expired, we can&#39;t continue.<br/>You will be redirect to the start page.</div>',
            closeButton: false,
            buttons: {
                main: {
                    label: "OK",
                    className: "btn-secondary custom-btn",
                    callback: function (result) {
                        window.location.href = "/";
                    }
                }
            }
        }).on('shown.bs.modal', function () {
            $(this).find('.modal-footer .btn-secondary').attr('title', 'OK');
        });

    },

    advancedAddressPopupDialog(messageText, continueCallback, cancelCallback) {

        window.bootbox.dialog({
            title: '<span class="glyphicon glyphicon-exclamation-sign text-error" aria-hidden="true"></span><span class="error-title">&nbsp;&nbsp;Attention</span>',
            closeButton: false,
            message: messageText,
            onEscape: false,
            className: "my-modal address-modal",
            buttons: {
                main: {
                    label: "Save",
                    className: "btn-secondary pull-right",
                    callback: continueCallback
                },
                cancel: {
                    label: "Cancel",
                    className: "btn-link",
                    callback: cancelCallback
                }
            }
        }).on('shown.bs.modal', function () {
            $(this).find('.modal-footer .btn-secondary').attr('title', 'Save');
            $(this).find('.modal-footer .btn-link').attr('title', 'Cancel');
        });
    },

    advancedConsentPopupDialog(messageText, continueCallback, cancelCallback) {

        window.bootbox.dialog({
            title: '',
            closeButton: false,
            message: messageText,
            onEscape: false,
            className: "my-modal consent-modal",
            buttons: {
                main: {
                    label: "Accept and Continue",
                    className: "btn-secondary",
                    callback: continueCallback
                },
                cancel: {
                    label: "Cancel",
                    className: "btn-link",
                    callback: cancelCallback
                }
            }
        }).on('shown.bs.modal', function () {
            $(this).find('.modal-footer .btn-secondary').attr('aria-label', 'Accept and Continue disclosures regarding this website.');
            $(this).find('.modal-footer .btn-link').attr('aria-label', 'Cancel');
        });
    },

    advancedMedicalExamPopupDialog(messageText, continueCallback, cancelCallback) {

        window.bootbox.dialog({
            title:
                '<span class="glyphicon glyphicon-exclamation-sign text-error" aria-hidden="true"></span><span class="error-title">&nbsp;&nbsp;Oops - we found some items that need your attention.</span>',
            closeButton: false,
            message: messageText,
            onEscape: false,
            className: "my-modal pickdate-modal",
            buttons: {
                main: {
                    label: "Continue",
                    className: "btn-link",
                    callback: continueCallback
                },
                cancel: {
                    label: "Pick a New Date",
                    className: "btn-secondary",
                    callback: cancelCallback
                }
            }
        }).on('shown.bs.modal', function () {
            $(this).find('.modal-footer .btn-secondary').attr('title', 'Pick a New Date');
            $(this).find('.modal-footer .btn-link').attr('title', 'Continue');
        });
    },

    confirm(title, callback) {
        window.bootbox.confirm(title, callback);
    },

    showErrorDialog(messages) {
        // only do this on mobile
        if ($('#Mobile').val() == 'true') {
            window.bootbox.dialog({
                title: '<span class="glyphicon glyphicon-exclamation-sign text-error" aria-hidden="true"></span>&nbsp;&nbsp;Invalid Information',
                message: 'Please correct the issues indicated and try again.',
                closeButton: false,
                className: "my-modal",
                buttons: {
                    main: {
                        label: "OK",
                        className: "btn-secondary"

                    }
                }
            }).on('shown.bs.modal', function () {
                $(this).find('.modal-footer .btn-secondary').attr('title', 'OK');
            });
            $("html, body").animate({ scrollTop: 0 }, "slow");
        } else {

            // Show BootBox Error Message

            /* IE9 Modal Overlay FIX Starts Here */
            window.bootbox.dialog({
                title: '<span class="glyphicon glyphicon-exclamation-sign text-error" aria-hidden="true"></span>&nbsp;&nbsp;Oops - we found some items that need your attention.',
                message: 'Please correct the issues indicated below and try again:<br/><br/><ul class="error-bullets">' + messages.join(' ') + '</ul>',
                closeButton: false,
                className: "my-modal",
                show: false,
                buttons: {
                    main: {
                        label: "OK",
                        className: "btn-secondary",
                        callback: function () {
                            // Empty Error List
                        }
                    }
                }
            }).on('shown.bs.modal', function () {
                $(this).find('.modal-footer .btn-secondary').attr('title', 'OK');
            }).modal('show').on('hidden.bs.modal', function () {
            });
        }
        /* IE9 Modal Overlay FIX Ends Here */
    },

    showMessageDialog(message, success = false) {
        var title = '&nbsp;&nbsp;Oops - we found some items that need your attention.';
        var msgClass = 'glyphicon glyphicon-exclamation-sign text-error';
        if (success) {
            title = '&nbsp;&nbsp;Completed.';
            msgClass = 'glyphicon glyphicon-ok text-error';
        }
        /* IE9 Modal Overlay FIX Starts Here */
        window.bootbox.dialog({
            title: '<span class="' + msgClass + '" aria-hidden="true"></span>' + title,
            message: message,
            closeButton: false,
            className: "my-modal",
            show: false,
            buttons: {
                main: {
                    label: "OK",
                    className: "btn-secondary",
                    callback: function () {
                        // Empty Error List
                    }
                }
            }
        }).on('shown.bs.modal', function () {
            $(this).find('.modal-footer .btn-secondary').attr('title', 'OK');
        }).modal('show').on('hidden.bs.modal', function () {
        });
    },

    showMessageDialogCallBack(message, callback, success = false) {
        var title = '&nbsp;&nbsp;Oops - we found some items that need your attention.';
        var msgClass = 'glyphicon glyphicon-exclamation-sign text-error';
        if (success) {
            title = '&nbsp;&nbsp;Completed.';
            msgClass = 'glyphicon glyphicon-ok text-error';
        }

        /* IE9 Modal Overlay FIX Starts Here */
        window.bootbox.dialog({
            title: '<span class="' + msgClass + '" aria-hidden="true"></span>' + title,
            message: message,
            closeButton: false,
            className: "my-modal",
            show: false,
            buttons: {
                main: {
                    label: "OK",
                    className: "btn-secondary",
                    callback: function () {
                        callback();
                    }
                }
            }
        }).on('shown.bs.modal', function () {
            $(this).find('.modal-footer .btn-secondary').attr('title', 'OK');
        }).modal('show').on('hidden.bs.modal', function () {
        });
    }
});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(7);
var toObject = __webpack_require__(78);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_parseHeaders_js__ = __webpack_require__(131);





const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

function isValidHeaderName(str) {
  return /^[-_a-zA-Z]+$/.test(str.trim());
}

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isString(value)) return;

  if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite)
    } else if(__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_parseHeaders_js__["a" /* default */])(header), valueOrRewrite);
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(this, (value, header) => {
      const key = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].freezeMethods(AxiosHeaders.prototype);
__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].freezeMethods(AxiosHeaders);

/* harmony default export */ __webpack_exports__["a"] = (AxiosHeaders);


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__(8);
var $documentAll = __webpack_require__(61);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
﻿const ComponentInterfaceMixin = {
    props: {
        dataBag: {
            type: Object,
            required: true
        },
        //form state for validation
        state: {
            type: Object,
            required: true
        },
        pageSchema: {
            type: Object,
            required: false
        },
        formKey: {
            type: String,
            required: false
        },
    },
}
/* harmony export (immutable) */ __webpack_exports__["a"] = ComponentInterfaceMixin;


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_index_js__ = __webpack_require__(139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_index_js__["a"]; });





/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(15);
var IE8_DOM_DEFINE = __webpack_require__(65);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(82);
var anObject = __webpack_require__(28);
var toPropertyKey = __webpack_require__(79);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var shared = __webpack_require__(75);
var hasOwn = __webpack_require__(18);
var uid = __webpack_require__(80);
var NATIVE_SYMBOL = __webpack_require__(76);
var USE_SYMBOL_AS_UID = __webpack_require__(81);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deepMerge;
/* unused harmony export getFieldValue */
/* harmony export (immutable) */ __webpack_exports__["b"] = getQueryValues;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMap;
﻿
function deepMerge(source1, source2) {
    // Create a new object that combines the properties of both input objects
    source1 = source1 || {};
    source2 = source2 || {};
    const merged = Object.assign({}, source1, source2);

    // Loop through the properties of the merged object
    for (const key of Object.keys(merged)) {
        if (Array.isArray(merged[key])) {
            //combine array
            merged[key] = (source1[key] || []).concat(source2[key] || [])
        }
        // Check if the property is an object
        else if (typeof merged[key] === 'object' && merged[key] !== null) {
            // If the property is an object, recursively merge the objects
            merged[key] = deepMerge(source1[key], source2[key]);
        }
    }
    return merged;
}

function getFieldValue(valueField, data) {
    var val = '';
    if (!valueField) {
        return val;
    }
    const vf = (valueField + '').trim();
    if (vf.indexOf('#') == 0) {
        val = (document.getElementById(vf.substring(1)) || {}).value || '';
    }
    else if (vf.startsWith('$') && vf.endsWith('$')) {
        const f = vf.replaceAll('$', '');
        val = window.document[f];
    }
    else if (vf.startsWith('@') && vf.endsWith('@')) {
        const f = vf.replaceAll('@', '');
        const params = new URLSearchParams(window.location.search)
        if (params && params.has(f)) {
            val = params.get(f);
        }
    }
    else if (vf.startsWith('%') && vf.endsWith('%')) {
        const f = vf.replaceAll('%', '');
        if (data) {
            val = data[f] || '';
        }
    }
    return val;
}

function getQueryValues(keys) {
    var map = {};
    keys = keys || [];
    if (!Array.isArray(keys)) {
        return map;
    }
    const params = new URLSearchParams(window.location.search)

    keys.forEach(key => {
        if (params && params.has(key)) {
            map[key] = params.get(key);
        }
    });
    return map;;
}

function buildMap(source, data) {
    var itemMap = {};
    if (source && Array.isArray(source)) {
        const items = source || []

        console.log('building key/value map', items);
        items.forEach((item) => {
            var val = item.value;
            if (item.valueField) {
                val = getFieldValue(item.valueField, data);
            }
            itemMap[item.key] = val;
        });
    }
    return itemMap;
}


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_AxiosError_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_js__ = __webpack_require__(4);





/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  __WEBPACK_IMPORTED_MODULE_0__core_AxiosError_js__["a" /* default */].call(this, message == null ? 'canceled' : message, __WEBPACK_IMPORTED_MODULE_0__core_AxiosError_js__["a" /* default */].ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

__WEBPACK_IMPORTED_MODULE_1__utils_js__["a" /* default */].inherits(CanceledError, __WEBPACK_IMPORTED_MODULE_0__core_AxiosError_js__["a" /* default */], {
  __CANCEL__: true
});

/* harmony default export */ __webpack_exports__["a"] = (CanceledError);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_node_classes_FormData_js__ = __webpack_require__(55);




// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored


/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isPlainObject(thing) || __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArray(arr) && !arr.some(isVisitable);
}

const predicates = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].toFlatObject(__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */], {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (__WEBPACK_IMPORTED_MODULE_2__platform_node_classes_FormData_js__["a" /* default */] || FormData)();

  // eslint-disable-next-line no-param-reassign
  options = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isSpecCompliantForm(formData);

  if (!__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isBlob(value)) {
      throw new __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__["a" /* default */]('Blob is not supported. Use a Buffer instead.');
    }

    if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArrayBuffer(value) || __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArray(value) && isFlatArray(value)) ||
        ((__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isFileList(value) || __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].endsWith(key, '[]')) && (arr = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(value, function each(el, key) {
      const result = !(__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isUndefined(el) || el === null) && visitor.call(
        formData, el, __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/* harmony default export */ __webpack_exports__["a"] = (toFormData);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(233).Buffer))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(20);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(7);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var isCallable = __webpack_require__(8);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(66);
var requireObjectCoercible = __webpack_require__(73);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
﻿
function evaluateConditionCollection(conditions, dataBag, defaultValue) {
    var result = defaultValue;
    var condIndex = 0;
    conditions = conditions || [];
    dataBag = dataBag || {};

    conditions.forEach(condition => {
        condIndex++;
        var data = dataBag[condition.dataKey];
        const value = condition.value;
        const operator = (condition.operator || '').trim();
        const format = condition.format;
        var dataResult = data;

        switch (format) {
            case 'count':
                {
                    dataResult = (data || []).length + '';
                }
                break;
            default:
        }
        var conditionResult = false;
        switch (operator) {
            case '=':
                {
                    conditionResult = dataResult == value;
                }
                break;
            case '!=':
                {
                    conditionResult = dataResult != value;
                }
                break;
            case '>':
                {
                    conditionResult = dataResult > value;
                }
                break;
            case '<':
                {
                    conditionResult = dataResult < value;
                }
                break;
            case '<=':
                {
                    conditionResult = dataResult <= value;
                }
                break;
            case '>=':
                {
                    conditionResult = dataResult <= value;
                }
                break;
            case 'in':
                {
                    conditionResult = (value || []).includes(dataResult);
                }
                break;
            default:
                conditionResult = false;
        }
        //const conditionResult = evalExpression(dataResult + operator + value, dataBag, defaultValue);
        //combine result from previous

        result = condIndex === 1 ? conditionResult : result && conditionResult;
    });
    return result;
}

function evaluateConditionExpression(expression, dataBag, defaultValue) {
    //expression = expression ;
    return evalExpression(expression, dataBag, defaultValue);
}
function evaluateConditions(conditions, dataBag, defaultValue) {

    if (Array.isArray(conditions)) {
        return evaluateConditionCollection(conditions, dataBag, defaultValue);
    }
    else if (typeof conditions === 'string' || conditions instanceof String) {
        return evaluateConditionExpression(conditions, dataBag, defaultValue);
    }

}

function isGroupHidable(grp, dataBag, defaultValue) {
    if (!grp) {
        return true;
    }
    if (grp.hideConditions && dataBag) {
        return evaluateConditions(grp.hideConditions, dataBag, defaultValue);
    }
    else {
        return false;
    }
}

function evalExpression(exp, data, defaultValue) {
    try {
        var dataBag = data || {};
        console.log('evalExpression', exp, dataBag)

        return eval(exp);
    } catch (e) {
        console.log(e);
    }
    return defaultValue;
}

/* harmony default export */ __webpack_exports__["a"] = ({
    evaluateConditions,
    isGroupHidable
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transitional_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_toFormData_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_toURLEncodedForm_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__platform_index_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_formDataToJSON_js__ = __webpack_require__(54);










const DEFAULT_CONTENT_TYPE = {
  'Content-Type': undefined
};

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: __WEBPACK_IMPORTED_MODULE_2__transitional_js__["a" /* default */],

  adapter: ['xhr', 'http'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isObject(data);

    if (isObjectPayload && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isFormData(data);

    if (isFormData) {
      if (!hasJSONContentType) {
        return data;
      }
      return hasJSONContentType ? JSON.stringify(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_formDataToJSON_js__["a" /* default */])(data)) : data;
    }

    if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArrayBuffer(data) ||
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isBuffer(data) ||
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isStream(data) ||
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isFile(data) ||
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isBlob(data)
    ) {
      return data;
    }
    if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArrayBufferView(data)) {
      return data.buffer;
    }
    if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_toURLEncodedForm_js__["a" /* default */])(data, this.formSerializer).toString();
      }

      if ((isFileList = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_toFormData_js__["a" /* default */])(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (data && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__["a" /* default */].from(e, __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__["a" /* default */].ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __WEBPACK_IMPORTED_MODULE_5__platform_index_js__["a" /* default */].classes.FormData,
    Blob: __WEBPACK_IMPORTED_MODULE_5__platform_index_js__["a" /* default */].classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].merge(DEFAULT_CONTENT_TYPE);
});

/* harmony default export */ __webpack_exports__["a"] = (defaults);


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(11);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__(36);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var defineGlobalProperty = __webpack_require__(34);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83), __webpack_require__(16)))

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
﻿/* harmony default export */ __webpack_exports__["a"] = ({
    //installed: false,

    install(Vue, options) {
        console.log("registering event bus");
        //if (install.installed) return
        //install.installed = true

        var eventBus = new Vue();

        Object.defineProperty(Vue.prototype, '$eventBus', {
            get() { return eventBus }
        })
    }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Constants__ = __webpack_require__(1);
﻿



const ValidateOnNextMixin = {

    data: function () {
        return {
            validateOnNext: false,
            pageLevel: false,
            componentKey: '',
            validationOrder: 0 //default order, validation will be in random order, 
            //determined by component registeration in page
            //any positive value will determine order i.e. 1 then 2 then 3 etc
        };
    },
    created() {
        console.log('ValidateOnNextMixin:created');
        this.attachValidateOnNextEventHandler();
    },
    destroyed() {
        console.log('ValidateOnNextMixin:destroyed');

        this.detachValidateOnNextEventHandler();
        this.deregisterSelfForValidationOnNext();

    },
    mounted() {
        this.registerSelfForValidationOnNext();
    },
    methods: {
        registerSelfForValidationOnNext() {
            //register self for onNext button validation
            if (this.validateOnNext) {
                //broacast registration event for registration
                console.log('Broadcasting registration event for componet on next button click for componentKey:' + this.componentKey);
                if (!this.componentKey) {
                    this.componentKey = __WEBPACK_IMPORTED_MODULE_1__Shared_Utilities_Utility__["b" /* Utility */].newGuid();
                }
                this.broadCastRegisterComponentForValidationOnNext({
                    nameKey: this.nameKey,
                    componentKey: this.componentKey,
                    pageLevel: this.pageLevel,
                    validationOrder: this.validationOrder
                });
            }
        },
        deregisterSelfForValidationOnNext() {
            //unregister component when destroyed
            if (this.validateOnNext) {
                //broadcast registration event for validation
                this.broadCastRegisterComponentForValidationOnNext({
                    componentKey: this.componentKey,
                    unregister: true
                });
            }
        },
        //events
        attachValidateOnNextEventHandler() {
            console.log('VlidateOnNextMixin=>registerValidateOnNextEventHandler');
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_2__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.VALIDATE_ON_NEXT, this.__onValidateOnNextInternal);
        },
        detachValidateOnNextEventHandler() {
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_2__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.VALIDATE_ON_NEXT, this.__onValidateOnNextInternal);
        },
        broadCastValidateOnNextCompleted(data) {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_2__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.VALIDATE_ON_NEXT_COMPLETED, data);
        },
        broadCastRegisterComponentForValidationOnNext(data) {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_2__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.REGISTER_COMPONENT_FOR_VALIDATION_ON_NEXT, data);
        },
        //on next validation related method
        __onValidateOnNextInternal(evtData) {
            console.log('evtData component key : ', evtData.componentKey);
            console.log('this component key : ', this.componentKey);
            if (evtData && evtData.componentKey === this.componentKey) {
                this.onValidateOnNext(evtData, this.__validateOnNextCompletedCallback);
            }
        },
        __validateOnNextCompletedCallback(data) {
            var consolidatedData = Object.assign(data || {}, { componentKey: this.componentKey });
            //provide feedback that validation is completed, 
            this.broadCastValidateOnNextCompleted(consolidatedData);
        },
        ///this need to be overidden in derived component to do actual task and then provide feedback about task completion
        onValidateOnNext(evtData, completionCallback) {
            console.log("ComponentBaseMixin=>ValidateOnNext", evtData, this);
            if (completionCallback) {
                completionCallback();
            }
        }
    }
}
/* harmony export (immutable) */ __webpack_exports__["a"] = ValidateOnNextMixin;


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
﻿/* harmony default export */ __webpack_exports__["a"] = ({
    //convert heirarchical session data to flat structure
    ConvertSessionDataToDataBag(sessionData) {
        var dataBag = {};
        if (sessionData == null || sessionData == undefined) {
            return dataBag;
        }
        for (var sItemIndex = 0; sItemIndex < sessionData.length; sItemIndex++)  {
            var sessionValue = sessionData[sItemIndex];

            var type = (sessionValue && sessionValue.type) ? sessionValue.type : ''
            if (type == 'string') {
                dataBag[sessionValue.id] = sessionValue.value;
            }
            else if (type == 'object') {
                var obj = {};
                dataBag[sessionValue.id] = obj;
                for (var oItemIndex = 0; oItemIndex < sessionValue.list.length; oItemIndex++) {
                    var oItem = sessionValue.list[oItemIndex];
                    obj[oItem.id] = oItem.value;
                }
            }
            else if (type == 'array') {
                var array = [];
                dataBag[sessionValue.id] = array;
                for (var aItemIndex = 0; aItemIndex < sessionValue.list.length; aItemIndex++) {
                    var aItem = sessionValue.list[aItemIndex];
                    var arrayItem = {};

                    for (var aInnerItemIndex = 0; aInnerItemIndex < aItem.list.length; aInnerItemIndex++) {
                        var aInnerItem = aItem.list[aInnerItemIndex];
                        arrayItem[aInnerItem.id] = aInnerItem.value;
                    }
                    array.push(arrayItem);
                }
            }
        }
        return dataBag
    },
    //convert flat structure dataBag to convert heirarchical session data
    ConvertDataBagToSessionData(dataBag) {
        var postDataBag = [];

        if (dataBag == null || dataBag == undefined) {
            return postDataBag;
        }

        for (var prop in dataBag) {
            //check the current prop is not an inherited prop
            if (dataBag.hasOwnProperty(prop)) {

                var value = dataBag[prop];
                if (value !== undefined && value != null
                    && typeof value !== "function" && typeof value !== "symbol") {
                    //check if the value is array
                    if (Array.isArray(value)) {
                        var items = [];

                        var answer = {
                            ID: prop,
                            Type: 'array',
                            List: [],
                        };
                        //answer.List.push(items);
                        postDataBag.push(answer);
                        //iterate array item
                        for (var itemIndex = 0; itemIndex < value.length; itemIndex++) {
                            var item = value[itemIndex];
                            //create answer for item
                            const itemId = (item["key"] || itemIndex + 1);
                            var itemAnswer = {
                                ID: itemId,
                                Type: item.type,
                            };
                            //pus answer to top level List array
                            answer.List.push(itemAnswer);

                            //create list for pushing current item properties
                            itemAnswer.List = [];
                            for (var p in item) {
                                //push item property to current item List collection
                                itemAnswer.List.push({
                                    ID: p,
                                    Type: 'string',
                                    Value: item[p],
                                })
                            }
                        }
                    }
                    else if (typeof value === "string" || typeof value === "number" || typeof value === 'boolean') {
                        var answer = {
                            ID: prop,
                            Type: 'string',
                            Value: value,
                        };
                        postDataBag.push(answer);
                    }
                    else if (typeof value === "object") {
                        //TODO
                        var answer = {
                            ID: prop,
                            Type: 'object',
                            List: [],
                        };
                        postDataBag.push(answer);
                        for (var p in value) {
                            //push item property to current item List collection
                            answer.List.push({
                                ID: p,
                                Type: 'string',
                                Value: value[p],
                            })
                        }
                    }
                }
            }
        }
        return postDataBag;
    }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const componentTypeNameMapping = {
    //'field type key in question schema': 'vue js registered component name',
    'label': 'label-view',
    'text': 'text-input-view',
    'textarea': 'text-input-view',
    'email': 'email-input-view',
    'date': 'date-input-view',
    'phone': 'phone-input-view',
    'money': 'money-input-view',
    'ssn': 'ssn-input-view',
    'dropdown': 'drop-down-view',
    'searchableList':'searchable-drop-down-view',
    'radio': 'radio-button-view',
    'yesno': 'yesno-button-view',
    'checkbox': 'checkbox-view',
    'toggle':'toggle-view',
    'checkboxGroupValidator': 'checkbox-group-validator',
    'single-tile': 'single-tile-view',
    'multi-tile': 'multi-tile-view',
    'content': 'content-view',
    'empty': 'empty-view',
    'richContent': 'rich-content-view',
    'lungDisorderComponent': 'lung-Disorder',
    'cancerDiseaseComponent': 'cancer-Disease',
    'heartDiseaseComponent': 'heart-Disease',
    'beneficiaryComponent': 'beneficiary',
    'beneficiaryAllocationComponent': 'beneficiary-Allocation',
    'travelPlanComponent': 'travelPlan',
    'declinedPolicyDetailComponent': 'declined-policy-detail',
    'existingPolicyDetailComponent': 'existing-policy-detail',
    'bankruptcyComponent': 'bankruptcy',
    'familystrokeComponent': 'family-Stroke-History',
    'cancerDiseaseHistoryComponent': 'cancer-disease-history',
    'drivingViolationComponent': 'driving-Violation',
    'paymentComponent': 'payment-component',
    'medicalExamComponent': 'medical-exam',
    'quoteComponent': 'quote',
    'termLengthComponent': 'term-length',
    'heartDiseaseHistoryComponent': 'heart-disease-history',
    'applicationSummaryReviewComponent': 'application-summary-review',
    'addressComponent': 'address-view',
    'personalinforeviewComponent': 'personal-info-review',
    'callUsComponent': 'callUsComponent',
    'giwlCallUsComponent':'giwlCallUsComponent',
    'thankYouComponent': 'thankQComponent',
    'coverageComponent': 'coverageComponent',
    'needsAnalysisComponent': 'needsAnalysisComponent',
    'childrenComponent': 'childrenComponent',
    'analyticsComponent': 'analyticsComponent',
    'selectPickerComponent': 'selectPicker',
    'landingComponent': 'landingComponent',
    "nfibLandingComponent": "nfibLandingComponent",
    'aigQuoteComponent': 'aigQuote',
    'advancedCallUsComponent': 'advancedCallUsComponent',
    'continueApplicationButtonComponent': 'continueApplicationButtonComponent',
    'loginComponent': 'loginComponent',
    'advisorDashboardComponent': 'advisor-dashboard',
    'signApplicationComponent': 'signApplicationComponent',
    'beneficiaryEditableList': 'beneficiary-editable-list-view',
    'coverageSummaryComponent': 'coverageSummaryComponent',
    'applicationSubmissionComponent':'applicationSubmissionComponent',
    "advanceFormComponent": "advanceFormComponent",
    'smartAddressComponent': 'smartAddressComponent',
    'giwlPaymentComponent': 'giwlPaymentComponent',
    'infoSectionComponent': 'infoSectionComponent',
    "smartListComponent": "smartListComponent",
    'inlineSmartFormComponent': 'inlineSmartFormComponent',
    'beneficiaryReviewComponent': 'beneficiaryReviewComponent',
    'quoteEditorComponent': 'quoteEditorComponent',
    'payConnectPaymentComponent': 'payConnectPaymentComponent',
    'consentDialog':'consent-dialog',
    'b2cLanding': 'b2cLanding',
    'faqComponent': 'faqComponent',
    'upsellQuoteComponent': 'upsellQuoteComponent',
    'contentComponent': 'contentComponent',
    'diclosureFormsComponent': 'diclosureFormsComponent',
    'payConnectPaymentViewWithNoAuthComponent': 'payConnectPaymentViewWithNoAuthComponent',
    'paymentReviewAndAuthorizeComponent': 'paymentReviewAndAuthorizeComponent',
    'sffThankYouComponent': 'sffThankYouComponent',
    'talkToAgent': 'talkToAgent',
    'calculatorComponent': 'calculatorComponent',
    'quoteEditor':'quoteEditor'
}
/* harmony export (immutable) */ __webpack_exports__["a"] = componentTypeNameMapping;


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    prefix: '',
    suffix: '',
    thousands: ',',
    decimal: '.',
    precision: 2
});


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isCancel;


function isCancel(value) {
  return !!(value && value.__CANCEL__);
}


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildFullPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_isAbsoluteURL_js__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_combineURLs_js__ = __webpack_require__(126);





/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_isAbsoluteURL_js__["a" /* default */])(requestedURL)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_combineURLs_js__["a" /* default */])(baseURL, requestedURL);
  }
  return requestedURL;
}


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AxiosHeaders_js__ = __webpack_require__(19);





const headersToObject = (thing) => thing instanceof __WEBPACK_IMPORTED_MODULE_1__AxiosHeaders_js__["a" /* default */] ? thing.toJSON() : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, caseless) {
    if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isPlainObject(target) && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isPlainObject(source)) {
      return __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].merge.call({caseless}, target, source);
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isPlainObject(source)) {
      return __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].merge({}, source);
    } else if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, caseless) {
    if (!__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isUndefined(b)) {
      return getMergedValue(a, b, caseless);
    } else if (!__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isUndefined(a)) {
      return getMergedValue(undefined, a, caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b) => mergeDeepProperties(headersToObject(a), headersToObject(b), true)
  };

  __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
});


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const VERSION = "1.3.3";
/* harmony export (immutable) */ __webpack_exports__["a"] = VERSION;


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toFormData_js__ = __webpack_require__(27);




/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toFormData_js__["a" /* default */])(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode);
  } : encode;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/* harmony default export */ __webpack_exports__["a"] = (AxiosURLSearchParams);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bind;


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildURL;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_AxiosURLSearchParams_js__ = __webpack_require__(51);





/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?object} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isURLSearchParams(params) ?
      params.toString() :
      new __WEBPACK_IMPORTED_MODULE_1__helpers_AxiosURLSearchParams_js__["a" /* default */](params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);




/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];
    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArray(target) ? target.length : name;

    if (isLast) {
      if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isFormData(formData) && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isFunction(formData.entries)) {
    const obj = {};

    __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/* harmony default export */ __webpack_exports__["a"] = (formDataToJSON);


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// eslint-disable-next-line strict
/* harmony default export */ __webpack_exports__["a"] = (null);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__(8);
var tryToString = __webpack_require__(224);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(24);
var create = __webpack_require__(211);
var defineProperty = __webpack_require__(23).f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(199);
var uncurryThis = __webpack_require__(7);
var IndexedObject = __webpack_require__(66);
var toObject = __webpack_require__(78);
var lengthOfArrayLike = __webpack_require__(70);
var arraySpeciesCreate = __webpack_require__(193);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(15);
var definePropertyModule = __webpack_require__(23);
var createPropertyDescriptor = __webpack_require__(60);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var isObject = __webpack_require__(20);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var uncurryThis = __webpack_require__(7);

module.exports = function (CONSTRUCTOR, METHOD) {
  return uncurryThis(global[CONSTRUCTOR].prototype[METHOD]);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var getOwnPropertyDescriptor = __webpack_require__(71).f;
var createNonEnumerableProperty = __webpack_require__(59);
var defineBuiltIn = __webpack_require__(196);
var defineGlobalProperty = __webpack_require__(34);
var copyConstructorProperties = __webpack_require__(195);
var isForced = __webpack_require__(207);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(15);
var fails = __webpack_require__(11);
var createElement = __webpack_require__(62);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(7);
var fails = __webpack_require__(11);
var classof = __webpack_require__(29);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(7);
var isCallable = __webpack_require__(8);
var store = __webpack_require__(39);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(30);
var isCallable = __webpack_require__(8);
var isPrototypeOf = __webpack_require__(215);
var USE_SYMBOL_AS_UID = __webpack_require__(81);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__(221);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(15);
var call = __webpack_require__(37);
var propertyIsEnumerableModule = __webpack_require__(217);
var createPropertyDescriptor = __webpack_require__(60);
var toIndexedObject = __webpack_require__(31);
var toPropertyKey = __webpack_require__(79);
var hasOwn = __webpack_require__(18);
var IE8_DOM_DEFINE = __webpack_require__(65);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(7);
var hasOwn = __webpack_require__(18);
var toIndexedObject = __webpack_require__(31);
var indexOf = __webpack_require__(191).indexOf;
var hiddenKeys = __webpack_require__(38);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var isNullOrUndefined = __webpack_require__(68);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(75);
var uid = __webpack_require__(80);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(208);
var store = __webpack_require__(39);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.28.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.28.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(198);
var fails = __webpack_require__(11);

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var trunc = __webpack_require__(210);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(73);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__(222);
var isSymbol = __webpack_require__(69);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(7);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(76);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(15);
var fails = __webpack_require__(11);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),
/* 83 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(309),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\FormApp\\components\\CalculatorComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CalculatorComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-939ef04a", Component.options)
  } else {
    hotAPI.reload("data-v-939ef04a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(305),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\FormApp\\components\\InteractiveFormComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] InteractiveFormComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8aab0372", Component.options)
  } else {
    hotAPI.reload("data-v-8aab0372", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\FormApp\\components\\MultiStepIndicator.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MultiStepIndicator.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-83dbe44c", Component.options)
  } else {
    hotAPI.reload("data-v-83dbe44c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(287),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\FormApp\\components\\TalkToAgent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TalkToAgent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4120d584", Component.options)
  } else {
    hotAPI.reload("data-v-4120d584", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(288),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\RichContentView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RichContentView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-44858ec8", Component.options)
  } else {
    hotAPI.reload("data-v-44858ec8", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mountApp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
﻿

function mountApp(appComponent, router, elementId = "app", props = ['experience', 'routePrefix']) {
    const nodeSelector = "#" + elementId;
    const appElement = document.querySelector(nodeSelector);

    var rootProps = {};
    if (appElement && appElement.dataset && props) {
        props.forEach(prop => {
            rootProps[prop] = appElement.dataset[prop];
        });
    }
    const ctx = {
        props: rootProps
    }
    console.log('app mounted with rootProps, node', rootProps, elementId)

    if (router) {
        const v = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
            el: nodeSelector,
            router: router,
            render: h => h(appComponent, ctx)
        });
    }
    else {
        new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
            render: h => h(appComponent, ctx)
        }).$mount(nodeSelector)
    }
}

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dropConsole;
﻿function dropConsole() {
    console.log('dropConsole ' + "dev")
    if (false) {
        console.log('console is dropped in ' + process.env.NODE_ENV)
        console.log = () => { };
        console.debug = () => { };
        console.info = () => { };
        console.warn = () => { };
    }
    else {
        console.log('console is not dropped in ' + "dev")
    }
}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(311),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\FormApp\\App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dbaef410", Component.options)
  } else {
    hotAPI.reload("data-v-dbaef410", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidateOnNextMixin__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_HttpCommunicationService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_dialogService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_Constants__ = __webpack_require__(1);
﻿






const BasePageComponentMixin = {
    mixins: [__WEBPACK_IMPORTED_MODULE_2__ValidateOnNextMixin__["a" /* ValidateOnNextMixin */]],
    data() {
        return {
            componentKey: __WEBPACK_IMPORTED_MODULE_1__Shared_Utilities_Utility__["b" /* Utility */].newGuid(),
            validateOnNext: true,
            onNextValidationComponents: [],
            pageLevel: true,
            timeoutRef: null,
            waitTime: 2000,
        }
    },
    created() {
        console.log('BasePageComponentMixin:created');
        this.attachValidateOnNextCompletedHandler();
        this.attachRegisterComponentForValidationOnNextHandler();
        this.attachFieldLoadedHandlers();
    },
    destroyed() {
        console.log('BasePageComponentMixin:destroyed');
        this.detachValidateOnNextCompleted();
        this.detachRegisterComponentForValidationOnNextHandler();
        this.detachFieldLoadedHandlers();
    },
    computed: {
        validateQuote() {
            const page = this.pageData;
            console.log('BasePageComponentMixin.computed=>validateQuote', page);
            return page && page.pageSchema && (page.pageSchema.verifyQuote + '' || '').toLowerCase() == 'true';
        },
        validateFormOnLoad() {
            const page = this.pageData;

            const validate = page && page.pageSchema &&
                page.pageSchema.validateDataOnLoad !== undefined ? page.pageSchema.validateDataOnLoad : false;
            console.log('BasePageComponentMixin.computed=>validateFormOnLoad', validate);
            return validate;
        },
    },
    methods: {
        broadCastValidateOnNext(data) {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_5__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.VALIDATE_ON_NEXT, data);
        },
        //register for child component for confirmation feedback event to initiate submission
        attachValidateOnNextCompletedHandler() {
            console.log('BasePageComponentMixin=>attachValidateOnNextCompletedHandler');
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_5__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.VALIDATE_ON_NEXT_COMPLETED, this.validateOnNextCompletedHandler);
        },
        detachValidateOnNextCompleted() {
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_5__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.VALIDATE_ON_NEXT_COMPLETED, this.validateOnNextCompletedHandler);
        },
        attachRegisterComponentForValidationOnNextHandler() {
            console.log('BasePageComponentMixin=>attachRegisterComponentForValidationOnNextHandler');
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_5__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.REGISTER_COMPONENT_FOR_VALIDATION_ON_NEXT,
                this.registerComponentForValidationOnNextHandler);
        },
        detachRegisterComponentForValidationOnNextHandler() {
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_5__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.REGISTER_COMPONENT_FOR_VALIDATION_ON_NEXT,
                this.registerComponentForValidationOnNextHandler);
        },
        registerComponentForValidationOnNextHandler(data) {

            console.log('BasePageComponentMixin registraion event recieved with event data', data);
            //if unregister then remove from collection
            if (data.unregister) {
                console.log('registerComponentForValidationOnNext = > Unregistering component with key: ', data.componentKey);
                this.removeComponentFromValidation(data);
            }
            else {
                //its registeration event, add event source key in collection
                console.log('registerComponentForValidationOnNext => Registring component with key: ', data.componentKey);
                this.addComponentForValidation(data);
            }
        },

        attachFieldLoadedHandlers() {
            console.log('BasePageComponentMixin=>attachFieldLoadedHandlers');
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_5__Shared_Constants__["a" /* Constants */].FIELD_EVENTS.FIELD_LOADED, this.onFieldLoaded);
        },
        detachFieldLoadedHandlers() {
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_5__Shared_Constants__["a" /* Constants */].FIELD_EVENTS.FIELD_LOADED, this.onFieldLoaded);
        },
        onFieldLoaded(data) {
            console.log('BasePageComponentMixin=>onFieldLoaded', data);
            const self = this;
            //invoke
            //clear first existing
            if (window) {
                if (this.timeoutRef) {
                    window.clearTimeout(this.timeoutRef);
                    this.timeoutRef = null;
                }
                this.timeoutRef = window.setTimeout(function () {
                    console.log('validate form on load', self.validateFormOnLoad);
                    if (self.validateFormOnLoad) {
                        self.validateForm();
                    }
                }, this.waitTime);
            }
        },

        validateOnNextCompletedHandler(data) {
            console.log("onValidateOnNextCompleted", data);
            data = data || {};
            //check for another component if need valdiation or save data and navigate
            this.validateOnNextOrSaveDataBagAndNavigateToNext(data);
        },

        //inform child component to take action/confirm before submission

        validateOnNextOrSaveDataBagAndNavigateToNext(data, evtData) {
            //check if any component needs to validate onNext button click
            var components = this.onNextValidationComponents;
            console.log('validateOnNextOrSaveDataBagAndNavigateToNext=>component list', components);
            if (data) {
                //remove already validated component from list
                this.removeComponentFromValidation(data);
            }
            evtData = evtData || {};
            //check if need to suppress validation on next
            var supressValidation = evtData[__WEBPACK_IMPORTED_MODULE_5__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENT_DATA.SUPPRESS_VALIDATION_ON_NEXT] || false;
            //inform component to validate itself, take first from list;
            const componentData = this.getNextComponentForValidation();

            if (componentData && !supressValidation) {
                console.log('validateOnNextOrSaveDataBagAndNavigateToNext=>broadcasting validation event for next component', components);
                //broadcast validate events for component validation;
                this.broadCastValidateOnNext(componentData);
            }
            else {
                //reset page level component to not validated for next page;
                this.resetPageLevelComponentValidationFlag();
                console.log('validateOnNextOrSaveDataBagAndNavigateToNext=>no more component for validation, submitting page...');
                //else submit and navigate
                this.saveDataBagAndNavigateToNext();
            }
        },

        addComponentForValidation(data) {
            console.log('addComponentForValidation', data);
            var components = this.onNextValidationComponents || [];
            if (data && data.componentKey) {
                //push
                components.push(data);
                //component will be ordered by validationOrder i.e. 1,2,3... and at last 0
                components.sort((c1, c2) => {
                    if (c1.validationOrder === 0 && c2.validationOrder === 0) {
                        return 0;
                    }
                    else if (c1.validationOrder > 0 && c2.validationOrder > 0) {
                        return c1.validationOrder - c2.validationOrder;
                    }
                    else {
                        return c2.validationOrder - c1.validationOrder;
                    }
                });
                console.log('component validation order', components);
            }
        },

        getNextComponentForValidation() {
            var components = this.onNextValidationComponents || [];
            //get first component which is not validation yet
            const component = components.find(c => !c.pageLevel || (c.pageLevel && !c.validated));
            return component;
        },

        resetPageLevelComponentValidationFlag() {
            var components = this.onNextValidationComponents || [];
            components.forEach(c => c.validated = false);
        },

        removeComponentFromValidation(data) {
            var components = this.onNextValidationComponents || [];
            if (data && data.componentKey) {
                //get component from keys
                var componentIndex = components.findIndex(c => c.componentKey == data.componentKey);
                if (componentIndex > -1) {
                    var componentData = components[componentIndex];
                    if (componentData) {
                        //if its a page level compnent, dont remove but rather update to set flag that is validated
                        if (componentData.pageLevel) {
                            componentData.validated = true;
                            components[componentIndex] = componentData;
                            console.log('removeComponentFromValidation = >  Updated component to validated with key: ' + data.componentKey)
                        }
                        else {
                            components.splice(componentIndex, 1);
                            console.log('removeComponentFromValidation = >  Unregistered component with key: ' + data.componentKey);
                        }
                    }
                }
            }
        },

        //to support page level validation to trigger on click of next button
        onValidateOnNext(evtData, completionCallback) {
            //put all validation here
            console.log('BasePageComponent=>onValidateOnNext', evtData);
            this.verifyQuote(evtData, completionCallback);
        },
        navigateToQuotePage() {
            var nextPage = __WEBPACK_IMPORTED_MODULE_5__Shared_Constants__["a" /* Constants */].PAGE_ID.QUOTE;
            var route = {
                path: '',
                params: { pageId: nextPage }
            };
            this.$router.push(route);
        },
        verifyQuote(evtData, completionCallback) {
            console.log('verifyQuote=>validateQuote : ', this.validateQuote);
            if (!this.validateQuote) {
                if (completionCallback) {
                    completionCallback();
                }
                return;
            }
            console.log("BasePageComponentMixin=>verifyQuote", evtData, this);
            console.log('verifying quote...');
            //make API call, show message if needed
            var $this = this;
            //show wait dialog
            const dialog = __WEBPACK_IMPORTED_MODULE_4__services_dialogService__["a" /* default */].showProcessingDialog();

            __WEBPACK_IMPORTED_MODULE_3__services_HttpCommunicationService__["a" /* default */].verifyQuote(
                function (quoteValid) {
                    if (!quoteValid) {
                        $this.closeDialog(dialog);
                        const message = "There may have been an issue with your quote, we need you to verify your selection for coverage and premium. Your progress has been saved and re-entry will not be required.  Click \"Ok\" to continue. ";
                        __WEBPACK_IMPORTED_MODULE_4__services_dialogService__["a" /* default */].showMessageDialogCallBack(message,
                            function () {
                                $this.navigateToQuotePage();
                            });
                    }
                    else {
                        if (completionCallback) {
                            $this.closeDialog(dialog);
                            completionCallback();
                        }
                    }
                },
                function (error) {
                    console.log("verifyQuote " + error);
                    if (completionCallback) {
                        $this.closeDialog(dialog);
                        completionCallback();
                    }
                });
        },

        closeDialog(dialog) {
            dialog.modal('hide');
        }
    }
}
/* harmony export (immutable) */ __webpack_exports__["a"] = BasePageComponentMixin;



/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_HttpCommunicationService__ = __webpack_require__(12);
﻿

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function () {
        return {
            componentIdentifier: '',
            dynamicData: {},
            dynamicContentLoaded: true,
            dynamicContentKeys: []
        };
    },
    methods: {
        loadDynamicContent(componentIdentifier, properties) {
            try {

                componentIdentifier = componentIdentifier || this.componentIdentifier;
                properties = properties || this.dynamicContentKeys;

                const $this = this;
                var propsValue = properties;
                //,successCallback, failureCallback
                //if properties is array then convert to comma separated string
                if (Array.isArray(properties)) {
                    propsValue = properties.join(',');
                }

                console.log('loadDynamicContent', { componentIdentifier, propsValue });

                $this.dynamicContentLoaded = false;
                __WEBPACK_IMPORTED_MODULE_0__services_HttpCommunicationService__["a" /* default */].getDynamicContent(
                    {
                        key: componentIdentifier,
                        properties: propsValue
                    },
                    //successCallback
                    (data) => {
                        $this.dynamicData = data;
                        $this.dynamicContentLoaded = true;
                    },
                    //failureCallback
                    (error) => {
                        $this.dynamicContentLoaded = true;
                    });

            } catch (error) {

            }
        }
    }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_components_TextInputView_vue__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_components_TextInputView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Shared_components_TextInputView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_components_EmailInputView_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_components_EmailInputView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Shared_components_EmailInputView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_components_DateInputView_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_components_DateInputView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Shared_components_DateInputView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_components_PhoneInputView_vue__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_components_PhoneInputView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Shared_components_PhoneInputView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_components_MoneyInputView_vue__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_components_MoneyInputView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Shared_components_MoneyInputView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_components_SSNInputView_vue__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_components_SSNInputView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Shared_components_SSNInputView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_components_DropDownView_vue__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_components_DropDownView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Shared_components_DropDownView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_components_RadioButtonView_vue__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_components_RadioButtonView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Shared_components_RadioButtonView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_components_YesNoOptionView_vue__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Shared_components_YesNoOptionView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Shared_components_YesNoOptionView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_components_CheckboxView_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Shared_components_CheckboxView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Shared_components_CheckboxView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_components_CheckboxGroupValidator_vue__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Shared_components_CheckboxGroupValidator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Shared_components_CheckboxGroupValidator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_components_SingleTileView_vue__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_components_SingleTileView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Shared_components_SingleTileView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_components_GroupComponent_vue__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Shared_components_GroupComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Shared_components_GroupComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Shared_components_QuestionViewComponent_vue__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Shared_components_QuestionViewComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Shared_components_QuestionViewComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_components_SubformValidationMessageView_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Shared_components_SubformValidationMessageView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__Shared_components_SubformValidationMessageView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_components_ContentView_vue__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Shared_components_ContentView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Shared_components_ContentView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Shared_components_EmptyView_vue__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Shared_components_EmptyView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Shared_components_EmptyView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Shared_components_RichContentView_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Shared_components_RichContentView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__Shared_components_RichContentView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Shared_components_FormComponent_vue__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Shared_components_FormComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__Shared_components_FormComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Shared_components_LoadingView_vue__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Shared_components_LoadingView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__Shared_components_LoadingView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Shared_components_ReadonlyView_vue__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Shared_components_ReadonlyView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Shared_components_ReadonlyView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Shared_components_HelpBubbleComponent_vue__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Shared_components_HelpBubbleComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__Shared_components_HelpBubbleComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Shared_components_SmartAddressComponent_vue__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Shared_components_SmartAddressComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__Shared_components_SmartAddressComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Shared_components_ExperiencePageComponent_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Shared_components_ExperiencePageComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__Shared_components_ExperiencePageComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Shared_components_PageManager_vue__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Shared_components_PageManager_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__Shared_components_PageManager_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_NavigationComponent_vue__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_NavigationComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_NavigationComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_ThankYou_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_ThankYou_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_ThankYou_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_TalkToAgent_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_TalkToAgent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_TalkToAgent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_CalculatorComponent_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_CalculatorComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_CalculatorComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Application_components_ChildrenComponent_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Application_components_ChildrenComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__Application_components_ChildrenComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Application_components_BankruptcyComponent_vue__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Application_components_BankruptcyComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__Application_components_BankruptcyComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Shared_components_businessComponents_ExistingPolicyDetailComponent_vue__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Shared_components_businessComponents_ExistingPolicyDetailComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__Shared_components_businessComponents_ExistingPolicyDetailComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Shared_components_SearchableDropdownView_vue__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Shared_components_SearchableDropdownView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__Shared_components_SearchableDropdownView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_QuoteEditor_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_QuoteEditor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_QuoteEditor_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Shared_components_ToggleView_vue__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__Shared_components_ToggleView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__Shared_components_ToggleView_vue__);
﻿












//import multiTileView from "./../Shared/components/MultiTileView.vue"






/*import sliderView from "./../Shared/components/SliderView.vue"*/

/*import ListComponent from "./../Shared/components/ListComponent.vue"*/
/*import SubFormComponent from "./../Shared/components/SubFormComponent.vue"*/



//import AdvanceFormComponent from "./../Shared/components/AdvanceFormComponent.vue"

/*import ContentComponent from './../Shared/components/ContentComponent.vue';*/













const componentRegistrationPlugin = {
    install(Vue, options) {
        console.log("registering form components");
        Vue.component('read-view', __WEBPACK_IMPORTED_MODULE_20__Shared_components_ReadonlyView_vue___default.a);
        Vue.component('text-input-view', __WEBPACK_IMPORTED_MODULE_0__Shared_components_TextInputView_vue___default.a);
        Vue.component('email-input-view', __WEBPACK_IMPORTED_MODULE_1__Shared_components_EmailInputView_vue___default.a);
        Vue.component('date-input-view', __WEBPACK_IMPORTED_MODULE_2__Shared_components_DateInputView_vue___default.a);
        Vue.component('phone-input-view', __WEBPACK_IMPORTED_MODULE_3__Shared_components_PhoneInputView_vue___default.a);
        Vue.component('money-input-view', __WEBPACK_IMPORTED_MODULE_4__Shared_components_MoneyInputView_vue___default.a);
        Vue.component('ssn-input-view', __WEBPACK_IMPORTED_MODULE_5__Shared_components_SSNInputView_vue___default.a);
        Vue.component('drop-down-view', __WEBPACK_IMPORTED_MODULE_6__Shared_components_DropDownView_vue___default.a);
        Vue.component('radio-button-view', __WEBPACK_IMPORTED_MODULE_7__Shared_components_RadioButtonView_vue___default.a);
        Vue.component('yesno-button-view', __WEBPACK_IMPORTED_MODULE_8__Shared_components_YesNoOptionView_vue___default.a);
        Vue.component('checkbox-view', __WEBPACK_IMPORTED_MODULE_9__Shared_components_CheckboxView_vue___default.a);
        Vue.component('checkbox-group-validator', __WEBPACK_IMPORTED_MODULE_10__Shared_components_CheckboxGroupValidator_vue___default.a);
        Vue.component('single-tile-view', __WEBPACK_IMPORTED_MODULE_11__Shared_components_SingleTileView_vue___default.a);
        //Vue.component('multi-tile-view', multiTileView);
        Vue.component('group-view', __WEBPACK_IMPORTED_MODULE_12__Shared_components_GroupComponent_vue___default.a);
        Vue.component('question-view', __WEBPACK_IMPORTED_MODULE_13__Shared_components_QuestionViewComponent_vue___default.a);
        Vue.component('sub-form-validator', __WEBPACK_IMPORTED_MODULE_14__Shared_components_SubformValidationMessageView_vue___default.a);
        Vue.component('content-view', __WEBPACK_IMPORTED_MODULE_15__Shared_components_ContentView_vue___default.a);
        Vue.component('empty-view', __WEBPACK_IMPORTED_MODULE_16__Shared_components_EmptyView_vue___default.a);
        Vue.component('rich-content-view', __WEBPACK_IMPORTED_MODULE_17__Shared_components_RichContentView_vue___default.a);
        //Vue.component('slider-view', sliderView);
        Vue.component('formComponent', __WEBPACK_IMPORTED_MODULE_18__Shared_components_FormComponent_vue___default.a);
        //Vue.component('listComponent', ListComponent);
        //Vue.component('subFormComponent', SubFormComponent);
        Vue.component('loading-view', __WEBPACK_IMPORTED_MODULE_19__Shared_components_LoadingView_vue___default.a);
        Vue.component('help-bubble', __WEBPACK_IMPORTED_MODULE_21__Shared_components_HelpBubbleComponent_vue___default.a);
        //Vue.component('advanceFormComponent', AdvanceFormComponent);
        Vue.component('smartAddressComponent', __WEBPACK_IMPORTED_MODULE_22__Shared_components_SmartAddressComponent_vue___default.a);
        //Vue.component('contentComponent', ContentComponent);
        Vue.component('experience-page', __WEBPACK_IMPORTED_MODULE_23__Shared_components_ExperiencePageComponent_vue___default.a);
        Vue.component('page-manager', __WEBPACK_IMPORTED_MODULE_24__Shared_components_PageManager_vue___default.a);
        Vue.component('navigation-view', __WEBPACK_IMPORTED_MODULE_25__components_NavigationComponent_vue___default.a);
        Vue.component('sffThankYouComponent', __WEBPACK_IMPORTED_MODULE_26__components_ThankYou_vue___default.a);
        Vue.component('talkToAgent', __WEBPACK_IMPORTED_MODULE_27__components_TalkToAgent_vue___default.a);
        Vue.component('calculatorComponent', __WEBPACK_IMPORTED_MODULE_28__components_CalculatorComponent_vue___default.a);
        Vue.component('childrenComponent', __WEBPACK_IMPORTED_MODULE_29__Application_components_ChildrenComponent_vue___default.a);
        Vue.component('bankruptcy', __WEBPACK_IMPORTED_MODULE_30__Application_components_BankruptcyComponent_vue___default.a);
        Vue.component('existing-policy-detail', __WEBPACK_IMPORTED_MODULE_31__Shared_components_businessComponents_ExistingPolicyDetailComponent_vue___default.a);
        Vue.component('searchable-drop-down-view', __WEBPACK_IMPORTED_MODULE_32__Shared_components_SearchableDropdownView_vue___default.a);
        Vue.component('quoteEditor', __WEBPACK_IMPORTED_MODULE_33__components_QuoteEditor_vue___default.a)
        Vue.component('toggle-view', __WEBPACK_IMPORTED_MODULE_34__Shared_components_ToggleView_vue___default.a);
    }
}
/* harmony export (immutable) */ __webpack_exports__["a"] = componentRegistrationPlugin;


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Startup__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_dropConsole_js__ = __webpack_require__(90);





__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Shared_dropConsole_js__["a" /* default */])();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false
const mountNodeId = "formApp";
const appsClass = 'u-form-apps'

const rootProps = [
    'formSchemaUrl',
    'formConfigKey',
    'formType',
    'extraData'
];
window.$uformApp = { status: 'loaded' };


function _mountApp(nodeId) {
    try {
        console.log('Mounting form app for element id ', nodeId)
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__Shared_Startup__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__App_vue___default.a, undefined, nodeId, rootProps);
    }
    catch (ex) {
        console.log(ex)
    }
}

var idNode = document.getElementById(mountNodeId)
if (idNode) {
    _mountApp(mountNodeId)
}

var appNodes = document.getElementsByClassName(appsClass)
if (appNodes && appNodes.length > 0) {
    for (let idx = 0; appNodes.length; idx++) {
        const element = appNodes[idx]
        if (element && element.id) {
            _mountApp(element.id)
        }
    }
}


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__ = __webpack_require__(1);
﻿

const AppNavigationMixin = {
    methods: {
        broadCastNavigateNext() {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT);
        },
        broadCastNavigatePrev() {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV);
        },
        broadCastPageLoading(pageId) {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].APPLICATION_EVENTS.PAGE_LOADING, pageId);
        },
        registerNavigationFeedbackEvents() {
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT_FEEDBACK, this.onNavigateNextFeedback);
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV_FEEDBACK, this.onNavigatePrevFeedback);
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.COMPONENT_NAVIGATE_NEXT, this.onComponentNavigateNext);
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.FIELD_ENTER_KEY, this.fieldEnterKeyHandler);
            this.registerNavigationEvents();
        },
        unRegisterNavigationFeedbackEvents() {
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT_FEEDBACK, this.onNavigateNextFeedback);
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV_FEEDBACK, this.onNavigatePrevFeedback);
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.COMPONENT_NAVIGATE_NEXT, this.onComponentNavigateNext);
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.FIELD_ENTER_KEY, this.fieldEnterKeyHandler);
            this.unRegisterNavigationEvents();
        },

        broadCastNavigateNextFeedback(data) {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT_FEEDBACK, data);
        },
        broadCastNavigatePrevFeedback(data) {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV_FEEDBACK, data);
        },

        registerNavigationEvents() {
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT, this.onNavigateNext);
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV, this.onNavigatePrev);
        },
        unRegisterNavigationEvents() {
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT, this.onNavigateNext);
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV, this.onNavigatePrev);
            //this.$eventBus.$off();
        },

        onNavigateNext() {
            var eventData = __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENT_DATA.NOT_NAVIGATED;
            this.broadCastNavigateNextFeedback(eventData);
        },
        onNavigatePrev() {
            var eventData = __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENT_DATA.NOT_NAVIGATED;
            this.broadCastNavigatePrevFeedback(eventData);
        },

        onComponentNavigateNext() {
            this.nextHandler();
        },

        onNavigateNextFeedback(navigated, evtData) {
            console.log("next feedback", navigated, evtData);
            if (navigated == __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENT_DATA.NOT_NAVIGATED) {
                this.saveDataBagAndNavigateToNext();
            }
        },

        onNavigatePrevFeedback(navigated) {
            console.log("prev feedback", navigated);
            if (navigated == __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENT_DATA.NOT_NAVIGATED) {
                console.log("navigateToPrevPage");
                this.navigateToPrevPage();
            }
        },

        validateForm() {
            console.log('validateForm', this.formState);
            //this.$set(this.formState, '$submitted', true);
            const frmState = this.formState
            if (frmState && frmState._validate) {
                try {
                    frmState._validate();
                } catch (e) {
                    console.log(e);
                }
            }
            this.touchFormState(frmState);
        },
        submitHandler() {
            console.log('submitHandler');
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.FORM_SUBMITTED);
        },

        fieldEnterKeyHandler(fieldKey) {
            this.nextNavHandler();
        },

        prevNavHandler() {
            this.isPrevClicked = true;
            this.onBeforeBroadcastNavigatePrev();
            this.broadCastNavigatePrev();
        },

        onBeforeBroadcastNavigatePrev() {
        },

        nextNavHandler() {
            console.log('Page component next');
            //trigger form validation
            this.submitHandler();
            console.log('before form validation');
            this.validateForm();
            console.log('after form validation');

            if (this.formState.$valid && this.formErrors.length == 0) {
                console.log('valid form');
                this.$set(this.formState, '$submitted', false)
                this.onBeforeBroadcastNavigateNext();
                this.broadCastNavigateNext();
            }
        },

        onBeforeBroadcastNavigateNext() {
        },

        touchFormState(state) {
            if (state) {
                var errors = state.$error;
                var $this = this;
                if (errors) {
                    Object.keys(errors).forEach(function (key) {
                        var fieldState = errors[key]
                        if (fieldState) {
                            $this.$set(fieldState, '$touched', true);
                        }
                    })
                }
            }
        },
    }
}
/* harmony export (immutable) */ __webpack_exports__["a"] = AppNavigationMixin;


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_directives_mask_index__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es6_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Application_Plugins_EventBus__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__componentRegistrationPlugin__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Plugins_ValidationServicePlugin__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_validationService__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_features_array_find__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_features_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_features_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_features_array_find_index__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_features_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_features_array_find_index__);
﻿









//import googleAnalytic from './../Application/Plugins/GoogleAnalyticPlugin'
//import siteCatalyst from './../Application/Plugins/SiteCatalystPlugin'
//import sessionCam from './../Application/Plugins/SessionCamPlugin'
//import adrum from './../Shared/Plugins/AdrumPlugin'

__webpack_require__(230).polyfill();
//polyfill for Array for IE



function init(validationServiceConfigProvider){
    var viewFormOptions = {
        Promise: typeof window.Promise === 'function' ? window.Promise : __WEBPACK_IMPORTED_MODULE_3_es6_promise___default.a.Promise
    }

    if (__WEBPACK_IMPORTED_MODULE_7__services_validationService__["a" /* default */].requestConfigProvider && validationServiceConfigProvider) {
        __WEBPACK_IMPORTED_MODULE_7__services_validationService__["a" /* default */].requestConfigProvider = validationServiceConfigProvider
    }

    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_form___default.a, viewFormOptions);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2__Shared_directives_mask_index__["a" /* default */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__componentRegistrationPlugin__["a" /* componentRegistrationPlugin */]);
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4__Application_Plugins_EventBus__["a" /* default */]);
    //Validation service plugin
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6__Shared_Plugins_ValidationServicePlugin__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__services_validationService__["a" /* default */])

    ////register googleAnalytic plugin
    //Vue.use(googleAnalytic)
    ////register siteCatalyst plugin
    //Vue.use(siteCatalyst)
    ////register sessionCam plugin
    //Vue.use(sessionCam)
    ////App Dynamics adrum plugin
    //Vue.use(adrum)
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
﻿
/* harmony default export */ __webpack_exports__["a"] = ({
    //installed: false,
    defaultOptions: { dataLayerName: 'dataLayer' },
    install(Vue, options) {
        console.log("registering googleTagManager with options", options);

        options = Object.assign({}, options, this.defaultOptions);

        var googleTag = {

            getDataLayerInstance() {
                return window[options.dataLayerName];
            },

            push(data) {
                console.log("gtm push", data);
                var dl = this.getDataLayerInstance();
                if (typeof dl !== 'undefined') {
                    dl.push(data);
                    console.log("googleTag push", data);
                }
                else {
                    console.error("Google tag manager dataLayer object is not instantiated.");
                }
            }
        };

        Object.defineProperty(Vue.prototype, '$gtm', {
            get() { return googleTag }
        })
    }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formService__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utility__ = __webpack_require__(25);



const PHONE_URL = '/form/validate/phone/'
const EMAIL_URL = '/form/validate/email/'
const DEFAUL_HEADERS = [
    {
        "key": "XSRF-TOKEN",
        "valueField": "#__RequestVerificationToken"
    }
]

function toValue(vProvider, defValue) {
    if (vProvider && typeof vProvider == 'function') {
        return vProvider()
    }
    return vProvider || defValue
}

class ValidationServiceConfig {
    constructor(requestConfig) {
        this.phoneUrl = PHONE_URL;
        this.emailUrl = EMAIL_URL;
        this.headers = DEFAUL_HEADERS

        if (requestConfig) {
            this.headers = requestConfig.headers || DEFAUL_HEADERS
            if (requestConfig.urls && requestConfig.urls.validationService) {
                const vUrls = requestConfig.urls.validationService
                this.phoneUrl = vUrls.phoneUrl || PHONE_URL
                this.emailUrl = vUrls.emailUrl || EMAIL_URL
            }
        }
    }
}
/* unused harmony export ValidationServiceConfig */


/* harmony default export */ __webpack_exports__["a"] = ({

    requestConfig: undefined,
    requestConfigProvider: function () {
        return this.requestConfig
    },

    getServiceConfig() {
        const config = new ValidationServiceConfig(this.requestConfig)
        return config;
    },

    validatePhone(phone, callback) {
        //dummy implementation
        const config = this.getServiceConfig()
        console.log('validatePhone', { phone, config });
        const url = config.phoneUrl + phone;
        const headers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utility__["a" /* buildMap */])(config.headers);
        __WEBPACK_IMPORTED_MODULE_0__formService__["a" /* default */].httpGet(url, {}, headers, callback);
    },
    validateEmail(email, callback) {
        const config = this.getServiceConfig()
        console.log('validateEmail', { email, config });
        const url = config.emailUrl + email;       
        const headers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utility__["a" /* buildMap */])(config.headers);
        __WEBPACK_IMPORTED_MODULE_0__formService__["a" /* default */].httpGet(url, {}, headers, callback);
    },
    validateAddress(data, successCallback, failureCallback) {
        successCallback({});
    }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Application_services_HttpCommunicationService__ = __webpack_require__(12);
﻿

const defaultValidationService = {
    validatePhone(phone, callback) {
        return __WEBPACK_IMPORTED_MODULE_0__Application_services_HttpCommunicationService__["a" /* default */].validatePhone(phone, callback);
    },
    validateEmail(email, callback) {
        return __WEBPACK_IMPORTED_MODULE_0__Application_services_HttpCommunicationService__["a" /* default */].validateEmail(email, callback);
    },
    validateAddress(data, successCallback, failureCallback) {
        return __WEBPACK_IMPORTED_MODULE_0__Application_services_HttpCommunicationService__["a" /* default */].validateAddress(data, successCallback, failureCallback);
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    //installed: false,

    install(Vue, validationServiceInstance) {
        console.log("registering server side validation plugin");

        const serviceInstance = validationServiceInstance || defaultValidationService;
        //Change Global Vue Object
        //This is added to access data on Global Vue object without creating instance
        Vue.validationService = function () {
            return serviceInstance;
        };

        //modify Vue instance
        Object.defineProperty(Vue.prototype, '$validationService', {
            get() { return serviceInstance }
        });
    }
});

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
﻿const sessionSettingKey = 'sessionSettings';

var sessionStore = {
    [sessionSettingKey]: {}
};

const sessionSettings = {
    setSession(key, value) {
        let settings = sessionStore[sessionSettingKey] || {};
        settings[key] = value;
    },
    getSession(key) {
        return (sessionStore[sessionSettingKey] || {})[key];
    },
};
/* harmony export (immutable) */ __webpack_exports__["a"] = sessionSettings;


/* unused harmony default export */ var _unused_webpack_default_export = ({
    //installed: false,

    install(Vue, options) {
        console.log("registering settings plugin");

        //Change Global Vue Object
        //This is added to access data on Global Vue object without creating instance
        Vue.getSessionSettings = function () {
            return sessionSettings;
        };

        //modify Vue instance
        Object.defineProperty(Vue.prototype, '$sessionSettings', {
            get() { return sessionSettings }
        });
    }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = postForm;
﻿
function observeDom(containerSelector, elementSelector, callback) {

    var onMutationsObserved = function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                var elements = $(mutation.addedNodes).find(elementSelector);
                for (var i = 0, len = elements.length; i < len; i++) {
                    callback(elements[i]);
                }
            }
        });
    };

    var target = $(containerSelector)[0];
    var config = { childList: true, subtree: true };
    var mutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    var observer = new mutationObserver(onMutationsObserved);    
    observer.observe(target, config);

}

function postForm(formInfo, dialogService) {
    const method = "post"; // Set method to post by default if not specified.
    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", formInfo.action);

    const params = Object.assign({}, formInfo.dataDictionary);

    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", params[key]);
            form.appendChild(hiddenField);
        }
    }
    document.body.appendChild(form);
    form.submit();
    //remove form from body
    if (dialogService) {
        dialogService.showProcessingDialog(formInfo.processingMessage || '');
    }
}

/*
onElementInserted('body', '.myTargetElement', function(element) {
    console.log(element);
});
*/

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
﻿// util function to convert the input to string type
function convertToString(input) {

    if (input) {

        if (typeof input === "string") {

            return input;
        }

        return String(input);
    }
    return '';
}

function stringHashCode(input) {
    let code = input.split("").reduce(function (a, b) { a = ((a << 5) - a) + b.charCodeAt(0); return a & a }, 0);
    return code < 0 ? code * (-1) : code;
}


// convert string to words
function toWords(input) {

    input = convertToString(input);

    var regex = /[A-Z\xC0-\xD6\xD8-\xDE]?[a-z\xDF-\xF6\xF8-\xFF]+|[A-Z\xC0-\xD6\xD8-\xDE]+(?![a-z\xDF-\xF6\xF8-\xFF])|\d+/g;

    return input.match(regex);

}


// convert the input array to camel case
function toCamelCase(inputArray) {

    let result = "";

    for (let i = 0, len = inputArray.length; i < len; i++) {

        let currentStr = inputArray[i];

        let tempStr = currentStr.toLowerCase();

        if (i != 0) {

            // convert first letter to upper case (the word is in lowercase) 
            tempStr = tempStr.substr(0, 1).toUpperCase() + tempStr.substr(1);

        }

        result += tempStr;

    }

    return result;
}


// this function call all other functions

function toCamelCaseString(input) {

    let words = toWords(input);

    return toCamelCase(words);

}

/* harmony default export */ __webpack_exports__["a"] = ({
        toCamelCase: toCamelCaseString,
        stringHash: stringHashCode
    });

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Application_services_dialogService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DomHelper__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Application_services_HttpCommunicationService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__routeUtil__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility__ = __webpack_require__(3);
﻿






function runActions(actions, callback) {
    actions = actions || [];
    const actionCount = actions.length;
    var innerCounter = 0;

    const internalCallback = function () {
        innerCounter++;
        if (innerCounter === actionCount && callback) {
            callback();
        }
    }
    actions.forEach((action, index) => {
        __WEBPACK_IMPORTED_MODULE_2__Application_services_HttpCommunicationService__["a" /* default */].processDropinAction(action.actionKey,
            function (data) {
                if (data && data.length > 0) {
                    const actionInfo = data[0];
                    runAction(actionInfo, 'Please wait...', internalCallback);
                }
                else {
                    internalCallback();
                }
            },

            function (error) {
                console.log(error);
                internalCallback();
            }
        );
    });
}
function runAction(actionInfo, message, completionCallback) {
    completionCallback = completionCallback || function () { };
    if (actionInfo) {
        //pending action
        if (actionInfo.status === 2) {
            if (actionInfo.method === 0 || actionInfo.type === 3) {//error page
                //make get request
                //navigate to error page
                __WEBPACK_IMPORTED_MODULE_4__routeUtil__["a" /* default */].navigateToPage(__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */], actionInfo.url, true);
            }
            else if (actionInfo.method === 1) {//query/get
                //make get request
                completionCallback();
                window.location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Utility__["c" /* sanitizeUrl */])(actionInfo.url);
            }
            else if (actionInfo.method === 2) {//form/post
                var formInfo = {
                    action: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Utility__["c" /* sanitizeUrl */])(actionInfo.url),
                    dataDictionary: actionInfo.formData,
                    headers: actionInfo.headers,
                    processingMessage: message || 'Please wait...',
                }
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__DomHelper__["a" /* postForm */])(formInfo, __WEBPACK_IMPORTED_MODULE_0__Application_services_dialogService__["a" /* default */]);
                completionCallback();
            }
        }
        else if (actionInfo.status === 1) {
            //action already completed
            completionCallback();
        }
    }
    else {
        completionCallback();
    }
}


/* harmony default export */ __webpack_exports__["a"] = ({
    runActions
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utility__ = __webpack_require__(3);
﻿


const routeCollectionProperty = '$$__configuredRoutes';

/* harmony default export */ __webpack_exports__["a"] = ({

    configureRoutes: function ($router, routes) {
        console.log('configureRoutes', routes);
        $router.addRoutes(routes);
        //add configures routes to vue
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */][routeCollectionProperty] = routes;
    },

    getConfigredRoutes: function () {
        return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */][routeCollectionProperty];
    },

    getPrefix() {
        var routePrefix = (__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$applicationData || {}).routePrefix || '';
        var prefix = '';
        if (routePrefix) {
            prefix = '/' + routePrefix;
        }
        return prefix;
    },

    isLocalRoute: function (route) {
        var isLocal = false;
        const routes = this.getConfigredRoutes();
        if (routes && routes.length > 0) {
            isLocal = __WEBPACK_IMPORTED_MODULE_1__Utility__["b" /* Utility */].listItemContainPropertyValue(routes, 'path', route)
        }
        return isLocal;
    },

    navigateToNextPage: function (router, lastPageId) {
        const pages = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$applicationData.pageSequence;

        if (pages && pages.length > 0) {
            let lastVisitedPageIndex = pages.indexOf(lastPageId);
            if (lastVisitedPageIndex >= 0) {
                let nextPageId = pages[lastVisitedPageIndex + 1];
                var pageRoute = this.getPrefix() + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$applicationData.experience + '/' + nextPageId;
                
                console.log('navigateToPage:', nextPageId)

                if (router && nextPageId) {
                    router.push({ path: pageRoute });
                }
            }
        }
    },
    navigateToPreviousPage: function (router, lastPageId) {
        if (lastPageId) {
            const pages = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$applicationData.pageSequence;

            if (pages && pages.length > 0) {
                let lastVisitedPageIndex = pages.indexOf(lastPageId);
                if (lastVisitedPageIndex >= 0) {
                    let prevPageId = pages[lastVisitedPageIndex - 1];
                   
                    var pageRoute = this.getPrefix() + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$applicationData.experience + '/' + prevPageId;
                    console.log('navigateToPreviousPage:', pageRoute)

                    if (router && prevPageId) {
                        router.push({ path: pageRoute });
                    }
                }
            }
        }
        else {
            //go back to one page back
            router.back();
        }
    },

    navigateToPage: function (router, pageId, replace) {
        console.log('navigateToPage:' + pageId)
        
        var pageRoute = this.getPrefix() + '/' + __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$applicationData.experience + '/' + pageId;
        if (router && pageId) {
            if (replace !== undefined && replace) {
                router.replace({ path: pageRoute });
            }
            else {
                router.push({ path: pageRoute });
            }
        }
    }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Simple format function borrowed from PureMask.js
 * {@link https://github.com/romulobrasil/PureMask.js}
 *
 * @param {String} data String to mask (input value)
 * @param {String} [mask] Mask format, like `####-##`
 * @returns {string} Formatted text
 */
/* harmony default export */ __webpack_exports__["a"] = (function (data, mask){
  // don't do anything if mask is undefined/null/etc
  if(!mask) return data;

  const maskStartRegExp = /^([^#ANX]+)/;

  if (data.length == 1 && maskStartRegExp.test(mask)) {
    data = maskStartRegExp.exec(mask)[0] + data;
  }

  let text = '';

  // Adds a char offset to allow testing on optional values
  var cOffset = 0;

  // Cleans data to  avoid value loss on dynamic mask changing
  for (var i = 0; i < mask.length; i++) {
    var m = mask.charAt(i)
    switch(m) {
      case '#' : break;
      case 'A' : break;
      case '?' : break;
      case 'N' : break;
      case 'X' : break;
      default : data = data.replace(m, '')
    }
  }
  for (let i = 0, x = 1; x && i < mask.length; ++i) {
    // Uses the optional mask character offset
    let c = data.charAt(i - cOffset);
    let m = mask.charAt(i);

    switch (m) {
      case '#' : if (/\d/.test(c))        {text += c;} else {x = 0;} break;
      case 'A' : if (/[a-z]/i.test(c))    {text += c;} else {x = 0;} break;
      case 'N' : if (/[a-z0-9]/i.test(c)) {text += c;} else {x = 0;} break;
      // Skips testing if optional field is specified
      case '?' : cOffset++; break;
      case 'X' : text += c; break;
      default  :
        text += m;

        // preserve characters that are in the same spot we need to insert a mask
        // character by shifting the data over to the right (issue #5, & #7)
        if (c && c !== m) {
          data = ' ' + data;
        }

        break;
    }
  }
  return text;
});


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VueMaskPlugin; });
/* unused harmony export VueMaskPlugin */
/* unused harmony export VueMaskDirective */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_index_js__ = __webpack_require__(108);



/**
 * Event handler
 * @param {HTMLInputElement} el
 * @param {Boolean}          force
 */
function updateValue(el, force = false) {
    let value = el.value;
    let previousValue = '';
    let mask = '';

    //let {value, dataset: {previousValue = "", mask } } = el;
    if (el.dataset) {
        previousValue = el.dataset.previousValue || '';
        mask = el.dataset.mask;
    }
    else {
        previousValue = el.getAttribute('data-previous-value') || '';
        mask = el.getAttribute('data-mask');
    }

    if (force || (value && value !== previousValue && value.length > previousValue.length)) {
        el.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(value, mask);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_index_js__["a" /* trigger */])(el, 'input')
    }

    //el.dataset.previousValue = value;
    if (el.dataset) {
        el.dataset.previousValue = value;
    }
    else {
        el.setAttribute('data-previous-value', value);
    }
}

/**
 * Fires on handler update
 * @param {HTMLInputElement} el
 * @param {String}           mask
 */
function updateMask(el, mask) {
    // change format
    if (el.dataset) {
        el.dataset.mask = mask;
    }
    else {
        el.setAttribute('data-mask', mask);
    }
}


/**
 * Vue directive definition
 */
const VueMaskDirective = {

    /**
     * Called only once, when the directive is first bound to the element.
     * This is where you can do one-time setup work.
     *
     * @param {HTMLInputElement} el
     * @param {?String}          value
     */
    bind(el, {value}) {
        updateMask(el, value);
        updateValue(el);
    },

    /**
     * Called after the containing component has updated,
     * but possibly before its children have updated.
     * The directive’s value may or may not have changed,
     * but you can skip unnecessary updates by comparing the
     * binding’s current and old values.
     *
     * @param {HTMLInputElement} el
     * @param {?String}          value
     * @param {?String}          oldValue
     */
    componentUpdated(el, {value, oldValue}) {

        let isMaskChanged = value !== oldValue;

        // update mask first if changed
        if (isMaskChanged) {
            updateMask(el, value);
        }

        // update value
        updateValue(el, isMaskChanged);
    }
};


/**
 * Vue plugin definition
 * @param {Vue} Vue
 */
const VueMaskPlugin = function (Vue) {
    Vue.directive('mask', VueMaskDirective);
};





/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Notifies Vue about internal value change
 * @see https://github.com/vuejs/Discussion/issues/157#issuecomment-273301588
 *
 * @param {HTMLInputElement} el
 * @param {String}           type
 */
const trigger = (el, type) =>  {
  const e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e)
};
/* harmony export (immutable) */ __webpack_exports__["a"] = trigger;



/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
﻿/* harmony default export */ __webpack_exports__["a"] = (function (eventName) {
    var event = null;
    if (typeof (Event) === 'function') {
        event = new Event(eventName);
    }
    else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }
    return event;
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(defaults, extras) {
    return Object.keys(defaults).concat(Object.keys(extras)).reduce(function(acc, val) {
        acc[val] = extras[val] === undefined ? defaults[val] : extras[val]
        return acc
    }, {})
});


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assign__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__options__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Event__ = __webpack_require__(109);





/* harmony default export */ __webpack_exports__["a"] = (function(el, binding) {
    var opt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assign__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__options__["a" /* default */], binding.value)

    // v-money used on a component that's not a input
    if (el.tagName.toLocaleUpperCase() !== 'INPUT') {
        var els = el.getElementsByTagName('input')
        if (els.length !== 1) {
            throw new Error("v-money requires 1 input, found " + els.length)
        } else {
            el = els[0]
        }
    }

    el.oninput = function() {
        var positionFromEnd = el.value.length - el.selectionEnd
        el.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* format */])(el.value, opt)
        positionFromEnd = Math.max(positionFromEnd, opt.suffix.length) // right
        positionFromEnd = el.value.length - positionFromEnd
        positionFromEnd = Math.max(positionFromEnd, opt.prefix.length + 1) // left
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* setCursor */])(el, positionFromEnd)
        var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Event__["a" /* default */])('change');

        el.dispatchEvent(event) // v-model.lazy
    }

    el.onfocus = function() {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* setCursor */])(el, el.value.length - opt.suffix.length)
    }

    el.oninput()
    var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Event__["a" /* default */])('input');
    el.dispatchEvent(event) // force format after initialization
});


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* unused harmony export unformat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCursor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__options__ = __webpack_require__(45);


function format(input, opt = __WEBPACK_IMPORTED_MODULE_0__options__["a" /* default */]) {
    if (typeof input === 'number') {
        input = input.toFixed(fixed(opt.precision))
    }
    var numbers = onlyNumbers(input)
    //if numbers = 0 , return empty value
    if (numbers == 0) {
        return ''
    }
    var currency = numbersToCurrency(numbers, opt.precision)
    var parts = toStr(currency).split('.')
    var integer = parts[0]
    var decimal = parts[1]
    integer = addThousandSeparator(integer, opt.thousands)
    return opt.prefix + joinIntegerAndDecimal(integer, decimal, opt.decimal) + opt.suffix
}

function unformat(input, precision) {
    var numbers = onlyNumbers(input)
    var currency = numbersToCurrency(numbers, precision)
    return parseFloat(currency)
}

function onlyNumbers(input) {
    return toStr(input).replace(/\D+/g, '') || '0'
}

// Uncaught RangeError: toFixed() digits argument must be between 0 and 20 at Number.toFixed
function fixed(precision) {
    return between(0, precision, 20)
}

function between(min, n, max) {
    return Math.max(min, Math.min(n, max))
}

function numbersToCurrency(numbers, precision) {
    var exp = Math.pow(10, precision)
    var float = parseFloat(numbers) / exp
    return float.toFixed(fixed(precision))
}

function addThousandSeparator(integer, separator) {
    return integer.replace(/(\d)(?=(?:\d{3})+\b)/gm, `$1${separator}`)
}

function currencyToIntegerAndDecimal(float) {
    return toStr(float).split('.')
}

function joinIntegerAndDecimal(integer, decimal, separator) {
    return decimal ? integer + separator + decimal : integer
}

function toStr(value) {
    return value ? value.toString() : ''
}

function setCursor(el, position) {
    var setSelectionRange = function() { el.setSelectionRange(position, position) }
    if (el === document.activeElement) {
        setSelectionRange()
        setTimeout(setSelectionRange, 1) // Android Fix
    }
}




/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(315);
﻿


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

const router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
})

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Plugins_sessionSettingsPlugin__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(1);
﻿


/* harmony default export */ __webpack_exports__["a"] = ({

    isConfirmed() {
        return __WEBPACK_IMPORTED_MODULE_0__Plugins_sessionSettingsPlugin__["a" /* sessionSettings */].getSession(__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].SESSION_KEYS.REQUIRE_CONFIRMATION) === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].YES_NO_OPTION.NO;
    },
    setConfirmed() {
        __WEBPACK_IMPORTED_MODULE_0__Plugins_sessionSettingsPlugin__["a" /* sessionSettings */].setSession(__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].SESSION_KEYS.REQUIRE_CONFIRMATION, __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].YES_NO_OPTION.NO);
    },

    isConfirmationNeeded(dataBag) {
        //get databag value
        const confirmationNeeded = dataBag[__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].SESSION_KEYS.REQUIRE_CONFIRMATION] === __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].YES_NO_OPTION.YES;
        //either confirmation is not needed or confirmation is needed and confirmation is obtained
        if (confirmationNeeded && this.isConfirmed()) {
            return false;
        }
        else {
            return confirmationNeeded;
        }
    },
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Axios */
/* unused harmony export AxiosError */
/* unused harmony export CanceledError */
/* unused harmony export isCancel */
/* unused harmony export CancelToken */
/* unused harmony export VERSION */
/* unused harmony export all */
/* unused harmony export Cancel */
/* unused harmony export isAxiosError */
/* unused harmony export spread */
/* unused harmony export toFormData */
/* unused harmony export AxiosHeaders */
/* unused harmony export HttpStatusCode */
/* unused harmony export formToJSON */
/* unused harmony export mergeConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_axios_js__ = __webpack_require__(118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__lib_axios_js__["a"]; });


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const {
  Axios,
  AxiosError,
  CanceledError,
  isCancel,
  CancelToken,
  VERSION,
  all,
  Cancel,
  isAxiosError,
  spread,
  toFormData,
  AxiosHeaders,
  HttpStatusCode,
  formToJSON,
  mergeConfig
} = __WEBPACK_IMPORTED_MODULE_0__lib_axios_js__["a" /* default */];




/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http_js__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xhr_js__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_AxiosError_js__ = __webpack_require__(14);





const knownAdapters = {
  http: __WEBPACK_IMPORTED_MODULE_1__http_js__["a" /* default */],
  xhr: __WEBPACK_IMPORTED_MODULE_2__xhr_js__["a" /* default */]
}

__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(knownAdapters, (fn, value) => {
  if(fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  getAdapter: (adapters) => {
    adapters = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      if((adapter = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isString(nameOrAdapter) ? knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter)) {
        break;
      }
    }

    if (!adapter) {
      if (adapter === false) {
        throw new __WEBPACK_IMPORTED_MODULE_3__core_AxiosError_js__["a" /* default */](
          `Adapter ${nameOrAdapter} is not supported by the environment`,
          'ERR_NOT_SUPPORT'
        );
      }

      throw new Error(
        __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].hasOwnProp(knownAdapters, nameOrAdapter) ?
          `Adapter '${nameOrAdapter}' is not available in the build` :
          `Unknown adapter '${nameOrAdapter}'`
      );
    }

    if (!__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isFunction(adapter)) {
      throw new TypeError('adapter is not a function');
    }

    return adapter;
  },
  adapters: knownAdapters
});


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_settle_js__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_cookies_js__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_buildURL_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_buildFullPath_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_isURLSameOrigin_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaults_transitional_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_AxiosError_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cancel_CanceledError_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_parseProtocol_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__platform_index_js__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_AxiosHeaders_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_speedometer_js__ = __webpack_require__(133);
















function progressEventReducer(listener, isDownloadStream) {
  let bytesNotified = 0;
  const _speedometer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__helpers_speedometer_js__["a" /* default */])(50, 250);

  return e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e
    };

    data[isDownloadStream ? 'download' : 'upload'] = true;

    listener(data);
  };
}

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

/* harmony default export */ __webpack_exports__["a"] = (isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    let requestData = config.data;
    const requestHeaders = __WEBPACK_IMPORTED_MODULE_11__core_AxiosHeaders_js__["a" /* default */].from(config.headers).normalize();
    const responseType = config.responseType;
    let onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isFormData(requestData) && (__WEBPACK_IMPORTED_MODULE_10__platform_index_js__["a" /* default */].isStandardBrowserEnv || __WEBPACK_IMPORTED_MODULE_10__platform_index_js__["a" /* default */].isStandardBrowserWebWorkerEnv)) {
      requestHeaders.setContentType(false); // Let the browser set it
    }

    let request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      const username = config.auth.username || '';
      const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.set('Authorization', 'Basic ' + btoa(username + ':' + password));
    }

    const fullPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_buildFullPath_js__["a" /* default */])(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_buildURL_js__["a" /* default */])(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = __WEBPACK_IMPORTED_MODULE_11__core_AxiosHeaders_js__["a" /* default */].from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_settle_js__["a" /* default */])(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new __WEBPACK_IMPORTED_MODULE_7__core_AxiosError_js__["a" /* default */]('Request aborted', __WEBPACK_IMPORTED_MODULE_7__core_AxiosError_js__["a" /* default */].ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new __WEBPACK_IMPORTED_MODULE_7__core_AxiosError_js__["a" /* default */]('Network Error', __WEBPACK_IMPORTED_MODULE_7__core_AxiosError_js__["a" /* default */].ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = config.transitional || __WEBPACK_IMPORTED_MODULE_6__defaults_transitional_js__["a" /* default */];
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new __WEBPACK_IMPORTED_MODULE_7__core_AxiosError_js__["a" /* default */](
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? __WEBPACK_IMPORTED_MODULE_7__core_AxiosError_js__["a" /* default */].ETIMEDOUT : __WEBPACK_IMPORTED_MODULE_7__core_AxiosError_js__["a" /* default */].ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (__WEBPACK_IMPORTED_MODULE_10__platform_index_js__["a" /* default */].isStandardBrowserEnv) {
      // Add xsrf header
      const xsrfValue = (config.withCredentials || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_isURLSameOrigin_js__["a" /* default */])(fullPath))
        && config.xsrfCookieName && __WEBPACK_IMPORTED_MODULE_2__helpers_cookies_js__["a" /* default */].read(config.xsrfCookieName);

      if (xsrfValue) {
        requestHeaders.set(config.xsrfHeaderName, xsrfValue);
      }
    }

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', progressEventReducer(config.onDownloadProgress, true));
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', progressEventReducer(config.onUploadProgress));
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new __WEBPACK_IMPORTED_MODULE_8__cancel_CanceledError_js__["a" /* default */](null, config, request) : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_parseProtocol_js__["a" /* default */])(fullPath);

    if (protocol && __WEBPACK_IMPORTED_MODULE_10__platform_index_js__["a" /* default */].protocols.indexOf(protocol) === -1) {
      reject(new __WEBPACK_IMPORTED_MODULE_7__core_AxiosError_js__["a" /* default */]('Unsupported protocol ' + protocol + ':', __WEBPACK_IMPORTED_MODULE_7__core_AxiosError_js__["a" /* default */].ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
});


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_bind_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_Axios_js__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mergeConfig_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaults_index_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_formDataToJSON_js__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cancel_CanceledError_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cancel_CancelToken_js__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cancel_isCancel_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__env_data_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_toFormData_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__core_AxiosError_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_spread_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_isAxiosError_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__core_AxiosHeaders_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_HttpStatusCode_js__ = __webpack_require__(125);



















/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new __WEBPACK_IMPORTED_MODULE_2__core_Axios_js__["a" /* default */](defaultConfig);
  const instance = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_bind_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__core_Axios_js__["a" /* default */].prototype.request, context);

  // Copy axios.prototype to instance
  __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].extend(instance, __WEBPACK_IMPORTED_MODULE_2__core_Axios_js__["a" /* default */].prototype, context, {allOwnKeys: true});

  // Copy context to instance
  __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_mergeConfig_js__["a" /* default */])(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(__WEBPACK_IMPORTED_MODULE_4__defaults_index_js__["a" /* default */]);

// Expose Axios class to allow class inheritance
axios.Axios = __WEBPACK_IMPORTED_MODULE_2__core_Axios_js__["a" /* default */];

// Expose Cancel & CancelToken
axios.CanceledError = __WEBPACK_IMPORTED_MODULE_6__cancel_CanceledError_js__["a" /* default */];
axios.CancelToken = __WEBPACK_IMPORTED_MODULE_7__cancel_CancelToken_js__["a" /* default */];
axios.isCancel = __WEBPACK_IMPORTED_MODULE_8__cancel_isCancel_js__["a" /* default */];
axios.VERSION = __WEBPACK_IMPORTED_MODULE_9__env_data_js__["a" /* VERSION */];
axios.toFormData = __WEBPACK_IMPORTED_MODULE_10__helpers_toFormData_js__["a" /* default */];

// Expose AxiosError class
axios.AxiosError = __WEBPACK_IMPORTED_MODULE_11__core_AxiosError_js__["a" /* default */];

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = __WEBPACK_IMPORTED_MODULE_12__helpers_spread_js__["a" /* default */];

// Expose isAxiosError
axios.isAxiosError = __WEBPACK_IMPORTED_MODULE_13__helpers_isAxiosError_js__["a" /* default */];

// Expose mergeConfig
axios.mergeConfig = __WEBPACK_IMPORTED_MODULE_3__core_mergeConfig_js__["a" /* default */];

axios.AxiosHeaders = __WEBPACK_IMPORTED_MODULE_14__core_AxiosHeaders_js__["a" /* default */];

axios.formToJSON = thing => __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_formDataToJSON_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isHTMLForm(thing) ? new FormData(thing) : thing);

axios.HttpStatusCode = __WEBPACK_IMPORTED_MODULE_15__helpers_HttpStatusCode_js__["a" /* default */];

axios.default = axios;

// this module should only have a default export
/* harmony default export */ __webpack_exports__["a"] = (axios);


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CanceledError_js__ = __webpack_require__(26);




/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new __WEBPACK_IMPORTED_MODULE_0__CanceledError_js__["a" /* default */](message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (CancelToken);


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_buildURL_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InterceptorManager_js__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dispatchRequest_js__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeConfig_js__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buildFullPath_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_validator_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AxiosHeaders_js__ = __webpack_require__(19);











const validators = __WEBPACK_IMPORTED_MODULE_6__helpers_validator_js__["a" /* default */].validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new __WEBPACK_IMPORTED_MODULE_2__InterceptorManager_js__["a" /* default */](),
      response: new __WEBPACK_IMPORTED_MODULE_2__InterceptorManager_js__["a" /* default */]()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__mergeConfig_js__["a" /* default */])(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      __WEBPACK_IMPORTED_MODULE_6__helpers_validator_js__["a" /* default */].assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer !== undefined) {
      __WEBPACK_IMPORTED_MODULE_6__helpers_validator_js__["a" /* default */].assertOptions(paramsSerializer, {
        encode: validators.function,
        serialize: validators.function
      }, true);
    }

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    let contextHeaders;

    // Flatten headers
    contextHeaders = headers && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].merge(
      headers.common,
      headers[config.method]
    );

    contextHeaders && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = __WEBPACK_IMPORTED_MODULE_7__AxiosHeaders_js__["a" /* default */].concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [__WEBPACK_IMPORTED_MODULE_3__dispatchRequest_js__["a" /* default */].bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = __WEBPACK_IMPORTED_MODULE_3__dispatchRequest_js__["a" /* default */].call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__mergeConfig_js__["a" /* default */])(this.defaults, config);
    const fullPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__buildFullPath_js__["a" /* default */])(config.baseURL, config.url);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_buildURL_js__["a" /* default */])(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__mergeConfig_js__["a" /* default */])(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__mergeConfig_js__["a" /* default */])(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

/* harmony default export */ __webpack_exports__["a"] = (Axios);


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);




class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

/* harmony default export */ __webpack_exports__["a"] = (InterceptorManager);


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dispatchRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transformData_js__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cancel_isCancel_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaults_index_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancel_CanceledError_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_AxiosHeaders_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__adapters_adapters_js__ = __webpack_require__(116);









/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new __WEBPACK_IMPORTED_MODULE_3__cancel_CanceledError_js__["a" /* default */](null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = __WEBPACK_IMPORTED_MODULE_4__core_AxiosHeaders_js__["a" /* default */].from(config.headers);

  // Transform request data
  config.data = __WEBPACK_IMPORTED_MODULE_0__transformData_js__["a" /* default */].call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = __WEBPACK_IMPORTED_MODULE_5__adapters_adapters_js__["a" /* default */].getAdapter(config.adapter || __WEBPACK_IMPORTED_MODULE_2__defaults_index_js__["a" /* default */].adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = __WEBPACK_IMPORTED_MODULE_0__transformData_js__["a" /* default */].call(
      config,
      config.transformResponse,
      response
    );

    response.headers = __WEBPACK_IMPORTED_MODULE_4__core_AxiosHeaders_js__["a" /* default */].from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cancel_isCancel_js__["a" /* default */])(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = __WEBPACK_IMPORTED_MODULE_0__transformData_js__["a" /* default */].call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = __WEBPACK_IMPORTED_MODULE_4__core_AxiosHeaders_js__["a" /* default */].from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = settle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AxiosError_js__ = __webpack_require__(14);




/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new __WEBPACK_IMPORTED_MODULE_0__AxiosError_js__["a" /* default */](
      'Request failed with status code ' + response.status,
      [__WEBPACK_IMPORTED_MODULE_0__AxiosError_js__["a" /* default */].ERR_BAD_REQUEST, __WEBPACK_IMPORTED_MODULE_0__AxiosError_js__["a" /* default */].ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transformData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaults_index_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_AxiosHeaders_js__ = __webpack_require__(19);






/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || __WEBPACK_IMPORTED_MODULE_1__defaults_index_js__["a" /* default */];
  const context = response || config;
  const headers = __WEBPACK_IMPORTED_MODULE_2__core_AxiosHeaders_js__["a" /* default */].from(context.headers);
  let data = context.data;

  __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

/* harmony default export */ __webpack_exports__["a"] = (HttpStatusCode);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineURLs;


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_index_js__ = __webpack_require__(22);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__platform_index_js__["a" /* default */].isStandardBrowserEnv ?

// Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        const cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isString(path)) {
          cookie.push('path=' + path);
        }

        if (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

// Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })());


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAbsoluteURL;


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAxiosError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);




/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isObject(payload) && (payload.isAxiosError === true);
}


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_index_js__ = __webpack_require__(22);





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__platform_index_js__["a" /* default */].isStandardBrowserEnv ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement('a');
    let originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      let href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
          urlParsingNode.pathname :
          '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      const parsed = (__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
          parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })());


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);




// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
/* harmony default export */ __webpack_exports__["a"] = (rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
});


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseProtocol;


function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (speedometer);


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = spread;


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toURLEncodedForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toFormData_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform_index_js__ = __webpack_require__(22);






function toURLEncodedForm(data, options) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toFormData_js__["a" /* default */])(data, new __WEBPACK_IMPORTED_MODULE_2__platform_index_js__["a" /* default */].classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (__WEBPACK_IMPORTED_MODULE_2__platform_index_js__["a" /* default */].isNode && __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env_data_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__ = __webpack_require__(14);





const validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + __WEBPACK_IMPORTED_MODULE_0__env_data_js__["a" /* VERSION */] + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__["a" /* default */](
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__["a" /* default */].ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__["a" /* default */]('options must be an object', __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__["a" /* default */].ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__["a" /* default */]('option ' + opt + ' must be ' + result, __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__["a" /* default */].ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__["a" /* default */]('Unknown option ' + opt, __WEBPACK_IMPORTED_MODULE_1__core_AxiosError_js__["a" /* default */].ERR_BAD_OPTION);
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  assertOptions,
  validators
});


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = (typeof FormData !== 'undefined' ? FormData : null);


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_AxiosURLSearchParams_js__ = __webpack_require__(51);



/* harmony default export */ __webpack_exports__["a"] = (typeof URLSearchParams !== 'undefined' ? URLSearchParams : __WEBPACK_IMPORTED_MODULE_0__helpers_AxiosURLSearchParams_js__["a" /* default */]);


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_URLSearchParams_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__classes_FormData_js__ = __webpack_require__(137);



/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const isStandardBrowserEnv = (() => {
  let product;
  if (typeof navigator !== 'undefined' && (
    (product = navigator.product) === 'ReactNative' ||
    product === 'NativeScript' ||
    product === 'NS')
  ) {
    return false;
  }

  return typeof window !== 'undefined' && typeof document !== 'undefined';
})();

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
 const isStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();


/* harmony default export */ __webpack_exports__["a"] = ({
  isBrowser: true,
  classes: {
    URLSearchParams: __WEBPACK_IMPORTED_MODULE_0__classes_URLSearchParams_js__["a" /* default */],
    FormData: __WEBPACK_IMPORTED_MODULE_1__classes_FormData_js__["a" /* default */],
    Blob
  },
  isStandardBrowserEnv,
  isStandardBrowserWebWorkerEnv,
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
});


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_dialogService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_HttpCommunicationService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_ComponentBaseMixin__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_ComponentBaseMixin__["a" /* ComponentBaseMixin */]],
    props: {},
    data: function () {
        return {
            //add bankruptcy flag
            showBankruptcyForm: false
        };
    },
    created() {
        //assing key to groups
        this.componentDataBag = this.getComponentDataBag();
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.dataBagKey]) {
            this.$set(this.dataBag, this.dataBagKey, []);
        }

        if (this.bankruptcies.length == 0) {
            this.showBankruptcyForm = true;
        }
    },
    computed: {
        bankruptcies() {
            return this.dataBag[this.dataBagKey] || [];
        },

        dataBagKey() {
            return this.dataKeyObject.dataKey || this.dataKey;
        },

        formGroups() {
            this.ensureDataKeyParsing();
            var groups = this.getFormGroups(this.dataKeyObject.formKey, this.componentKey);
            if (!(groups && groups.length > 0)) {
                groups = this.getQuestionGroups();
            }
            groups = this.assignKey(groups);
            return groups;
        }
    },
    methods: {
        getComponentDataBag() {
            var key = this.componentKey;
            return {
                [key + '_bankruptcyFileMonth']: '',
                [key + '_bankruptcyFileYear']: '',
                [key + '_bankruptcyOutcome']: '',
                [key + '_bankruptcyChapterFiled']: '',
                [key + '_bankruptcyDischargedMonth']: '',
                [key + '_bankruptcyDischargedYear']: '',
                [key + '_bankruptcyReason']: ''
            };
        },
        onAddBankruptcy() {
            this.showBankruptcyForm = true;
        },
        onSave() {
            console.log('onSave');
            this.$set(this.componentState, '$submitted', true);
            //touch component states to highlight field
            this.touchComponentState(this.componentState);
            //check component state for val
            if (this.componentState.$valid) {
                this.$set(this.componentState, '$submitted', false);
                if (!this.componentDataBag.key) {
                    this.componentDataBag.key = __WEBPACK_IMPORTED_MODULE_3__Shared_Utilities_Utility__["b" /* Utility */].newGuid();
                }
                var key = this.componentKey;
                //push to collection
                this.dataBag[this.dataBagKey].push({
                    key: this.componentDataBag.key,
                    bankruptcyFileMonth: this.componentDataBag[key + '_bankruptcyFileMonth'],
                    bankruptcyFileYear: this.componentDataBag[key + '_bankruptcyFileYear'],
                    bankruptcyOutcome: this.componentDataBag[key + '_bankruptcyOutcome'],
                    bankruptcyChapterFiled: this.componentDataBag[key + '_bankruptcyChapterFiled'],
                    bankruptcyDischargedMonth: this.componentDataBag[key + '_bankruptcyDischargedMonth'],
                    bankruptcyDischargedYear: this.componentDataBag[key + '_bankruptcyDischargedYear'],
                    bankruptcyReason: this.componentDataBag[key + '_bankruptcyReason']
                });

                //reset data
                this.componentDataBag = this.getComponentDataBag();
                //reset flag
                this.showBankruptcyForm = false;
                this.saveComponentData();
                this.clearFormState();
            }
        },
        onCancel() {
            this.showBankruptcyForm = false;
            this.componentDataBag = this.getComponentDataBag();
            this.clearFormState();
        },
        getBankruptcyByChapterFiled(typeKey) {
            var item = null;
            var list = this.dataBag[this.dataBagKey];
            for (var index = 0; index < list.length; index++) {
                if (list[index].bankruptcyChapterFiled == typeKey) {
                    item = list[index];
                    break;
                }
            }
            return item;
        },

        deleteBankruptcy(key) {
            var $this = this;
            if (__WEBPACK_IMPORTED_MODULE_0__services_dialogService__["a" /* default */].confirmAdvanced) {
                __WEBPACK_IMPORTED_MODULE_0__services_dialogService__["a" /* default */].confirmAdvanced("Do you really want to delete Bankruptcy?", function (result) {
                    if (result) {
                        var itemIdex = -1;
                        var list = $this.dataBag[$this.dataBagKey];
                        for (var index = 0; index < list.length; index++) {
                            if (list[index].key == key) {
                                itemIdex = index;
                                break;
                            }
                        }
                        if (itemIdex > -1) {
                            list.splice(itemIdex, 1);
                            //save data
                            $this.saveComponentData();
                        }
                        //check policy count
                        if ($this.bankruptcies.length == 0) {
                            $this.showBankruptcyForm = true;
                        }
                    }
                }, 'Delete');
            }
        },
        getQuestionGroups() {
            return [{
                "title": "When did you file?",
                "helpText": "",
                "questions": [[{

                    "question": {
                        "questionKey": this.componentKey + "_bankruptcyFileMonth",
                        "autoSave": false,
                        "text": "Month",
                        "type": "dropdown",
                        "selectText": "Month",
                        "answerOptionsFunction": "MONTH_LIST",
                        "validators": {
                            "required": true,
                            "requiredMessage": "This field is required"
                        }
                    },
                    "colSize": 4
                }, {
                    "question": {
                        "questionKey": this.componentKey + "_bankruptcyFileYear",
                        "autoSave": false,
                        "text": "Year",
                        "type": "dropdown",
                        "selectText": "Year",
                        "answerOptionsFunction": 'PAST_YEAR_UNTILL_CURRENT_YEAR_LIST',
                        "answerOptions": [],
                        "validators": {
                            "required": true,
                            "requiredMessage": "This field is required"
                        }
                    },
                    "colSize": 4

                }]]
            }, {
                "title": "What was the outcome?",
                "helpText": "",
                "questions": [[{

                    "question": {
                        "questionKey": this.componentKey + "_bankruptcyOutcome",
                        "text": "Bankruptcy Outcome",
                        "autoSave": false,
                        "type": "dropdown",
                        "selectText": "Choose One",
                        "answerOptions": [{
                            "text": "My bankruptcy was discharged / completed",
                            "value": "discharged"
                        }, {
                            "text": "I am still making payments",
                            "value": "unresolved"
                        }, {
                            "text": "My bankruptcy was dismissed / not completed",
                            "value": "dismissed"
                        }],
                        "validators": {
                            "required": true,
                            "requiredMessage": "This field is required"
                        }
                    },
                    "colSize": 8,
                    "groups": [{
                        "title": "When was the bankruptcy discharged (completed) or dismissed?",
                        "helpText": "",
                        "questions": [[{

                            "question": {
                                "questionKey": this.componentKey + "_bankruptcyDischargedMonth",
                                "autoSave": false,
                                "text": "Month",
                                "type": "dropdown",
                                "selectText": "Month",
                                "enableCondition": "discharged|dismissed",
                                "answerOptionsFunction": "MONTH_LIST",
                                "validators": {
                                    "required": true,
                                    "requiredMessage": "This field is required"
                                }
                            }

                        }, {
                            "question": {
                                "questionKey": this.componentKey + "_bankruptcyDischargedYear",
                                "autoSave": false,
                                "text": "Year",
                                "type": "dropdown",
                                "selectText": "Year",
                                "enableCondition": "discharged|dismissed",
                                "answerOptionsFunction": 'PAST_YEAR_UNTILL_CURRENT_YEAR_LIST',
                                "answerOptions": [],
                                "validators": {
                                    "required": true,
                                    "requiredMessage": "This field is required"
                                }
                            }

                        }]]
                    }]
                }]]
            }, {
                "title": "Chapter Filed",
                "helpText": "",
                "questions": [[{

                    "question": {
                        "questionKey": this.componentKey + "_bankruptcyChapterFiled",
                        "text": "Bankruptcy Chapter",
                        "autoSave": false,
                        "type": "dropdown",
                        "selectText": "Choose One",
                        "answerOptions": [{
                            "text": "Chapter 7 (liquidation, the most common filing)",
                            "value": "7"
                        }, {
                            "text": "Chapter 11 (reorganization, typically used by corporations)",
                            "value": "11"
                        }, {
                            "text": "Chapter 13 (adjustment of debts of an individual with regular income)",
                            "value": "13"
                        }],
                        "validators": {
                            "required": true,
                            "requiredMessage": "This field is required"
                        }
                    },
                    "colSize": 8

                }]]
            }, {
                "title": "What was the reason for filing bankruptcy?",
                "helpText": "",
                "questions": [[{

                    "question": {
                        "questionKey": this.componentKey + "_bankruptcyReason",
                        "text": "Bankruptcy Reason",
                        "autoSave": false,
                        "type": "dropdown",
                        "selectText": "Choose One",
                        "answerOptions": [{
                            "text": "Personal - Debt Consolidation or Credit Problems",
                            "value": "Personal - Debt Consolidation or Credit Problems"
                        }, {
                            "text": "Personal - Divorce/Child Support/Alimony",
                            "value": "Personal - Divorce/Child Support/Alimony"
                        }, {
                            "text": "Personal - Death of a Spouse",
                            "value": "Personal - Death of a Spouse"
                        }, {
                            "text": "Personal - Loss of Employment",
                            "value": "Personal - Loss of Employment"
                        }, {
                            "text": "Personal - Loss of Investment Income",
                            "value": "Personal - Loss of Investment Income"
                        }, {
                            "text": "Personal - Loss Due to Natural Disaster",
                            "value": "Personal - Loss Due to Natural Disaster"
                        }, {
                            "text": "Personal - Mortgage Losses or Foreclosure",
                            "value": "Personal - Mortgage Losses or Foreclosure"
                        }, {
                            "text": "Personal - Lawsuit or Adverse Court Settlement",
                            "value": "Personal - Lawsuit or Adverse Court Settlement"
                        }, {
                            "text": "Personal - Gambling Losses",
                            "value": "Personal - Gambling Losses"
                        }, {
                            "text": "Medical - Personal Medical Bills",
                            "value": "Medical - Personal Medical Bills"
                        }, {
                            "text": "Medical - Medical Bills of a Spouse or Family Member",
                            "value": "Medical - Medical Bills of a Spouse or Family Member"
                        }, {
                            "text": "Business - Business Failure",
                            "value": "Business - Business Failure"
                        }, {
                            "text": "Business - Lawsuit or Adverse Court Settlement",
                            "value": "Business - Lawsuit or Adverse Court Settlement"
                        }, {
                            "text": "Other",
                            "value": "Other"
                        }],
                        "validators": {
                            "required": true,
                            "requiredMessage": "This field is required"
                        }
                    },
                    "colSize": 8

                }]]
            }];
        }
    }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_dialogService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ComponentBaseMixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Constants__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_ComponentBaseMixin__["a" /* ComponentBaseMixin */]],
    props: {},
    data: function () {
        return {
            //add disorder flag
            showChildrenForm: false,
            //setup data properties
            fundEducation: this.getFundEduation(),
            lessThanOne: "<1"
        };
    },
    created() {
        this.componentDataBag = this.getComponentDataBag();
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.dataBagKey]) {
            this.$set(this.dataBag, this.dataBagKey, []);
        }
        if (this.childs.length == 0) {
            this.showChildrenForm = true;
        }
    },
    computed: {
        childs() {
            return this.dataBag[this.dataBagKey] || [];
        },

        dataBagKey() {
            return this.dataKeyObject.dataKey || this.dataKey;
        },

        childFormGroups() {
            this.ensureDataKeyParsing();
            var groups = this.getFormGroups(this.dataKeyObject.formKey, this.componentKey);
            if (!(groups && groups.length > 0)) {
                groups = this.getQuestionGroups();
                this.applyQuestionKeyPrefix(groups, this.componentKey);
            }
            groups = this.assignKey(groups);
            return groups;
        }
    },
    methods: {
        getComponentDataBag() {
            var key = this.componentKey;
            return {
                [key + '_childAge']: ''
            };
        },

        onAddChild() {
            this.showChildrenForm = true;
        },

        onSave() {
            console.log('onSave');
            //this.$eventBus.$emit(Constants.NAVIGATION_EVENTS.FORM_SUBMITTED);
            //check component state for val
            this.$set(this.componentState, '$submitted', true);
            //touch component states to highlight field
            this.touchComponentState(this.componentState);

            if (this.componentState.$valid) {
                this.$set(this.componentState, '$submitted', false);

                var key = this.componentKey;

                this.dataBag[this.dataBagKey].push({
                    childAge: this.componentDataBag[key + '_childAge']
                });
                //reset data
                this.componentDataBag = this.getComponentDataBag();

                //reset flag
                this.showChildrenForm = false;
                //save data
                this.saveComponentData();
                this.clearFormState();
            }
        },

        onCancel() {
            this.showChildrenForm = false;
            this.componentDataBag = this.getComponentDataBag();
            this.clearFormState();
        },

        deleteFn(name) {
            if (name) {
                const self = this;
                var itemIdex = -1;
                var list = self.dataBag[self.dataBagKey];
                for (var index = 0; index < list.length; index++) {
                    if (list[index].childAge == name) {
                        itemIdex = index;
                        break;
                    }
                }
                if (itemIdex > -1) {
                    list.splice(itemIdex, 1);
                    //save data
                    self.saveComponentData();
                }
                if (self.childs.length == 0) {
                    self.showChildrenForm = true;
                }
            }
        },

        deleteChild(name) {
            const self = this;
            if (__WEBPACK_IMPORTED_MODULE_0__services_dialogService__["a" /* default */].confirmAdvanced) {
                __WEBPACK_IMPORTED_MODULE_0__services_dialogService__["a" /* default */].confirmAdvanced("Do you really want to delete Child?", function (result) {
                    if (result) {
                        self.deleteFn(name);
                    }
                }, 'Delete');
            }
            //else {
            //    self.deleteFn(name);
            //}
        },
        getFundEduation() {
            return {
                "questionKey": "Insured_DependentChildren_IsFundEducation",
                "text": "Do you want to fund your children's college education?",
                "type": "radio",
                "disableDestroyAction": true,
                "answerOptions": [{
                    "text": "Yes",
                    "value": "Yes",
                    "iconClass": 'glyphicon-ok-circle'
                }, {
                    "text": "No",
                    "value": "No",
                    "iconClass": 'glyphicon-remove-circle'
                }],
                "validators": {
                    "required": true,
                    "requiredMessage": "This field is required"
                }
            };
        },
        getQuestionGroups() {
            return [{
                "title": "",
                "helpText": "",
                "questions": [[{
                    "question": {
                        "questionKey": "_childAge",
                        "text": "Age",
                        "type": "dropdown",
                        "autoSave": false,
                        "selectText": "Age",
                        "answerOptionsFunction": "CHILD_AGE_LIST",
                        "validators": {
                            "required": true,
                            "requiredMessage": "This field is required"
                        }
                    },
                    "colCss": 'col-sm-11 col-lg-9'
                }]]
            }];
        },
        dummyHandler() {}
    }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LeadForm_vue__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LeadForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_LeadForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_InteractiveForm_vue__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_InteractiveForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_InteractiveForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_GoogleTagManagerPlugin__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Application_Plugins_EventBus__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CalculatorPage_vue__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CalculatorPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_CalculatorPage_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3__plugins_GoogleTagManagerPlugin__["a" /* default */], {});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5__Application_Plugins_EventBus__["a" /* default */]);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__plugins__["a" /* init */])();

const FORM_TYPE_INTERACTIVE = 'interactive';
const FORM_TYPE_CALCULATOR = 'calculator';

/* harmony default export */ __webpack_exports__["default"] = ({
    /*name: 'SmartForm',*/
    components: {
        SmartForm: __WEBPACK_IMPORTED_MODULE_1__components_LeadForm_vue___default.a,
        InteractiveForm: __WEBPACK_IMPORTED_MODULE_2__components_InteractiveForm_vue___default.a,
        CalculatorPage: __WEBPACK_IMPORTED_MODULE_6__components_CalculatorPage_vue___default.a
    },
    props: {
        formSchemaUrl: {
            type: String,
            required: true
        },
        formConfigKey: {
            type: String,
            required: true
        },
        formType: {
            type: String,
            required: true
        },
        extraData: {
            type: [Object, String],
            required: false
        }
    },
    computed: {
        interactive() {
            return this.formType === FORM_TYPE_INTERACTIVE;
        },
        calculator() {
            return this.formType === FORM_TYPE_CALCULATOR;
        }
    }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Application_mixins_ComponentBaseMixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_components_businessComponents_CoverageRecommendationResultComponent_vue__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_components_businessComponents_CoverageRecommendationResultComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Shared_components_businessComponents_CoverageRecommendationResultComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InteractiveFormComponent_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InteractiveFormComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InteractiveFormComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Application_services_RequestResponseFormatter__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_formService__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Shared_Utilities_Utility__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










const reqConfig = {
    endpoint: "/form/coverage",
    method: "POST",
    headers: [{
        key: "XSRF-TOKEN",
        valueField: "#__RequestVerificationToken"
    }]
};

/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'coverageRecommendationResultComponent': __WEBPACK_IMPORTED_MODULE_2__Shared_components_businessComponents_CoverageRecommendationResultComponent_vue___default.a,
        'interactiveFormComponent': __WEBPACK_IMPORTED_MODULE_3__InteractiveFormComponent_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Application_mixins_ComponentBaseMixin__["a" /* ComponentBaseMixin */]],
    props: {
        useCoverageCallback: {
            type: Function,
            required: false,
            default: function () {
                return function () {
                    console.log('default useCoverageCallback');
                };
            }
        }
    },
    data: function () {
        return {
            actionBus: new __WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */](),
            componentDataBag: {},
            show: false,
            defaultCoverageAmount: 450000,
            recommendations: {},
            processing: false,
            recalculate: false,
            canCalculate: false,
            showTerm: false,
            previousEstimatedCoverage: '',
            hideBack: false,
            submitError: false
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
    },
    computed: {
        fomrSubmissionError() {
            return this.pageMessages['formSubmission_error'];
        },
        estimatedAmount() {
            if (this.recommendations) {
                var amount = this.recommendations.recommendedCoverageAmount || 0;
                return __WEBPACK_IMPORTED_MODULE_7__Shared_Utilities_Utility__["b" /* Utility */].formatCurrency(amount);
            }
            return '';
        },
        calculatorLinkText() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.calculatorLinkText || 'Calculate Coverage';
        },
        needCoverageHelpText() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.needCoverageHelpText;
        },
        transition() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.transition;
        },
        formGroups() {
            this.ensureDataKeyParsing();
            var groups = [];
            var formSchema = this.getFormSchema(this.dataKeyObject.formKey);
            groups = (formSchema || {}).groups || [];
            return groups;
        },
        keyMap() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.keyMap || [];
        },

        showingResult() {
            return this.recommendations && this.recommendations.recommendedCoverageAmount && !this.recalculate;
        },
        nextButtonText() {
            return this.canCalculate ? 'Calculate Coverage' : 'Next';
        },
        previousEstimatedCoverageFormatted() {
            if (this.recommendations && this.recommendations.recommendedCoverageAmount) {
                var amount = this.recommendations.recommendedCoverageAmount;
                return __WEBPACK_IMPORTED_MODULE_7__Shared_Utilities_Utility__["b" /* Utility */].formatCurrency(amount);
            }
            return '';
        },
        isIndependent() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.independentMode || false;
        },

        globalRequestConfig() {
            const globalReq = ((this.pageSchema || {}).submissionConfig || {}).request || {};
            return globalReq;
        },
        coverageUrl() {
            const calc = (this.globalRequestConfig.urls || {}).calculatorComponent;
            return calc ? calc.coverageUrl : reqConfig.endpoint;
        }
    },
    methods: {
        populateComponentDataBag() {
            const self = this;

            this.keyMap.forEach(map => {
                if (map.formFieldKey && map.dataBagKey) {
                    self.$set(self.componentDataBag, map.formFieldKey, self.dataBag[map.dataBagKey]);
                }
            });
            console.log('populateComponentDataBag', self.componentDataBag);
        },

        calculateCoverageAmount() {
            const self = this;
            //submit data
            //invoke backend api

            //format databag
            var data = __WEBPACK_IMPORTED_MODULE_4__Application_services_RequestResponseFormatter__["a" /* default */].ConvertDataBagToSessionData(self.componentDataBag);
            var postedData = { answers: data };

            console.log('calculateCoverageAmount', postedData);
            self.processing = true;
            //post to server and get response
            //merge config
            const gConfig = Object.assign({}, self.globalRequestConfig, { endpoint: self.coverageUrl });

            const config = __WEBPACK_IMPORTED_MODULE_7__Shared_Utilities_Utility__["b" /* Utility */].deepMerge(reqConfig, gConfig);
            __WEBPACK_IMPORTED_MODULE_5__services_formService__["a" /* default */].postForm(config, postedData, data => {
                self.recommendations = data;
            }, error => {
                console.log('calculateCoverageAmount:error', error);
                self.submitError = true;
            }, () => {
                self.processing = false;
                self.recalculate = false;
            });
        },

        setBackButtonView(stepGrpIndex) {
            //for first step and stepGrpIndex = 0, hide back/prev button
            if (stepGrpIndex == 0) {
                this.hideBack = true;
            } else {
                this.hideBack = false;
            }
        },

        groupInteractionCallback(grp, direction, success, grpIdx, isLastGrp) {
            console.log('groupInteractionCallback', grp, direction, success, grpIdx, isLastGrp);
            this.setBackButtonView(grpIdx);
            //no more groups, i.e. last step
            this.canCalculate = isLastGrp && direction == 1;
        },

        validateCalculatorForm() {
            this.actionBus.$emit('validate');
            //console.log(this.componentState)
            return this.componentState.$valid;
        },

        nextOrCalculateCoverageHandler() {

            if (this.validateCalculatorForm()) {
                if (this.canCalculate) {
                    this.calculateCoverageAmount();
                } else {
                    this.actionBus.$emit(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT);
                }
            }
        },

        prevHandler() {
            this.actionBus.$emit(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV);
        },

        selectCoverageHandler() {
            var amount = this.recommendations.recommendedCoverageAmount || this.defaultCoverageAmount;

            const cb = this.useCoverageCallback;
            if (this.isIndependent && cb && typeof cb == 'function') {
                cb(amount);
            } else if (this.dataBag && this.dataKeyObject.coverageKey) {
                this.$set(this.dataBag, this.dataKeyObject.coverageKey, amount);
            }
            this.show = false;
            this.onPopupClose();
        },

        showCalculatorHandler() {
            this.populateComponentDataBag();
            this.recommendations = {};
            this.show = true;
            if (!this.isIndependent) {
                var bodyElements = document.getElementsByTagName('body');
                if (bodyElements && bodyElements.length > 0) {
                    bodyElements[0].classList.add('popup-overlay');
                }
            }
        },
        recalculateHandler() {
            this.recalculate = true;
            this.canCalculate = false;
        },
        closeHandler() {
            if (this.clearFormState) {
                this.clearFormState();
            }
            this.show = false;
            this.onPopupClose();
        },
        onPopupClose() {
            if (!this.isIndependent) {
                var bodyElements = document.getElementsByTagName('body');
                if (bodyElements && bodyElements.length > 0) {
                    bodyElements[0].classList.remove('popup-overlay');
                }
            }
        }
    }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_formService__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalculatorComponent_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CalculatorComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CalculatorComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Utilities_Utility__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'calculatorComponent': __WEBPACK_IMPORTED_MODULE_1__CalculatorComponent_vue___default.a
    },
    props: {
        formSchemaUrl: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            componentState: {},
            componentDataBag: {},
            formSchema: undefined,
            settings: {
                formKey: "calculator_form",
                dataKey: "dataKey",
                transition: "slideUp",
                coverageKey: "premium",
                showTabNavigation: true,
                independentMode: true,
                keyMap: []
            }
        };
    },

    mounted() {
        console.log('LeadForm mounted with props', { url: this.formSchemaUrl });
        this.init();
    },
    computed: {},
    methods: {
        init() {
            this.loadFormSchema();
        },

        loadFormSchema() {
            try {
                const self = this;
                console.log('loadFormSchema', self);
                if (!self.formSchema && self.formSchemaUrl) {
                    //clone setting

                    __WEBPACK_IMPORTED_MODULE_0__services_formService__["a" /* default */].loadFormSchema(self.formSchemaUrl, data => {
                        self.formSchema = data; // JSON.parse(JSON.stringify(data));
                        console.log('loadFormSchema: schema loaded successfully', self.formSchema);
                    }, error => {
                        console.error('loadFormSchema: Error loading form schema', error);
                    });
                }
            } catch (e) {
                console.error('loadFormSchema: Error loading form schema', e);
            }
        },

        useCoverageHandler(amount) {
            const fSchema = this.formSchema;
            if (fSchema && fSchema.quotePageUrl) {
                const key = fSchema.coverageKey || 'coverage';
                const url = fSchema.quotePageUrl + '?' + key + '=' + amount;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Shared_Utilities_Utility__["a" /* httpGet */])(url);
            }
        }
    }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Application_mixins_BasePageComponentMixin__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_formService__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_services_conditionEvaluator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_components_RichContentView_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_components_RichContentView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Shared_components_RichContentView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_AppNavigationMixin__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MultiStepIndicator_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MultiStepIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__MultiStepIndicator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InteractiveFormComponent_vue__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InteractiveFormComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__InteractiveFormComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_utility__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'multiStepIndicator': __WEBPACK_IMPORTED_MODULE_7__MultiStepIndicator_vue___default.a,
        'interactiveFormComponent': __WEBPACK_IMPORTED_MODULE_8__InteractiveFormComponent_vue___default.a,
        'richContentView': __WEBPACK_IMPORTED_MODULE_5__Shared_components_RichContentView_vue___default.a
    },
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Application_mixins_BasePageComponentMixin__["a" /* BasePageComponentMixin */], __WEBPACK_IMPORTED_MODULE_6__mixins_AppNavigationMixin__["a" /* AppNavigationMixin */]],
    props: {
        formSchemaUrl: {
            type: String,
            required: true
        },
        formConfigKey: {
            type: String,
            required: true
        },
        extraData: {
            type: [Object, String],
            required: false
        }
    },
    data: function () {
        return {
            actionBus: new __WEBPACK_IMPORTED_MODULE_10_vue__["a" /* default */](),
            showForm: false,
            openerId: undefined,
            formState: {},
            dataBag: {},
            parsedSchema: {},
            processing: false,
            startTime: 0,
            activeStepIndex: -1,
            activeStep: {},
            pendingSuccessCallbacks: [],
            submitResponse: {},
            submissionErrors: [],
            hideBack: false,
            showingStepOnly: false
        };
    },
    created() {
        //fetch page data;
        console.log("PageComponent=>created");
        const self = this;
        this.registerNavigationFeedbackEvents();
        Object.keys(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].ACTION_EVENTS).forEach(key => {
            self.$eventBus.$on(key, data => {
                self.actionHandler(key, data);
            });
        });
    },
    mounted() {
        document.addEventListener("showform", this.showFormHandler);
        document.addEventListener("interactive_submitData", this.submitDataToServer);
        document.addEventListener("interactive_showStep", this.showStepHandler);
        this.loadFormSchema();
    },
    destroyed() {
        this.unRegisterNavigationFeedbackEvents();
        const self = this;
        Object.keys(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].ACTION_EVENTS).forEach(key => {
            self.$eventBus.$off(key);
        });
    },
    computed: {
        formErrorHeaderText() {
            return this.getMessage('formErrorHeaderText');
        },
        formSubmission_error() {
            return this.getMessage('formSubmission_error');
        },
        waitMessage() {
            return this.getMessage('waitMessage');
        },
        innerSettings() {
            var req = this.getSubmissionRequest(0);
            return {
                renderMode: this.renderMode,
                requestConfig: req
            };
        },
        appTitle() {
            return this.showingStepOnly ? this.activeStep.title || this.formSchema.title : this.formSchema.title;
        },
        progressBar() {
            return this.formSchema && this.formSchema.progressBar;
        },
        closeButton() {
            return this.formSchema.closeButton != undefined ? this.formSchema.closeButton : true;
        },
        formKey() {
            return this.formConfigKey;
        },
        nextNav() {
            var stp = this.activeStep;
            return {
                text: stp.nextLabel || '',
                hide: !stp.nextLabel
            };
        },

        prevNav() {
            var stp = this.activeStep;
            return {
                text: stp.prevLabel || '',
                hide: !stp.prevLabel
            };
        },

        hidePrev() {
            if (this.hideBack) {
                return this.hideBack;
            }
            return this.prevNav.hide;
        },

        navSteps() {
            var navItems = [];

            this.steps.forEach((step, idx) => {
                const foundItemIdx = navItems.findIndex(item => item.title === step.title);

                if (step.title && foundItemIdx < 0) {
                    navItems.push({ title: step.title, iconClass: step.iconClass });
                }
            });
            return navItems;
        },

        activeNavIndex() {
            return this.navSteps.findIndex(item => item.title === this.activeStep.title);
        },

        formSchema() {
            const schema = this.parsedSchema || {};
            console.log('formSchema', schema);
            return schema;
        },
        globalRequestConfig() {
            return (this.formSchema.submissionConfig || {}).request || {};
        },

        steps() {
            return this.formSchema.steps || [];
        },
        totalStep() {
            return this.steps.length || 0;
        },

        activeStepGroups() {
            var grps = (this.activeStep.form || {}).groups || [];
            return grps;
        },

        renderMode() {
            return ((this.activeStep.form || {}).renderMode || 'replace').toLowerCase();
        },

        canSubmit() {
            return this.activeStep.submit || false;
        },

        gtmEnabled() {
            return this.formSchema && this.formSchema.gtm;
        },

        errorsCount() {
            var errors = this.formState.$error;
            var count = 0;
            if (errors && this.formState.$submitted) {
                count = Object.keys(errors).length;
            };
            return count;
        },
        formErrors() {
            var errors = [];
            var errObj = this.formState.$error;

            if (errObj) {
                //iterate each error by key
                Object.keys(errObj).forEach(key => {
                    //exclude built-in properties begin with '$'
                    if (key && key.indexOf('$') == -1) {
                        //get error from error object by key
                        const error = errObj[key];
                        if (error && typeof error == 'object') {
                            //test condition & push to collection if condition is met
                            if (error.$submitted && error.submitCount > 0 || error.$touched) {
                                errors.push(key);
                            }
                        }
                    }
                });
            }
            return errors || [];
        }
    },

    methods: {
        setStepRequestConfig() {
            console.log('setStepRequestConfig');
            const valService = this.$validationService;
            const req = this.getSubmissionRequest();
            if (valService && req) {
                valService.requestConfig = req;
            }
        },
        actionHandler(action, data) {
            console.log('actionHandler', { action, data });
            const self = this;
            data = data || {};

            switch (action) {
                case __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].ACTION_EVENTS.ACTION_IN_PROGRESS:
                    self.showWaitDialog();
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].ACTION_EVENTS.ACTION_COMPLETED:
                    self.requestCompleted();
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].ACTION_EVENTS.SERVER_ERROR:
                    self.handleServerError(data.errors);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].ACTION_EVENTS.VALIDATION_ERROR:
                    self.handleErrorMessages(data.errors);
                    break;
                default:
                    break;
            }
        },
        setBackButtonView(stepGrpIndex) {
            //for first step and stepGrpIndex = 0, hide back/prev button
            if (this.activeStepIndex <= 0 && stepGrpIndex == 0) {
                this.hideBack = true;
            } else {
                this.hideBack = false;
            }
        },
        groupInteractionCallback(grp, direction, success, stepGrpIndex) {
            this.setBackButtonView(stepGrpIndex);
            console.log('groupInteractionCallback', grp, direction, success, this.activeStepIndex);

            if (success === false) {
                const self = this;
                window.setTimeout(() => {
                    self.changeActiveStep(direction == 1);
                }, 100);
            }
        },

        showStepHandler(evt) {
            if (this.showingStepOnly) {
                return;
            }
            if (evt && evt.detail && evt.detail.stepKey) {
                const idx = (this.steps || []).findIndex(s => s.key == evt.detail.stepKey);
                if (idx > -1) {
                    this.showingStepOnly = true;
                    this.showForm = true;
                    this.changeActiveStep(true, idx);
                }
            }
        },

        showFormHandler(evt) {
            console.log('show form', evt);
            if (this.showForm) {
                console.log('form already showing', evt);
                return;
            }
            const self = this;
            if (evt && evt.type === "showform"
            /*&& evt.detail.formKey === this.formSchema.formKey*/
            ) {
                    if (evt.detail && evt.detail.target) {
                        if (evt.detail.target.id) {
                            self.openerId = evt.detail.target.id;
                        } else {
                            self.openerId = __WEBPACK_IMPORTED_MODULE_3__Shared_Utilities_Utility__["b" /* Utility */].newGuid();
                            evt.detail.target.id = self.openerId;
                        }
                    }

                    window.setTimeout(function () {
                        /*document.getElementById(self.formKey)
                            .scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });*/
                        //$('html,body').animate({ scrollTop: $("#" + self.formKey).offset().top - 80 }, 'slow');
                        self.showHideOpener(true);
                        self.setShowForm(true);
                    }, 100);
                }
        },

        showHideOpener(hide) {
            const self = this;
            if (self.openerId) {
                var el = document.getElementById(self.openerId);
                if (el) {
                    el.hidden = hide;
                }
            }
        },

        formCloseHandler() {
            this.showHideOpener(false);
            this.showForm = false;
            this.showingStepOnly = false;
        },

        startTimer() {
            this.startTime = new Date().getTime();
            console.log('startTimer', this.startTime);
        },

        getTotalTime() {
            var endTime = new Date().getTime();
            console.log('endTime', endTime);
            //convert total time to second
            return (endTime - this.startTime) / 1000;
        },

        getSubmissionRequest(frm = 1) {
            //combine global and step submission config
            const globalRequest = this.globalRequestConfig;
            var submitRequest = globalRequest;
            var detail = this.activeStep;
            if (detail && detail.submissionConfig && detail.submissionConfig.request) {
                const stepRequest = detail.submissionConfig.request || {};
                submitRequest = __WEBPACK_IMPORTED_MODULE_3__Shared_Utilities_Utility__["b" /* Utility */].deepMerge(globalRequest, stepRequest);
            }
            return submitRequest;
        },

        applySetting() {
            this.loadQueryStringsIntoDatabag();
            this.setShowForm(this.formSchema.showAtStartup);
            //save other pros in databag
            const self = this;
            self.$set(self.dataBag, "formKey", self.formConfigKey);
        },

        loadQueryStringsIntoDatabag() {
            const self = this;
            const qsKeys = this.formSchema.queryStringKeysToload || [];
            if (qsKeys && Array.isArray(qsKeys) && qsKeys.length > 0) {
                var qsMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_utility__["b" /* getQueryValues */])(qsKeys);
                console.log('loadQueryStringsIntoDatabag', qsMap);
                for (const qkey in qsMap) {
                    self.$set(self.dataBag, qkey, qsMap[qkey]);
                }
            }
        },

        setShowForm(show) {
            this.showForm = show;
            if (this.showForm) {
                this.startTimer();
                this.configureGtag();
                this.resetFormRendering();
            }
        },

        resetFormRendering() {
            this.activeStepIndex = -1;
            this.changeActiveStep();
        },

        changeActiveStep(fwdDirection = true, stpIdx = -1) {
            const steps = this.steps;
            if (steps.length == 0) {
                this.activeStep = {};
                return;
            }

            if (stpIdx == -1) {

                let newStepIndex = -1;
                if (fwdDirection) {
                    newStepIndex = this.activeStepIndex + 1;
                } else {
                    newStepIndex = this.activeStepIndex - 1;
                }

                if (!(newStepIndex >= 0 && newStepIndex < this.totalStep)) {
                    return;
                }

                this.activeStepIndex = newStepIndex;
            } else {
                this.activeStepIndex = stpIdx;
            }

            var newStep = undefined;

            while (!newStep) {
                const stp = steps[this.activeStepIndex];

                //if condition are defined then evaluate
                if (stp && stp.form && stp.form.filters && stp.form.filters.length > 0) {
                    const validGrp = __WEBPACK_IMPORTED_MODULE_4__Shared_services_conditionEvaluator__["a" /* default */].evaluateConditions(stp.form.filters, this.dataBag, true);
                    if (validGrp) {
                        newStep = stp;
                        break;
                    }

                    if (fwdDirection) {
                        this.activeStepIndex++;
                        //break if out of range
                        if (this.activeStepIndex >= steps.length) {
                            break;
                        }
                    } else {
                        this.activeStepIndex--;
                        //break if out of range
                        if (this.activeStepIndex < 0) {
                            break;
                        }
                    }
                } else {
                    //take next non conditonal step as active step
                    newStep = stp;
                }
            }

            this.activeStep = newStep || {};
            //reset group when step changes
            this.setStepRequestConfig();
            this.sendPageView();
        },

        postLoadForm() {
            var schema = this.formSchema;
            try {

                var eData = typeof this.extraData == 'object' ? this.extraData : JSON.parse(this.extraData);
                console.log('postLoadForm', schema);
                if (schema && eData) {
                    var messages = schema.messages || [];
                    Object.keys(eData).forEach(prop => {
                        messages.push({
                            key: prop,
                            value: eData[prop]
                        });
                    });
                    schema.messages = messages;
                    console.log('postLoadForm', schema.messages);
                }
            } catch (e) {}
        },

        loadFormSchema() {
            try {
                const self = this;
                console.log('loadFormSchema', self);
                if (!self.config && self.formSchemaUrl) {
                    //clone setting
                    __WEBPACK_IMPORTED_MODULE_2__services_formService__["a" /* default */].loadFormSchema(self.formSchemaUrl, data => {
                        console.log('loadFormSchema: schema loaded successfully', data);
                        self.onDataLoaded(data);
                    }, error => {
                        console.error('loadFormSchema: Error loading form schema', error);
                    });
                }
            } catch (e) {
                console.error('loadFormSchema: Error loading form schema', e);
            }
        },

        onDataLoaded(data) {
            console.log('onPageDataLoaded');

            this.processing = false;
            if (data) {
                this.parsedSchema = data;
                this.postLoadForm();
                this.applySetting();
            }
        },

        configureGtag() {
            //if (this.gtmEnabled && this.$gtm) {
            //    this.$gtag.startTracking(this.formSchema.gtagTrackingId);
            //}
        },

        sendPageView() {

            if (!this.gtmEnabled || !this.activeStep) {
                return;
            }

            console.log('sendPageView');
            const activeStep = this.activeStep;
            if (this.$gtm && activeStep && activeStep.gtm && !activeStep.gtm.disable) {
                //process gtm config
                var gtmData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__services_utility__["a" /* buildMap */])(activeStep.gtm.data);
                this.$gtm.push(gtmData);
            }
        },

        saveDataBagAndNavigateToNext() {
            //no data save, just navigate to next
            const self = this;
            if (this.canSubmit) {
                this.submitStepData(() => {
                    this.mergeStepDataSubmissionResponse(self.dataBag);
                    self.navigateToNextPage({});
                });
            } else {
                this.navigateToNextPage({});
            }
        },

        submitDataToServer(evt) {
            //evt.detail : { dataBag, cb, extraData }
            console.log('submitDataToServer', evt);
            const evtDetail = evt.detail || {};
            const dataBag = evtDetail.dataBag || {};
            const callback = evtDetail.callback || {};
            const extraData = evtDetail.extraData || {};

            var req = this.getSubmissionRequest();
            __WEBPACK_IMPORTED_MODULE_2__services_formService__["a" /* default */].postForm(req, dataBag, callback.success, callback.error, callback.completed, extraData);
        },

        submitStepData(successCallback) {
            const self = this;
            this.addPendingCallback(successCallback);

            var submitData = Object.assign({}, this.dataBag);
            //submitData["formKey"] = this.formConfigKey;
            submitData["timeTakenToSubmit"] = this.getTotalTime();
            this.showWaitDialog();
            var additionalData = {};

            (self.formSchema.messages || []).forEach(m => {
                additionalData[m.key] = m.value;
            });

            var req = self.getSubmissionRequest();
            this.submissionErrors = [];
            __WEBPACK_IMPORTED_MODULE_2__services_formService__["a" /* default */].postForm(req, submitData, this.handleSuccessResponse, this.handleServerError, this.requestCompleted, additionalData);
        },

        handleSuccessResponse(data) {
            //const { url, method, formData } = data.navigation;
            //_internalFormPost(url, method, formData);
            const self = this;
            if (data.success) {
                console.log('axios success', data);
                //submit
                self.submitResponse = data;
                var cb = self.popPendingCallback();
                if (cb) {
                    cb();
                }
            } else if (data.errors) {
                console.log('axios errors');
                this.handleErrorMessages(data.errors);
            } else {
                console.log('axios then else');
            }
        },

        mergeStepDataSubmissionResponse(target) {
            if (this.submitResponse && target) {
                target = Object.assign(target, this.submitResponse.data || {});
            }
            console.log('mergeStepDataSubmissionResponse', target);
        },

        getMessage(key) {
            const messages = this.formSchema.messages;
            var message = '';
            if (messages && Array.isArray(messages)) {
                message = (messages.find(m => m.key == key) || {}).value;
            }
            return message;
        },

        handleErrorMessages(errors) {
            const self = this;
            console.log('handleErrorMessages', errors);
            if (errors && Object.keys(errors).length > 0) {
                //this.prev();
                var messages = [];
                Object.keys(errors).forEach(key => {
                    var filterKey = (key || '_noKey').toLowerCase();
                    var m = self.getMessage(filterKey);
                    if (m) {
                        messages.push(m);
                    }
                });
                this.submissionErrors = messages;
            }
        },
        handleServerError(error) {
            console.error('Server error', error);
            this.submissionErrors = [];
            this.submissionErrors.push(this.formSubmission_error);
        },

        requestCompleted() {
            this.hideWaitDialog();
        },
        showWaitDialog() {
            this.processing = true;
        },

        hideWaitDialog() {
            this.processing = false;
        },

        addPendingCallback(cb) {
            if (typeof cb === 'function') {
                var cbs = this.pendingSuccessCallbacks || [];
                cbs.push(cb);
            }
        },

        popPendingCallback() {
            var cbs = this.pendingSuccessCallbacks || [];
            var successCb = undefined;

            if (cbs.length > 0) {
                successCb = cbs.pop();
            }
            return successCb;
        },

        navigateToPrevPage() {
            this.actionBus.$emit(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV);
        },

        navigateToNextPage() {
            this.actionBus.$emit(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT);
        }

    }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Application_mixins_ComponentBaseMixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Application_mixins_ComponentBaseMixin__["a" /* ComponentBaseMixin */]],
    props: {
        actionBus: {
            type: Object,
            required: false,
            default: function () {
                return new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]();
            }
        },
        groupInteractionCallback: {
            type: Function,
            required: false
        }
    },
    data: function () {
        return {
            activeGroup: undefined,
            renderableGroups: [],
            currentGroupIndex: -1,
            groupAutoNavigated: false,
            isForwardDirection: true
        };
    },
    created() {},

    mounted() {
        this.actionBus.$on(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT, this.navigateToNextGroup);
        this.actionBus.$on(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV, this.navigateToPrevGroup);
        this.actionBus.$on('validate', this.validateForm);
        this.resetGroupView();
    },

    beforeDestroy() {
        this.actionBus.$off(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT, this.navigateToNextGroup);
        this.actionBus.$off(__WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV, this.navigateToPrevGroup);
    },

    watch: {
        questionGroupList(newGroups, oldVal) {
            //console.log('watchers:questionGroupList');
            this.resetGroupView();
        }
    },

    computed: {
        modifiedActiveGroup() {
            if (this.activeGroup) {
                this.setComponentSettings([this.activeGroup], this.settings);
            }
            return this.activeGroup;
        },
        allGroups() {
            return this.questionGroupList || [];
        },

        showTabNavigation() {
            this.ensureDataKeyParsing();
            return (this.settings || {}).showTabNavigation;
        },

        tabNavLinks() {
            return this.allGroups.filter(gr => !!gr.linkTitle).map((g, idx) => {
                return { linkTitle: g.linkTitle, index: idx };
            });
        },

        renderMode() {
            this.ensureDataKeyParsing();
            return ((this.settings || {}).renderMode || 'replace').toLowerCase();
        },

        validate() {
            this.ensureDataKeyParsing();
            return (this.settings || {}).validate || true;
        },

        preserveData() {
            this.ensureDataKeyParsing();
            return (this.settings || {}).preserveData || true;
        },

        forwardTransition() {
            return (this.formSchema || {}).forwardTransition || "slide-left";
        },

        backwardTransition() {
            return (this.formSchema || {}).backwardTransition || "slide-right";
        },

        transitionClass() {
            var cls = 'group-container';
            if (this.transitionName) {
                cls += ' tg-' + this.transitionName;
            }
            return cls;
        },

        transitionName() {
            return this.isForwardDirection ? this.forwardTransition : this.backwardTransition;
        },

        showingLastGroup() {
            return this.currentGroupIndex == this.allGroups.length - 1;
        }

    },
    methods: {

        validateForm() {
            return this.validateState(this.state);
        },

        formFieldInteractionCallback(fieldKey, gKey, isLastField) {
            console.log('interactiveFormComponent::formFieldInteractionCallback', gKey, isLastField);
            if (!isLastField) {
                return;
            }

            var grp = this.activeGroup;
            if (grp && grp.groupKey == gKey && grp.autoNavigation === true && !this.groupAutoNavigated) {
                this.navigateToNextGroup();
            }
        },

        resetAutoNavigation() {
            const self = this;
            this.groupAutoNavigated = true;
            window.setTimeout(() => {
                self.groupAutoNavigated = false;
                //console.log('resetAutoNavigation');
            }, 2000);
        },

        setPreserveDataFlag(grps) {
            if (this.preserveData) {
                this.setQuestionProperties(grps, { disableDestroyAction: true });
            }
        },

        resetGroupView() {
            //this.activeGroup = undefined;
            this.renderableGroups = [];
            this.currentGroupIndex = -1;
            if (this.isForwardDirection) {
                this.navigateToNextGroup(0, this.isForwardDirection, true);
            } else {
                this.navigateToPrevGroup();
            }
        },

        selectGroup(index) {
            if (index > this.currentGroupIndex) {
                this.navigateToNextGroup(index);
            } else if (index < this.currentGroupIndex) {
                this.navigateToNextGroup(index, false);
            }
        },

        //function to set next group to be rendered in UI
        renderNextGroup(index = -1) {
            var hasGroup = false;
            var groups = this.allGroups;

            if (index == -1) {
                if (this.currentGroupIndex + 1 >= groups.length) {
                    return hasGroup;
                }
                this.currentGroupIndex = this.currentGroupIndex + 1;
            } else {
                if (index < 0 && index >= groups.length) {
                    return hasGroup;
                }
                this.currentGroupIndex = index;
            }
            var grp = groups[this.currentGroupIndex];

            if (grp) {
                this.setGroupKey(grp);
                this.setPreserveDataFlag([grp]);

                //replace old group with new group
                if (this.renderMode == __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].RENDER_MODE.REPLACE) {
                    this.renderableGroups.splice(0, this.renderableGroups.length); //clear array
                    if (!grp.nofocus) {
                        grp.focus = true;
                    }
                    this.renderableGroups.push(grp); //push new item to array
                    hasGroup = true;
                    this.activeGroup = grp;
                }
                //keep existing group and stack new group on top on it
                else if (this.renderMode == __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].RENDER_MODE.STACKED) {
                        //set focus on first item of the group
                        if (!grp.nofocus) {
                            grp.focus = true;
                        }
                        this.renderableGroups.push(grp);
                        hasGroup = true;
                    }
                    //default is render all.
                    else {
                            if (groups.length > 0 && !grp.nofocus) {
                                groups[0].focus = true;
                            }
                            this.renderableGroups = groups;
                            hasGroup = false;
                        }
            }
            return hasGroup;
        },

        renderPrevGroup() {
            var hasGroup = false;
            var groups = this.allGroups;

            if (this.currentGroupIndex < 0) {
                //move to last
                this.currentGroupIndex = groups.length;
            }

            if (this.renderMode == __WEBPACK_IMPORTED_MODULE_0__Shared_Constants__["a" /* Constants */].RENDER_MODE.REPLACE && this.currentGroupIndex > 0) {
                this.currentGroupIndex = this.currentGroupIndex - 1;
                var grp = groups[this.currentGroupIndex];

                if (grp) {
                    this.setGroupKey(grp);
                    this.setPreserveDataFlag([grp]);

                    //replace old group with new group
                    this.renderableGroups.splice(0, this.renderableGroups.length); //clear array
                    this.renderableGroups.push(grp); //push new item to array
                    this.activeGroup = grp;
                    hasGroup = true;
                }
            }
            return hasGroup;
        },

        navigateToPrevGroup() {
            this.resetAutoNavigation();
            this.isForwardDirection = false;
            //try to render prev group in current active step
            var success = this.renderPrevGroup();
            const self = this;
            //this.groupNavigated = true;
            window.setTimeout(() => {
                self.notifyGroupInteraction(self.activeGroup, -1, success);
            }, 100);
        },

        navigateToNextGroup(index = -1, forward = true, fromReset = false) {

            var valid = true;
            if (this.validate && !fromReset) {
                valid = this.validateState(this.state);
            }

            //navigate if valid or moving backward
            if (valid || !forward) {
                this.resetAutoNavigation();
                this.isForwardDirection = forward != undefined ? forward : true;
                //try to render next group in current active step
                var success = this.renderNextGroup(index);
                const self = this;
                //this.groupNavigated = true;
                window.setTimeout(() => {
                    self.notifyGroupInteraction(self.activeGroup, 1, success);
                }, 100);
            }
        },

        notifyGroupInteraction(grp, direction, success) {
            if (this.groupInteractionCallback) {
                this.groupInteractionCallback(grp, direction, success, this.currentGroupIndex, this.showingLastGroup);
            }
        }
    }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_formService__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utility__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MultiStepIndicator_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MultiStepIndicator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MultiStepIndicator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_Constants__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'multiStepIndicator': __WEBPACK_IMPORTED_MODULE_2__MultiStepIndicator_vue___default.a
    },
    props: {
        formSchemaUrl: {
            type: String,
            required: true
        },
        formConfigKey: {
            type: String,
            required: true
        },
        extraData: {
            type: [Object, String],
            required: false
        }
    },
    data() {
        return {
            openerId: undefined,
            showForm: false,
            startTime: 0,
            config: undefined,
            currentStep: 0,
            /*formData: {},*/
            stepDetail: {},
            consolidatedData: {},
            inputErrors: {},
            pendingSuccessCallbacks: [],
            submitResponse: {},
            wait: false,
            componentState: {},
            componentDataBag: {},
            formUiConfig: {},
            pageSchema: {},
            submissionErrors: []
        };
    },
    created() {
        this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_4__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT, this.next);
    },
    mounted() {
        console.log('LeadForm mounted with props', { url: this.formSchemaUrl, key: this.formConfigKey });
        this.init();
    },
    //watch: {
    //    config(newValue, oldValue) {
    //        console.log('watch-config', newValue, oldValue);
    //        if (oldValue && Object.keys(oldValue).length > 0) {
    //            console.log('watch-config return');
    //            return;
    //        }
    //        this.initOnce();
    //    }
    //},
    computed: {
        formErrorHeaderText() {
            return this.getMessage('formErrorHeaderText');
        },
        formSubmission_error() {
            return this.getMessage('formSubmission_error');
        },

        formKey() {
            return this.formConfigKey || 'x1234';
        },
        formSetting() {
            return this.config || {};
        },
        completed() {
            if (this.formSetting.testMode) {
                return true;
            }
            return this.currentStep == this.totalStep;
        },
        navSteps() {
            var navItems = [];

            this.steps.forEach((step, idx) => {
                const foundItemIdx = navItems.findIndex(item => item.title === step.title);

                if (step.title && foundItemIdx < 0) {
                    navItems.push({ title: step.title, iconClass: step.iconClass });
                }
            });
            return navItems;
        },

        steps() {
            return (this.formSetting || {}).steps || [];
        },
        currentStepDetail() {
            return this.stepDetail || {};
        },
        totalStep() {
            return this.steps.length || 0;
        },
        formFieldGroups() {
            return (this.currentStepDetail.form || {}).groups || [];
        },

        canSubmit() {
            return this.currentStepDetail.submit || false;
        },

        gtmEnabled() {
            return this.formSetting && this.formSetting.gtm;
        },

        waitMessage() {
            return (this.currentStepDetail.messages || {}).waitMessage || "Please wait...";
        },
        updatedFormConfig() {
            //const self = this;
            const step = this.currentStepDetail;

            var config = {
                submitButton: {
                    label: step.nextLabel,
                    show: !!step.nextLabel,
                    enabled: true
                },
                cancelButton: {
                    label: step.prevLabel,
                    show: !!step.prevLabel
                }
            };
            return config;
        }
    },
    methods: {
        init() {
            this.loadFormSchema();
            //attach hadnler for trigger from outside
            document.addEventListener("showform", this.showFormHandler);
            console.log('init-show', this.showForm);
        },
        getCurrentStepResponseData() {
            var tnxData = {};
            if (this.submitResponse) {
                tnxData = this.submitResponse.data || {};
            }
            console.log('getCurrentStepResponseData', tnxData);
            return tnxData;
        },
        showFormHandler(evt) {
            console.log('show form', evt);
            const self = this;
            if (evt && evt.type === "showform"
            /*&& evt.detail.formKey === this.formSetting.formKey*/
            ) {
                    if (evt.detail && evt.detail.target) {
                        if (evt.detail.target.id) {
                            self.openerId = evt.detail.target.id;
                        } else {
                            self.openerId = __WEBPACK_IMPORTED_MODULE_3__Shared_Utilities_Utility__["b" /* Utility */].newGuid();
                            evt.detail.target.id = self.openerId;
                        }
                    }
                    this.setFormShow(true);
                    window.setTimeout(function () {
                        /*document.getElementById(self.formKey)
                            .scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });*/
                        $('html,body').animate({ scrollTop: $("#" + self.formKey).offset().top - 80 }, 'slow');
                        self.showHideOpener(true);
                    }, 100);
                }
        },
        showHideOpener(hide) {
            const self = this;
            if (self.openerId) {
                var el = document.getElementById(self.openerId);
                if (el) {
                    el.hidden = hide;
                }
            }
        },
        formCloseHandler() {
            this.showHideOpener(false);
            this.showForm = false;
        },
        startTimer() {
            this.startTime = new Date().getTime();
            console.log('startTimer', this.startTime);
        },
        getTotalTime() {
            var endTime = new Date().getTime();
            console.log('endTime', endTime);
            //convert total time to second
            return (endTime - this.startTime) / 1000;
        },
        getCurrentSubmissionRequest() {
            //combine global and step submission config

            const globalRequest = this.formSetting.submissionConfig.request;
            var submitRequest = globalRequest;

            var detail = this.stepDetail;
            if (detail && detail.submissionConfig && detail.submissionConfig.request) {
                const stepRequest = this.stepDetail.submissionConfig.request || {};
                submitRequest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_utility__["c" /* deepMerge */])(globalRequest, stepRequest);
            }
            return submitRequest;
        },

        postLoadForm() {
            var schema = this.config;
            try {

                var eData = typeof this.extraData == 'object' ? this.extraData : JSON.parse(this.extraData);
                console.log('postLoadForm');
                if (schema && eData) {
                    var messages = schema.messages || [];
                    Object.keys(eData).forEach(prop => {
                        messages.push({
                            key: prop,
                            value: eData[prop]
                        });
                    });
                    schema.messages = messages;
                    console.log('postLoadForm', schema.messages);
                }
            } catch (e) {}
        },

        loadFormSchema() {
            try {
                const self = this;
                console.log('loadFormSchema', self);
                if (!self.config && self.formSchemaUrl) {
                    //clone setting

                    __WEBPACK_IMPORTED_MODULE_0__services_formService__["a" /* default */].loadFormSchema(self.formSchemaUrl, data => {
                        self.config = data; // JSON.parse(JSON.stringify(data));
                        console.log('loadFormSchema: schema loaded successfully', self.config);
                        self.postLoadForm();
                        self.applySetting();
                    }, error => {
                        console.error('loadFormSchema: Error loading form schema', error);
                    });
                }
            } catch (e) {
                console.error('loadFormSchema: Error loading form schema', e);
            }
        },

        applySetting() {
            this.loadQueryStringsIntoDatabag();
            this.setFormShow(this.formSetting.showAtStartup);
        },

        loadQueryStringsIntoDatabag() {
            const self = this;
            const qsKeys = this.formSetting.queryStringKeysToload || [];
            if (qsKeys && Array.isArray(qsKeys) && qsKeys.length > 0) {
                var qsMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_utility__["b" /* getQueryValues */])(qsKeys);
                console.log('loadQueryStringsIntoDatabag', qsMap);
                for (const qkey in qsMap) {
                    self.$set(self.componentDataBag, qkey, qsMap[qkey]);
                }
            }
        },

        setFormShow(show) {
            this.showForm = show;
            if (this.showForm) {
                if (this.currentStep == 0) {
                    this.currentStep = 1;

                    this.configureGtag();
                    this.loadStepSchema();
                }
                this.startTimer();
            }
        },

        next() {
            //submit
            const self = this;
            if (this.canSubmit) {
                this.saveData(self.canSubmit, function () {
                    self.performNextAction();
                });
            } else {
                self.performNextAction();
            }
        },
        prev() {
            if (this.currentStep > 1) {
                this.currentStep--;
                this.loadStepSchema();
                this.componentDataBag = Object.assign({}, this.consolidatedData);
            }
        },
        performNextAction() {
            if (this.currentStep < this.totalStep) {
                this.currentStep++;
                //load next step schema to render
                this.loadStepSchema();
                const tData = this.getCurrentStepResponseData();
                this.componentDataBag = Object.assign({}, this.consolidatedData, tData);
            }
            console.log('rendering step:' + (this.stepDetail || {}).title, this.componentDataBag);
        },
        setStepRequestConfig() {
            console.log('setStepRequestConfig');
            const valService = this.$validationService;
            const req = this.getCurrentSubmissionRequest();
            if (valService && req) {
                valService.requestConfig = req;
            }
        },
        updateStepComponentSettings(stp) {
            const req = this.getCurrentSubmissionRequest();
            if (stp && req) {
                const grps = (stp.form || {}).groups || [];
                grps.forEach(g => {
                    if (g.components) {
                        const components = g.components || [];
                        components.forEach(c => {
                            c.settings = Object.assign({}, c.settings || {}, { requestConfig: req });
                        });
                    }
                });
            }
        },
        loadStepSchema() {
            let stepIndex = this.currentStep - 1;

            const steps = this.steps;
            const tempStep = steps && steps.length > 0 ? steps[stepIndex] : {};
            this.updateStepComponentSettings(tempStep);
            this.stepDetail = tempStep;
            this.sendPageView();

            this.setStepRequestConfig();
            //this.setStepData();
        },
        //setStepData() {
        //    //copy current response to databag to pass to next step
        //    this.componentDataBag = this.getCurrentStepResponseData();
        // },

        configureGtag() {
            //if (this.gtmEnabled && this.$gtm) {
            //    this.$gtag.startTracking(this.formSetting.gtagTrackingId);
            //}
        },

        sendPageView() {
            const currentStep = this.stepDetail;

            if (!this.gtmEnabled || !currentStep) {
                return;
            }

            console.log('sendPageView');

            if (this.$gtm && currentStep && currentStep.gtm && !currentStep.gtm.disable) {
                //process gtm config
                var gtmData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__services_utility__["a" /* buildMap */])(currentStep.gtm.data);
                this.$gtm.push(gtmData);
            }
        },

        async handleSubmit(dt) {
            console.log('handleSubmit', dt);
            if (dt.valid) {
                //submit data
                this.consolidatedData = Object.assign(this.consolidatedData, dt.formData);
                this.next();
            }
        },

        addPendingCallback(cb) {
            if (typeof cb === 'function') {
                var cbs = this.pendingSuccessCallbacks || [];
                cbs.push(cb);
            }
        },

        popPendingCallback() {
            var cbs = this.pendingSuccessCallbacks || [];
            var successCb = undefined;

            if (cbs.length > 0) {
                successCb = cbs.pop();
            }
            return successCb;
        },

        showWaitDialog() {
            this.wait = true;
        },

        hideWaitDialog() {
            this.wait = false;
        },
        requestCompleted() {
            this.hideWaitDialog();
        },

        saveData(submit, successCallback) {
            if (submit) {
                const self = this;
                this.addPendingCallback(successCallback);
                this.consolidatedData["formKey"] = this.formConfigKey;
                this.consolidatedData["timeTakenToSubmit"] = this.getTotalTime();
                this.showWaitDialog();
                var req = self.getCurrentSubmissionRequest();

                var additionalData = {};
                var schema = this.config;

                (schema.messages || []).forEach(m => {
                    additionalData[m.key] = m.value;
                });
                this.submissionErrors = [];

                __WEBPACK_IMPORTED_MODULE_0__services_formService__["a" /* default */].postForm(req, this.consolidatedData, this.handleSuccessResponse, this.handleServerError, this.requestCompleted, additionalData);
            }
        },
        handleSuccessResponse(data) {
            //const { url, method, formData } = data.navigation;
            //_internalFormPost(url, method, formData);
            const self = this;
            if (data.success) {
                console.log('axios success', data);
                //submit
                self.submitResponse = data;
                var cb = self.popPendingCallback();
                if (cb) {
                    cb();
                }
            } else if (data.errors) {
                console.log('axios errors');
                this.handleErrorMessages(data.errors);
            } else {
                console.log('axios then else');
            }
        },

        getMessage(key) {
            const messages = (this.config || {}).messages || [];

            var message = '';
            if (messages && Array.isArray(messages)) {
                message = (messages.find(m => m.key == key) || {}).value;
            }
            return message;
        },

        handleErrorMessages(errors) {
            const self = this;
            console.log('handleErrorMessages', errors);
            if (errors && Object.keys(errors).length > 0) {
                //this.prev();
                var messages = [];
                Object.keys(errors).forEach(key => {
                    var filterKey = (key || '_noKey').toLowerCase();
                    var m = self.getMessage(filterKey);
                    if (m) {
                        messages.push(m);
                    }
                });
                this.submissionErrors = messages;
            }
        },

        handleServerError(error) {
            console.error('Server error', error);
            this.submissionErrors = [];
            this.submissionErrors.push(this.formSubmission_error);
        }

    }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'MultiStepIndicator',
    props: {
        show: {
            type: Boolean,
            required: true,
            default: true
        },
        activeStep: {
            type: Number,
            required: true
        },
        steps: {
            type: Array,
            required: true
        }
    },
    computed: {
        totalSteps() {
            return (this.steps || []).length || 0;
        },
        navSteps() {
            //var titles = [];
            //this.steps.forEach(step => {
            //    if (typeof step == 'object') {
            //        titles.push(step.title);
            //    }
            //    else {
            //        titles.push(step);
            //    }
            //})
            //return titles;
            return this.steps || [];
        }
    },
    methods: {
        stepProgressBarClass(stepIdx) {
            var classes = ' text-center form-stepper-list ';
            //{' d-none ': (index + 1) !== currentStep,
            //' form-stepper-active ': (index + 1) == currentStep,
            //' form-stepper-completed ': (index + 1) < currentStep }

            //d-none
            //if (stepIdx + 1 !== this.currentStep) {
            //    classes += ' d-none '
            //}
            console.log('stepProgressBarClass', { stepIdx, currentStep: this.activeStep });
            if (stepIdx + 1 == this.activeStep) {
                classes += ' form-stepper-active ';
            }
            if (stepIdx + 1 < this.activeStep || this.activeStep == this.totalSteps) {
                classes += ' form-stepper-completed ';
            }
            return classes;
        }
    }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        nextCallback: {
            type: Function,
            required: true
        },
        prevCallback: {
            type: Function,
            required: true
        },
        hideNext: {
            type: Boolean,
            default: true,
            required: true
        },
        hidePrev: {
            type: Boolean,
            default: true,
            required: true
        },
        processing: {
            type: Boolean,
            required: false,
            default: false
        },
        nextButtonText: {
            type: String,
            required: false
        },
        prevButtonText: {
            type: String,
            required: false
        }
    },
    computed: {
        nextText() {
            return this.nextButtonText || 'Next';
        },
        prevText() {
            return this.prevButtonText || 'Previous';
        }
    },
    mounted() {
        //this.registerEnterKeyHandler();
    },
    destroyed() {
        //this.unRegisterEnterKeyHandler();
    },
    methods: {
        //registerEnterKeyHandler() {
        //    if (document && document.addEventListener) {
        //        document.addEventListener("keypress", this.enterKeyHandler/*, true*/)
        //    }
        //},
        //unRegisterEnterKeyHandler() {
        //    if (document && document.removeEventListener) {
        //        document.removeEventListener("keypress", this.enterKeyHandler)
        //    }
        //},
        //enterKeyHandler(e) {
        //    //console.log("enterKeyHandler", e.target.form);
        //    let keyCode = event.keyCode ? event.keyCode : event.which;
        //    if (keyCode == 13) {
        //        this.next();
        //    }
        //},
        next($event) {
            if (this.nextCallback) {
                this.nextCallback();
            }
        },
        prev() {
            if (this.prevCallback) {
                this.prevCallback();
            }
        }
    }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Application_mixins_ComponentBaseMixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_formService__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Shared_Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Constants__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Application_mixins_ComponentBaseMixin__["a" /* ComponentBaseMixin */]],
    props: {},
    data() {
        return {
            editError: null,
            editing: false,
            editorFormData: {},
            quoteEditor: {
                schema: {},
                formState: {},
                formData: {},
                uiConfig: {
                    submitButton: { label: 'UPDATE QUOTE', show: true, cssClass: 'btn btn-secondary' },
                    cancelButton: { label: 'Cancel', show: true, cssClass: 'btn btn-link' },
                    buttonContainer: { cssClass: 'clearfix button-group custom-btn-group' }
                },
                fields: [{
                    "key": "g1",
                    "questions": [[{
                        "question": {
                            "questionKey": "premium",
                            "text": "Coverage Amount",
                            "selectText": "Please select",
                            "type": "dropdown",
                            "answerOptionsFunction": "COVERAGE_AMOUNT_LIST",
                            "validators": {
                                "required": true,
                                "requiredMessage": "Please select a Coverage Amount."
                            }
                        },
                        "colCss": "basis-50"
                    }, {
                        "question": {
                            "questionKey": "termLength",
                            "text": "Term Length",
                            "selectText": "Please select",
                            "type": "dropdown",
                            "answerOptionsFunction": "TERM_LENGTH_LIST",
                            "validators": {
                                "required": true,
                                "requiredMessage": "Please select a Term Length."
                            }
                        },
                        "colCss": "basis-50"
                    }]]
                }]
            },
            updateUrl: '',
            submitUrl: ''
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        waitMessage() {
            return this.getMessage('waitMessage');
        },
        formSubmission_error() {
            return this.getMessage('formSubmission_error');
        },
        requestConfig() {
            const req = (this.settings || {}).requestConfig;
            console.log('quote editor:requestConfig', req);
            return req;
        },
        quote() {
            const db = this.dataBag;
            var amt = __WEBPACK_IMPORTED_MODULE_2__Shared_Utilities_Utility__["b" /* Utility */].formatCurrency(db.premium);
            const q = {
                monthlyPremium: db.monthly,
                coverageAmount: amt,
                termLength: db.termLength,
                rateClass: db.rateClass
            };
            return q;
        },

        monthlyPremiumDollar() {
            var dollar = '';
            const premium = this.quote.monthlyPremium || '';
            if (premium) {
                dollar = Number.parseInt(premium, 10);
                dollar = Number.isNaN(dollar) ? '' : dollar;
            }
            return dollar;
        },
        monthlyPremiumCents() {
            var cents = '';
            const premium = this.quote.monthlyPremium || '';
            if (premium) {
                const parts = (premium + '').split('.');
                if (Array.isArray(parts) && parts.length > 0) {
                    cents = parts[1];
                }
            }
            return cents;
        }
    },
    methods: {
        init() {
            console.log('mounted::Quote editor', this.settings, this.requestConfig.urls);
            const urls = this.requestConfig.urls;
            if (urls && urls.quoteEditor) {
                this.updateUrl = urls.quoteEditor.updateUrl;
                this.submitUrl = urls.quoteEditor.submitUrl;
            }
            this.loadQuote();
        },
        loadQuote() {
            console.log('loadQuote', this.dataBag, this.schema);
        },
        updateDataBag(resData, reqData) {
            this.dataBag = Object.assign({}, this.dataBag, reqData, resData);
        },
        navigateToNextPage() {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_3__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT);
        },
        notifyActionEvent(action, data) {
            console.log('notifyActionEvent', { action, data });
            this.$eventBus.$emit(action, data);
        },
        submitQuoteHandler() {
            const self = this;
            const reqConfig = Object.assign({}, self.requestConfig, { endpoint: self.submitUrl });
            console.log('submitQuoteHandler', this.dataBag, reqConfig);

            self.actionInProgress();
            __WEBPACK_IMPORTED_MODULE_1__services_formService__["a" /* default */].postForm(reqConfig, this.dataBag, function (res) {
                console.log('quote submit success', res);
                if (res && res.success) {
                    self.navigateToNextPage();
                }
            }, function (error) {
                console.log('quote submit error', error);
                self.notifyActionEvent(__WEBPACK_IMPORTED_MODULE_3__Shared_Constants__["a" /* Constants */].ACTION_EVENTS.SERVER_ERROR, { errors: [error] });
            }, this.requestCompleted);
        },
        editQuoteHandler() {
            const db = this.dataBag;
            this.editorFormData = Object.assign({}, {
                termLength: db.termLength,
                premium: db.premium
            });
            this.editing = true;
        },

        cancelQuoteUpdateHandler() {
            this.editing = false;
        },

        updateQuoteHandler(data) {
            const self = this;
            if (data.valid) {
                //this.editing = false;
                //submit data data.formData
                const submitData = Object.assign({}, this.dataBag, data.formData);
                const reqConfig = Object.assign({}, self.requestConfig, { endpoint: self.updateUrl });
                console.log('updateQuoteHandler', submitData, ...reqConfig);

                self.actionInProgress();
                __WEBPACK_IMPORTED_MODULE_1__services_formService__["a" /* default */].postForm(reqConfig, submitData, function (res) {
                    self.handleSuccessResponse(res, submitData);
                }, this.handleServerError, this.requestCompleted);
            }
        },
        handleSuccessResponse(response, reqData) {
            console.log('quote-editor::edit success', response);
            if (response.success && response.data) {

                this.updateDataBag(response.data, reqData);
            }
            this.editing = false;
        },
        handleServerError(error) {
            console.log('quote-editor::edit error', error);
            this.editing = true;
            this.notifyActionEvent(__WEBPACK_IMPORTED_MODULE_3__Shared_Constants__["a" /* Constants */].ACTION_EVENTS.SERVER_ERROR, { errors: [error] });
        },
        requestCompleted() {
            console.log('quote-editor::edit completed');
            //this.processing = false;
            this.notifyActionEvent(__WEBPACK_IMPORTED_MODULE_3__Shared_Constants__["a" /* Constants */].ACTION_EVENTS.ACTION_COMPLETED, { errors: [] });
        },
        actionInProgress() {
            console.log('quote-editor::in progress');
            //this.processing = false;
            this.notifyActionEvent(__WEBPACK_IMPORTED_MODULE_3__Shared_Constants__["a" /* Constants */].ACTION_EVENTS.ACTION_IN_PROGRESS, { errors: [] });
        }
    }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Application_mixins_ComponentBaseMixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_formService__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




const CALL_OPTION = {
    CALL_NOW: "1",
    CALL_SCHEDULE: "2"
};

const CALL_STATUS = {
    Scheduling: 'Scheduling',
    Scheduled: 'Scheduled',
    Initiated: 'Initiated',
    Connected: 'Connected',
    ConfirmedName: 'ConfirmedName',
    AgentConnected: 'AgentConnected',
    Failed: 'Failed',
    Completed: 'Completed',
    Error: 'Error',
    ThankYou: 'ThankYou'
};

const UI_CONFIG = {
    multistep: false,
    submitButton: {
        /*label: self.getLabel,*/
        show: true,
        enabled: true,
        labelProviderKey: "callUsType"
    },
    cancelButton: {
        label: 'Cancel',
        show: false
    }
};

const MESSAGE_PREFIX = 'call_';

/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Application_mixins_ComponentBaseMixin__["a" /* ComponentBaseMixin */]],
    props: {
        submitSuccessCallback: {
            type: Function,
            required: false
        }
    },
    data() {
        return {
            processing: false,
            callStatus: 'Please wait while we connect you to agent...',
            componentDataBag: {},
            componentDataCopy: {},
            componentState: {},
            showForm: true,
            currentGrpIdx: 0,
            multiStep_cancelButton: {
                label: 'Back',
                show: true
            },
            thankMessage: ''
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        formUIConfig() {
            const self = this;
            const cancelBtn = this.canGoPrev ? this.multiStep_cancelButton : this.settingUiConfig.cancelButton || UI_CONFIG.cancelButton;

            const localConfig = Object.assign({}, UI_CONFIG, self.settingUiConfig, { cancelButton: cancelBtn });

            localConfig.submitButton.label = self.getLabel;
            return localConfig;
        },
        //phoneNumber() {
        //    return this.componentDataBag['phoneOne'] || '';
        //},
        formGroups() {
            this.ensureDataKeyParsing();
            var groups = [];
            var formSchema = this.getFormSchema(this.dataKeyObject.formKey);
            groups = (formSchema || {}).groups || [];
            return groups;
        },
        renderGroups() {
            const grp = this.formGroups[this.currentGrpIdx];
            return [grp];
        },
        keyMap() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.keyMap || [];
        },

        settingUiConfig() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.uiConfig || {};
        },

        requestConfig() {
            return this.settings.requestConfig;
        },
        callEndpointKey() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.callEndpointKey;
        },
        interactiveCall() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.interactiveCall == true;
        },
        multiStep() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.multistep != undefined ? this.dataKeyObject.multistep : false;
        },
        canGoNext() {
            return this.multiStep ? this.currentGrpIdx < this.formGroups.length - 1 : false;
        },
        canGoPrev() {
            return this.multiStep ? this.currentGrpIdx > 0 : false;
        }
    },
    methods: {
        updateDataCopy() {
            //make copy
            this.componentDataCopy = Object.assign(this.componentDataCopy, this.componentDataBag);
        },
        isScheduleOption() {
            return this.componentDataBag["callUsType"] == CALL_OPTION.CALL_SCHEDULE;
        },
        init() {
            const self = this;
            console.log('TalkToAgent::init', this.settings);
            //var bag = {};
            this.keyMap.forEach(map => {
                if (map.formFieldKey) {
                    if (map.dataBagKey) {
                        self.$set(self.componentDataBag, map.formFieldKey, self.dataBag[map.dataBagKey]);
                    } else if (map.value) {
                        self.$set(self.componentDataBag, map.formFieldKey, map.value);
                    }
                }
            });
            this.updateDataCopy();
        },
        getLabel(selectedValue) {
            var label = 'Talk to agent';
            switch (selectedValue) {
                case CALL_OPTION.CALL_NOW:
                    {
                        label = 'Talk to agent';break;
                    }
                case CALL_OPTION.CALL_SCHEDULE:
                    {
                        label = 'Schedule Call';break;
                    }
                default:
            }
            return label;
        },

        showNextGroup() {
            if (this.canGoNext) {
                this.currentGrpIdx++;
            }
        },

        showPrevGroup() {
            if (this.canGoPrev) {
                this.currentGrpIdx--;
                this.componentDataBag = Object.assign({}, this.componentDataCopy);
            }
        },

        callNowHandler(dt) {
            const self = this;
            if (dt.valid) {
                //submit data
                //dt.formData
                self.componentDataBag = Object.assign({}, self.componentDataCopy, dt.formData);
                //update copy of data
                this.updateDataCopy();

                console.log("callRequest", self.componentDataBag);
                if (!this.canGoNext) {
                    this.submitCallRequest();
                } else {
                    this.showNextGroup();
                }
            }
        },

        submitCallRequest() {
            if (this.isScheduleOption()) {
                this.setStatusMessage(CALL_STATUS.Scheduling, true);
            } else {
                this.setStatusMessage(CALL_STATUS.Initiated, true);
            }
            console.log('request', this.requestConfig);
            //make copy
            const req = Object.assign({}, this.requestConfig);
            req.endpoint = req[this.callEndpointKey] || req.endpoint;
            console.log('updated request', { upated: req, original: this.requestConfig });

            __WEBPACK_IMPORTED_MODULE_1__services_formService__["a" /* default */].postForm(req, this.componentDataBag, this.handleSuccessResponse, this.handleErrorResponse);
        },

        handleSuccessResponse(response) {
            if (this.submitSuccessCallback) {
                this.submitSuccessCallback();
                this.showForm = false;
            }

            if (this.isScheduleOption()) {
                this.setStatusMessage(CALL_STATUS.Scheduled, false);
            } else if (this.interactiveCall) {
                //initiate call monitoring
                this.monitorCallProgressStatus(response.leadId);
            } else {
                this.setStatusMessage(CALL_STATUS.ThankYou, false);
                this.showForm = false;
            }
        },
        handleErrorResponse(error) {
            this.setStatusMessage(CALL_STATUS.Error, false);
        },

        setStatusMessage(status, processing = true) {
            const self = this;
            this.callStatus = this.getMessage((MESSAGE_PREFIX + status).toLowerCase());
            if (status == CALL_STATUS.ThankYou) {
                this.thankMessage = this.callStatus;
            } else {
                this.thankMessage = '';
            }
            if (!processing) {
                //show message for some time and then close
                if (!status) {
                    self.processing = processing;
                } else {
                    window.setTimeout(() => {
                        self.processing = processing;
                    }, 5000);
                }
            } else {
                self.processing = processing;
            }
        },

        cancelHandler() {
            this.showPrevGroup();
        },

        monitorCallProgressStatus(leadId) {
            const self = this;

            if (!($.connection && $.connection.web2CallHub && leadId)) {
                console.warn('Signalr hub is not configured.');
                self.setStatusMessage('', false);
                return;
            }
            // Reference the auto-generated proxy for the hub.
            var hub = $.connection.web2CallHub;

            //var disconnectClient = () => {
            //    $.connection.hub.stop()
            //}

            // set client ID
            $.connection.hub.qs = { foreignKey: leadId };

            // Create a function that the hub can call back
            hub.client.callStatus = function (status) {
                // event handling
                switch (status) {
                    case CALL_STATUS.Connected:
                        self.setStatusMessage(CALL_STATUS.Connected, true);
                        break;
                    case CALL_STATUS.ConfirmedName:
                        self.setStatusMessage(CALL_STATUS.ConfirmedName, true);
                        break;
                    case CALL_STATUS.AgentConnected:
                        self.setStatusMessage(CALL_STATUS.AgentConnected, true);
                        break;
                    case CALL_STATUS.Failed:
                        self.setStatusMessage(CALL_STATUS.Failed, false);
                        //disconnectClient();
                        break;
                    case CALL_STATUS.Completed:
                        self.setStatusMessage(CALL_STATUS.Completed, false);
                        //disconnectClient();
                        break;
                    default:
                        break;
                }
            };

            //disconnect handler from server
            hub.client.serverDisconnect = function () {
                $.connection.hub.stop();
                console.log('Signalr client connection is stopped');
            };

            // Start the connection.
            $.connection.hub.start().done(function () {
                //TODO
                console.log('Connected to signalr hub');
            });
        }
    }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_formService__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Application_mixins_ComponentBaseMixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TalkToAgent_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TalkToAgent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__TalkToAgent_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const defaultProps = {
    showRegularThankYou: false,
    showDisqualificationThankYou: false,
    regularBody: '',
    regularDisqualifiedBody: '',
    showConsentThankYou: false,
    consentBody: '',
    consentOrBody: '',
    consentThankYouBody: '',
    showSelfFulfillingThankYou: false,
    selfFulfillingBody: '',
    overlayMessageBody: '',
    primaryPhoneNumberMasked: ''
};

const consentCallStatusMessageMap = {
    call_initiated: 'statusInitialBody',
    call_connected: 'statusConfirmBody',
    call_confirmedName: 'statusConnectingBody',
    call_agentconnected: 'statusAgentBody',
    /*call_completed: '',*/
    call_failed: 'statusSorryBody'
};





/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__Application_mixins_ComponentBaseMixin__["a" /* ComponentBaseMixin */]],
    components: {
        'callMeNowComponent': __WEBPACK_IMPORTED_MODULE_2__TalkToAgent_vue___default.a
    },
    props: {
        dataBag: {
            type: Object,
            required: false,
            default: function () {
                return defaultProps;
            }
        }
    },
    data() {
        return {
            showConsentForm: true,
            showConsentThankYouEnd: false,
            processing: false,
            showConsentUI: true
        };
    },
    mounted() {
        console.log('mounted', this);
        this.updateMessages();
        this.init();
    },
    computed: {},
    methods: {
        init() {
            var productType = this.dataBag.quoteRequestProduct;

            //ADD OR GIWL
            if (this.dataBag.allowRedirectToQuote && (productType == 2 || productType == 4)) {
                this.initiateSff();
            }
            var sffAction = document.getElementById("submitSelfFulfillingBtn");
            if (sffAction) {
                sffAction.addEventListener('click', this.initiateSff);
            }
        },
        async initiateSff() {
            const url = this.dataBag.diyApplicationEndPoint;
            //var formData = this.dataBag.sffFormData
            if (url) {
                this.processing = true;
                //formService.createAndSubmitForm(url, 'POST', formData);
                __WEBPACK_IMPORTED_MODULE_0__services_formService__["a" /* default */].redirectToUrl(url);
            }
        },

        updateMessages() {
            const self = this;
            const messages = (this.pageSchema || {}).messages || [];

            for (var key in consentCallStatusMessageMap) {
                const dbMsgKey = consentCallStatusMessageMap[key];
                if (dbMsgKey) {
                    const value = self.dataBag[dbMsgKey];
                    const item = messages.find(m => m.key == key);
                    if (item) {
                        item.value = value;
                    } else {
                        messages.push({ key: key, value: value });
                    }
                }
            }
        },

        submitSuccessCallbackHandler() {
            //hide form
            this.showConsentUI = false;
        }
    }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    data: function () {
        return {
            //setup data properties
            isRequired: this.getValidatorValue('required'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            isGroupValidator: true
        };
    },
    destroyed() {
        if (this.dataBag && this.questionData.groupName) {
            this.$set(this.dataBag, this.questionData.groupName, 0);
        }
    },
    methods: {},
    computed: {
        value() {
            const count = this.dataBag[this.questionData.groupName];
            console.log('Checkbox validator count', count);
            return count != 0 ? "valid" : '';
        },
        groupStateTouched() {
            var myState = this.state[this.questionData.groupName];
            return myState ? myState.$touched : false;
        }
    }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





const YES_VALUE = 'Yes';
const NO_VALUE = 'No';

/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {
        //answer change notification callback
        answerChange: {
            type: Function,
            required: true
        }
    },
    data: function () {
        return {
            //setup data properties
            isRequired: this.getValidatorValue('required'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            YES_VALUE: YES_VALUE,
            NO_VALUE: NO_VALUE,
            defaultValue: NO_VALUE
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, this.defaultValue);
        } else {
            this.initializeFieldView();
            if (this.answerChange) {
                this.answerChange(this.dataBag[this.questionData.questionKey]);
            }
        }
        //for group validation
        if (this.questionData.groupName) {
            if (!this.dataBag[this.questionData.groupName]) {
                this.$set(this.dataBag, this.questionData.groupName, 0);
            }
        }
    },
    methods: {
        getFieldRef() {
            console.log('CheckboxView=>getFieldRef');
            return this.$refs.checkBoxControl;
        },
        changeHandler($event) {
            const checked = $event.target.checked;
            //update databag with yes/no
            this.dataBag[this.questionData.questionKey] = checked ? this.YES_VALUE : this.NO_VALUE;

            var $this = this;
            if (this.questionData.showValueChangeAlert) {

                this.alertValueChange(function () {
                    $this.processChange(checked);
                });
            } else {
                this.processChange(checked);
            }
        },
        processChange(checked) {

            if (checked == undefined) {
                checked = this.dataBag[this.questionData.questionKey] == this.YES_VALUE;
            }

            this.setGroupValidationDataBagState(checked);

            //if callback is not null, invoke it
            if (this.answerChange) {
                this.answerChange(this.dataBag[this.questionData.questionKey]);
            }
            //trigger field interaction notification
            this.notifyFieldInteraction();
            this.saveFieldData();
        },
        setGroupValidationDataBagState(value) {

            if (this.questionData.groupName) {
                var data = value ? 1 : -1;
                var $this = this;
                __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].nextTick(function () {
                    var totalCount = parseInt($this.dataBag[$this.questionData.groupName] || 0) + data;
                    //reset to zero if less than zero
                    totalCount = totalCount < 0 ? 0 : totalCount;
                    $this.dataBag[$this.questionData.groupName] = totalCount;
                });
            }
        }
    },
    computed: {}
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */]],
    mounted() {
        //set default value in databag
        if (!this.questionData.dontSave) {
            this.$set(this.dataBag, this.questionData.questionKey, this.questionData.defaultValue);
        }
    },
    computed: {
        dataValue() {
            return this.dataBag[this.questionData.questionKey] || '';
        },
        text() {
            var text = '';
            const messages = (this.pageSchema || {}).messages;
            const key = this.questionData.valueField;
            if (messages && key) {
                text = (messages.find(m => m.key == key) || {}).value || '';
            }
            return text || this.dataValue || this.questionData.text;
        }
    }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities_Utility__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {},
    data: function () {
        return {
            //setup data properties
            isRequired: this.getValidatorValue('required'),
            pattern: this.getValidatorValue('pattern'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            patternMessage: this.getValidationMessage('patternMessage'),
            dateMessage: this.getValidationMessage('dateMessage') || 'Please enter valid date',
            dateRangeMessage: this.getValidationMessage('dateRangeMessage') || 'Date is out of range',
            invalidMonthDaysMessage: this.getValidationMessage('invalidMonthDaysMessage') || 'Date is not allowed.',
            maskFormat: this.questionData.maskFormat || '',
            originalValue: '',
            pickerOpened: false
        };
    },
    mounted() {
        const self = this;
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, '');
        }
        //field has saved value
        else {
                this.$nextTick(() => {
                    self.initializeFieldView();
                    //self.setFocus();
                });
                this.originalValue = this.dataBag[this.questionData.questionKey];
            }
        if (!this.questionData.disableCalender) {
            this.bindDatePicker();
        }
    },
    computed: {
        additionalSetting() {
            return this.questionData.additionalSetting || {};
        },

        dateRange() {
            return __WEBPACK_IMPORTED_MODULE_2__Utilities_Utility__["b" /* Utility */].getDateRangeNew(this.questionData.dateYearRange);
        },
        invalidMonthDays() {
            var invalidDays = (this.questionData.additionalSetting || {}).invalidMonthDays || [];
            return invalidDays;
        },
        buttonTrigger() {
            return (((this.questionData.additionalSetting || {}).datePicker || {}).showOn || '') == 'button';
        }
    },
    methods: {
        getFieldRef() {
            console.log('DateViewInput=>getFieldRef');
            return this.$refs.dateInput;
        },
        bindDatePicker() {
            var $ = window.jQuery || window.jquery;
            const self = this;
            var $this = this;
            var minYear = '1900';
            var maxYear = new Date().getFullYear();
            var dateRange = this.dateRange;

            if (dateRange.maxDate != null) {
                maxYear = dateRange.maxDate.getFullYear();
            }

            if (dateRange.minDate != null) {
                minYear = dateRange.minDate.getFullYear();
            }

            var dtPickerOptions = {
                dateFormat: 'mm/dd/yy',
                minDate: dateRange.minDate,
                maxDate: dateRange.maxDate,
                changeDate: true,
                changeMonth: true,
                changeYear: true,
                yearRange: minYear + ":" + maxYear,
                showAnim: 'slide',
                onSelect: function (date) {
                    console.log("onSelect");
                    $this.$set($this.dataBag, $this.questionData.questionKey, date);
                    $this.onDateChanged();
                    $(this).parent().addClass("focused");
                    $this.pickerOpened = false;
                },
                onClose: function () {
                    console.log("onClose");
                    $this.pickerOpened = false;
                },
                beforeShowDay: function (date) {
                    var day = date.getDate();
                    var list = $this.invalidMonthDays || [];
                    if (list.indexOf(day) > -1) {
                        return [false];
                    }
                    return [true];
                },
                beforeShow: function () {
                    console.log("beforeShow");
                    $this.pickerOpened = true;
                }
            };

            var dtPkrSettings = self.additionalSetting.datePicker || {};
            if (typeof dtPkrSettings == 'object') {
                for (var p in dtPkrSettings) {
                    dtPickerOptions[p] = dtPkrSettings[p];
                }
            }
            console.log('dtPickerOptions', dtPickerOptions);

            $($this.$refs.dateInput).datepicker(dtPickerOptions);
            $(".datepicker-trigger").click(function () {
                $($this.$refs.dateInput).datepicker("show");
            });
        },
        validateDate: function (value) {
            // return true to set input as $valid, false to set as $invalid
            return __WEBPACK_IMPORTED_MODULE_2__Utilities_Utility__["b" /* Utility */].isValidDate(value, '/');
        },
        validateDateRange: function (value) {
            // return true to set input as $valid, false to set as $invalid
            var dateRange = this.dateRange;
            if (dateRange && dateRange.maxDate != null && dateRange.minDate != null) {
                var valid = false;
                if (value != '' && value.length == 10) {
                    // test and set the validity after update.
                    var dateValue = new Date(value);
                    valid = dateValue >= dateRange.minDate && dateValue <= dateRange.maxDate;
                }
                return valid;
            }
            return true;
        },
        validateInvalidMonthDays: function (value) {
            if (this.invalidMonthDays.length > 0) {
                var dateValue = new Date(value);
                var day = dateValue.getDate();
                var valid = this.invalidMonthDays.indexOf(day) < 0;
                return valid;
            }
            return true;
        },
        onDateChanged() {
            var $this = this;
            //check if the requoting is required
            if (this.questionData.showValueChangeAlert) {
                //pass callback fn to execute when user want to continue with change,
                //this callback will not be called when user click cancel and reverted the value to original
                //hence no need to notify changes
                this.alertValueChange(function () {
                    $this.notifyFieldInteraction();
                    $this.saveFieldData();
                });
            }
            //else alway notify date change
            else {
                    $this.notifyFieldInteraction();
                    $this.saveFieldData();
                }
        },
        blurHandler() {
            if (!this.pickerOpened) {
                console.log("blurHandler");
                //trigger field interaction notification
                var $this = this;
                //delay for sometime
                window.setTimeout(function () {
                    $this.onDateChanged();
                }, 200);
            }

            this.applyBlurPlaceholder(this.$refs.dateInput);
        },
        focusHandler() {
            this.applyFocusPlaceholder(this.$refs.dateInput);
        }
    }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





const default_option_group = 'Others';

/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {
        //answer change notification callback
        answerChange: {
            type: Function,
            required: true
        }
    },
    data: function () {
        return {
            //setup data properties
            isRequired: this.getValidatorValue('required'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            options: this.getOptions(),
            defaultValue: ''
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, this.defaultValue);
        } //field has saved value
        else {
                this.initializeFieldView();
                if (this.answerChange) {
                    this.answerChange(this.dataBag[this.questionData.questionKey]);
                }
            }
        this.SetSalutation();
        this.$nextTick(function () {
            this.addPlaceholder();
        });
    },

    computed: {
        hasOptionGroups() {
            return (this.options || []).some(o => o.group !== undefined && o.group !== '');
        },

        optionGroups() {
            var grps = [];
            (this.options || []).forEach(opt => {
                if (opt.group && grps.indexOf(opt.group) < 0) {
                    grps.push(opt.group);
                }
            });
            //add last option group as others
            if (grps.length > 0 && grps.indexOf(default_option_group) < 0) {
                grps.push(default_option_group);
            }
            return grps;
        },
        selectOption() {
            const text = this.questionData.selectText || 'Please select ' + this.questionData.text;
            return { text: text, value: '' };
        },
        optionTextPrefix() {
            return this.questionData.optionTextPrefix || '';
        }
    },

    methods: {
        getFieldRef() {
            console.log('DropDownView=>getFieldRef');
            return this.$refs.dropdownRef;
        },
        SetSalutation() {
            if (this.questionData.questionKey == __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* Constants */].SALUTATION_KEY) {
                var title = '';
                var gender = this.dataBag[__WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* Constants */].GENDER_KEY];
                if (gender == 'Male') {
                    title = 'Mr.';
                } else if (gender == 'Female') {
                    title = 'Mrs.';
                } else {
                    title = '';
                }
                var $this = this;

                this.$set(this.dataBag, this.questionData.questionKey, title);
            }
        },
        getOptions() {

            //clone array
            var opts = [];
            if (this.questionData.answerOptionsFunction) {
                var fn = __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* Constants */][this.questionData.answerOptionsFunction];
                if (fn && typeof fn === "function") {
                    //call dataListFunction
                    opts = fn();
                }
            } else {
                opts = (this.questionData.answerOptions || []).slice(0);
            }
            //opts.unshift({ text: text, value: '', group:'' });
            this.applyExcludeOptions(opts);
            var sortKey = this.questionData.sortKey;
            if (sortKey) {
                opts = opts.sort((a, b) => {
                    if (a[sortKey] < b[sortKey]) {
                        return -1;
                    } else if (a[sortKey] > b[sortKey]) {
                        return 1;
                    }
                    return 0;
                });
            }
            return opts;
        },
        applyExcludeOptions(options) {
            if (!options || !Array.isArray(options) || options.length == 0) {
                return;
            }
            let excludeOptions = this.questionData.excludeOptions || [];
            if (excludeOptions && excludeOptions.length > 0) {
                excludeOptions.forEach(optVal => {
                    let foundIndex = options.findIndex(o => o.value == optVal);
                    if (foundIndex > -1) {
                        //delete item at index
                        options.splice(foundIndex, 1);
                    }
                });
            }
        },

        getGroupOptions(groupName) {
            let optList = this.options || [];
            if (groupName && groupName !== default_option_group) {
                return optList.filter(opt => opt.group === groupName).slice(0);
            } else {
                return optList.filter(opt => opt.group === undefined).slice(0);
            }
        },
        changeHandler() {
            var $this = this;
            if (this.questionData.showValueChangeAlert) {

                this.alertValueChange(function () {
                    $this.processChange();
                });
            } else {
                this.processChange();
            }
        },
        processChange() {

            //call answerChange if callback is not null
            if (this.answerChange) {
                this.answerChange(this.dataBag[this.questionData.questionKey]);
            }
            //trigger field interaction notification
            this.notifyFieldInteraction();
            this.saveFieldData();
        },
        addPlaceholder() {
            if (this.questionData.questionKey == __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* Constants */].SALUTATION_KEY) {
                var $this = __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* Constants */].SALUTATION_KEY;
                $('#' + $this).parent().addClass("focused");
            }
        }
    }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {},
    data: function () {
        return {
            //setup data properties
            isRequired: this.getValidatorValue('required'),
            pattern: this.getValidatorValue('pattern'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            patternMessage: this.getValidationMessage('patternMessage'),
            emailMessage: this.getValidationMessage('emailMessage') || __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].INVALID_EMAIL_MESSAGE,
            validatedValue: ''
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, '');
        }
        //field has saved value
        else {
                this.initializeFieldView();
            }
    },
    methods: {
        getFieldRef() {
            console.log('EmailInputView=>getFieldRef');
            return this.$refs.emailInputRef;
        },
        validateEmail: function (value) {
            const self = this;
            var valid = true;
            //validate the pattern
            if (self.patternRegex) {
                valid = self.patternRegex.test(value);
            }

            //validate with server only when all other validation is passed;
            if (valid) {
                //logic to prevent multiple validation for same value
                if (this.validatedValue === value) {
                    return valid;
                }
                // return true to set input as $valid, false to set as $invalid
                let valPromise = this.validateInputWithServer(value, "email");
                valPromise.then(function (valid) {
                    self.validated(value, valid);
                });
                return valPromise;
            }
            //return false if other validation are failed;
            return false;
        },
        validated(value, valid) {
            if (valid) {
                this.validatedValue = value;
            }
        },
        blurHandler() {
            //trigger field interaction notification
            this.notifyFieldInteraction();
            this.saveFieldData();
        }
    },
    computed: {
        patternRegex() {
            const validators = this.questionData.validators;
            if (validators && validators.pattern) {
                return new RegExp(validators.pattern);
            }
            return undefined;
        }
    }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
//
//
//
//


//This view does not show any content, the purpose of this component to include CM question answer in databag
//to submit with application to CM always by default like agent consent, user consent etc.


/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */]],
    mounted() {
        //set default value in databag
        if (!this.questionData.dontSave) {
            this.$set(this.dataBag, this.questionData.questionKey, this.questionData.defaultValue);
        }
    }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Application_mixins_ComponentInterfaceMixin__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_conditionEvaluator__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__Application_mixins_ComponentInterfaceMixin__["a" /* ComponentInterfaceMixin */]],
    props: {
        //group collection
        groups: {
            type: Array,
            required: true,
            default: function () {
                return [];
            }
        },
        transitionName: {
            type: String,
            required: true
        },
        renderMode: {
            type: String,
            required: true
        },
        //groups last form field interaction callback
        pageInteractionCompletionCallback: {
            type: Function,
            required: false
        }
    },
    data: function () {
        return {
            //setup data properties
            renderableGroups: [],
            currentGroupIndex: -1,
            interactionCompleted: false,
            activeGroup: undefined,
            prev: false
        };
    },
    created() {
        //fetch page data;
        this.registerNavigationEvents();
    },
    mounted() {
        this.renderNextGroup();
    },
    destroyed() {
        console.log("Experience page destroyed");
        this.unRegisterNavigationEvents();
    },
    computed: {
        pageCss() {
            const ps = this.pageSchema;
            return ps && ps.pageMetadata ? ps.pageMetadata.containerCss : '';
        },
        isReplaceMode() {
            return (this.renderMode || '').toLowerCase() == __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].RENDER_MODE.REPLACE;
        },
        transitionClass() {
            var cls = 'group-container';
            if (this.transitionName) {
                cls += ' tg-' + this.transitionName;
            }
            return cls;
        }
    },
    methods: {
        broadCastNavigateNextFeedback(data) {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT_FEEDBACK, data);
        },
        broadCastNavigatePrevFeedback(data) {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV_FEEDBACK, data);
        },

        registerNavigationEvents() {
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT, this.onNavigateNext);
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV, this.onNavigatePrev);
        },
        unRegisterNavigationEvents() {
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT, this.onNavigateNext);
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_PREV, this.onNavigatePrev);
            //this.$eventBus.$off();
        },
        onNavigateNext() {
            var navigated = this.renderNextGroup();
            this.prev = false;
            var eventData = navigated ? __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENT_DATA.NAVIGATED : __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENT_DATA.NOT_NAVIGATED;
            this.broadCastNavigateNextFeedback(eventData);
        },
        onNavigatePrev() {
            var navigated = this.renderPrevGroup();
            this.prev = true;
            var eventData = navigated ? __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENT_DATA.NAVIGATED : __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].NAVIGATION_EVENT_DATA.NOT_NAVIGATED;
            this.broadCastNavigatePrevFeedback(eventData);
        },
        //get last group key
        getLastGroupKey() {
            return this.groups[this.groups.length - 1].groupKey;
        },
        //groups last field interaction callback handler function
        groupLastFormFieldInteractionHandler(groupKey) {
            ////if its a last page, notify page manager
            //if (groupKey == this.getLastGroupKey()
            //    && this.pageInteractionCompletionCallback) {
            //    //call only if interaction is not completed
            //    if (!this.interactionCompleted) {
            //        this.pageInteractionCompletionCallback();
            //        this.interactionCompleted = true;
            //    }

            //}//else render next group
            //else {
            //    this.renderNextGroup();
            //}
        },
        //function to set next group to be rendered in UI
        renderNextGroup() {
            var navigateResult = false;
            var mode = (this.renderMode || '').toLowerCase();

            if (this.currentGroupIndex + 1 >= this.groups.length) {
                return navigateResult;
            }
            this.currentGroupIndex = this.currentGroupIndex + 1;
            var grp = this.groups[this.currentGroupIndex];

            if (grp) {
                //keep existing group and stack new group on top on it
                if (mode == __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].RENDER_MODE.STACKED) {
                    //set focus on first item of the group
                    if (!grp.nofocus) {
                        grp.focus = true;
                    }
                    this.renderableGroups.push(grp);
                    navigateResult = true;
                }
                //replace old group with new group
                else if (mode == __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].RENDER_MODE.REPLACE) {
                        this.renderableGroups.splice(0, this.renderableGroups.length); //clear array
                        if (!grp.nofocus) {
                            grp.focus = true;
                        }
                        this.renderableGroups.push(grp); //push new item to array
                        navigateResult = true;
                        var hidable = __WEBPACK_IMPORTED_MODULE_3__services_conditionEvaluator__["a" /* default */].isGroupHidable(grp, this.dataBag, true);
                        if (!hidable) {
                            this.activeGroup = grp;
                        } else {
                            this.renderNextGroup();
                        }
                    } //default is render all.
                    else {
                            if (this.groups.length > 0 && !grp.nofocus) {
                                this.groups[0].focus = true;
                            }
                            this.renderableGroups = this.groups;
                            navigateResult = false;
                        }
            }
            return navigateResult;
        },
        renderPrevGroup() {

            var mode = (this.renderMode || '').toLowerCase();
            var navigateResult = false;

            if (mode == __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].RENDER_MODE.REPLACE && this.currentGroupIndex > 0) {
                this.currentGroupIndex = this.currentGroupIndex - 1;
                var grp = this.groups[this.currentGroupIndex];

                if (grp) {
                    //replace old group with new group
                    this.renderableGroups.splice(0, this.renderableGroups.length); //clear array
                    this.renderableGroups.push(grp); //push new item to array
                    var hidable = __WEBPACK_IMPORTED_MODULE_3__services_conditionEvaluator__["a" /* default */].isGroupHidable(grp, this.dataBag, true);
                    if (!hidable) {
                        this.activeGroup = grp;
                    } else {
                        this.renderPrevGroup();
                    }
                    navigateResult = true;
                }
            }
            return navigateResult;
        }
    }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Application_mixins_ComponentBaseMixin__ = __webpack_require__(9);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



const configDefault = {
    submitButton: { label: 'Submit', show: true, cssClass: 'btn btn-secondary' },
    cancelButton: { label: 'Cancel', show: true, cssClass: 'btn btn-link' },
    buttonContainer: { cssClass: 'clearfix button-group custom-btn-group' }
};

/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Application_mixins_ComponentBaseMixin__["a" /* ComponentBaseMixin */]],
    props: {
        name: {
            type: String,
            required: false
        },
        dataKey: {
            type: [String, Object],
            required: false
        },
        questionGroups: {
            type: Array,
            required: true,
            default: function () {
                return [];
            }
        },
        onSubmit: {
            type: Function,
            required: true
        },
        onCancel: {
            type: Function,
            required: false
        },
        config: {
            type: Object,
            required: false,
            default: function () {
                return {};
            }
        }
    },
    data() {
        return {
            //uiConfig: this.merge(configDefault, this.config),
            componentState: this.getState(),
            componentDataBag: {}
        };
    },
    created() {
        this.updateComponentDataBag();
        //console.log('FormComponent created', this.componentDataBag);
    },

    watch: {
        dataBag(newVal, oldVal) {
            //console.log('watch::dataBag', { oldVal, newVal });
            this.updateComponentDataBag();
        }
    },
    computed: {
        submitDisabled() {
            if (this.combinedConfig.submitButton.enabled) {
                return false;
            }
            return !this.isComponentStateValid;
        },
        combinedConfig() {
            return this.merge(configDefault, this.config);
        },
        formGroups() {
            var items = this.assignKey(this.questionGroups || []);
            return items;
        }
    },

    methods: {
        getButtonText(btn) {
            var label = btn.label;
            if (btn && btn.label && typeof btn.label == "function") {
                var value = this.componentDataBag[btn.labelProviderKey];
                label = btn.label(value);
            }
            return label;
        },
        getState() {
            return this.state;
        },
        submitHandler() {
            console.log('form-submitHandler', this.componentState);
            //check component state for val
            this.$set(this.componentState, '$submitted', true);
            //touch component states to highlight field
            this.touchComponentState();
            if (this.componentState.$valid) {
                this.$set(this.componentState, '$submitted', false);
                console.log('form valid');
            } else {
                console.log('form invalid');
            }
            if (this.onSubmit) {
                this.onSubmit({ formData: this.componentDataBag, valid: this.componentState.$valid });
            }
        },
        cancelHandler() {
            if (this.onCancel) {
                this.onCancel();
            }
        },
        merge(target, source) {
            let merged = Object.assign({}, target, source);

            if (source) {
                Object.keys(merged).forEach(key => {
                    if (typeof merged[key] === 'object') {
                        merged[key] = Object.assign({}, target[key], source[key]);
                    }
                });
                console.log('option merge', { target, source, merged });
            }
            return merged;
        },
        updateComponentDataBag() {
            this.componentDataBag = this.dataBag;
        }
    }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_componentTypeNameMapping__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_conditionEvaluator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Application_mixins_ComponentInterfaceMixin__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__Application_mixins_ComponentInterfaceMixin__["a" /* ComponentInterfaceMixin */]],
    props: {
        //group definition
        groupData: {
            type: Object,
            required: true
        },
        //groups last form field interaction callback
        lastFormFieldInteractionCallback: {
            type: Function,
            required: false
        },
        formFieldInteractionCallback: {
            type: Function,
            required: false
        }
    },
    data() {
        return {
            lastQuestionKey: '',
            interactionCompleted: false,
            focusSettingInitialize: false,
            readMode: false,
            editing: false,
            hideSelf: true
        };
    },
    created() {
        this.registerAnswerChangeEvents();
    },
    destroyed() {
        this.unregisterAnswerChangeEvents();
    },
    mounted() {
        //update last question key in groups
        this.lastQuestionKey = this.getLastQuestionKey();
        this.$nextTick(function () {
            var tt = $('[data-toggle="tooltip"]');
            if (tt && tt.tooltip) {
                tt.tooltip();
            }
        });
        this.initMode();
        this.evaluateGroupHideConditions();
    },
    updated() {
        //update last question key in groups
        this.lastQuestionKey = this.getLastQuestionKey();
    },
    watch: {
        'groupData.readMode': function (newValue, oldValue) {
            console.log('GroupComponent:watch::groupData.readMode');
            this.readMode = newValue;
        }
        /*
        dataBag: {
            deep: false,
            handler: function (newValue) {
                var ps = this.getChangedDataBagProperties();
                if (ps.length > 0) {
                    console.log('dataBag, properties changed', ps)
                    this.evaluateGroupHideConditions();
                }
            }
        }
        */
    },

    computed: {
        hideGroup() {
            return this.hideSelf;
        },
        filteredComponents() {
            return this.groupData.components;
        }
    },

    methods: {
        registerAnswerChangeEvents() {
            this.$eventBus.$on(__WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].APPLICATION_EVENTS.ANSWER_CHANGE, this.answerChangeHandler);
        },
        unregisterAnswerChangeEvents() {
            this.$eventBus.$off(__WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].APPLICATION_EVENTS.ANSWER_CHANGE, this.answerChangeHandler);
        },
        answerChangeHandler(answerData) {
            console.debug('Group-component:answerChangeHandler', answerData);
            if (answerData) {
                const properties = this.groupData.watchDataBagProperties || [];
                if (properties.indexOf(answerData.questionKey) >= 0) {
                    this.evaluateGroupHideConditions();
                }
            }
        },
        evaluateGroupHideConditions() {
            this.hideSelf = __WEBPACK_IMPORTED_MODULE_1__services_conditionEvaluator__["a" /* default */].isGroupHidable(this.groupData, this.dataBag, true);
        },
        evaluateComponentCondition(condition) {
            var showComponent = true;
            /*
            if (condition && this.dataBag) {
                showComponent = evaluator.evaluateConditions(condition, this.dataBag, true);
            }
            */
            return showComponent;
        },
        initMode() {
            this.readMode = this.groupData.readMode !== undefined ? this.groupData.readMode : false;
        },
        /*
        getChangedDataBagProperties(newDataBag) {
            var changedProps = [];
            newDataBag = newDataBag || {};
            const properties = this.groupData.watchDataBagProperties || [];
            properties.forEach(p => {
                if (this.dataBag[p] != newDataBag[p]) {
                    changedProps.push(p);
                }
            });
            return changedProps;
        },
        */
        questionInteractionCallbackHandler(fieldKey) {
            const isLastField = this.lastQuestionKey == fieldKey;
            if (this.lastFormFieldInteractionCallback && isLastField) {
                if (!this.interactionCompleted) {
                    this.lastFormFieldInteractionCallback(this.groupData.groupKey);
                    this.interactionCompleted = true;
                }
            }
            if (this.formFieldInteractionCallback) {
                this.formFieldInteractionCallback(fieldKey, this.groupData.groupKey, isLastField);
            }
        },
        //calculate last question key in groups
        getLastQuestionKey() {
            var lastQuestionKey = '';
            const rows = this.groupData.questions || [];
            //iterate rows
            for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
                //iterate columns
                const cols = rows[rowIndex];
                for (var colIndex = 0; colIndex < cols.length; colIndex++) {
                    const question = cols[colIndex].question;
                    if (question) {
                        lastQuestionKey = question.questionKey;
                    }
                }
            }
            return lastQuestionKey;
        },
        getQuestionData(data) {
            this.initQuestionFocusSetting();
            this.setTabIndex(data);
            //.log('getQuestionData', { old: data.question.readMode, new: this.readMode })
            //data.question.readMode = this.readMode;
            return data;
        },
        initQuestionFocusSetting() {
            if (this.focusSettingInitialize) {
                return;
            }
            const rows = this.groupData.questions || [];
            //set focus on first question in group
            if (rows.length > 0 && rows[0] && rows[0].length > 0 && rows[0][0].question) {
                rows[0][0].question.focus = this.groupData.focus;
            }
            this.focusSettingInitialize = true;
        },
        setTabIndex(questionData) {
            //set group question tabindex to -1 to disable focus
            console.log('Group component=>assigning tabindex');
            questionData.question.tabIndex = this.groupData.readonly ? -1 : 0;
        },
        isNotEmpty(text) {
            return text != null && text != undefined && text != '';
        },
        getJoinedContent(texts) {
            return (texts || []).join('');
        },
        //calculate columns class based on of question in row
        getQuestionColumnClass(colSize, rowQuestions, colCss) {
            if (colCss) {
                return colCss;
            }
            var className = 'col-sm-12';
            if (!isNaN(colSize) && colSize > 0) {
                className = 'col-sm-' + colSize;
            } else {
                var questionPerCols = 12 / rowQuestions.length;
                className = 'col-sm-' + questionPerCols;
            }
            return className;
        },
        getRootClass() {
            const readOnlyClass = this.groupData.readonly ? 'readonly' : '';

            return 'clearfix group-view ' + readOnlyClass + ' ' + (this.groupData.cssClass || '');
        },
        //get ui component to render field using key
        getComponentRegisteredName(key) {
            var componentName = __WEBPACK_IMPORTED_MODULE_0__Shared_componentTypeNameMapping__["a" /* componentTypeNameMapping */][key];
            return componentName;
        },
        getEditTitle() {
            return 'Edit ' + this.groupData.title;
        },
        groupEditHandler() {
            this.readMode = !this.readMode;
            this.editing = !this.readMode;

            //const readMode = this.editing ? !this.editing : this.readMode;
            //const questions = this.groupData.questions || [];
            //questions.forEach(qRow => {
            //    (qRow || []).forEach(qCol => {
            //        qCol.question.readMode = readMode;
            //    });
            //});
            //this.questions = [];
            //this.questions = questions;
        },
        groupEditCompleteHandler() {
            //toggle
            this.groupEditHandler();
        },
        getComponentContainerCss(component) {
            console.log('getComponentContainerCss', component);
            var cssClass = 'col-sm-12 form-col';
            if (component.settings && component.settings.containerCssClass) {
                cssClass = component.settings.containerCssClass;
            }
            return cssClass;
        }
    }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    props: {
        helpText: {
            type: String,
            required: false
        }
    }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'loading-view',
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        message: {
            type: String,
            required: false,
            default: ''
        }
    }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_money_directive__ = __webpack_require__(111);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {},
    directives: {
        'money': __WEBPACK_IMPORTED_MODULE_2__directives_money_directive__["a" /* default */]
    },
    data: function () {
        return {
            //setup data properties
            value: this.dataBag[this.questionData.questionKey],
            isRequired: this.getValidatorValue('required'),
            minlength: this.getValidatorValue('minlength'),
            maxlength: this.getValidatorValue('maxlength'),
            maxValue: this.getValidatorValue('maxValue'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            minlengthMessage: this.getValidationMessage('minlengthMessage'),
            maxlengthMessage: this.getValidationMessage('maxlengthMessage'),
            maxValueMessage: this.getValidationMessage('maxValueMessage'),
            moneyOption: {
                decimal: '.',
                thousands: ',',
                prefix: '$',
                suffix: '',
                precision: this.questionData.precision || 0,
                masked: false
            }
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, '');
        } //field has saved value
        else {
                this.initializeFieldView();
            }
    },
    methods: {
        getFieldRef() {
            console.log('MoneyInputView=>getFieldRef');
            return this.$refs.moneyInputRef;
        },
        validateMaxValue: function (value) {
            // return true to set input as $valid, false to set as $invalid
            if (!this.maxValue) {
                return true;
            } else {
                var amount = parseInt(value.replace(/[^0-9\.]/g, ''));
                console.log(amount, this.maxValue);
                var maxAmount = parseInt(this.maxValue.replace(/[^0-9\.]/g, ''));

                return amount < maxAmount;
            }
        },
        blurHandler(evt) {
            //trigger field interaction notification
            this.notifyFieldInteraction();
            this.saveFieldData();
        },
        changeHandler(evt) {
            this.$set(this.dataBag, this.questionData.questionKey, evt.target.value);
            console.log(evt.target.value);
        }
    },
    computed: {}
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Application_mixins_ComponentInterfaceMixin__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_3__Application_mixins_ComponentInterfaceMixin__["a" /* ComponentInterfaceMixin */]],
    props: {
        //group collection
        groups: {
            type: Array,
            required: true,
            default: function () {
                return [];
            }
        }
    },
    data: function () {
        return {
            //setup data properties
            virtualPages: [],
            visiblePages: [],
            currentPageIndex: -1,
            experiencePage: {
                key: '',
                transitionName: '',
                renderMode: ''
            }
        };
    },
    mounted() {
        //parse groups and create pages
        console.log('page manager mounted');
        this.init();
    },
    methods: {
        init() {
            //reset this.visiblePages
            this.currentPageIndex = -1, this.visiblePages = [];
            this.createPages();
            this.showNextPage();
        },
        assignGuid(groups) {
            for (var groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
                var grp = this.groups[groupIndex];

                if (grp && !grp.groupKey) {
                    grp.groupKey = __WEBPACK_IMPORTED_MODULE_2__Utilities_Utility__["b" /* Utility */].newGuid();
                }
            }
        },
        createPages() {
            //assign unique id to groups
            this.assignGuid(this.groups);

            var currentRenderMode = null;
            var currentPage = null;
            this.virtualPages = [];

            for (var groupIndex = 0; groupIndex < this.groups.length; groupIndex++) {
                var grpRenderMode = this.groups[groupIndex].renderMode || __WEBPACK_IMPORTED_MODULE_1__Constants__["a" /* Constants */].RENDER_MODE.DEFAULT;
                var grpTransitionName = this.groups[groupIndex].transitionName || 'interview';

                if (currentRenderMode != grpRenderMode) {
                    currentRenderMode = grpRenderMode;
                    //create new page;
                    currentPage = {
                        renderMode: currentRenderMode,
                        transitionName: grpTransitionName,
                        groups: [],
                        key: __WEBPACK_IMPORTED_MODULE_2__Utilities_Utility__["b" /* Utility */].newGuid()
                        //add page to pages
                    };this.virtualPages.push(currentPage);
                }
                //add group to current page groups
                if (currentPage) {
                    currentPage.groups.push(this.groups[groupIndex]);
                } else {
                    console.warn('currentPage is null');
                }
            }
            this.experiencePage = currentPage;
            console.log('this.virtualPages', this.virtualPages.length);
        },
        //groups last field interaction callback handler function
        pageInteractionCompletionCallbackHandler() {
            console.log('page complete');
            this.showNextPage();
        },
        showNextPage() {
            console.log('showNextPage');
            if (this.virtualPages.length > 0 && this.virtualPages.length >= this.currentPageIndex + 1) {
                this.currentPageIndex = this.currentPageIndex + 1;
                var page = this.virtualPages[this.currentPageIndex];

                if (page) {
                    this.visiblePages.push(page);
                    $("html, body").animate({ scrollTop: 0 }, "slow");
                    $(".experience-page-container").attr("tabindex", -1).focus();
                }
            }
        }
    },
    watch: {
        groups(newValue) {
            console.log('page manager watch');
            this.init();
        }
    }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {},
    data: function () {
        return {
            //setup data properties
            isRequired: this.getValidatorValue('required'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            minlength: this.getValidatorValue('minlength'),
            minlengthMessage: this.getValidationMessage('minlengthMessage'),
            maxlength: this.getValidatorValue('maxlength'),
            maxlengthMessage: this.getValidationMessage('maxlengthMessage'),
            pattern: this.getValidatorValue('pattern'),
            patternMessage: this.getValidationMessage('patternMessage'),
            phoneMessage: this.getValidationMessage('phoneMessage') || __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].INVALID_PHONE_MESSAGE,
            maskFormat: this.questionData.maskFormat || '',
            validatedValue: '',
            validating: false
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, '');
        }
        //field has saved value
        else {
                this.initializeFieldView();
            }
    },
    methods: {
        getFieldRef() {
            console.log('PhoneInputView=>getFieldRef');
            return this.$refs.phoneInput;
        },
        validatePhone: function (value) {
            var valid = true;

            //validate the pattern
            if (this.questionData.validators && this.questionData.validators.pattern) {
                var validPattern = new RegExp(this.questionData.validators.pattern);
                valid = validPattern.test(value);
            }

            //validate the maskFormat
            if (this.questionData.maskFormat) {
                var requiredLength = (this.questionData.maskFormat || '').length;
                var actualLength = (value || '').length;
                valid = actualLength == requiredLength;
            }

            if (this.questionData.questionKey == __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].SECONDARY_PHONE_KEY) {
                if (this.dataBag[__WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].PRIMARY_PHONE_KEY] == this.dataBag[__WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].SECONDARY_PHONE_KEY]) {
                    this.phoneMessage = __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].INVALID_ALTERNATEPHONE_MESSAGE;
                    valid = false;
                }
                //else if (this.dataBag[Constants.SECONDARY_PHONE_KEY] != '') {
                //    this.phoneMessage = this.getValidationMessage('phoneMessage') || Constants.INVALID_PHONE_MESSAGE;
                //}
            }

            //validate with server only when all other validation is passed;
            if (valid) {
                //logic to prevent multiple validation for same value
                if (this.validatedValue === value) {
                    return valid;
                } else {
                    this.validatedValue = value;
                }
                // return true to set input as $valid, false to set as $invalid
                return this.validateInputWithServer(value, "phone");
            }
            //return false if other validation are failed;
            return false;
        },
        focusHandler() {
            this.applyFocusPlaceholder(this.$refs.phoneInput);
        },
        blurHandler() {
            //trigger field interaction notification
            this.notifyFieldInteraction();
            this.saveFieldData();

            this.applyBlurPlaceholder(this.$refs.phoneInput);
        }
    },
    computed: {}
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Shared_componentTypeNameMapping__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Application_mixins_ComponentInterfaceMixin__ = __webpack_require__(21);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__Application_mixins_ComponentInterfaceMixin__["a" /* ComponentInterfaceMixin */]],
    props: {
        //question definition
        questionData: {
            type: Object,
            required: true
        },
        //databag containing saved data
        dataBag: {
            type: Object,
            required: true
        },
        //form state for validation
        state: {
            type: Object,
            required: true
        },
        questionInteractionCallback: {
            type: Function,
            required: true
        },
        readMode: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            groups: []
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            //get already saved value for field from dataBag
            this.groups = this.filterGroups(this.dataBag[this.questionData.question.questionKey]);
        },
        getUpdatedGroup(grp) {
            grp.readMode = this.readMode;
            return grp;
        },
        fieldInteractionCallbackHandler(fieldKey) {
            if (this.questionInteractionCallback) {
                this.questionInteractionCallback(fieldKey);
            };
        },
        answerChangeHandler(newAnswer) {
            this.groups = this.filterGroups(newAnswer);
        },
        filterGroups(newAnswer) {
            var grps = [];
            const $this = this;
            const self = this;
            (this.questionData.groups || []).forEach(function (grp) {
                var grpQuestions = [];
                //assign uniqueKey to group
                __WEBPACK_IMPORTED_MODULE_1__Utilities_Utility__["b" /* Utility */].assignKey(grp);

                //first check group level enable condition
                if (self.isLayout || grp.showAlways || (grp.showAlways + '').toLowerCase() == 'true') {
                    grps.push(grp);
                    //move on to next grp
                    return;
                }
                //iterate questions rows
                const rows = grp.questions || [];
                for (var rowIndex = 0; rowIndex < rows.length; rowIndex++) {
                    //iterate columns
                    const cols = rows[rowIndex];
                    for (var colIndex = 0; colIndex < cols.length; colIndex++) {
                        const question = cols[colIndex].question;
                        if (question) {
                            const show = $this.isConditionSatisfied(question.enableCondition, newAnswer);
                            //cols[colIndex].hide = !show;
                            if (show) {
                                grpQuestions.push(question);
                            }
                        }
                    }
                }
                if (grpQuestions.length > 0) {
                    grps.push(grp);
                }

                var grpComponents = [];
                //iterate components rows
                const components = grp.components || [];
                for (var compIndex = 0; compIndex < components.length; compIndex++) {
                    //iterate columns
                    const component = components[compIndex];
                    if (component) {
                        const show = $this.isConditionSatisfied(component.enableCondition, newAnswer);
                        //cols[colIndex].hide = !show;
                        if (show) {
                            grpComponents.push(component);
                        } else {
                            $this.clearData(component.dataKey);
                        }
                    }
                }
                if (grpComponents.length > 0) {
                    grps.push(grp);
                }
            });
            return grps;
        },
        //function to test conditions whether newvalue meet condtions defined in conditions
        isConditionSatisfied(conditions, newValue) {
            if (newValue == null || newValue == undefined || newValue == "" || conditions == null) {
                return false;
            }
            console.log(newValue);
            var notCondition = conditions.trim().indexOf("!") == 0;
            if (notCondition) {
                conditions = conditions.replace("!", "");
            }
            var conditionValues = conditions.replace("(", "").replace(")", "").toLowerCase().split("|");

            var retValue = false;
            newValue = newValue.toLowerCase();
            if (notCondition) {
                retValue = conditionValues.indexOf(newValue) == -1;
            } else {
                retValue = conditionValues.indexOf(newValue) > -1;
            }
            return retValue;
        },
        clearData(dataKey) {
            var data = this.dataBag[dataKey];
            if (data) {
                console.log(data);
                if (Array.isArray(data)) {
                    this.$set(this.dataBag, dataKey, []);
                } else if (typeof data === 'object') {
                    this.$set(this.dataBag, dataKey, {});
                } else {
                    this.$set(this.dataBag, dataKey, '');
                }
            }
        }
    },
    computed: {
        //get ui component to render field using key
        componentName() {
            return __WEBPACK_IMPORTED_MODULE_0__Shared_componentTypeNameMapping__["a" /* componentTypeNameMapping */][this.questionData.question.type];
        },
        visibleGroups() {
            return this.groups;
        },
        expandedClass() {
            var className = '';
            var expanded = this.groups.length > 0;
            if (expanded) {
                className = this.questionData.question.type + '-reflective-visible';
            }
            return className;
        },
        isLayout() {
            return this.questionData.question.type === 'empty' || this.questionData.question.type === 'content';
        }
    },
    watch: {
        dataBag(newValue) {
            this.init();
        }
    }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {
        answerChange: {
            type: Function,
            required: true
        }
    },
    data: function () {
        return {
            //setup data properties
            isRequired: this.getValidatorValue('required'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            defaultValue: 'No'
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, '');
        } //field has saved value
        else {
                this.initializeFieldView();
                if (this.answerChange) {
                    this.answerChange(this.dataBag[this.questionData.questionKey]);
                }
            }
    },
    computed: {
        options() {
            //clone array
            var opts = (this.questionData.answerOptions || []).slice(0);
            return opts;
        }
    },
    methods: {
        getOptionCssClass(option) {
            var cssClass = option.iconClass ? option.iconClass : '';
            if (option.disabled) {
                cssClass = cssClass + ' disabled';
            }
            if (option.helpText) {
                cssClass = cssClass + ' has-help';
            }
            return cssClass;
        },
        getFieldRef() {
            console.log('radio=>getFieldRef', this.$refs.radioInput);
            return this.$refs.radioInput;
        },
        changeHandler() {
            var $this = this;
            if (this.questionData.showValueChangeAlert) {

                this.alertValueChange(function () {
                    $this.processChange();
                });
            } else {
                this.processChange();
            }
        },
        processChange() {
            //call answerChange if callback is not null
            if (this.answerChange) {
                this.answerChange(this.dataBag[this.questionData.questionKey]);
            }
            //trigger field interaction notification
            this.notifyFieldInteraction();
            this.saveFieldData();
            this.broadCastAnswerChange({
                questionKey: this.questionData.questionKey,
                answer: this.dataBag[this.questionData.questionKey]
            });
            var val = this.dataBag[this.questionData.questionKey];
            if (val) {
                var options = (this.questionData.answerOptions || []).filter(opt => opt.value == val && opt.action);
                if (options && options.length > 0 && options[0].action) {
                    window.location.href = options[0].action;
                }
            }
        }
    }

});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */]],
    computed: {
        readViewLabelCss() {
            return (this.questionData.AdditionalSetting || {}).readViewLabelCss;
        },
        readViewValueCss() {
            return (this.questionData.AdditionalSetting || {}).readViewValueCss;
        }
    }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        content: {
            required: true,
            validator: prop => typeof prop === 'string' || prop == null
        },
        showLoadingText: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        displayContent() {
            return !this.content && this.showLoadingText ? 'Loading...' : this.content;
        },
        showContainer() {
            const text = this.displayContent;
            return !(text == null || text == '' || text == undefined);
        }
    }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {},
    data: function () {
        return {
            //setup data properties
            value: '',
            isRequired: this.getValidatorValue('required'),
            minlength: this.getValidatorValue('minlength'),
            maxlength: this.getValidatorValue('maxlength'),
            pattern: this.getAnyPattern(),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            minlengthMessage: this.getValidationMessage('minlengthMessage'),
            maxlengthMessage: this.getValidationMessage('maxlengthMessage'),
            patternMessage: this.getValidationMessage('patternMessage'),
            maskFormat: '###-##-####',
            maskCharacter: this.questionData.maskCharacter || 'X',
            maskPattern: '^[a-zA-Z]{3}-[a-zA-Z]{2}-[0-9]{4}$',
            ssnMasked: true,
            defautMaskedValue: 'XXX-XX-XXXX'
            //buttonTitle: 'Unmask SSN'
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, '');
        } //field has saved value
        else {
                this.maskFieldValue();
            }
        this.setRequired();
    },
    computed: {
        buttonTitle() {
            return this.ssnMasked ? 'Unmask SSN' : 'Mask SSN';
        },
        hasValueOnServer() {
            var captured = this.dataBag[this.questionData.questionKey + '_captured'];
            return captured ? captured == '1' : this.originalValue === this.defautMaskedValue;
        }
    },
    methods: {
        setRequired() {
            this.isRequired = this.getValidatorValue('required') && !this.hasValueOnServer;
        },
        setContextualPattern() {
            this.pattern = this.hasValueOnServer && !this.hasValueChanged() ? this.getAnyPattern() : this.maskPattern;
        },
        getFieldRef() {
            //console.log('SSNInputView=>getFieldRef');
            return this.$refs.ssnInput;
        },
        saveToDatabag(value) {
            if (value != '') {
                this.$set(this.dataBag, this.questionData.questionKey, value);
            }
        },
        maskFieldValue() {
            var ssn = this.dataBag[this.questionData.questionKey];
            if (ssn != '') {
                this.maskFormat = 'XXX-XX-XXXX';
                this.setContextualPattern();
                this.value = this.getMaskedString(this.maskCharacter, 3) + '-' + this.getMaskedString(this.maskCharacter, 2) + '-' + ssn.substring(ssn.length - 4);
                this.ssnMasked = true;
            }
        },
        unmaskFieldValue() {
            this.pattern = this.getValidatorValue('pattern');
            this.value = this.dataBag[this.questionData.questionKey];
            this.ssnMasked = false;
        },
        getMaskedString(character, count) {
            var val = '';
            for (var index = 0; index < count; index++) {
                val = val + character;
            }
            return val;
        },
        blurHandler() {
            if (this.value == '') {
                this.maskFieldValue();
            } else {
                if (this.fieldStateValid()) {
                    this.saveToDatabag(this.value);
                }
                //trigger field interaction notification
                this.notifyFieldInteraction();
                this.saveFieldData();
                if (this.questionData.maskAlways) {
                    this.maskFieldValue();
                }
            }
            this.applyBlurPlaceholder(this.$refs.ssnInput);
            const me = this;
            window.setTimeout(function () {
                me.triggerFloatingLabelVisibility();
            }, 100);
        },
        focusHandler() {
            this.maskFormat = '###-##-####';
            this.pattern = this.getAnyPattern(); //this.getValidatorValue('pattern');
            //this.isRequired = false;
            this.value = '';

            this.applyFocusPlaceholder(this.$refs.ssnInput);
        },
        keypressHandler($evt) {
            //console.log('keypressHandler', $evt);
            this.pattern = this.getValidatorValue('pattern');
        },
        ssnMaskToggleHandler() {
            this.ssnMasked = !this.ssnMasked;
            if (this.ssnMasked) {
                this.maskFieldValue();
            } else {
                this.unmaskFieldValue();
            }
        }
    }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    components: { vSelect: __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a },
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {
        //answer change notification callback
        answerChange: {
            type: Function,
            required: true
        }
    },
    data: function () {
        return {
            //setup data properties
            isRequired: this.getValidatorValue('required'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            options: [],
            allOptions: [],
            placeholdertext: 'Type to search',
            fValue: ''
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, '');
            if (this.isNotEmpty(this.questionData.text)) {
                this.placeholdertext = this.questionData.text;
            }
        } //field has saved value
        else {
                this.applySelectedStyle();

                this.initializeFieldView();
                if (this.answerChange) {
                    this.answerChange(this.dataBag[this.questionData.questionKey]);
                }
            }
        this.options = this.getOptions();
        this.allOptions = (this.options || []).map(x => x) || [];
    },
    computed: {

        optionLabelField() {
            return this.questionData.optionLabelField || "text";
        },
        optionDataField() {
            return this.questionData.optionDataField || "value";
        }
    },
    methods: {
        getFieldRef() {
            console.log('Seachable-list=>getFieldRef');
            return this.$refs.hid;
        },
        getOptions() {
            //clone array
            var opts = [];
            if (this.questionData.answerOptionsFunction) {
                var fn = __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* Constants */][this.questionData.answerOptionsFunction];
                if (fn && typeof fn === "function") {
                    //call dataListFunction
                    opts = fn();
                }
            } else if (this.questionData.answerOptions) {
                opts = (this.questionData.answerOptions || []).slice(0);
            }
            //opts.unshift({ text: text, value: '', group:'' });
            this.applyExcludeOptions(opts);
            return opts;
        },
        applyExcludeOptions(options) {
            if (!options || !Array.isArray(options) || options.length == 0) {
                return;
            }
            let excludeOptions = this.questionData.excludeOptions || [];
            if (excludeOptions && excludeOptions.length > 0) {
                excludeOptions.forEach(optVal => {
                    let foundIndex = options.findIndex(o => o.value == optVal);
                    if (foundIndex > -1) {
                        //delete item at index
                        options.splice(foundIndex, 1);
                    }
                });
            }
        },

        searchOptions(searchText, loading) {

            var searchFn = this.questionData.searchFunction;
            if (!searchFn || typeof searchFn != 'function') {
                searchFn = this.defaultSearchFn;
            }

            if (searchFn && typeof searchFn == 'function') {
                loading(true);
                searchFn(searchText, data => {
                    if (data && Array.isArray(data)) {
                        this.options = data;
                    }
                    loading(false);
                });
            }
        },

        defaultSearchFn(searchText, callback) {
            var list = [];
            this.allOptions.forEach(function (item) {
                if (item.text.toUpperCase().startsWith(searchText.toUpperCase())) {
                    list.push({ value: item.value, text: item.text || item.name });
                }
            });
            console.log('data search ', searchText, list);
            callback(list);
        },

        reduce(option) {
            var val = '';
            if (option) {
                val = option[this.optionDataField];
            }
            //console.log('reduce', option, val);
            return val;
        },

        changeHandler(selectedValue) {
            selectedValue = selectedValue || '';
            this.applySelectedStyle();

            //call answerChange if callback is not null
            if (this.answerChange) {
                this.answerChange(this.dataBag[this.questionData.questionKey]);
            }
            //trigger field interaction notification
            this.notifyFieldInteraction();
            this.saveFieldData();
        },
        searchBlurHandler() {
            this.touchField();
            this.applySelectedStyle();
            //console.log('search:blur', this.dataBag[this.questionData.questionKey], this.state);
        },

        applySelectedStyle() {
            const p = $('.floating-label-control');
            if (this.dataBag[this.questionData.questionKey]) {
                p.addClass("focused");
            } else {
                p.removeClass("focused");
            }
        }
    }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_Constants__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {},
    data: function () {
        return {
            //setup data properties
            isRequired: this.getValidatorValue('required'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            YES_VALUE: __WEBPACK_IMPORTED_MODULE_3__Shared_Constants__["a" /* Constants */].YES_NO_OPTION.YES,
            NO_VALUE: __WEBPACK_IMPORTED_MODULE_3__Shared_Constants__["a" /* Constants */].YES_NO_OPTION.NO,
            destroyed: false
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, this.NO_VALUE);
        } else {
            this.initializeFieldView();
        }
        if (this.keyCode) {
            var element = $("#" + this.questionData.questionKey);
            console.log("binded ", element);
            $(document).on("keypress", element, this.shortcutKeyHandler);
        }
    },
    destroyed() {
        this.destroyed = true;
        if (this.keyCode) {
            var element = $("#" + this.questionData.questionKey);
            console.log("destroyed ", element);
            $(document).off("keypress", element, this.shortcutKeyHandler);
        }
    },
    methods: {
        shortcutKeyHandler(event) {
            var $this = this;
            if ($this.destroyed) {
                return;
            }
            console.log("bindKeyPressHandler " + $this.questionData.questionKey);
            var myKeyCode = $this.keyCode || 'NO_KEY_ASSIGNED';
            var pressedKey = event && event.key ? event.key : '';

            if (pressedKey.toLowerCase() == myKeyCode.toLowerCase()) {
                $this.changeHandler();
            }
        },
        changeHandler($event) {
            var val = '';
            if ($event) {
                //update databag with yes/no
                val = $event.target.checked ? this.YES_VALUE : this.NO_VALUE;
            } else {
                val = this.dataBag[this.questionData.questionKey];
                val = val == this.YES_VALUE ? this.NO_VALUE : this.YES_VALUE;
            }
            this.$set(this.dataBag, this.questionData.questionKey, val);

            //trigger field interaction notification
            this.notifyFieldInteraction();
            this.saveFieldData();
        }
    },
    computed: {
        selectedClass() {
            var selected = this.dataBag[this.questionData.questionKey] == this.YES_VALUE;
            var className = selected ? 'selected' : '';
            return className;
        },
        keyCode() {
            return this.questionData.keyCode;
        }
    }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Application_mixins_ComponentBaseMixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Application_services_HttpCommunicationService__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Application_services_dialogService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







const DEFAULT_FORMK_KEY = 'address_form';

/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__Application_mixins_ComponentBaseMixin__["a" /* ComponentBaseMixin */]],
    props: {
        dataKey: {
            type: [String, Object],
            required: false
        }
    },
    data: function () {
        return {
            defaultOptions: {
                formKey: DEFAULT_FORMK_KEY
            },
            nextValCompleted: false,
            componentState: {},
            componentDataBag: {},
            addressQuestionGroups: [],
            originalAddress: {},
            showPopup: true,
            showRequoteAlert: false,
            internalDataKey: '',
            componentAddressFieldPrefix: '_component_address',
            componentAddressQuestionGroups: [],
            showAddressPopup: false,
            addressTitle: '',
            validationAttempts: 0,
            defaultMaxValidationAttempts: 3,
            maxValidationAttempts: 3,
            addressModalPopupId: 'addressModalpopup',
            readOnly: false,
            addressModelPopupDialog: null,
            formSchema: undefined
        };
    },
    created() {
        console.log('AddressComponent:created');
        this.ensureDataKey();
        this.addressModalPopupId = this.addressModalPopupId + "_" + this.internalDataKey;
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        //if (!this.dataBag[this.dataKey]) {
        //    this.$set(this.dataBag, this.dataKey, this.componentDataBag)
        //}
        console.log('AddressComponent:mounted');
        this.ensureDataKey();

        this.originalAddress = {
            "Address1": this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS1_KEY],
            "Address2": this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS2_KEY],
            "City": this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.CITY_KEY],
            "State": this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.STATE_KEY],
            "PostalCode": this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ZIP_KEY]
        };
        this.addressQuestionGroups = this.getMainAddressGroups();
        this.componentAddressQuestionGroups = this.getComponentAddressGroups();
        const self = this;
        setTimeout(function () {
            self.bindAutoComplete();
        }, 2000);
    },
    computed: {
        validationRetryNeeded() {
            return this.validationAttempts < this.maxValidationAttempts;
        },
        validationCount() {
            return this.validationAttempts;
        }
    },
    destroyed() {
        console.log('AddressComponent:destroyed');
    },
    methods: {
        tryGetFormSchema(keyPrefix) {
            this.ensureDataKey();
            return this.getFormSchema(this.dataKeyObject.formKey, keyPrefix);
        },
        getUpdatedGroup(grp) {
            grp.readMode = this.readMode;
            console.log('AddressComponent:getUpdatedGroup', grp);
            return grp;
        },
        assignTabIndex(question) {
            const tabIndex = this.dataKeyObject.readonly ? -1 : 0;
            if (tabIndex < 0) {
                question.tabIndex = tabIndex;
            }
            return question;
        },
        //dont remove it;
        dummyHandler() {},
        getMainAddressGroups() {

            var schema = this.tryGetFormSchema(this.internalDataKey);
            const tabIndex = this.dataKeyObject.readonly ? -1 : 0;
            if (tabIndex < 0) {
                this.setQuestionProperties(schema.groups, { tabIndex: tabIndex, readOnly: this.readOnly });
            }
            return schema.groups;
        },
        getComponentAddressGroups() {
            var schema = this.tryGetFormSchema(this.internalDataKey + this.componentAddressFieldPrefix);
            this.setQuestionProperties(schema.groups, { readOnly: this.readOnly });
            return schema.groups;
        },
        broadCastNavigateNext(evtData) {
            this.$eventBus.$emit(__WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENTS.NAVIGATE_NEXT_FEEDBACK, __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENT_DATA.NOT_NAVIGATED, evtData);
        },
        ensureDataKey() {
            //call component base parsing method
            this.ensureDataKeyParsing();

            this.showRequoteAlert = this.dataKeyObject.showRequoteAlert;
            this.internalDataKey = this.dataKeyObject.addressKey || this.dataKeyObject.dataKey;
            this.addressTitle = this.dataKeyObject.addressTitle || '';
            this.maxValidationAttempts = this.dataKeyObject.maxValidationAttempts || this.defaultMaxValidationAttempts;
            this.readOnly = this.dataKeyObject.readOnly;

            console.log('ensureDataKey', this.internalDataKey);
        },
        bindAutoComplete() {
            var $this = this;
            var NoResultsLabel = "Enter more information to narrow down your search";
            this.ensureDataKey();
            $("#" + $this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS1_KEY).autocomplete({
                source: function (request, response) {

                    var adds1 = $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS1_KEY];
                    __WEBPACK_IMPORTED_MODULE_2__Application_services_HttpCommunicationService__["a" /* default */].AutoAddress(adds1, function (data) {

                        var array = $.map(data, function (m) {
                            var add2 = typeof m.address2 !== "undefined" && m.address2 !== null && m.address2 != "" ? ", " + m.address2 : "";

                            return {
                                label: m.address + add2 + ", " + m.city + ", " + m.state + ", " + m.postalCode,
                                value: m.address,
                                address: m
                            };
                        });

                        if (!array.length) {
                            array = [NoResultsLabel];
                        }
                        return response(array);
                    }, function () {});
                },
                select: function (event, ui) {
                    if (ui.item.label === NoResultsLabel) {
                        event.preventDefault();
                    } else {
                        $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS1_KEY] = ui.item.address.address;
                        $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS2_KEY] = ui.item.address.address2;
                        $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.CITY_KEY] = ui.item.address.city;
                        $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.STATE_KEY] = ui.item.address.state;
                        $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ZIP_KEY] = ui.item.address.postalCode;
                        $this.alertStateChange();

                        //                            var placeholderAddress2 = $this.internalDataKey + Constants.ADDRESS_FIELDS.ADDRESS2_KEY;
                        var placeholderCity = $this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.CITY_KEY;
                        var placeholderState = $this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.STATE_KEY;
                        var placeholderZip = $this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ZIP_KEY;

                        function addPlaceholder(e) {
                            var $thisId = e;
                            $('#' + $thisId).parent().addClass("focused");
                        }

                        addPlaceholder(placeholderCity);
                        addPlaceholder(placeholderState);
                        addPlaceholder(placeholderZip);
                    }
                },
                focus: function (event, ui) {
                    if (ui.item.label === NoResultsLabel) {
                        event.preventDefault();
                    }
                },
                minLength: 3
            });
        },

        addressValidationAttempted() {
            this.validationAttempts = this.validationAttempts + 1;
            console.log('Validation Attempt No: ' + this.validationAttempts);
        },
        fieldInteractionCallbackHandler(questionKey) {

            const mainAddressStateKey = this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.STATE_KEY;
            console.log('Smart address:fieldInteractionCallbackHandler', questionKey, mainAddressStateKey);
            if (questionKey === mainAddressStateKey) {
                this.stateChangeHandler();
            }
        },
        stateChangeHandler() {
            this.alertStateChange();
        },
        alertStateChange(callbackFnToExecuteInsteadOfNavigateNext) {
            var $this = this;
            //show alert popup to inform that quote may change
            var state = $this.originalAddress.State;
            var newState = $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.STATE_KEY];

            var alert = state && newState && state != newState;

            if (this.showRequoteAlert && alert) {
                var msg = __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].STATE_CHANGE_MESSAGE;
                __WEBPACK_IMPORTED_MODULE_3__Application_services_dialogService__["a" /* default */].confirmAdvanced(msg, function (result) {
                    //when cancel, revert value to original
                    if (!result) {
                        __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].nextTick(function () {
                            $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.STATE_KEY] = state;
                        });
                    } else {
                        if (callbackFnToExecuteInsteadOfNavigateNext) {
                            callbackFnToExecuteInsteadOfNavigateNext();
                        } else {
                            var evtData = {};
                            //intruct not do validation and do submission for requote
                            evtData[__WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].NAVIGATION_EVENT_DATA.SUPPRESS_VALIDATION_ON_NEXT] = $this.validateOnNext;
                            $this.broadCastNavigateNext(evtData);
                        }
                    }
                }, "Continue");
                return true;
            } else {
                return false;
            }
        },
        copyAddressData(sourceObject, targetObject) {
            //copy source property->source, prefix->sourcePrefix
            let { source: source, prefix: sourcePrefix } = sourceObject;
            //copy source property->target, prefix->targetPrefix
            var { source: target, prefix: targetPrefix } = targetObject;

            target[targetPrefix + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS1_KEY] = source[sourcePrefix + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS1_KEY];
            target[targetPrefix + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS2_KEY] = source[sourcePrefix + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS2_KEY];
            target[targetPrefix + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.CITY_KEY] = source[sourcePrefix + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.CITY_KEY];
            target[targetPrefix + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.STATE_KEY] = source[sourcePrefix + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.STATE_KEY];
            target[targetPrefix + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ZIP_KEY] = source[sourcePrefix + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ZIP_KEY];
        },
        validateAddress(completionCallback, label) {
            console.log('validateAddress: ' + label);
            //if completionCallback is null or nt defined then use dummy fn to avoid null reference;
            completionCallback = completionCallback || function (data) {};

            var valid = this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS1_KEY] != '' && this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.CITY_KEY] != '' && this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.STATE_KEY] != '' && this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ZIP_KEY] != '';
            console.log('Address form has values ' + valid);

            var $this = this;
            const self = this;
            //validate with server only when all other validation is passed;
            if (valid && $this.showPopup) {
                $this.showPopup = false;

                var isValidated = $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.IS_VALIDATED_KEY] === 'true';
                console.log('Is ' + $this.internalDataKey + ' Address Validated - ' + isValidated);
                //validate if either its not validated yet or address is modified
                const needValidation = !isValidated || !$this.isAddressNotModified();

                if (needValidation) {
                    //copy address data from main databag to component/popup form databag
                    $this.copyAddressData({ source: $this.dataBag, prefix: $this.internalDataKey }, { source: $this.componentDataBag, prefix: $this.internalDataKey + $this.componentAddressFieldPrefix });
                    //set flag to show popup
                    $this.showAddressPopup = true;
                    var data = {
                        "address": [{
                            "address1": $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS1_KEY],
                            "address2": $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS2_KEY],
                            "city": $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.CITY_KEY],
                            "state": $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.STATE_KEY],
                            "zipCode": $this.dataBag[$this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ZIP_KEY],
                            "country": "US"
                        }]
                    };
                    //show wait dialog
                    var title = $this.addressTitle || 'Address';
                    var waitDialog = __WEBPACK_IMPORTED_MODULE_3__Application_services_dialogService__["a" /* default */].showWaitDialog(title + ' validation is in progress.');
                    console.log(title + ' validation is in progress.');

                    __WEBPACK_IMPORTED_MODULE_2__Application_services_HttpCommunicationService__["a" /* default */].validateAddress(data,
                    //httpService.validateAddress - success callback
                    function (addressValid) {
                        //update that validation is attempted
                        self.addressValidationAttempted();
                        waitDialog.modal('hide');
                        console.log('Address valid:' + addressValid);
                        //validation failed
                        if (!addressValid && self.validationRetryNeeded) {
                            //or give more chance for validation
                            self.openAddressPopup(function (result) {
                                //stop if form is invalid
                                if ($this.componentState.$invalid) {
                                    return false;
                                }
                                //reset to true
                                $this.showPopup = true;
                                //copy data to main databag
                                $this.copyAddressData({ source: $this.componentDataBag, prefix: $this.internalDataKey + $this.componentAddressFieldPrefix }, { source: $this.dataBag, prefix: $this.internalDataKey });
                                //check for state change, if state is not changed then false will be returned
                                var showingAlert = $this.alertStateChange(function () {
                                    completionCallback({ valid: true });
                                });
                                //if need state change alert, then close address popup and
                                //dont call completionCallback to stop submission
                                if (showingAlert) {
                                    //return true to close address popup
                                    return true;
                                }
                                //clear validation states
                                self.clearFormState();

                                //retry address valdiation
                                if (self.validationRetryNeeded) {
                                    self.validateAddress(completionCallback, 'inner retry: ' + self.validationCount);
                                }
                                console.log('advancedAddressPopupDialog=> okCallback');
                                return true;
                            }, function (result) {
                                console.log('advancedAddressPopupDialog=> cancelCallback');
                                self.showPopup = true;
                                self.clearFormState();
                                return true;
                            });
                        } else {
                            console.log('Proceeding with entered address as either address is valid or all validation attempts are over.');
                            self.showPopup = true;
                            //address is valid, trigger validatinCompleted callback
                            self.acceptCurrentAddress(completionCallback, addressValid);
                        }
                    },
                    //httpService.validateAddress - failure callback
                    function (error) {
                        waitDialog.modal('hide');
                        $this.showPopup = true;
                        //completionCallback({ valid: false });
                        __WEBPACK_IMPORTED_MODULE_3__Application_services_dialogService__["a" /* default */].showTechnicalErrorDialog();
                    });
                } else {
                    completionCallback({ valid: true });
                }
                return true;
            } else {
                //return false if other validation are failed;
                //completionCallback({ valid: false });
                return false;
            }
        },
        acceptCurrentAddress(completionCallback, verifiedAddress) {
            //user accepted curent address, no more validation required,
            //trigger validatinCompleted callback
            this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.IS_VALIDATED_KEY] = verifiedAddress;
            completionCallback({ valid: true });
        },

        isAddressNotModified() {
            return this.originalAddress.Address1 == this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS1_KEY] && this.originalAddress.Address2 == this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ADDRESS2_KEY] && this.originalAddress.City == this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.CITY_KEY] && this.originalAddress.State == this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.STATE_KEY] && this.originalAddress.PostalCode == this.dataBag[this.internalDataKey + __WEBPACK_IMPORTED_MODULE_1__Shared_Constants__["a" /* Constants */].ADDRESS_FIELDS.ZIP_KEY];
        },
        //ValidateOnNext event handler
        onValidateOnNext(evtData, completionCallback) {
            const self = this;
            this.nextValCompleted = false;
            console.log("AddressComponent=>onValidateOnNext", evtData, this);
            //do validation task and then provide feedback about validation completion by calling base method
            console.log('validating address...');
            this.validateAddress(function (data) {
                //send completion event data
                if (completionCallback && !self.nextValCompleted) {
                    self.nextValCompleted = true;
                    self.closeAddressPopup('done', true);
                    const evtData = {};
                    console.log('AddressComponent->onValidateOnNext::completionCallback');
                    completionCallback(evtData);
                }
            }, 'main');
        },
        closeAddressPopup(desc, destroy) {
            //var self = this;
            console.log('closeAddressPopup for: ' + desc);
            var action = 'hide';
            if (action && this.addressModelPopupDialog && this.addressModelPopupDialog.modal) {
                console.log('closeAddressPopup action: ' + action);
                try {
                    this.addressModelPopupDialog.modal(action);
                    //$('.modal-backdrop').remove();
                } catch (e) {
                    console.log('closeAddressPopup error: ', e);
                }
            }

            if (!this.validationRetryNeeded || destroy) {
                this.showAddressPopup = false;
                this.unbindAddressPopupActionButtons();
            }
        },
        //events for address bootstrap dialog
        openAddressPopup(okCallback, cancelCallback) {
            var self = this;
            if (this.addressModelPopupDialog) {
                //modal dialog is already opened, just show
                //delay little
                window.setTimeout(function () {
                    console.log('openAddressPopup:show');
                    self.addressModelPopupDialog.modal('show');
                }, 100);
            } else {
                //$this.showAddressPopup = true;
                //create new modal
                this.createAddressModalPopup(okCallback, cancelCallback);
            }
        },
        createAddressModalPopup(okCallback, cancelCallback) {
            var self = this;
            console.log('createAddressPopup');
            //create new modal and configure
            const modalRef = $('#' + self.addressModalPopupId);
            this.addressModelPopupDialog = modalRef.modal({
                keyboard: false,
                backdrop: 'static'
            }).on('shown.bs.modal', function () {
                $(document.body).removeAttr('style');
            }).on('hidden.bs.modal', function (e) {
                $(document.body).removeAttr('style');
            });
            //register event handler
            this.bindAddressPopupActionButtons(modalRef, okCallback, cancelCallback);
        },
        bindAddressPopupActionButtons(modalRef, okCallback, cancelCallback) {
            const self = this;
            $(modalRef).find('.modal-footer .btn-secondary').on('click', function () {
                var result = okCallback();
                if (result) {
                    self.closeAddressPopup('ok');
                }
            });

            $(modalRef).find('.modal-footer .btn-link').on('click', function () {
                var result = cancelCallback();
                if (result) {
                    self.closeAddressPopup('cancel');
                }
            });
        },
        unbindAddressPopupActionButtons() {
            const self = this;
            const modalRef = $('#' + self.addressModalPopupId);
            $(modalRef).find('.modal-footer .btn-secondary').off('click');
            $(modalRef).find('.modal-footer .btn-link').off('click');
        }
    }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utilities_Utility__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {
        //form state for validation
        state: {
            type: Object,
            required: true
        },
        message: {
            type: String,
            required: true
        }
    },
    data: function () {
        return {
            //setup data properties
            value: '',
            questionData: {
                questionKey: __WEBPACK_IMPORTED_MODULE_1__Utilities_Utility__["b" /* Utility */].newGuid()
            }
        };
    }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utilities_StringFunctions__ = __webpack_require__(103);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {},
    data: function () {
        return {
            //setup data properties
            value: this.dataBag[this.questionData.questionKey],
            isRequired: this.getValidatorValue('required'),
            minlength: this.getValidatorValue('minlength'),
            maxlength: this.getValidatorValue('maxlength'),
            minvalue: this.getValidatorValue('minvalue'),
            maxvalue: this.getValidatorValue('maxvalue'),
            pattern: this.getValidatorValue('pattern'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            minlengthMessage: this.getValidationMessage('minlengthMessage'),
            maxlengthMessage: this.getValidationMessage('maxlengthMessage'),
            minvalueMessage: this.getValidationMessage('minvalueMessage'),
            maxvalueMessage: this.getValidationMessage('maxvalueMessage'),
            patternMessage: this.getValidationMessage('patternMessage'),
            compareMessage: this.getValidationMessage('compareFieldKeyMessage'),
            maskFormat: this.questionData.maskFormat || '',
            rows: this.questionData.rows || 3,
            cols: this.questionData.cols || 20
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            var defaultValue = this.questionData.defaultValue || '';
            if (this.questionData.defaultValueFieldKey && this.dataBag[this.questionData.defaultValueFieldKey]) {
                console.log('textbox=>mounted=>defaultValueFieldKey', this.questionData.defaultValueFieldKey);
                defaultValue = this.dataBag[this.questionData.defaultValueFieldKey];
            }
            console.log('textbox=>mounted=>defaultValue', defaultValue);
            this.$set(this.dataBag, this.questionData.questionKey, defaultValue);
            if (defaultValue) {
                console.log('textbox=>mounted=>if', defaultValue);
                var $this = this;
                this.$nextTick(() => {
                    $this.initializeFieldView();
                    $this.setFocus();
                });
            }
        } //field has saved value
        else {
                this.initializeFieldView();
            }
        if (this.questionData.allowedCharacters) {
            this.registerKeyPressHandler();
        }
    },
    methods: {
        getFieldRef() {
            console.log('TextInputView=>getFieldRef');
            return this.questionData.type == 'text' ? this.$refs.textInput : this.$refs.textAreaInput;
        },
        keyPressHandler(event) {
            if (this.questionData.questionKey == __WEBPACK_IMPORTED_MODULE_2__Constants__["a" /* Constants */].JOBDESCRIPTON_KEY) {
                if (event.keyCode == 13) {
                    event.preventDefault();
                }
            }
        },
        focusHandler() {
            this.applyFocusPlaceholder(this.getFieldRef());
        },
        blurHandler(event) {

            //trigger field interaction notification
            this.notifyFieldInteraction();
            this.saveFieldData();
            this.applyBlurPlaceholder(this.getFieldRef());
        },
        registerKeyPressHandler() {
            $(this.$refs.textInput).keypress(e => {
                var char = String.fromCharCode(!e.charCode ? e.which : e.charCode);
                var keyCode = e.keyCode;
                var charCode = !e.charCode ? e.which : e.charCode;

                //console.log(char, keyCode, e, navigator.userAgent)
                const firefox = navigator.userAgent.search("Firefox") >= 0;

                // Allow: backspace, delete, tab, escape, enter, home, end, pageup, pagedown and arrow keys.
                if ($.inArray(keyCode, [8, 9, 13, 35, 36, 37, 38, 39, 40, 46]) !== -1 && firefox ||
                // Allow: Ctrl+A, Command+A
                charCode == 97 && (e.ctrlKey === true || e.metaKey === true)) {
                    // let it happen, don't do anything
                    return;
                }

                var expression = "^" + this.questionData.allowedCharacters + "+$";
                if (!new RegExp(expression).test(char)) {
                    e.preventDefault();
                    return false;
                }
            });
        },

        compareValidator: function (value) {
            //compareFieldKey and value has some value
            if (!this.questionData.validators.compareFieldKey || !value) {
                return true;
            }

            //get compare field value
            const compareFieldValue = this.dataBag[this.questionData.validators.compareFieldKey] || '';

            //compareFieldValue has some value and its not same as value
            if (compareFieldValue && (value + '').toLowerCase() == (compareFieldValue + '').toLowerCase()) {
                return false;
            }
            return true;
        }
    },
    computed: {
        dataType() {
            return this.questionData.datatype || 'text';
        },
        fKey() {
            let keyValue = this.questionData.questionKey;
            if (this.questionData.validators && this.questionData.validators.compareFieldKey) {
                const fValue = this.dataBag[this.questionData.validators.compareFieldKey];
                if (fValue) {
                    keyValue = this.questionData.questionKey + '_' + __WEBPACK_IMPORTED_MODULE_3__Utilities_StringFunctions__["a" /* default */].stringHash(fValue);
                }
            }
            console.log('fKey', keyValue);
            return keyValue;
        }
    }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





const YES_VALUE = 'Yes';
const NO_VALUE = 'No';

/* harmony default export */ __webpack_exports__["default"] = ({
    //setup mixins
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_1__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {
        //answer change notification callback
        answerChange: {
            type: Function,
            required: true
        }
    },
    data: function () {
        return {
            //setup data properties
            YES_VALUE: YES_VALUE,
            NO_VALUE: NO_VALUE,
            defaultValue: NO_VALUE
        };
    },
    mounted() {
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, this.defaultValue);
        } else {
            this.initializeFieldView();
            if (this.answerChange) {
                this.answerChange(this.dataBag[this.questionData.questionKey]);
            }
        }
    },
    methods: {
        getFieldRef() {
            console.log('CheckboxView=>getFieldRef');
            return this.$refs.checkBoxControl;
        },
        changeHandler($event) {
            const checked = $event.target.checked;
            //update databag with yes/no
            this.dataBag[this.questionData.questionKey] = checked ? this.YES_VALUE : this.NO_VALUE;

            var $this = this;
            if (this.questionData.showValueChangeAlert) {

                this.alertValueChange(function () {
                    $this.processChange(checked);
                });
            } else {
                this.processChange(checked);
            }
        },
        processChange(checked) {

            if (checked == undefined) {
                checked = this.dataBag[this.questionData.questionKey] == this.YES_VALUE;
            }

            //if callback is not null, invoke it
            if (this.answerChange) {
                this.answerChange(this.dataBag[this.questionData.questionKey]);
            }
            //trigger field interaction notification
            this.notifyFieldInteraction();
            this.saveFieldData();
        }
    }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_FormFieldComponentBaseMixin__["a" /* FormFieldComponentBaseMixin */], __WEBPACK_IMPORTED_MODULE_0__mixins_ViewValidationHelperMixin__["a" /* ViewValidationHelperMixin */]],
    props: {
        answerChange: {
            type: Function,
            required: false
        }
    },
    data: function () {
        return {
            isRequired: this.getValidatorValue('required'),
            requiredMessage: this.getValidationMessage('requiredMessage'),
            options: this.questionData.answerOptions && this.questionData.answerOptions.length > 0 ? this.questionData.answerOptions : this.getOptions(),
            defaultValue: 'No'
        };
    },
    mounted() {
        if (!this.dataBag[this.questionData.questionKey]) {
            this.$set(this.dataBag, this.questionData.questionKey, '');
        } else {
            this.initializeFieldView();
            if (this.answerChange) {
                this.answerChange(this.dataBag[this.questionData.questionKey]);
            }
        }
    },
    methods: {
        changeHandler() {
            var $this = this;
            if (this.questionData.showValueChangeAlert) {

                this.alertValueChange(function () {
                    $this.processChange();
                });
            } else {
                this.processChange();
            }
        },
        processChange() {
            //call answerChange if callback is not null
            if (this.answerChange) {
                this.answerChange(this.dataBag[this.questionData.questionKey]);
            }
            //trigger field interaction notification
            this.notifyFieldInteraction();
            this.saveFieldData();
        },
        getOptions() {
            //clone array
            var opts = [{
                text: 'Yes',
                value: 'Yes',
                iconClass: 'glyphicon-ok-circle'
            }, {
                text: 'No',
                value: 'No',
                iconClass: 'glyphicon-remove-circle'
            }];
            return opts;
        },
        isNotEmpty(text) {
            return text != null && text != undefined && text != '';
        }
    },
    computed: {}
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities_Utility__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//recommendationEngineData
//import { ComponentBaseMixin } from './../../../Application/mixins/ComponentBaseMixin'
/* harmony default export */ __webpack_exports__["default"] = ({
    //mixins: [ComponentBaseMixin],
    props: {
        result: {
            type: Object,
            required: true
        },
        onSelectCoverage: {
            type: Function,
            required: false
        },
        onCancelCoverage: {
            type: Function,
            required: false
        },
        showTerm: {
            type: Boolean,
            required: false,
            default: true
        },
        showCancelButton: {
            type: Boolean,
            required: false,
            default: false
        },

        showHeader: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    computed: {
        recommendationEngineData() {
            return this.result;
        },
        showSelectButton() {
            return this.onSelectCoverage != undefined && this.onSelectCoverage != null;
        },
        estimatedAmount() {
            return __WEBPACK_IMPORTED_MODULE_0__Utilities_Utility__["b" /* Utility */].formatCurrency(this.recommendationEngineData.recommendedCoverageAmount);
        }
    },
    methods: {
        selectCoverageHandler() {
            if (this.onSelectCoverage) {
                this.onSelectCoverage();
            }
        },
        cancelHandler() {
            if (this.onCancelCoverage) {
                this.onCancelCoverage();
            }
        }
    }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utilities_Utility__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Application_services_dialogService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Application_mixins_ComponentBaseMixin__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Application_services_HttpCommunicationService__ = __webpack_require__(12);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_2__Application_mixins_ComponentBaseMixin__["a" /* ComponentBaseMixin */]],
    props: {},
    data: function () {
        return {
            //add policy flag
            showPolicyForm: false,
            //setup data properties
            defaultOptions: {
                showReplaceOption: true
            },
            dataKeyObject: {
                dataKey: '',
                showReplaceOption: true
            },
            carrierList: undefined
        };
    },
    created() {},
    mounted() {
        this.ensureDateKeyNormalization(this.defaultOptions);
        this.dataKeyObject.showReplaceOption = (this.dataKeyObject.showReplaceOption + '' || '').toLowerCase() != 'false';
        //check if datakey exist in data bag
        //if not create key in data bag
        if (!this.dataBag[this.dataBagKey]) {
            this.$set(this.dataBag, this.dataBagKey, []);
        }

        this.componentDataBag = this.getComponentDataBag();
        this.showPolicyForm = this.policies.length === 0;

        this.loadCarrierList();
        this.loadDynamicContent('existingPolicyDetailComponent', 'existingPolicyNoteHtml');
    },
    computed: {
        policies() {
            return this.dataBag[this.dataBagKey] || [];
        },
        //from local in memory
        carrierListJsonUrl() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.carrierListJsonUrl;
        },

        dataBagKey() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.dataKey || this.dataKey;
        },

        dynamicPropertiesMap() {
            this.ensureDataKeyParsing();
            return this.dataKeyObject.dynamicPropertiesMap || [];
        },

        formGroups() {
            this.ensureDataKeyParsing();
            var groups = this.getFormGroups(this.dataKeyObject.formKey, this.componentKey);
            if (!(groups && groups.length > 0)) {
                groups = this.getQuestionGroups();
            }
            groups = this.assignKey(groups);

            this.setGroupQuestionProperties(groups, this.questionPropertiesProvider);
            return groups;
        }
    },
    methods: {

        questionPropertiesProvider(question) {
            const self = this;
            var props = {};

            if (!question || !question.questionKey) {
                return props;
            }

            var foundMap = this.dynamicPropertiesMap.find(pm => question.questionKey.indexOf(pm.questionKey) > -1);

            if (foundMap && foundMap.props) {
                foundMap.props.forEach(p => {
                    props[p.prop] = self[p.valueRef];
                });
                console.log('found dynamic properties for ', foundMap, props);
            }

            return props;
        },
        getComponentDataBag() {
            var key = this.componentKey;
            var cData = {
                [key + '_Company']: '',
                [key + '_Product']: '',
                [key + '_Amount']: '',
                [key + '_Year']: ''
            };

            if (this.dataKeyObject.showReplaceOption) {
                cData[key + '_Replace'] = '';
            }
            return cData;
        },
        resetLocalDataModel() {
            this.componentDataBag = this.getComponentDataBag();
        },
        onAddPolicyDetail() {
            this.showPolicyForm = true;
            this.resetLocalDataModel();
        },
        onSave() {
            console.log('onSave');
            //check component state for val
            this.$set(this.componentState, '$submitted', true);
            //touch component states to highlight field
            this.touchComponentState(this.componentState);
            if (this.componentState.$valid) {
                this.$set(this.componentState, '$submitted', false);
                if (!this.componentDataBag.key) {
                    this.componentDataBag.key = __WEBPACK_IMPORTED_MODULE_0__Utilities_Utility__["b" /* Utility */].newGuid();
                }
                //push to collection
                var key = this.componentKey;

                var currentRecord = {
                    key: this.componentDataBag.key,
                    Company: this.componentDataBag[key + '_Company'],
                    Product: this.componentDataBag[key + '_Product'],
                    Amount: this.componentDataBag[key + '_Amount'],
                    Year: this.componentDataBag[key + '_Year']
                };

                if (this.dataKeyObject.showReplaceOption) {
                    currentRecord.Replace = this.componentDataBag[key + '_Replace'];
                }
                this.dataBag[this.dataBagKey].push(currentRecord);

                //reset data
                this.resetLocalDataModel();
                //reset flag
                this.showPolicyForm = false;
                //save data
                //this.saveComponentData();
                this.clearFormState();
            }
        },
        onCancel() {
            this.showPolicyForm = false;
            this.resetLocalDataModel();
            this.clearFormState();
        },
        deletePolicyDetail(policy) {
            var $this = this;
            if (__WEBPACK_IMPORTED_MODULE_1__Application_services_dialogService__["a" /* default */].confirmAdvanced) {
                __WEBPACK_IMPORTED_MODULE_1__Application_services_dialogService__["a" /* default */].confirmAdvanced("Do you really want to delete Policy Detail?", function (result) {
                    if (result) {
                        var itemIdex = -1;
                        var list = $this.dataBag[$this.dataBagKey];
                        for (var index = 0; index < list.length; index++) {
                            if (list[index].key == policy.key) {
                                itemIdex = index;
                                break;
                            }
                        }
                        if (itemIdex > -1) {
                            list.splice(itemIdex, 1);
                            $this.saveComponentData();
                        }
                        //check policy count
                        if ($this.policies.length == 0) {
                            $this.showPolicyForm = true;
                        }
                    }
                }, 'Delete');
            }
        },

        processCarrierList(data) {
            const self = this;
            if (data && Array.isArray(data)) {
                var items = [];
                data.forEach(item => {
                    var option = {};
                    for (var p in item) {
                        if (p.toLowerCase() == 'text' || p.toLowerCase() == 'name') {
                            option['text'] = item[p];
                        } else if (p.toLowerCase() == 'value') {
                            option['value'] = item[p];
                        } else if (p.toLowerCase() == 'id' || p.toLowerCase() == 'key') {
                            option['key'] = item[p];
                        }
                    }
                    items.push(option);
                });
                self.carrierList = items;
            }
        },

        loadCarrierList() {
            const self = this;
            if (this.carrierListJsonUrl) {
                __WEBPACK_IMPORTED_MODULE_4__Application_services_HttpCommunicationService__["a" /* default */].download(this.carrierListJsonUrl, this.processCarrierList);
            } else {
                __WEBPACK_IMPORTED_MODULE_4__Application_services_HttpCommunicationService__["a" /* default */].GetListItems(' ', this.processCarrierList);
            }
        },

        searchCarrier(searchText, callback) {
            console.log('carrier search ', searchText);
            if (this.carrierList) {
                callback(this.carrierList);
            } else {
                __WEBPACK_IMPORTED_MODULE_4__Application_services_HttpCommunicationService__["a" /* default */].GetListItems(searchText, callback);
            }
        },

        getQuestionGroups() {
            const currentYear = new Date().getFullYear();
            var questions = [{
                "title": "Insurance Company Name",
                "helpText": "",
                "questions": [[{
                    "question": {
                        "questionKey": this.componentKey + "_Company",
                        "text": "Type to search",
                        "type": "searchableList",
                        "searchFunction": this.searchCarrier,
                        "dataKey": "testPicker",
                        "validators": {
                            "required": true,
                            "requiredMessage": "This field is required"
                        }
                    },
                    "colCss": 'col-sm-9 col-lg-7'
                }]]
            }, {
                "title": "What is the product type?",
                "helpText": "",
                "questions": [[{
                    "question": {
                        "questionKey": this.componentKey + "_Product",
                        "type": "dropdown",
                        "text": "Product Type",
                        "autoSave": false,
                        "selectText": "Choose One",
                        "answerOptionsFunction": 'PRODUCT_TYPE_LIST',
                        "sortKey": "text",
                        "validators": {
                            "required": true,
                            "requiredMessage": "This field is required"
                        }
                    },
                    "colCss": 'col-sm-9 col-lg-7'
                }]]
            }, {
                "title": "Amount of insurance (or annuity value)?",
                "helpText": "",
                "questions": [[{
                    "question": {
                        "questionKey": this.componentKey + "_Amount",
                        "type": "money",
                        "text": "Amount",
                        "autoSave": false,
                        "placeholder": "Amount",
                        "maskFormat": "$#######",
                        "validators": {
                            "required": true,
                            "requiredMessage": "This field is required"
                        }
                    },
                    "colCss": 'col-sm-9 col-lg-7'
                }]]
            }, {
                "title": "When was the policy or annuity issued?",
                "helpText": "",
                "questions": [[{
                    "question": {
                        "questionKey": this.componentKey + "_Year",
                        "text": "Year",
                        "type": "text",
                        "maskFormat": "####",
                        "placeholder": "Year",
                        "autoSave": false,
                        "validators": {
                            "required": true,
                            "requiredMessage": "The Year is required and cannot be left blank",
                            "pattern": __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Constants */].REGEX.PASTYEAR_UNTIL_CURRENTYEAR(),
                            "patternMessage": "Only include policies in the past (1900-" + currentYear + ")"
                        }
                    },
                    "colCss": 'col-sm-9 col-lg-7'
                }]]
            }];
            if (this.dataKeyObject.showReplaceOption) {

                questions.push({
                    "title": "Do you plan to replace, change, or use any monetary value of any existing or pending life insurance policy or annuity in connection with the policy being applied for?",
                    "helpText": "",
                    "questions": [[{
                        "question": {
                            "questionKey": this.componentKey + "_Replace",
                            "text": "",
                            "type": "radio",
                            "autoSave": false,
                            "answer": "",
                            "answerOptions": [{
                                "text": "Yes",
                                "value": "Yes",
                                "iconClass": 'glyphicon-ok-circle'
                            }, {
                                "text": "No",
                                "value": "No",
                                "iconClass": 'glyphicon-remove-circle'
                            }],
                            "validators": {
                                "required": true,
                                "requiredMessage": "This field is required"
                            }
                        }
                    }]]
                });
            }
            return questions;
        }
    }
});

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(228);

module.exports = parent;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(229);

module.exports = parent;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(226);
var entryUnbind = __webpack_require__(63);

module.exports = entryUnbind('Array', 'findIndex');


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(227);
var entryUnbind = __webpack_require__(63);

module.exports = entryUnbind('Array', 'find');


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(189);


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(190);


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(183);

module.exports = parent;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(184);

module.exports = parent;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(31);
var toAbsoluteIndex = __webpack_require__(220);
var lengthOfArrayLike = __webpack_require__(70);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(205);
var isConstructor = __webpack_require__(206);
var isObject = __webpack_require__(20);
var wellKnownSymbol = __webpack_require__(24);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__(192);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(223);
var isCallable = __webpack_require__(8);
var classofRaw = __webpack_require__(29);
var wellKnownSymbol = __webpack_require__(24);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__(18);
var ownKeys = __webpack_require__(219);
var getOwnPropertyDescriptorModule = __webpack_require__(71);
var definePropertyModule = __webpack_require__(23);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__(8);
var definePropertyModule = __webpack_require__(23);
var makeBuiltIn = __webpack_require__(209);
var defineGlobalProperty = __webpack_require__(34);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),
/* 197 */
/***/ (function(module, exports) {

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var userAgent = __webpack_require__(197);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(201);
var aCallable = __webpack_require__(56);
var NATIVE_BIND = __webpack_require__(36);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(15);
var hasOwn = __webpack_require__(18);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var classofRaw = __webpack_require__(29);
var uncurryThis = __webpack_require__(7);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__(56);
var isNullOrUndefined = __webpack_require__(68);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(30);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(225);
var global = __webpack_require__(10);
var isObject = __webpack_require__(20);
var createNonEnumerableProperty = __webpack_require__(59);
var hasOwn = __webpack_require__(18);
var shared = __webpack_require__(39);
var sharedKey = __webpack_require__(74);
var hiddenKeys = __webpack_require__(38);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(29);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(7);
var fails = __webpack_require__(11);
var isCallable = __webpack_require__(8);
var classof = __webpack_require__(194);
var getBuiltIn = __webpack_require__(30);
var inspectSource = __webpack_require__(67);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(11);
var isCallable = __webpack_require__(8);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(7);
var fails = __webpack_require__(11);
var isCallable = __webpack_require__(8);
var hasOwn = __webpack_require__(18);
var DESCRIPTORS = __webpack_require__(15);
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(200).CONFIGURABLE;
var inspectSource = __webpack_require__(67);
var InternalStateModule = __webpack_require__(204);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),
/* 210 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(28);
var definePropertiesModule = __webpack_require__(212);
var enumBugKeys = __webpack_require__(35);
var hiddenKeys = __webpack_require__(38);
var html = __webpack_require__(203);
var documentCreateElement = __webpack_require__(62);
var sharedKey = __webpack_require__(74);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(15);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(82);
var definePropertyModule = __webpack_require__(23);
var anObject = __webpack_require__(28);
var toIndexedObject = __webpack_require__(31);
var objectKeys = __webpack_require__(216);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(72);
var enumBugKeys = __webpack_require__(35);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 214 */
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__(7);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(72);
var enumBugKeys = __webpack_require__(35);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__(37);
var isCallable = __webpack_require__(8);
var isObject = __webpack_require__(20);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(30);
var uncurryThis = __webpack_require__(7);
var getOwnPropertyNamesModule = __webpack_require__(213);
var getOwnPropertySymbolsModule = __webpack_require__(214);
var anObject = __webpack_require__(28);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(77);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__(77);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__(37);
var isObject = __webpack_require__(20);
var isSymbol = __webpack_require__(69);
var getMethod = __webpack_require__(202);
var ordinaryToPrimitive = __webpack_require__(218);
var wellKnownSymbol = __webpack_require__(24);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(24);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 224 */
/***/ (function(module, exports) {

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(10);
var isCallable = __webpack_require__(8);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(64);
var $findIndex = __webpack_require__(58).findIndex;
var addToUnscopables = __webpack_require__(57);

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(64);
var $find = __webpack_require__(58).find;
var addToUnscopables = __webpack_require__(57);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(185);

module.exports = parent;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var parent = __webpack_require__(186);

module.exports = parent;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */



function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};


/***/ }),
/* 231 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 232 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(182)
var ieee754 = __webpack_require__(231)
var isArray = __webpack_require__(232)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(235);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16), __webpack_require__(83)))

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.VueForm = factory());
}(this, (function () { 'use strict';

var emailRegExp = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i; // from angular
var urlRegExp = /^(http\:\/\/|https\:\/\/)(.{4,})$/;

var email = function email(value, attrValue, vnode) {
  return emailRegExp.test(value);
};
email._allowNulls = true;

var number = function number(value, attrValue, vnode) {
  return !isNaN(value);
};
number._allowNulls = true;

var url = function url(value, attrValue, vnode) {
  return urlRegExp.test(value);
};
url._allowNulls = true;

var validators = {
  email: email,
  number: number,
  url: url,
  required: function required(value, attrValue, vnode) {
    if (attrValue === false) {
      return true;
    }

    if (value === 0) {
      return true;
    }

    if (vnode.data.attrs && typeof vnode.data.attrs.bool !== 'undefined' || vnode.componentOptions && vnode.componentOptions.propsData && typeof vnode.componentOptions.propsData.bool !== 'undefined') {
      // bool attribute is present, allow false pass validation
      if (value === false) {
        return true;
      }
    }

    if (Array.isArray(value)) {
      return !!value.length;
    }
    return !!value;
  },
  minlength: function minlength(value, length) {
    return value.length >= length;
  },
  maxlength: function maxlength(value, length) {
    return length >= value.length;
  },
  pattern: function pattern(value, _pattern) {
    var patternRegExp = new RegExp('^' + _pattern + '$');
    return patternRegExp.test(value);
  },
  min: function min(value, _min, vnode) {
    if ((vnode.data.attrs.type || '').toLowerCase() == 'number') {
      return +value >= +_min;
    }
    return value >= _min;
  },
  max: function max(value, _max, vnode) {
    if ((vnode.data.attrs.type || '').toLowerCase() == 'number') {
      return +_max >= +value;
    }
    return _max >= value;
  }
};

var config = {
  validators: validators,
  formComponent: 'VueForm',
  formTag: 'form',
  messagesComponent: 'FieldMessages',
  messagesTag: 'div',
  showMessages: '',
  validateComponent: 'Validate',
  validateTag: 'div',
  fieldComponent: 'Field',
  fieldTag: 'div',
  formClasses: {
    dirty: 'vf-form-dirty',
    pristine: 'vf-form-pristine',
    valid: 'vf-form-valid',
    invalid: 'vf-form-invalid',
    touched: 'vf-form-touched',
    untouched: 'vf-form-untouched',
    focused: 'vf-form-focused',
    submitted: 'vf-form-submitted',
    pending: 'vf-form-pending'
  },
  validateClasses: {
    dirty: 'vf-field-dirty',
    pristine: 'vf-field-pristine',
    valid: 'vf-field-valid',
    invalid: 'vf-field-invalid',
    touched: 'vf-field-touched',
    untouched: 'vf-field-untouched',
    focused: 'vf-field-focused',
    submitted: 'vf-field-submitted',
    pending: 'vf-field-pending'
  },
  inputClasses: {
    dirty: 'vf-dirty',
    pristine: 'vf-pristine',
    valid: 'vf-valid',
    invalid: 'vf-invalid',
    touched: 'vf-touched',
    untouched: 'vf-untouched',
    focused: 'vf-focused',
    submitted: 'vf-submitted',
    pending: 'vf-pending'
  },
  Promise: typeof Promise === 'function' ? Promise : null
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

function getClasses(classConfig, state) {
  var _ref;

  return _ref = {}, defineProperty(_ref, classConfig.dirty, state.$dirty), defineProperty(_ref, classConfig.pristine, state.$pristine), defineProperty(_ref, classConfig.valid, state.$valid), defineProperty(_ref, classConfig.invalid, state.$invalid), defineProperty(_ref, classConfig.touched, state.$touched), defineProperty(_ref, classConfig.untouched, state.$untouched), defineProperty(_ref, classConfig.focused, state.$focused), defineProperty(_ref, classConfig.pending, state.$pending), defineProperty(_ref, classConfig.submitted, state.$submitted), _ref;
}

function addClass(el, className) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    el.className += ' ' + className;
  }
}

function removeClass(el, className) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
  }
}

function vModelValue(data) {
  if (data.model) {
    return data.model.value;
  }
  return data.directives.filter(function (v) {
    return v.name === 'model';
  })[0].value;
}

function getVModelAndLabel(nodes, config) {
  var foundVnodes = {
    vModel: [],
    label: null,
    messages: null
  };

  if (!nodes) {
    return foundVnodes;
  }

  function traverse(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];

      if (node.componentOptions) {
        if (node.componentOptions.tag === hyphenate(config.messagesComponent)) {
          foundVnodes.messages = node;
        }
      }

      if (node.tag === 'label' && !foundVnodes.label) {
        foundVnodes.label = node;
      }

      if (node.data) {
        if (node.data.model) {
          // model check has to come first. If a component has
          // a directive and v-model, the directive will be in .directives
          // and v-modelstored in .model
          foundVnodes.vModel.push(node);
        } else if (node.data.directives) {
          var match = node.data.directives.filter(function (v) {
            return v.name === 'model';
          });
          if (match.length) {
            foundVnodes.vModel.push(node);
          }
        }
      }
      if (node.children) {
        traverse(node.children);
      } else if (node.componentOptions && node.componentOptions.children) {
        traverse(node.componentOptions.children);
      }
    }
  }

  traverse(nodes);

  return foundVnodes;
}

function getName(vnode) {
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.name) {
    return vnode.data.attrs.name;
  } else if (vnode.componentOptions && vnode.componentOptions.propsData && vnode.componentOptions.propsData.name) {
    return vnode.componentOptions.propsData.name;
  }
}

var hyphenateRE = /([^-])([A-Z])/g;
function hyphenate(str) {
  return str.replace(hyphenateRE, '$1-$2').replace(hyphenateRE, '$1-$2').toLowerCase();
}

function randomId() {
  return Math.random().toString(36).substr(2, 10);
}

// https://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

function isShallowObjectDifferent(a, b) {
  var aValue = '';
  var bValue = '';
  Object.keys(a).sort().filter(function (v) {
    return typeof a[v] !== 'function';
  }).forEach(function (v) {
    return aValue += a[v];
  });
  Object.keys(b).sort().filter(function (v) {
    return typeof a[v] !== 'function';
  }).forEach(function (v) {
    return bValue += b[v];
  });
  return aValue !== bValue;
}

var vueFormConfig = 'VueFormProviderConfig' + randomId();
var vueFormState = 'VueFormProviderState' + randomId();
var vueFormParentForm = 'VueFormProviderParentForm' + randomId();

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty$1 = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty$1 && options.name === '__proto__') {
		defineProperty$1(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

var extend = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};

var vueForm = {
  render: function render(h) {
    var _this = this;

    var attrs = {};

    if (typeof window !== 'undefined') {
      attrs.novalidate = '';
    }

    return h(this.tag || this.vueFormConfig.formTag, {
      on: {
        submit: function submit(event) {
          if (_this.state.$pending) {
            event.preventDefault();
            _this.vueFormConfig.Promise.all(_this.promises).then(function () {
              _this.state._submit();
              _this.$emit('submit', event);
              _this.promises = [];
            });
          } else {
            _this.state._submit();
            _this.$emit('submit', event);
          }
        },
        reset: function reset(event) {
          _this.state._reset();
          _this.$emit('reset', event);
        }
      },
      class: this.className,
      attrs: attrs
    }, [this.$slots.default]);
  },

  props: {
    state: {
      type: Object,
      required: true
    },
    tag: String,
    showMessages: String
  },
  inject: { vueFormConfig: vueFormConfig },
  provide: function provide() {
    var _ref;

    return _ref = {}, defineProperty(_ref, vueFormState, this.state), defineProperty(_ref, vueFormParentForm, this), _ref;
  },

  data: function data() {
    return {
      promises: []
    };
  },
  created: function created() {
    var _this2 = this;

    if (!this.state) {
      return;
    }
    var controls = {};
    var state = this.state;
    var formstate = {
      $dirty: false,
      $pristine: true,
      $valid: true,
      $invalid: false,
      $submitted: false,
      $touched: false,
      $untouched: true,
      $focused: false,
      $pending: false,
      $error: {},
      $submittedState: {},
      _id: '',
      _submit: function _submit() {
        _this2.state.$submitted = true;
        _this2.state._cloneState();
      },
      _cloneState: function _cloneState() {
        var cloned = JSON.parse(JSON.stringify(state));
        delete cloned.$submittedState;
        Object.keys(cloned).forEach(function (key) {
          _this2.$set(_this2.state.$submittedState, key, cloned[key]);
        });
      },
      _addControl: function _addControl(ctrl) {
        controls[ctrl.$name] = ctrl;
        _this2.$set(state, ctrl.$name, ctrl);
      },
      _removeControl: function _removeControl(ctrl) {
        delete controls[ctrl.$name];
        _this2.$delete(_this2.state, ctrl.$name);
        _this2.$delete(_this2.state.$error, ctrl.$name);
      },
      _validate: function _validate() {
        Object.keys(controls).forEach(function (key) {
          controls[key]._validate();
        });
      },
      _reset: function _reset() {
        state.$submitted = false;
        state.$pending = false;
        state.$submittedState = {};
        Object.keys(controls).forEach(function (key) {
          var control = controls[key];
          control._hasFocused = false;
          control._setUntouched();
          control._setPristine();
          control.$submitted = false;
          control.$pending = false;
        });
      }
    };

    Object.keys(formstate).forEach(function (key) {
      _this2.$set(_this2.state, key, formstate[key]);
    });

    this.$watch('state', function () {
      var isDirty = false;
      var isValid = true;
      var isTouched = false;
      var isFocused = false;
      var isPending = false;
      Object.keys(controls).forEach(function (key) {
        var control = controls[key];

        control.$submitted = state.$submitted;

        if (control.$dirty) {
          isDirty = true;
        }
        if (control.$touched) {
          isTouched = true;
        }
        if (control.$focused) {
          isFocused = true;
        }
        if (control.$pending) {
          isPending = true;
        }
        if (!control.$valid) {
          isValid = false;
          // add control to errors
          _this2.$set(state.$error, control.$name, control);
        } else {
          _this2.$delete(state.$error, control.$name);
        }
      });

      state.$dirty = isDirty;
      state.$pristine = !isDirty;
      state.$touched = isTouched;
      state.$untouched = !isTouched;
      state.$focused = isFocused;
      state.$valid = isValid;
      state.$invalid = !isValid;
      state.$pending = isPending;
    }, {
      deep: true,
      immediate: true
    });

    /* watch pristine? if set to true, set all children to pristine
    Object.keys(controls).forEach((ctrl) => {
      controls[ctrl].setPristine();
    });*/
  },

  computed: {
    className: function className() {
      var classes = getClasses(this.vueFormConfig.formClasses, this.state);
      return classes;
    }
  },
  methods: {
    reset: function reset() {
      this.state._reset();
    },
    validate: function validate() {
      this.state._validate();
    }
  }
};

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};





function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var scope_eval = createCommonjsModule(function (module) {
// Generated by CoffeeScript 1.10.0
(function() {
  var hasProp = {}.hasOwnProperty,
    slice = [].slice;

  module.exports = function(source, scope) {
    var key, keys, value, values;
    keys = [];
    values = [];
    for (key in scope) {
      if (!hasProp.call(scope, key)) continue;
      value = scope[key];
      if (key === 'this') {
        continue;
      }
      keys.push(key);
      values.push(value);
    }
    return Function.apply(null, slice.call(keys).concat(["return eval(" + (JSON.stringify(source)) + ")"])).apply(scope["this"], values);
  };

}).call(commonjsGlobal);
});

function findLabel(nodes) {
  if (!nodes) {
    return;
  }
  for (var i = 0; i < nodes.length; i++) {
    var vnode = nodes[i];
    if (vnode.tag === 'label') {
      return nodes[i];
    } else if (nodes[i].children) {
      return findLabel(nodes[i].children);
    }
  }
}

var messages = {
  inject: { vueFormConfig: vueFormConfig, vueFormState: vueFormState, vueFormParentForm: vueFormParentForm },
  render: function render(h) {
    var _this = this;

    var children = [];
    var field = this.formstate[this.fieldname];
    if (field && field.$error && this.isShown) {
      Object.keys(field.$error).forEach(function (key) {
        if (_this.$slots[key] || _this.$scopedSlots[key]) {
          var out = _this.$slots[key] || _this.$scopedSlots[key](field);
          if (_this.autoLabel) {
            var label = findLabel(out);
            if (label) {
              label.data = label.data || {};
              label.data.attrs = label.data.attrs || {};
              label.data.attrs.for = field._id;
            }
          }
          children.push(out);
        }
      });
      if (!children.length && field.$valid) {
        if (this.$slots.default || this.$scopedSlots.default) {
          var out = this.$slots.default || this.$scopedSlots.default(field);
          if (this.autoLabel) {
            var label = findLabel(out);
            if (label) {
              label.data = label.data || {};
              label.data.attrs = label.data.attrs || {};
              label.data.attrs.for = field._id;
            }
          }
          children.push(out);
        }
      }
    }
    return h(this.tag || this.vueFormConfig.messagesTag, children);
  },

  props: {
    state: Object,
    name: String,
    show: {
      type: String,
      default: ''
    },
    tag: {
      type: String
    },
    autoLabel: Boolean
  },
  data: function data() {
    return {
      formstate: null,
      fieldname: ''
    };
  },
  created: function created() {
    this.fieldname = this.name;
    this.formstate = this.state || this.vueFormState;
  },

  computed: {
    isShown: function isShown() {
      var field = this.formstate[this.fieldname];
      var show = this.show || this.vueFormParentForm.showMessages || this.vueFormConfig.showMessages;

      if (!show || !field) {
        return true;
      }

      return scope_eval(show, field);
    }
  }
};

var validate = {
  render: function render(h) {
    var _this = this;

    var foundVnodes = getVModelAndLabel(this.$slots.default, this.vueFormConfig);
    var vModelnodes = foundVnodes.vModel;
    var attrs = {
      for: null
    };
    if (vModelnodes.length) {
      this.name = getName(vModelnodes[0]);

      if (foundVnodes.messages) {
        this.$nextTick(function () {
          var messagesVm = foundVnodes.messages.componentInstance;
          if (messagesVm) {
            messagesVm.fieldname = messagesVm.fieldname || _this.name;
          }
        });
      }

      if (this.autoLabel) {
        var id = vModelnodes[0].data.attrs.id || this.fieldstate._id;
        this.fieldstate._id = id;
        vModelnodes[0].data.attrs.id = id;
        if (foundVnodes.label) {
          foundVnodes.label.data = foundVnodes.label.data || {};
          foundVnodes.label.data.attrs = foundVnodes.label.data.attrs || {};
          foundVnodes.label.data.attrs.for = id;
        } else if (this.tag === 'label') {
          attrs.for = id;
        }
      }
      vModelnodes.forEach(function (vnode) {
        if (!vnode.data.directives) {
          vnode.data.directives = [];
        }
        vnode.data.directives.push({ name: 'vue-form-validator', value: { fieldstate: _this.fieldstate, config: _this.vueFormConfig } });
        vnode.data.attrs['vue-form-validator'] = '';
        vnode.data.attrs['debounce'] = _this.debounce;
      });
    } else {
      //console.warn('Element with v-model not found');
    }
    return h(this.tag || this.vueFormConfig.validateTag, { 'class': this.className, attrs: attrs }, this.$slots.default);
  },

  props: {
    state: Object,
    custom: null,
    autoLabel: Boolean,
    tag: {
      type: String
    },
    debounce: Number
  },
  inject: { vueFormConfig: vueFormConfig, vueFormState: vueFormState, vueFormParentForm: vueFormParentForm },
  data: function data() {
    return {
      name: '',
      formstate: null,
      fieldstate: {}
    };
  },

  methods: {
    getClasses: function getClasses$$1(classConfig) {
      var s = this.fieldstate;
      return Object.keys(s.$error).reduce(function (classes, error) {
        classes[classConfig.invalid + '-' + hyphenate(error)] = true;
        return classes;
      }, getClasses(classConfig, s));
    }
  },
  computed: {
    className: function className() {
      return this.getClasses(this.vueFormConfig.validateClasses);
    },
    inputClassName: function inputClassName() {
      return this.getClasses(this.vueFormConfig.inputClasses);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.fieldstate.$name = this.name;
    this.formstate._addControl(this.fieldstate);

    var vModelEls = this.$el.querySelectorAll('[vue-form-validator]');

    // add classes to the input element
    this.$watch('inputClassName', function (value, oldValue) {
      var out = void 0;

      var _loop = function _loop(i, el) {
        if (oldValue) {
          Object.keys(oldValue).filter(function (k) {
            return oldValue[k];
          }).forEach(function (k) {
            return removeClass(el, k);
          });
        }
        out = [];
        Object.keys(value).filter(function (k) {
          return value[k];
        }).forEach(function (k) {
          out.push(k);
          addClass(el, k);
        });
      };

      for (var i = 0, el; el = vModelEls[i++];) {
        _loop(i, el);
      }
      _this2.fieldstate._className = out;
    }, {
      deep: true,
      immediate: true
    });

    this.$watch('name', function (value, oldValue) {
      _this2.formstate._removeControl(_this2.fieldstate);
      _this2.fieldstate.$name = value;
      _this2.formstate._addControl(_this2.fieldstate);
    });
  },
  created: function created() {
    var _this4 = this;

    this.formstate = this.state || this.vueFormState;
    var vm = this;
    var pendingValidators = [];
    var _val = void 0;
    var prevVnode = void 0;
    this.fieldstate = {
      $name: '',
      $dirty: false,
      $pristine: true,
      $valid: true,
      $invalid: false,
      $touched: false,
      $untouched: true,
      $focused: false,
      $pending: false,
      $submitted: false,
      $error: {},
      $attrs: {},
      _className: null,
      _id: 'vf' + randomId(),
      _setValidatorValidity: function _setValidatorValidity(validator, isValid) {
        if (isValid) {
          vm.$delete(this.$error, validator);
        } else {
          vm.$set(this.$error, validator, true);
        }
      },
      _setValidity: function _setValidity(isValid) {
        this.$valid = isValid;
        this.$invalid = !isValid;
      },
      _setDirty: function _setDirty() {
        this.$dirty = true;
        this.$pristine = false;
      },
      _setPristine: function _setPristine() {
        this.$dirty = false;
        this.$pristine = true;
      },
      _setTouched: function _setTouched() {
        this.$touched = true;
        this.$untouched = false;
      },
      _setUntouched: function _setUntouched() {
        this.$touched = false;
        this.$untouched = true;
      },
      _setFocused: function _setFocused(value) {
        this.$focused = typeof value === 'boolean' ? value : false;
        if (this.$focused) {
          this._setHasFocused();
        } else {
          this._setTouched();
        }
      },
      _setHasFocused: function _setHasFocused() {
        this._hasFocused = true;
      },

      _hasFocused: false,
      _validators: {},
      _validate: function _validate(vnode) {
        var _this3 = this;

        if (!vnode) {
          vnode = prevVnode;
        } else {
          prevVnode = vnode;
        }
        this.$pending = true;
        var isValid = true;
        var emptyAndRequired = false;
        var value = vModelValue(vnode.data);
        _val = value;

        var pending = {
          promises: [],
          names: []
        };

        pendingValidators.push(pending);

        var attrs = vnode.data.attrs || {};
        var childvm = vnode.componentInstance;
        if (childvm && childvm._vfValidationData_) {
          attrs = extend({}, attrs, childvm._vfValidationData_);
        }

        var propsData = vnode.componentOptions && vnode.componentOptions.propsData ? vnode.componentOptions.propsData : {};

        Object.keys(this._validators).forEach(function (validator) {
          // when value is empty and current validator is not the required validator, the field is valid
          if ((value === '' || value === undefined || value === null) && validator !== 'required') {
            _this3._setValidatorValidity(validator, true);
            emptyAndRequired = true;
            // return early, required validator will
            // fall through if it is present
            return;
          }

          var attrValue = typeof attrs[validator] !== 'undefined' ? attrs[validator] : propsData[validator];
          var isFunction = typeof _this3._validators[validator] === 'function';

          // match vue behaviour, ignore if attribute is null or undefined. But for type=email|url|number and custom validators, the value will be null, so allow with _allowNulls
          if (isFunction && (attrValue === null || typeof attrValue === 'undefined') && !_this3._validators[validator]._allowNulls) {
            return;
          }

          if (attrValue) {
            _this3.$attrs[validator] = attrValue;
          }

          var result = isFunction ? _this3._validators[validator](value, attrValue, vnode) : vm.custom[validator];

          if (typeof result === 'boolean') {
            if (result) {
              _this3._setValidatorValidity(validator, true);
            } else {
              isValid = false;
              _this3._setValidatorValidity(validator, false);
            }
          } else {
            pending.promises.push(result);
            pending.names.push(validator);
            vm.vueFormParentForm.promises.push(result);
          }
        });

        if (pending.promises.length) {
          vm.vueFormConfig.Promise.all(pending.promises).then(function (results) {

            // only concerned with the last promise results, in case
            // async responses return out of order
            if (pending !== pendingValidators[pendingValidators.length - 1]) {
              //console.log('ignoring old promise', pending.promises);
              return;
            }

            pendingValidators = [];

            results.forEach(function (result, i) {
              var name = pending.names[i];
              if (result) {
                _this3._setValidatorValidity(name, true);
              } else {
                isValid = false;
                _this3._setValidatorValidity(name, false);
              }
            });
            _this3._setValidity(isValid);
            _this3.$pending = false;
          });
        } else {
          this._setValidity(isValid);
          this.$pending = false;
        }
      }
    };

    // add custom validators
    if (this.custom) {
      Object.keys(this.custom).forEach(function (prop) {
        if (typeof _this4.custom[prop] === 'function') {
          _this4.custom[prop]._allowNulls = true;
          _this4.fieldstate._validators[prop] = _this4.custom[prop];
        } else {
          _this4.fieldstate._validators[prop] = _this4.custom[prop];
        }
      });
    }

    this.$watch('custom', function (v, oldV) {
      if (!oldV || !v) {
        return;
      }
      if (isShallowObjectDifferent(v, oldV)) {
        _this4.fieldstate._validate();
      }
    }, {
      deep: true
    });
  },
  destroyed: function destroyed() {
    this.formstate._removeControl(this.fieldstate);
  }
};

var field = {
  inject: { vueFormConfig: vueFormConfig },
  render: function render(h) {
    var foundVnodes = getVModelAndLabel(this.$slots.default, this.vueFormConfig);
    var vModelnodes = foundVnodes.vModel;
    var attrs = {
      for: null
    };
    if (vModelnodes.length) {
      if (this.autoLabel) {
        var id = vModelnodes[0].data.attrs && vModelnodes[0].data.attrs.id || 'vf' + randomId();
        vModelnodes[0].data.attrs.id = id;
        if (foundVnodes.label) {
          foundVnodes.label.data = foundVnodes.label.data || {};
          foundVnodes.label.data.attrs = foundVnodes.label.data.attrs = {};
          foundVnodes.label.data.attrs.for = id;
        } else if (this.tag === 'label') {
          attrs.for = id;
        }
      }
    }
    return h(this.tag || this.vueFormConfig.fieldTag, { attrs: attrs }, this.$slots.default);
  },

  props: {
    tag: {
      type: String
    },
    autoLabel: {
      type: Boolean,
      default: true
    }
  }
};

var debouncedValidators = {};

function addValidators(attrs, validators, fieldValidators) {
  Object.keys(attrs).forEach(function (attr) {
    var prop = attr === 'type' ? attrs[attr].toLowerCase() : attr.toLowerCase();

    if (validators[prop] && !fieldValidators[prop]) {
      fieldValidators[prop] = validators[prop];
    }
  });
}

function compareChanges(vnode, oldvnode, validators) {

  var hasChanged = false;
  var attrs = vnode.data.attrs || {};
  var oldAttrs = oldvnode.data.attrs || {};
  var out = {};

  if (vModelValue(vnode.data) !== vModelValue(oldvnode.data)) {
    out.vModel = true;
    hasChanged = true;
  }

  Object.keys(validators).forEach(function (validator) {
    if (attrs[validator] !== oldAttrs[validator]) {
      out[validator] = true;
      hasChanged = true;
    }
  });

  // if is a component
  if (vnode.componentOptions && vnode.componentOptions.propsData) {
    var _attrs = vnode.componentOptions.propsData;
    var _oldAttrs = oldvnode.componentOptions.propsData;
    Object.keys(validators).forEach(function (validator) {
      if (_attrs[validator] !== _oldAttrs[validator]) {
        out[validator] = true;
        hasChanged = true;
      }
    });
  }

  if (hasChanged) {
    return out;
  }
}

var vueFormValidator = {
  name: 'vue-form-validator',
  bind: function bind(el, binding, vnode) {
    var fieldstate = binding.value.fieldstate;
    var validators = binding.value.config.validators;

    var attrs = vnode.data.attrs || {};
    var inputName = getName(vnode);

    if (!inputName) {
      console.warn('vue-form: name attribute missing');
      return;
    }

    if (attrs.debounce) {
      debouncedValidators[fieldstate._id] = debounce(function (fieldstate, vnode) {
        if (fieldstate._hasFocused) {
          fieldstate._setDirty();
        }
        fieldstate._validate(vnode);
      }, attrs.debounce);
    }

    // add validators
    addValidators(attrs, validators, fieldstate._validators);

    // if is a component, a validator attribute could be a prop this component uses
    if (vnode.componentOptions && vnode.componentOptions.propsData) {
      addValidators(vnode.componentOptions.propsData, validators, fieldstate._validators);
    }

    fieldstate._validate(vnode);

    // native listeners
    el.addEventListener('blur', function () {
      fieldstate._setFocused(false);
    }, false);
    el.addEventListener('focus', function () {
      fieldstate._setFocused(true);
    }, false);

    // component listeners
    var vm = vnode.componentInstance;
    if (vm) {
      vm.$on('blur', function () {
        fieldstate._setFocused(false);
      });
      vm.$on('focus', function () {
        fieldstate._setFocused(true);
      });

      vm.$once('vf:addFocusListeners', function () {
        el.addEventListener('focusout', function () {
          fieldstate._setFocused(false);
        }, false);
        el.addEventListener('focusin', function () {
          fieldstate._setFocused(true);
        }, false);
      });

      vm.$on('vf:validate', function (data) {
        if (!vm._vfValidationData_) {
          addValidators(data, validators, fieldstate._validators);
        }
        vm._vfValidationData_ = data;
        fieldstate._validate(vm.$vnode);
      });
    }
  },
  update: function update(el, binding, vnode, oldVNode) {
    var validators = binding.value.config.validators;

    var changes = compareChanges(vnode, oldVNode, validators);
    var fieldstate = binding.value.fieldstate;


    var attrs = vnode.data.attrs || {};
    var vm = vnode.componentInstance;
    if (vm && vm._vfValidationData_) {
      attrs = extend({}, attrs, vm[vm._vfValidationData_]);
    }

    if (vnode.elm.className.indexOf(fieldstate._className[0]) === -1) {
      vnode.elm.className = vnode.elm.className + ' ' + fieldstate._className.join(' ');
    }

    if (!changes) {
      return;
    }

    if (changes.vModel) {
      // re-validate all
      if (attrs.debounce) {
        fieldstate.$pending = true;
        debouncedValidators[fieldstate._id](fieldstate, vnode);
      } else {
        if (fieldstate._hasFocused) {
          fieldstate._setDirty();
        }
        fieldstate._validate(vnode);
      }
    } else {
      // attributes have changed
      // to do: loop through them and re-validate changed ones
      //for(let prop in changes) {
      //  fieldstate._validate(vnode, validator);
      //}
      // for now
      fieldstate._validate(vnode);
    }
  }
};

function VueFormBase(options) {
  var _components;

  var c = extend(true, {}, config, options);
  this.provide = function () {
    return defineProperty({}, vueFormConfig, c);
  };
  this.components = (_components = {}, defineProperty(_components, c.formComponent, vueForm), defineProperty(_components, c.messagesComponent, messages), defineProperty(_components, c.validateComponent, validate), defineProperty(_components, c.fieldComponent, field), _components);
  this.directives = { vueFormValidator: vueFormValidator };
}

var VueForm = function (_VueFormBase) {
  inherits(VueForm, _VueFormBase);

  function VueForm() {
    classCallCheck(this, VueForm);
    return possibleConstructorReturn(this, (VueForm.__proto__ || Object.getPrototypeOf(VueForm)).apply(this, arguments));
  }

  createClass(VueForm, null, [{
    key: 'install',
    value: function install(Vue, options) {
      Vue.mixin(new this(options));
    }
  }, {
    key: 'installed',
    get: function get$$1() {
      return !!this.install.done;
    },
    set: function set$$1(val) {
      this.install.done = val;
    }
  }]);
  return VueForm;
}(VueFormBase);

VueFormBase.call(VueForm);
// temp fix for vue 2.3.0
VueForm.options = new VueForm();

return VueForm;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(289),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Application\\components\\BankruptcyComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] BankruptcyComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-473f445e", Component.options)
  } else {
    hotAPI.reload("data-v-473f445e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(279),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Application\\components\\ChildrenComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ChildrenComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-209cfa4b", Component.options)
  } else {
    hotAPI.reload("data-v-209cfa4b", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(283),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\FormApp\\components\\CalculatorPage.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CalculatorPage.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24ef1321", Component.options)
  } else {
    hotAPI.reload("data-v-24ef1321", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(276),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\FormApp\\components\\InteractiveForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] InteractiveForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-19d06df4", Component.options)
  } else {
    hotAPI.reload("data-v-19d06df4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(273),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\FormApp\\components\\LeadForm.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LeadForm.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-13bbf730", Component.options)
  } else {
    hotAPI.reload("data-v-13bbf730", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(285),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\FormApp\\components\\NavigationComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] NavigationComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-373f13ee", Component.options)
  } else {
    hotAPI.reload("data-v-373f13ee", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(312),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\FormApp\\components\\QuoteEditor.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] QuoteEditor.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f160186e", Component.options)
  } else {
    hotAPI.reload("data-v-f160186e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(291),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\FormApp\\components\\ThankYou.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ThankYou.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4db82745", Component.options)
  } else {
    hotAPI.reload("data-v-4db82745", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(302),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\CheckboxGroupValidator.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CheckboxGroupValidator.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7f620e68", Component.options)
  } else {
    hotAPI.reload("data-v-7f620e68", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(154),
  /* template */
  __webpack_require__(306),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\CheckboxView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CheckboxView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8b9667c4", Component.options)
  } else {
    hotAPI.reload("data-v-8b9667c4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\ContentView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ContentView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-61b1ee18", Component.options)
  } else {
    hotAPI.reload("data-v-61b1ee18", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(156),
  /* template */
  __webpack_require__(314),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\DateInputView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DateInputView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f89c1a4a", Component.options)
  } else {
    hotAPI.reload("data-v-f89c1a4a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(290),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\DropDownView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] DropDownView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-48d61a8c", Component.options)
  } else {
    hotAPI.reload("data-v-48d61a8c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(278),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\EmailInputView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EmailInputView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1ed6e92e", Component.options)
  } else {
    hotAPI.reload("data-v-1ed6e92e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(301),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\EmptyView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] EmptyView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7b859928", Component.options)
  } else {
    hotAPI.reload("data-v-7b859928", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\ExperiencePageComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ExperiencePageComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-603d973e", Component.options)
  } else {
    hotAPI.reload("data-v-603d973e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(292),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\FormComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] FormComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-53d0241a", Component.options)
  } else {
    hotAPI.reload("data-v-53d0241a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(280),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\GroupComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] GroupComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-20a48dd4", Component.options)
  } else {
    hotAPI.reload("data-v-20a48dd4", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(284),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\HelpBubbleComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] HelpBubbleComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-361b8eac", Component.options)
  } else {
    hotAPI.reload("data-v-361b8eac", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(303),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\LoadingView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] LoadingView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-827fb04a", Component.options)
  } else {
    hotAPI.reload("data-v-827fb04a", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(286),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\MoneyInputView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] MoneyInputView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3bb530c5", Component.options)
  } else {
    hotAPI.reload("data-v-3bb530c5", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(293),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\PageManager.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PageManager.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-56e95510", Component.options)
  } else {
    hotAPI.reload("data-v-56e95510", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(307),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\PhoneInputView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] PhoneInputView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8c8ac252", Component.options)
  } else {
    hotAPI.reload("data-v-8c8ac252", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(281),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\QuestionViewComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] QuestionViewComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-20db7f28", Component.options)
  } else {
    hotAPI.reload("data-v-20db7f28", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(298),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\RadioButtonView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] RadioButtonView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62ce33ac", Component.options)
  } else {
    hotAPI.reload("data-v-62ce33ac", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(277),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\ReadonlyView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ReadonlyView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1c217f9d", Component.options)
  } else {
    hotAPI.reload("data-v-1c217f9d", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(310),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\SSNInputView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SSNInputView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d7566492", Component.options)
  } else {
    hotAPI.reload("data-v-d7566492", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(294),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\SearchableDropdownView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SearchableDropdownView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-600aa80e", Component.options)
  } else {
    hotAPI.reload("data-v-600aa80e", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(282),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\SingleTileView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SingleTileView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-240a6cf1", Component.options)
  } else {
    hotAPI.reload("data-v-240a6cf1", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\SmartAddressComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SmartAddressComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6221362c", Component.options)
  } else {
    hotAPI.reload("data-v-6221362c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(275),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\SubformValidationMessageView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] SubformValidationMessageView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-15a1bff6", Component.options)
  } else {
    hotAPI.reload("data-v-15a1bff6", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(308),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\TextInputView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] TextInputView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8ff87888", Component.options)
  } else {
    hotAPI.reload("data-v-8ff87888", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(274),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\ToggleView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ToggleView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-14e9522f", Component.options)
  } else {
    hotAPI.reload("data-v-14e9522f", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(300),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\YesNoOptionView.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] YesNoOptionView.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6e30723c", Component.options)
  } else {
    hotAPI.reload("data-v-6e30723c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(299),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\businessComponents\\CoverageRecommendationResultComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] CoverageRecommendationResultComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-689051dc", Component.options)
  } else {
    hotAPI.reload("data-v-689051dc", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(313),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "C:\\Users\\shirawat\\project\\github\\5511-aigdirect-com-cbd-web-dotnet-site\\CBDirect.Web\\VueJsSrc\\Shared\\components\\businessComponents\\ExistingPolicyDetailComponent.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ExistingPolicyDetailComponent.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f67d0268", Component.options)
  } else {
    hotAPI.reload("data-v-f67d0268", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.config && _vm.showForm) ? _c('div', {
    staticClass: "multi-step-form lead-form",
    attrs: {
      "id": _vm.formKey
    }
  }, [_c('button', {
    staticClass: "form-back",
    attrs: {
      "id": "form-back"
    },
    on: {
      "click": _vm.formCloseHandler
    }
  }, [_vm._v("\n        Back\n    ")]), _vm._v(" "), _c('loading-view', {
    attrs: {
      "loading": _vm.wait,
      "message": _vm.waitMessage
    }
  }), _vm._v(" "), _c('multiStepIndicator', {
    attrs: {
      "show": _vm.formSetting && _vm.formSetting.progressBar,
      "steps": _vm.navSteps,
      "activeStep": _vm.currentStep
    }
  }), _vm._v(" "), (_vm.submissionErrors && _vm.submissionErrors.length > 0) ? _c('div', {
    staticClass: "errors validation-messages"
  }, [_c('span', [_vm._v(_vm._s(_vm.formErrorHeaderText))]), _vm._v(" "), _c('ul', _vm._l((_vm.submissionErrors), function(error) {
    return _c('li', [_vm._v("\n                " + _vm._s(error) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('formComponent', {
    attrs: {
      "questionGroups": _vm.formFieldGroups,
      "state": _vm.componentState,
      "dataBag": _vm.componentDataBag,
      "pageSchema": _vm.pageSchema,
      "config": _vm.updatedFormConfig,
      "onSubmit": _vm.handleSubmit,
      "onCancel": _vm.prev
    }
  })], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-13bbf730", module.exports)
  }
}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group toggle-view-container"
  }, [(_vm.isNotEmpty(_vm.questionData.text)) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_vm._v(_vm._s(_vm.questionData.text))]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "checkBoxControl",
    staticClass: "animated toggle-view",
    attrs: {
      "type": "checkbox",
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "title": _vm.questionData.text,
      "tabindex": _vm.questionData.tabIndex,
      "readonly": _vm.readonly,
      "aria-describedby": _vm.questionData.questionKey + '_Error'
    },
    domProps: {
      "checked": _vm.dataBag[_vm.questionData.questionKey] == _vm.YES_VALUE
    },
    on: {
      "change": function($event) {
        return _vm.changeHandler($event)
      }
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-14e9522f", module.exports)
  }
}

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('validate', {
    attrs: {
      "tag": "div"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "hidden",
    attrs: {
      "type": "text",
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "aria-describedby": _vm.questionData.questionKey + '_Error',
      "required": true
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages-sub-form",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('small', [_vm._v("\n                " + _vm._s(_vm.message) + "\n            ")]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-15a1bff6", module.exports)
  }
}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showForm) ? _c('div', {
    staticClass: "multi-step-form lead-form interactive-form page-component",
    attrs: {
      "id": _vm.formKey
    }
  }, [(_vm.closeButton) ? _c('div', {
    staticClass: "form-top-bar"
  }, [_c('button', {
    staticClass: "form-close",
    attrs: {
      "id": "form-close",
      "title": "Close"
    },
    on: {
      "click": _vm.formCloseHandler
    }
  }, [_vm._v("\n            X\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.appTitle) ? _c('richContentView', {
    staticClass: "title-bar primary-heading text-center",
    attrs: {
      "content": _vm.appTitle
    }
  }) : _vm._e(), _vm._v(" "), _c('loading-view', {
    attrs: {
      "loading": _vm.processing,
      "message": _vm.waitMessage
    }
  }), _vm._v(" "), _c('multiStepIndicator', {
    attrs: {
      "show": _vm.progressBar,
      "steps": _vm.navSteps,
      "activeStep": _vm.activeNavIndex + 1
    }
  }), _vm._v(" "), (_vm.submissionErrors && _vm.submissionErrors.length > 0) ? _c('div', {
    staticClass: "errors validation-messages"
  }, [_c('span', [_vm._v(_vm._s(_vm.formErrorHeaderText))]), _vm._v(" "), _c('ul', _vm._l((_vm.submissionErrors), function(error) {
    return _c('li', [_vm._v("\n                " + _vm._s(error) + "\n            ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('interactiveFormComponent', {
    attrs: {
      "questionGroupList": _vm.activeStepGroups,
      "state": _vm.formState,
      "dataBag": _vm.dataBag,
      "pageSchema": _vm.formSchema,
      "groupInteractionCallback": _vm.groupInteractionCallback,
      "actionBus": _vm.actionBus,
      "settings": _vm.innerSettings
    }
  }), _vm._v(" "), _c('navigation-view', {
    attrs: {
      "nextCallback": _vm.nextNavHandler,
      "prevCallback": _vm.prevNavHandler,
      "hideNext": _vm.nextNav.hide,
      "hidePrev": _vm.hidePrev,
      "processing": _vm.processing,
      "nextButtonText": _vm.nextNav.text,
      "prevButtonText": _vm.prevNav.text
    }
  })], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-19d06df4", module.exports)
  }
}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "readonly-view form-group"
  }, [(_vm.isNotEmpty(_vm.questionData.text)) ? _c('label', {
    staticClass: "field-label col-form-label",
    class: _vm.readViewLabelCss,
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_vm._v(_vm._s(_vm.questionData.text) + ":")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "field-value col-form-label",
    class: _vm.readViewValueCss
  }, [_vm._v("\n        " + _vm._s(_vm.dataBag[_vm.questionData.questionKey]) + "\n    ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1c217f9d", module.exports)
  }
}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('validate', {
    staticClass: "form-group",
    class: _vm.getValidationClassName(),
    attrs: {
      "tag": "div",
      "custom": {
        email: _vm.validateEmail
      }
    }
  }, [_c('div', {
    staticClass: "floating-label-control",
    class: _vm.getModeClass()
  }, [(_vm.isNotEmpty(_vm.questionData.text)) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_vm._v(_vm._s(_vm.questionData.text))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.dataBag[_vm.questionData.questionKey]),
      expression: "dataBag[questionData.questionKey]",
      modifiers: {
        "trim": true
      }
    }],
    ref: "emailInputRef",
    staticClass: "form-control animated",
    class: _vm.getValidationClassName(),
    attrs: {
      "type": "text",
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "title": _vm.questionData.text,
      "placeholder": _vm.placeholder,
      "aria-describedby": _vm.questionData.questionKey + '_Error',
      "required": _vm.isRequired,
      "pattern": _vm.pattern,
      "tabindex": _vm.questionData.tabIndex,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": (_vm.dataBag[_vm.questionData.questionKey])
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyHandler($event)
      },
      "blur": [_vm.blurHandler, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataBag, _vm.questionData.questionKey, $event.target.value.trim())
      }
    }
  }), _vm._v(" "), (_vm.validating) ? _c('span', {
    staticClass: "validating-indicator"
  }) : _vm._e(), _vm._v(" "), (_vm.isNotEmpty(_vm.questionData.helpText)) ? _c('small', {
    staticClass: "form-text text-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.questionData.helpText)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.readMode) ? _c('read-view', {
    attrs: {
      "questionData": _vm.questionData,
      "state": _vm.state,
      "dataBag": _vm.dataBag
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.requiredMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "pattern"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.patternMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "email"
  }, [((_vm.fieldStateTouched || _vm.submitTried) && !_vm.validating) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.emailMessage) + "\n            ")]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1ed6e92e", module.exports)
  }
}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "child-component"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 form-col"
  }, [(_vm.childs && _vm.childs.length > 0) ? _c('table', {
    staticClass: "table details-list-table table-condensed"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.childs), function(child, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('table', {
      staticClass: "table"
    }, [_vm._m(1, true), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('span', {
      staticClass: "details-list-title"
    }, [_vm._v(" Child " + _vm._s(index + 1))])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "width": "30%"
      }
    }, [_c('span', {
      staticClass: "details-list-name"
    }, [_vm._v("Age")]), _vm._v(" "), (child.childAge != 0) ? _c('span', {
      staticClass: "details-list-value"
    }, [_vm._v(_vm._s(child.childAge))]) : _vm._e(), _vm._v(" "), (child.childAge == 0) ? _c('span', {
      staticClass: "details-list-value"
    }, [_vm._v(_vm._s(_vm.lessThanOne))]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_c('button', {
      staticClass: "remove-list-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteChild(child.childAge)
        }
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon glyphicon-remove"
    }), _vm._v(" Remove\n                                        ")])])])])])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-7 form-col"
  }, [(_vm.showChildrenForm) ? _c('div', {
    staticClass: "clearfix"
  }, [((_vm.childs && _vm.childs.length == 0) && _vm.componentErrorCount == 0) ? _c('div', {
    staticClass: "validation-error-container"
  }, [_c('sub-form-validator', {
    attrs: {
      "state": _vm.state,
      "message": 'Please add at least one child.'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.componentErrorCount > 0) ? _c('div', {
    staticClass: "validation-messages-sub-form"
  }, [_c('small', {}, [_vm._v("\n                        " + _vm._s(_vm.cancelCompleteFormMessage) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('vue-form', {
    attrs: {
      "state": _vm.componentState
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, _vm._l((_vm.childFormGroups), function(item) {
    return _c('group-view', {
      key: item.key,
      attrs: {
        "groupData": item,
        "state": _vm.componentState,
        "dataBag": _vm.componentDataBag
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix button-group custom-btn-group"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSave($event)
      }
    }
  }, [_vm._v("\n                            Save\n                        ")]), _vm._v(" "), (_vm.childs.length > 0) ? _c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onCancel($event)
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (!_vm.showChildrenForm) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-secondary add-question-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onAddChild($event)
      }
    }
  }, [_vm._v("\n                        Add Child\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "form-title"
  }, [_vm._v("Do you want to fund your children's college education?")]), _vm._v(" "), _c('radio-button-view', {
    attrs: {
      "dataBag": _vm.dataBag,
      "state": _vm.state,
      "questionData": _vm.fundEducation,
      "answerChange": _vm.dummyHandler
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "sr-only"
  }, [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                            Dependent children information\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "sr-only"
  }, [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                                            Child\n                                        ")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                                            Age\n                                        ")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-209cfa4b", module.exports)
  }
}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getRootClass()
  }, [(_vm.isNotEmpty(_vm.groupData.title) && !_vm.hideGroup) ? _c('div', {
    staticClass: "form-title group-header"
  }, [_vm._v("\n        " + _vm._s(_vm.groupData.title) + "\n\n        "), _c('help-bubble', {
    attrs: {
      "helpText": _vm.groupData.helpText
    }
  }), _vm._v(" "), (_vm.groupData.editable && !_vm.editing) ? _c('span', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button",
      "title": _vm.getEditTitle()
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.groupEditHandler($event)
      }
    }
  }, [_c('img', {
    staticClass: "group-edit",
    attrs: {
      "src": "/images/new_edit_icon.svg",
      "alt": "Edit"
    }
  }), _vm._v(" Edit\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('span', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn done",
    attrs: {
      "type": "button",
      "title": "Done"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.groupEditCompleteHandler($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-ok"
  }), _vm._v(" Save\n            ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.hideGroup) ? _c('div', {
    staticClass: "group-body"
  }, [_c('div', {
    staticClass: "group-questions",
    class: _vm.groupData.questionContainerCssClass
  }, _vm._l((_vm.groupData.questions), function(rowQuestions) {
    return _c('div', {
      staticClass: "row form-row group-question-container"
    }, [_vm._l((rowQuestions), function(colQuesData) {
      return _c('div', {
        staticClass: "form-col",
        class: _vm.getQuestionColumnClass(colQuesData.colSize, rowQuestions, colQuesData.colCss)
      }, [_c('rich-content-view', {
        attrs: {
          "content": _vm.getJoinedContent(colQuesData.beforeHtml)
        }
      }), _vm._v(" "), (colQuesData.question) ? _c('question-view', {
        attrs: {
          "questionData": _vm.getQuestionData(colQuesData),
          "state": _vm.state,
          "dataBag": _vm.dataBag,
          "pageSchema": _vm.pageSchema,
          "readMode": _vm.readMode,
          "questionInteractionCallback": _vm.questionInteractionCallbackHandler
        }
      }) : _vm._e(), _vm._v(" "), (colQuesData.component) ? _c(_vm.getComponentRegisteredName(colQuesData.component.type), {
        tag: "component",
        attrs: {
          "state": _vm.state,
          "dataBag": _vm.dataBag,
          "pageSchema": _vm.pageSchema,
          "readMode": _vm.readMode,
          "dataKey": colQuesData.component.dataKey,
          "settings": colQuesData.component.settings,
          "formKey": colQuesData.component.formKey
        }
      }) : _vm._e(), _vm._v(" "), _c('rich-content-view', {
        attrs: {
          "content": _vm.getJoinedContent(colQuesData.afterHtml)
        }
      })], 1)
    }), _vm._v(" "), _vm._t("default")], 2)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "group-components",
    class: _vm.groupData.componentContainerCssClass
  }, [_c('div', {
    staticClass: "row form-row clearfix group-component-container"
  }, _vm._l((_vm.groupData.components), function(userComponent) {
    return _c('div', {
      class: _vm.getComponentContainerCss(userComponent)
    }, [(_vm.evaluateComponentCondition(userComponent.enableCondition)) ? _c(_vm.getComponentRegisteredName(userComponent.type), {
      tag: "component",
      attrs: {
        "state": _vm.state,
        "dataBag": _vm.dataBag,
        "pageSchema": _vm.pageSchema,
        "readMode": _vm.readMode,
        "dataKey": userComponent.dataKey,
        "settings": userComponent.settings,
        "formKey": userComponent.formKey
      }
    }) : _vm._e()], 1)
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20a48dd4", module.exports)
  }
}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-view",
    class: _vm.expandedClass
  }, [_c(_vm.componentName, {
    tag: "component",
    attrs: {
      "questionData": _vm.questionData.question,
      "state": _vm.state,
      "dataBag": _vm.dataBag,
      "pageSchema": _vm.pageSchema,
      "readMode": _vm.readMode,
      "answerChange": _vm.answerChangeHandler,
      "fieldInteractionCallback": _vm.fieldInteractionCallbackHandler
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slideUpDown",
      "appear": ""
    }
  }, [(_vm.visibleGroups.length > 0) ? _c('div', {
    staticClass: "question-view-group-container"
  }, _vm._l((_vm.visibleGroups), function(group) {
    return _c('group-view', {
      key: group.key,
      attrs: {
        "groupData": _vm.getUpdatedGroup(group),
        "state": _vm.state,
        "dataBag": _vm.dataBag,
        "pageSchema": _vm.pageSchema
      }
    })
  }), 1) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-20db7f28", module.exports)
  }
}

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('validate', {
    staticClass: "single-tile",
    attrs: {
      "tag": "div"
    }
  }, [_c('label', {
    class: _vm.selectedClass,
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_c('input', {
    ref: "checkBoxControl",
    staticClass: "animated",
    class: _vm.getValidationClassName(),
    attrs: {
      "type": "checkbox",
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "required": _vm.isRequired,
      "title": _vm.questionData.text,
      "aria-describedby": _vm.questionData.questionKey + '_Error'
    },
    domProps: {
      "checked": _vm.dataBag[_vm.questionData.questionKey] == _vm.YES_VALUE
    },
    on: {
      "change": function($event) {
        return _vm.changeHandler($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "focus"
  }), _vm._v(" "), _c('span', {
    staticClass: "tile-unselect"
  }, [_vm._v("Unselect")]), _vm._v(" "), _c('span', {
    staticClass: "control-indicator"
  }, [_vm._v(_vm._s(_vm.questionData.text))]), _vm._v(" "), _c('span', {
    staticClass: "descriptionText"
  }, [_vm._v(_vm._s(_vm.questionData.descriptionText))]), _vm._v(" "), (_vm.keyCode) ? _c('span', {
    staticClass: "tile-keyCode"
  }, [_vm._v(_vm._s(_vm.keyCode))]) : _vm._e()]), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('small', [_vm._v("\n                " + _vm._s(_vm.requiredMessage) + "\n            ")]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-240a6cf1", module.exports)
  }
}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multi-step-form lead-form interactive-form page-component"
  }, [(_vm.formSchema) ? _c('calculatorComponent', {
    attrs: {
      "state": _vm.componentState,
      "dataBag": _vm.componentDataBag,
      "pageSchema": _vm.formSchema,
      "dataKey": _vm.settings.dataKey,
      "settings": _vm.settings,
      "useCoverageCallback": _vm.useCoverageHandler,
      "formKey": _vm.settings.formKey
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-24ef1321", module.exports)
  }
}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.helpText !== undefined && _vm.helpText !== null && _vm.helpText !== '') ? _c('span', {
    staticClass: "help-bubble",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": _vm.helpText
    }
  }, [_vm._v("\n    " + _vm._s(_vm.helpText) + "\n")]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-361b8eac", module.exports)
  }
}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row navigation action-btn-nav"
  }, [(!_vm.hideNext) ? _c('div', {
    staticClass: "col-sm-push-6 col-sm-6 float-right"
  }, [(!_vm.processing) ? _c('button', {
    staticClass: "btn btn-primary center-block",
    attrs: {
      "id": "btnNext",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.nextText) + " "), _c('span', {
    staticClass: "icon icon-next"
  })]) : _vm._e(), _vm._v(" "), (_vm.processing) ? _c('button', {
    staticClass: "btn btn-primary center-block",
    attrs: {
      "id": "btnNext",
      "type": "button"
    }
  }, [_vm._v("\n            Processing  \n            "), _c('i', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate next-load-glyph"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.hidePrev) ? _c('div', {
    staticClass: "col-sm-6",
    class: {
      'col-sm-pull-6': !_vm.hidePrev
    }
  }, [_c('button', {
    staticClass: "btn btn-text btn-previous",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prev($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-prev"
  }), _vm._v(_vm._s(_vm.prevText) + "\n        ")])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-373f13ee", module.exports)
  }
}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('validate', {
    staticClass: "form-group",
    class: _vm.getValidationClassName(),
    attrs: {
      "tag": "div",
      "custom": {
        maxValue: _vm.validateMaxValue
      }
    }
  }, [_c('div', {
    staticClass: "floating-label-control"
  }, [(_vm.isNotEmpty(_vm.questionData.text)) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_vm._v(_vm._s(_vm.questionData.text))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.dataBag[_vm.questionData.questionKey]),
      expression: "dataBag[questionData.questionKey]",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.moneyOption),
      expression: "moneyOption"
    }],
    ref: "moneyInputRef",
    staticClass: "form-control animated",
    class: _vm.getValidationClassName(),
    attrs: {
      "type": "text",
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "title": _vm.questionData.text,
      "placeholder": _vm.placeholder,
      "required": _vm.isRequired,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "tabindex": _vm.questionData.tabIndex,
      "readonly": _vm.readonly,
      "aria-describedby": _vm.questionData.questionKey + '_Error'
    },
    domProps: {
      "value": (_vm.dataBag[_vm.questionData.questionKey])
    },
    on: {
      "blur": [function($event) {
        return _vm.blurHandler($event)
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "change": function($event) {
        _vm.$set(_vm.dataBag, _vm.questionData.questionKey, $event.target.value.trim())
      }
    }
  }), _vm._v(" "), (_vm.isNotEmpty(_vm.questionData.helpText)) ? _c('small', {
    staticClass: "form-text text-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.questionData.helpText)
    }
  }) : _vm._e()]), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.requiredMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "minlength"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.minlengthMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "maxlength"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.maxlengthMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "maxValue"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.maxValueMessage) + "\n            ")]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3bb530c5", module.exports)
  }
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "talk-to-agent"
  }, [_c('loading-view', {
    attrs: {
      "loading": _vm.processing,
      "message": _vm.callStatus
    }
  }), _vm._v(" "), (_vm.showForm) ? _c('formComponent', {
    attrs: {
      "questionGroups": _vm.renderGroups,
      "state": _vm.componentState,
      "dataBag": _vm.componentDataBag,
      "pageSchema": _vm.pageSchema,
      "config": _vm.formUIConfig,
      "onSubmit": _vm.callNowHandler,
      "onCancel": _vm.cancelHandler
    }
  }) : _vm._e(), _vm._v(" "), (_vm.thankMessage) ? _c('div', {
    staticClass: "thank-syou",
    domProps: {
      "innerHTML": _vm._s(_vm.thankMessage)
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4120d584", module.exports)
  }
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showContainer) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.displayContent)
    }
  }) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-44858ec8", module.exports)
  }
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bankruptcy-component"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "col-sm-12 form-col"
  }, [(_vm.bankruptcies && _vm.bankruptcies.length > 0) ? _c('table', {
    staticClass: "table details-list-table table-condensed"
  }, [_c('tbody', _vm._l((_vm.bankruptcies), function(bankruptcy, index) {
    return _c('tr', [_c('td', [_c('table', {
      staticClass: "table"
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('span', {
      staticClass: "details-list-title"
    }, [_vm._v("Bankruptcy " + _vm._s(index + 1))])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "width": "30%"
      }
    }, [_c('span', {
      staticClass: "details-list-name"
    }, [_vm._v("Type")]), _vm._v(" "), _c('span', {
      staticClass: "details-list-value"
    }, [_vm._v("Chapter " + _vm._s(bankruptcy.bankruptcyChapterFiled))])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_c('span', {
      staticClass: "details-list-name"
    }, [_vm._v("Date")]), _vm._v(" "), _c('span', {
      staticClass: "details-list-value"
    }, [_vm._v(_vm._s(bankruptcy.bankruptcyFileMonth) + "/" + _vm._s(bankruptcy.bankruptcyFileYear))])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_c('button', {
      staticClass: "remove-list-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteBankruptcy(bankruptcy.key)
        }
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon glyphicon-remove"
    }), _vm._v(" Remove\n                                        ")])])])])])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-col"
  }, [(_vm.showBankruptcyForm) ? _c('div', {
    staticClass: "clearfix"
  }, [((_vm.bankruptcies && _vm.bankruptcies.length == 0) && _vm.componentErrorCount == 0) ? _c('div', {
    staticClass: "validation-error-container"
  }, [_c('sub-form-validator', {
    attrs: {
      "state": _vm.state,
      "message": 'Please add at least one bankruptcy.'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.componentErrorCount > 0) ? _c('div', {
    staticClass: "validation-messages-sub-form"
  }, [_c('small', {}, [_vm._v("\n                        " + _vm._s(_vm.cancelCompleteFormMessage) + "\n                    ")])]) : _vm._e(), _vm._v(" "), _c('vue-form', {
    attrs: {
      "state": _vm.componentState
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, _vm._l((_vm.formGroups), function(group) {
    return _c('group-view', {
      key: group.key,
      attrs: {
        "groupData": group,
        "state": _vm.componentState,
        "dataBag": _vm.componentDataBag
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix button-group custom-btn-group"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSave($event)
      }
    }
  }, [_vm._v("\n                            Save\n                        ")]), _vm._v(" "), (_vm.bankruptcies.length > 0) ? _c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onCancel($event)
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (!_vm.showBankruptcyForm) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-secondary add-question-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onAddBankruptcy($event)
      }
    }
  }, [_vm._v("Add Bankruptcy")])])]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-473f445e", module.exports)
  }
}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('validate', {
    staticClass: "form-group",
    class: _vm.getValidationClassName(),
    attrs: {
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "floating-label-control custom-select",
    class: _vm.getModeClass()
  }, [(_vm.isNotEmpty(_vm.questionData.text)) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_vm._v(_vm._s(_vm.questionData.text))]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataBag[_vm.questionData.questionKey]),
      expression: "dataBag[questionData.questionKey]"
    }],
    ref: "dropdownRef",
    staticClass: "form-control animated",
    class: _vm.getValidationClassName(),
    attrs: {
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "title": _vm.questionData.text,
      "placeholder": _vm.questionData.text,
      "aria-describedby": _vm.questionData.questionKey + '_Error',
      "required": _vm.isRequired,
      "tabindex": _vm.questionData.tabIndex,
      "disabled": _vm.readonly
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dataBag, _vm.questionData.questionKey, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.changeHandler]
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.selectOption.value
    }
  }, [_vm._v(_vm._s(_vm.selectOption.text))]), _vm._v(" "), (_vm.hasOptionGroups) ? _vm._l((_vm.optionGroups), function(group) {
    return _c('optgroup', {
      attrs: {
        "label": group
      }
    }, _vm._l((_vm.getGroupOptions(group)), function(option) {
      return _c('option', {
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\n                        " + _vm._s(_vm.optionTextPrefix + option.text) + "\n                    ")])
    }), 0)
  }) : _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(_vm.optionTextPrefix + option.text))])
  })], 2), _vm._v(" "), (_vm.isNotEmpty(_vm.questionData.helpText)) ? _c('small', {
    staticClass: "form-text text-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.questionData.helpText)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.readMode) ? _c('read-view', {
    attrs: {
      "questionData": _vm.questionData,
      "state": _vm.state,
      "dataBag": _vm.dataBag
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.requiredMessage) + "\n            ")]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-48d61a8c", module.exports)
  }
}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thank-you-container"
  }, [(_vm.dataBag.showRegularThankYou) ? _c('div', {
    staticClass: "container regular-section",
    domProps: {
      "innerHTML": _vm._s(_vm.dataBag.regularBody)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showConsentForm && _vm.dataBag.showConsentThankYou) ? _c('div', {
    staticClass: "container consent-section",
    attrs: {
      "id": "consentThankYou"
    }
  }, [(_vm.showConsentUI) ? _c('div', {
    staticClass: "aigd-new-thank-you"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.dataBag.consentBody)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "consent-thank-you aigd-new-thank-you"
  }, [_c('div', {
    staticClass: "call-me-form"
  }, [_c('callMeNowComponent', {
    attrs: {
      "state": _vm.state,
      "dataBag": _vm.dataBag,
      "pageSchema": _vm.pageSchema,
      "dataKey": _vm.dataKey,
      "settings": _vm.settings,
      "formKey": _vm.formKey,
      "submitSuccessCallback": _vm.submitSuccessCallbackHandler
    }
  })], 1), _vm._v(" "), (_vm.showConsentUI) ? _c('div', {
    staticClass: "horizontal-divider"
  }, [_c('span', [_vm._v("OR")])]) : _vm._e(), _vm._v(" "), (_vm.showConsentUI) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.dataBag.consentOrBody)
    }
  }, [_vm._v(">")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.dataBag.showSelfFulfillingThankYou) ? _c('div', {
    staticClass: "container self-fullfilling-section",
    domProps: {
      "innerHTML": _vm._s(_vm.dataBag.selfFulfillingBody)
    }
  }) : _vm._e(), _vm._v(" "), _c('loading-view', {
    attrs: {
      "loading": _vm.processing,
      "message": _vm.dataBag.overlayMessageBody
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4db82745", module.exports)
  }
}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-form', {
    attrs: {
      "state": _vm.componentState
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, _vm._l((_vm.formGroups), function(group) {
    return _c('group-view', {
      key: group.key,
      attrs: {
        "groupData": group,
        "state": _vm.componentState,
        "dataBag": _vm.componentDataBag,
        "pageSchema": _vm.pageSchema
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    class: _vm.combinedConfig.buttonContainer.cssClass
  }, [(_vm.combinedConfig.submitButton.show) ? _c('button', {
    class: _vm.combinedConfig.submitButton.cssClass,
    attrs: {
      "type": "submit",
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitHandler($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getButtonText(_vm.combinedConfig.submitButton)) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.combinedConfig.cancelButton.show) ? _c('button', {
    class: _vm.combinedConfig.cancelButton.cssClass,
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onCancel($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getButtonText(_vm.combinedConfig.cancelButton)) + "\n        ")]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-53d0241a", module.exports)
  }
}

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row experience-page-container"
  }, [(_vm.experiencePage) ? _c('experience-page', {
    key: _vm.experiencePage.key,
    attrs: {
      "groups": _vm.experiencePage.groups,
      "state": _vm.state,
      "dataBag": _vm.dataBag,
      "transitionName": _vm.experiencePage.transitionName,
      "renderMode": _vm.experiencePage.renderMode,
      "pageSchema": _vm.pageSchema
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-56e95510", module.exports)
  }
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchable-list"
  }, [_c('div', {
    staticClass: "floating-label-control"
  }, [(_vm.isNotEmpty(_vm.questionData.text)) ? _c('label', {
    staticClass: "control-label v-custom-select-label",
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_vm._v(_vm._s(_vm.questionData.text))]) : _vm._e(), _vm._v(" "), _c('v-select', {
    staticClass: "form-control animated v-custom-select",
    class: _vm.getValidationClassName(),
    attrs: {
      "id": _vm.questionData.questionKey + '_select',
      "name": _vm.questionData.questionKey + '_select',
      "title": _vm.questionData.text,
      "debounce": 250,
      "options": _vm.options,
      "aria-describedby": _vm.questionData.questionKey + '_Error',
      "label": _vm.optionLabelField,
      "reduce": _vm.reduce,
      "placeholder": _vm.questionData.placeholder
    },
    on: {
      "input": _vm.changeHandler,
      "search:blur": _vm.searchBlurHandler,
      "search": _vm.searchOptions
    },
    model: {
      value: (_vm.dataBag[_vm.questionData.questionKey]),
      callback: function($$v) {
        _vm.$set(_vm.dataBag, _vm.questionData.questionKey, $$v)
      },
      expression: "dataBag[questionData.questionKey]"
    }
  })], 1), _vm._v(" "), _c('validate', {
    staticClass: "form-group select-picker",
    class: _vm.getValidationClassName(),
    attrs: {
      "tag": "div"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataBag[_vm.questionData.questionKey]),
      expression: "dataBag[questionData.questionKey]"
    }],
    ref: "hid",
    staticClass: "shadow-input",
    attrs: {
      "type": "text",
      "tabindex": "-1",
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "required": _vm.isRequired
    },
    domProps: {
      "value": (_vm.dataBag[_vm.questionData.questionKey])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataBag, _vm.questionData.questionKey, $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages v-custom-select-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.state.$submitted) ? _c('div', [_vm._v("\n                    " + _vm._s(_vm.requiredMessage) + "\n                ")]) : _vm._e()])], 2)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-600aa80e", module.exports)
  }
}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "experience-page",
    class: _vm.pageCss
  }, [(_vm.isReplaceMode) ? _c('transition', {
    class: _vm.transitionClass,
    attrs: {
      "mode": "out-in",
      "name": _vm.transitionName,
      "tag": "div"
    }
  }, [(_vm.activeGroup) ? _c('group-view', {
    key: _vm.activeGroup.groupKey,
    attrs: {
      "groupData": _vm.activeGroup,
      "state": _vm.state,
      "dataBag": _vm.dataBag,
      "pageSchema": _vm.pageSchema,
      "lastFormFieldInteractionCallback": _vm.groupLastFormFieldInteractionHandler
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isReplaceMode) ? _c('transition-group', {
    class: _vm.transitionClass,
    attrs: {
      "name": _vm.transitionName,
      "tag": "div"
    }
  }, _vm._l((_vm.renderableGroups), function(group) {
    return _c('group-view', {
      key: group.groupKey,
      attrs: {
        "groupData": group,
        "state": _vm.state,
        "dataBag": _vm.dataBag,
        "pageSchema": _vm.pageSchema,
        "lastFormFieldInteractionCallback": _vm.groupLastFormFieldInteractionHandler
      }
    })
  }), 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-603d973e", module.exports)
  }
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isNotEmpty(_vm.text)) ? _c('rich-content-view', {
    staticClass: "content-view",
    attrs: {
      "content": _vm.text
    }
  }) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61b1ee18", module.exports)
  }
}

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "address-containter row form-row"
  }, [(_vm.dataKeyParsed) ? _c('div', {
    staticClass: "col-sm-12 form-col"
  }, _vm._l((_vm.addressQuestionGroups), function(group) {
    return _c('group-view', {
      key: group.key,
      attrs: {
        "groupData": _vm.getUpdatedGroup(group),
        "state": _vm.state,
        "dataBag": _vm.dataBag,
        "formFieldInteractionCallback": _vm.fieldInteractionCallbackHandler
      }
    })
  }), 1) : _vm._e()]), _vm._v(" "), (_vm.showAddressPopup) ? _c('vue-form', {
    attrs: {
      "state": _vm.componentState
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "modal my-modal address-modal",
    attrs: {
      "id": _vm.addressModalPopupId,
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "addressModalpopupTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-dialog-centered",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "addressModalpopupTitle"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign text-error",
    staticStyle: {
      "vertical-align": "middle",
      "top": "-1px",
      "background": "#fff",
      "border-radius": "50%",
      "padding": "3px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error-title"
  }, [_vm._v("  Attention - " + _vm._s(_vm.addressTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.dataKeyParsed) ? _c('div', {
    ref: "addressContainer",
    staticClass: "clearfix"
  }, [_c('h4', [_vm._v("\n                                Please make sure you have entered all address information as completely as possible.\n                                This includes any apartment, suite, or unit numbers.\n                            ")]), _vm._v(" "), _vm._l((_vm.componentAddressQuestionGroups), function(group) {
    return _c('group-view', {
      key: group.key,
      attrs: {
        "groupData": group,
        "state": _vm.componentState,
        "dataBag": _vm.componentDataBag,
        "formFieldInteractionCallback": _vm.fieldInteractionCallbackHandler
      }
    })
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "address-containter-modal hide"
  }, [_vm._v("\n        " + _vm._s(_vm.componentDataBag) + "\n        " + _vm._s(_vm.componentAddressQuestionGroups) + "\n    ")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6221362c", module.exports)
  }
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('validate', {
    staticClass: "form-group radio-btn-group",
    class: _vm.getValidationClassName(),
    attrs: {
      "tag": "fieldset"
    }
  }, [_c('div', {
    staticClass: "radio-btn-container",
    class: _vm.getModeClass()
  }, [(_vm.isNotEmpty(_vm.questionData.text)) ? _c('legend', {
    staticClass: "sr-only",
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_vm._v(_vm._s(_vm.questionData.text))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix field animated",
    class: _vm.getValidationClassName()
  }, _vm._l((_vm.options), function(option) {
    return _c('label', {
      staticClass: "radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dataBag[_vm.questionData.questionKey]),
        expression: "dataBag[questionData.questionKey]"
      }],
      ref: "radioInput",
      refInFor: true,
      attrs: {
        "type": "radio",
        "id": _vm.questionData.questionKey + '_' + option.value,
        "name": _vm.questionData.questionKey,
        "title": option.text,
        "aria-describedby": _vm.questionData.questionKey + '_Error',
        "required": option.disabled ? false : _vm.isRequired,
        "tabindex": _vm.questionData.tabIndex,
        "disabled": option.disabled
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.dataBag[_vm.questionData.questionKey], option.value)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.dataBag, _vm.questionData.questionKey, option.value)
        }, _vm.changeHandler]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "control-indicator",
      class: _vm.getOptionCssClass(option),
      attrs: {
        "title": option.disabled ? option.helpText : ''
      }
    }, [_vm._v("\n                    " + _vm._s(option.text) + "\n                    "), (option.helpText) ? _c('div', {
      staticClass: "help",
      domProps: {
        "innerHTML": _vm._s(option.helpText)
      }
    }) : _vm._e()])])
  }), 0)]), _vm._v(" "), (_vm.readMode) ? _c('read-view', {
    attrs: {
      "questionData": _vm.questionData,
      "state": _vm.state,
      "dataBag": _vm.dataBag
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.requiredMessage) + "\n            ")]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-62ce33ac", module.exports)
  }
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.recommendationEngineData) ? _c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "accordion-Recommondations",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel-collapse coverageterm-collapse collapse",
    attrs: {
      "id": "collapseOne",
      "role": "tabpanel",
      "aria-labelledby": "headingOne",
      "aria-expanded": "true"
    }
  }, [_vm._t("default", [(_vm.showHeader) ? _c('div', {
    staticClass: "panel-heading coveragepage-QuoteInfo",
    attrs: {
      "role": "tab",
      "id": "Recommendation-heading"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6 text-right"
  }, [_c('p', {
    staticClass: "sheet-QuoteEntry"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.estimatedAmount))])])])]), _vm._v(" "), (_vm.showTerm) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6 text-right"
  }, [_c('p', {
    staticClass: "sheet-QuoteEntry"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.termLength) + " Years")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.showCancelButton) ? _c('div', {
    staticClass: "col-md-offset-8 col-xs-offset-6 col-md-4 col-xs-6"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-warning m-t22 btn-no",
    attrs: {
      "type": "button",
      "title": "No, I will use my own"
    },
    on: {
      "click": _vm.cancelHandler
    }
  }, [_vm._v("\n                                No, I will use my own\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.showSelectButton) ? _c('div', {
    staticClass: "col-md-offset-8 col-xs-offset-6 col-md-4 col-xs-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-warning m-t22 btn-yes",
    attrs: {
      "type": "button",
      "title": "Use this coverage"
    },
    on: {
      "click": _vm.selectCoverageHandler
    }
  }, [_vm._v("\n                                Use this coverage\n                            ")])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel recommdationsheet"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body nopadding"
  }, [_c('p', {
    staticClass: "b-bottom b-top sheetHeading"
  }, [_vm._v("Your Needs")]), _vm._v(" "), _c('p', {
    staticClass: "sheetSubheading"
  }, [_vm._v("Immediate Cash Needs")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.finalExpenseAmount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Emergency Fund (" + _vm._s(_vm.recommendationEngineData.recommendationsConfig.monthsOfHouseholdForEmergency) + " Months of Household Income):")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.emergencyFund))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.mortgagePayOff))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.addlDebtPayOff))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.totalCashNeeds))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "sheetSubheading"
  }, [_vm._v("Amount Necessary to Fund Income Needs (Invested at a Balanced, Conservative " + _vm._s(_vm.recommendationEngineData.recommendationsConfig.investmentReturnRate * 100) + "%)")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Survivor Income Needs with Children (" + _vm._s(_vm.recommendationEngineData.recommendationsConfig.percentIncomeNeedPerHouseholdWithKids * 100) + "% of the Household Income)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.lumpSurvIncNeedWithKids))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Survivor Income Needs for Empty Nest(" + _vm._s(_vm.recommendationEngineData.recommendationsConfig.percentIncomeNeedPerHouseholdWithoutKids * 100) + "% of Household Income)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.lumpSurvIncNeedEmptyNest))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Children's Education Needs (" + _vm._s(_vm.recommendationEngineData.recommendationsConfig.collegeCostPerYear) + "/year x 4 Years for Each Child):")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.lumpEducNeedTotal))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.totalIncomeNeeds))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4 text-right nopadding"
  }, [_c('p', {
    staticClass: "sheetBoldEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.totalNeeds))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "b-bottom b-top sheetHeading margin-top-bottom"
  }, [_vm._v("Your Income and Asset Sources")]), _vm._v(" "), _c('p', {
    staticClass: "sheetSubheading"
  }, [_vm._v("Lump Sum Value of Income Sources (Invested at a Balanced, Conservative " + _vm._s(_vm.recommendationEngineData.recommendationsConfig.investmentReturnRate * 100) + "%)")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.totalLumpSumSurvBen))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.totalLumpSumRetBen))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.lumpSpouseIncome))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.totalLumpAllIncome))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "sheetSubheading"
  }, [_vm._v("Existing Assets and Life Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.invAssets))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-offset-1 col-md-offset-0 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.totalInsurance))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.totalAssetsInsurance))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetBoldEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.totalIncomeAssets))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "sheetHeading"
  }, [_vm._v("Your Result")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(17), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4 text-right"
  }, [_c('p', {
    staticClass: "sheetBoldEntry"
  }, [_c('span', {
    staticClass: "pull-left"
  }), _c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.resultsRaw))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sheetpanel panel-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6 text-right"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.recommendationEngineData.resultsRounded))])])])])])])])])], 2)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-6 text-left"
  }, [_c('p', {
    staticClass: "sheet-QuoteEntry"
  }, [_vm._v("Your estimated coverage amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-6 text-left"
  }, [_c('p', {
    staticClass: "sheet-QuoteEntry"
  }, [_vm._v("Calculated Term length:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading",
    attrs: {
      "role": "tab",
      "id": "headingOne"
    }
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#collapseOne",
      "aria-expanded": "true",
      "aria-controls": "collapseOne"
    }
  }, [_vm._v("\n                                YOUR SURVIVOR NEEDS ANALYSIS RESULTS\n                            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Final Expenses:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Mortgage Payoff:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Additional Debt Payoff:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Total Immediate Cash Needs:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-8 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Total Income Needs:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-8 text-left"
  }, [_c('p', {
    staticClass: "sheetBoldEntry"
  }, [_vm._v("Total Needs:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Social Security Survivor Benefits (Includes Parent and Child Benefits)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Social Security Retirement Benefits for Surviving Spouse")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Surviving Spouse's Earnings (Until Retirement at Age 67):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-8 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Total Income Sources:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Available Financial/Investment Assets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-7 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Current Life Insurance Policies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-8 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Total Assets and Life Insurance:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-8 text-left"
  }, [_c('p', {
    staticClass: "sheetBoldEntry"
  }, [_vm._v("Total Income and Asset Sources:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-8 text-left"
  }, [_c('p', {
    staticClass: "sheetBoldEntry"
  }, [_vm._v("Shortfall (Needs Minus Sources)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-9 col-xs-6 text-left"
  }, [_c('p', {
    staticClass: "sheetEntry"
  }, [_vm._v("Your Estimated Additional Insurance Needs: (Rounded Shortfall)")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-689051dc", module.exports)
  }
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('validate', {
    attrs: {
      "tag": "div"
    }
  }, [_c('fieldset', {
    staticClass: "drill-down-question"
  }, [_c('legend', {
    staticClass: "control-label"
  }, [_vm._v("\n            " + _vm._s(_vm.questionData.text) + "\n\n            "), (_vm.isNotEmpty(_vm.questionData.helpText)) ? _c('span', {
    staticClass: "help-bubble",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": _vm.questionData.helpText
    }
  }, [_vm._v("\n                " + _vm._s(_vm.questionData.helpText) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "drill-down-radio clearfix field animated",
    class: _vm.getValidationClassName()
  }, _vm._l((_vm.options), function(option) {
    return _c('label', {
      staticClass: "radio"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.dataBag[_vm.questionData.questionKey]),
        expression: "dataBag[questionData.questionKey]"
      }],
      attrs: {
        "type": "radio",
        "id": _vm.questionData.questionKey + '_' + option.value,
        "name": _vm.questionData.questionKey,
        "required": _vm.isRequired,
        "title": option.text,
        "readonly": _vm.readonly,
        "aria-describedby": _vm.questionData.questionKey + '_Error'
      },
      domProps: {
        "value": option.value,
        "checked": _vm._q(_vm.dataBag[_vm.questionData.questionKey], option.value)
      },
      on: {
        "change": [function($event) {
          return _vm.$set(_vm.dataBag, _vm.questionData.questionKey, option.value)
        }, _vm.changeHandler]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "control-indicator",
      class: option.iconClass
    }, [_vm._v(_vm._s(option.text))])])
  }), 0)]), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.requiredMessage) + "\n            ")]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6e30723c", module.exports)
  }
}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "empty-content-view"
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7b859928", module.exports)
  }
}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox-group-validator"
  }, [(_vm.isRequired && _vm.questionData.groupName) ? _c('validate', {
    attrs: {
      "tag": "div"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "hidden",
    attrs: {
      "type": "text",
      "id": _vm.questionData.groupName,
      "name": _vm.questionData.groupName,
      "required": _vm.isRequired
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages-sub-form",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.groupName
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.groupStateTouched || _vm.submitTried) ? _c('small', [_vm._v("\n                    " + _vm._s(_vm.requiredMessage) + "\n                ")]) : _vm._e()])], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7f620e68", module.exports)
  }
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "loading-message-wrapper"
  }, [_c('div', {
    staticClass: "loading-message-container"
  }, [_c('rich-content-view', {
    attrs: {
      "content": _vm.message
    }
  }), _vm._v(" "), _vm._m(0)], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "circle"
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-827fb04a", module.exports)
  }
}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('ul', {
    staticClass: "form-stepper form-stepper-horizontal text-center mx-auto pl-0"
  }, _vm._l((_vm.navSteps), function(stp, index) {
    return _c('li', {
      key: stp.title,
      class: _vm.stepProgressBarClass(index),
      attrs: {
        "step": index + 1
      }
    }, [_c('a', {
      staticClass: "mx-2"
    }, [_c('span', {
      staticClass: "step-icon",
      class: stp.iconClass
    }), _vm._v(" "), _c('div', {
      staticClass: "label"
    }, [_vm._v(_vm._s(stp.title))]), _vm._v(" "), _c('span', {
      class: [{
        'text-muted': (index + 1) == _vm.activeStep
      }, 'form-stepper-circle']
    })])])
  }), 0) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-83dbe44c", module.exports)
  }
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interactive-form page-component"
  }, [_c('div', {
    staticClass: "form-body"
  }, [(_vm.showTabNavigation && _vm.tabNavLinks.length > 0) ? _c('ul', {
    staticClass: "form-tab-nav"
  }, _vm._l((_vm.tabNavLinks), function(tabNav) {
    return _c('li', {
      class: {
        'completed': tabNav.index < _vm.currentGroupIndex, 'active': tabNav.index == _vm.currentGroupIndex
      }
    }, [_c('button', {
      attrs: {
        "type": "button",
        "title": tabNav.linkTitle
      },
      on: {
        "click": function($event) {
          return _vm.selectGroup(tabNav.index)
        }
      }
    }, [_vm._v("\n                    " + _vm._s(tabNav.linkTitle) + "\n                ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('vue-form', {
    attrs: {
      "state": _vm.state
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('transition', {
    class: _vm.transitionClass,
    attrs: {
      "tag": "div",
      "mode": "out-in",
      "name": _vm.transitionName
    }
  }, [(_vm.modifiedActiveGroup) ? _c('group-view', {
    key: _vm.modifiedActiveGroup.groupKey,
    attrs: {
      "groupData": _vm.modifiedActiveGroup,
      "state": _vm.state,
      "dataBag": _vm.dataBag,
      "pageSchema": _vm.pageSchema,
      "formFieldInteractionCallback": _vm.formFieldInteractionCallback
    }
  }) : _vm._e()], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8aab0372", module.exports)
  }
}

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox"
  }, [_c('validate', {
    attrs: {
      "tag": "div"
    }
  }, [_c('label', {
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_c('input', {
    ref: "checkBoxControl",
    staticClass: "animated",
    class: _vm.getValidationClassName(),
    attrs: {
      "type": "checkbox",
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "title": _vm.questionData.text,
      "required": _vm.isRequired,
      "tabindex": _vm.questionData.tabIndex,
      "readonly": _vm.readonly,
      "aria-describedby": _vm.questionData.questionKey + '_Error'
    },
    domProps: {
      "checked": _vm.dataBag[_vm.questionData.questionKey] == _vm.YES_VALUE
    },
    on: {
      "change": function($event) {
        return _vm.changeHandler($event)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "control-indicator"
  }, [_vm._v(_vm._s(_vm.questionData.text))]), _vm._v(" "), (_vm.isNotEmpty(_vm.questionData.helpText)) ? _c('span', {
    staticClass: "help-bubble",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.questionData.helpText) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                    " + _vm._s(_vm.requiredMessage) + "\n                ")]) : _vm._e()])], 2)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8b9667c4", module.exports)
  }
}

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('validate', {
    staticClass: "form-group large-validation",
    class: _vm.getValidationClassName(),
    attrs: {
      "tag": "div",
      "custom": {
        phone: _vm.validatePhone
      }
    }
  }, [_c('div', {
    staticClass: "floating-label-control",
    class: _vm.getModeClass()
  }, [(_vm.isNotEmpty(_vm.questionData.text)) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_vm._v(_vm._s(_vm.questionData.text))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.dataBag[_vm.questionData.questionKey]),
      expression: "dataBag[questionData.questionKey]",
      modifiers: {
        "trim": true
      }
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.maskFormat),
      expression: "maskFormat"
    }],
    ref: "phoneInput",
    staticClass: "form-control animated",
    class: _vm.getValidationClassName(),
    attrs: {
      "type": "text",
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "placeholder": _vm.placeholder,
      "title": _vm.questionData.text,
      "required": _vm.isRequired,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "pattern": _vm.pattern,
      "tabindex": _vm.questionData.tabIndex,
      "readonly": _vm.readonly,
      "aria-describedby": _vm.questionData.questionKey + '_Error'
    },
    domProps: {
      "value": (_vm.dataBag[_vm.questionData.questionKey])
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyHandler($event)
      },
      "focus": _vm.focusHandler,
      "blur": [_vm.blurHandler, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataBag, _vm.questionData.questionKey, $event.target.value.trim())
      }
    }
  }), _vm._v(" "), (_vm.validating) ? _c('span', {
    staticClass: "validating-indicator"
  }) : _vm._e(), _vm._v(" "), (_vm.isNotEmpty(_vm.questionData.helpText)) ? _c('small', {
    staticClass: "form-text text-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.questionData.helpText)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.readMode) ? _c('read-view', {
    attrs: {
      "questionData": _vm.questionData,
      "state": _vm.state,
      "dataBag": _vm.dataBag
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', {
    staticClass: "required-msg"
  }, [_vm._v("\n                " + _vm._s(_vm.requiredMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "minlength"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', {
    staticClass: "minlength-msg"
  }, [_vm._v("\n                " + _vm._s(_vm.minlengthMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "maxlength"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', {
    staticClass: "maxlength-msg"
  }, [_vm._v("\n                " + _vm._s(_vm.maxlengthMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "pattern"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', {
    staticClass: "pattern-msg"
  }, [_vm._v("\n                " + _vm._s(_vm.patternMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "phone"
  }, [((_vm.fieldStateTouched || _vm.submitTried) && !_vm.validating) ? _c('div', {
    staticClass: "phone-msg"
  }, [_vm._v("\n                " + _vm._s(_vm.phoneMessage) + "\n            ")]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8c8ac252", module.exports)
  }
}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('validate', {
    staticClass: "form-group",
    class: _vm.getValidationClassName(),
    attrs: {
      "tag": "div",
      "custom": {
        compare: _vm.compareValidator
      }
    }
  }, [_c('div', {
    staticClass: "floating-label-control",
    class: _vm.getModeClass()
  }, [(_vm.isNotEmpty(_vm.questionData.text)) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_vm._v(_vm._s(_vm.questionData.text))]) : _vm._e(), _vm._v(" "), (_vm.questionData.type == 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.dataBag[_vm.questionData.questionKey]),
      expression: "dataBag[questionData.questionKey]",
      modifiers: {
        "trim": true
      }
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.maskFormat),
      expression: "maskFormat"
    }],
    key: _vm.fKey,
    ref: "textInput",
    staticClass: "form-control animated",
    class: _vm.getValidationClassName(),
    attrs: {
      "type": _vm.dataType,
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "title": _vm.questionData.text,
      "placeholder": _vm.placeholder,
      "required": _vm.isRequired,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "pattern": _vm.pattern,
      "min": _vm.minvalue,
      "max": _vm.maxvalue,
      "tabindex": _vm.questionData.tabIndex,
      "readonly": _vm.readonly,
      "aria-describedby": _vm.questionData.questionKey + '_Error'
    },
    domProps: {
      "value": (_vm.dataBag[_vm.questionData.questionKey])
    },
    on: {
      "blur": [function($event) {
        return _vm.blurHandler($event)
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "focus": _vm.focusHandler,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyHandler($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataBag, _vm.questionData.questionKey, $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.questionData.type == 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.dataBag[_vm.questionData.questionKey]),
      expression: "dataBag[questionData.questionKey]",
      modifiers: {
        "trim": true
      }
    }],
    ref: "textAreaInput",
    staticClass: "form-control animated",
    class: _vm.getValidationClassName(),
    attrs: {
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "title": _vm.questionData.text,
      "placeholder": _vm.placeholder,
      "required": _vm.isRequired,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "tabindex": _vm.questionData.tabIndex,
      "readonly": _vm.readonly,
      "aria-describedby": _vm.questionData.questionKey,
      "rows": _vm.rows,
      "cols": _vm.cols
    },
    domProps: {
      "value": (_vm.dataBag[_vm.questionData.questionKey])
    },
    on: {
      "blur": [function($event) {
        return _vm.blurHandler($event)
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "focus": _vm.focusHandler,
      "keypress": function($event) {
        return _vm.keyPressHandler($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataBag, _vm.questionData.questionKey, $event.target.value.trim())
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNotEmpty(_vm.questionData.helpText)) ? _c('small', {
    staticClass: "form-text text-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.questionData.helpText)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.readMode) ? _c('read-view', {
    attrs: {
      "questionData": _vm.questionData,
      "state": _vm.state,
      "dataBag": _vm.dataBag
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.requiredMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "minlength"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.minlengthMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "maxlength"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.maxlengthMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "pattern"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.patternMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "compare"
  }, [((_vm.fieldStateTouched || _vm.submitTried) && _vm.compareMessage) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.compareMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "min"
  }, [((_vm.fieldStateTouched || _vm.submitTried)) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.minvalueMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "max"
  }, [((_vm.fieldStateTouched || _vm.submitTried)) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.maxvalueMessage) + "\n            ")]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8ff87888", module.exports)
  }
}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calculator",
    class: {
      ' calculator-iframe': _vm.isIndependent
    }
  }, [(!_vm.isIndependent) ? _c('div', {
    staticClass: "action-box"
  }, [(_vm.needCoverageHelpText) ? _c('div', {
    staticClass: "help-text",
    domProps: {
      "innerHTML": _vm._s(_vm.needCoverageHelpText)
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "calculator-action btn btn-secondary center-block",
    attrs: {
      "type": "button",
      "title": _vm.calculatorLinkText
    },
    on: {
      "click": _vm.showCalculatorHandler
    }
  }, [_vm._v("\n            " + _vm._s(_vm.calculatorLinkText) + "\n        ")]), _vm._v(" "), (_vm.previousEstimatedCoverageFormatted) ? _c('span', {
    staticClass: "estimated"
  }, [_vm._v("\n            Previous estimated amount: " + _vm._s(_vm.previousEstimatedCoverageFormatted) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "mode": "out-in",
      "name": _vm.transition
    }
  }, [(_vm.show || _vm.isIndependent) ? _c('div', {
    staticClass: "calculator-body"
  }, [_c('div', {
    staticClass: "calculator-container"
  }, [(!_vm.isIndependent) ? _c('button', {
    staticClass: "form-close",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": _vm.closeHandler
    }
  }, [_vm._v("\n                    X\n                ")]) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.showingResult) ? _c('div', [_c('div', {
    staticClass: "cbd-form-title"
  }, [_vm._v("\n                            Coverage Calculator\n                        ")]), _vm._v(" "), _c('div', [_c('interactiveFormComponent', {
    attrs: {
      "questionGroupList": _vm.formGroups,
      "state": _vm.componentState,
      "dataBag": _vm.componentDataBag,
      "pageSchema": _vm.pageSchema,
      "groupInteractionCallback": _vm.groupInteractionCallback,
      "actionBus": _vm.actionBus,
      "settings": _vm.settings
    }
  }), _vm._v(" "), (_vm.submitError) ? _c('div', {
    staticClass: "errors validation-messages"
  }, [_vm._v("\n                                " + _vm._s(_vm.fomrSubmissionError) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "calc-btn-group"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "title": "Calculate coverage"
    },
    on: {
      "click": _vm.nextOrCalculateCoverageHandler
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.nextButtonText) + "\n                                ")]), _vm._v(" "), (!_vm.hideBack) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.prevHandler($event)
      }
    }
  }, [_vm._v("\n                                    Back\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.hideBack) ? _c('div', [_vm._v(" ")]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showingResult && !_vm.processing) ? _c('div', [_c('coverageRecommendationResultComponent', {
    attrs: {
      "result": _vm.recommendations,
      "showTerm": _vm.showTerm,
      "showHeader": false
    }
  }, [_c('div', {
    staticClass: "panel-heading coveragepage-QuoteInfo",
    attrs: {
      "role": "tab",
      "id": "Recommendation-heading"
    }
  }, [_c('div', {
    staticClass: "basis-2/3 ca-block"
  }, [_c('h4', [_vm._v("Your estimated coverage amount")]), _vm._v(" "), _c('div', {
    staticClass: "coverage-amt"
  }, [_vm._v(_vm._s(_vm.estimatedAmount))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Use this coverage"
    },
    on: {
      "click": _vm.selectCoverageHandler
    }
  }, [_vm._v("\n                                        Use this coverage\n                                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "basis-1/3 flex flex-col"
  }, [_c('button', {
    staticClass: "btn btn-secondary recalculate-btn",
    attrs: {
      "title": "Calculate coverage again"
    },
    on: {
      "click": _vm.recalculateHandler
    }
  }, [_vm._v("\n                                        Recalculate\n                                    ")]), _vm._v(" "), (!_vm.isIndependent) ? _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "title": "No, I will use my own"
    },
    on: {
      "click": _vm.closeHandler
    }
  }, [_vm._v("\n                                        No, I will use my own\n                                    ")]) : _vm._e()])])])], 1) : _vm._e()]), _vm._v(" "), _c('loading-view', {
    attrs: {
      "loading": _vm.processing,
      "message": 'Calculating your coverage requirement...'
    }
  })], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-939ef04a", module.exports)
  }
}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('validate', {
    staticClass: "form-group",
    class: _vm.getValidationClassName(),
    attrs: {
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "floating-label-control"
  }, [(_vm.isNotEmpty(_vm.questionData.text)) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_vm._v(_vm._s(_vm.questionData.text))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.value),
      expression: "value",
      modifiers: {
        "trim": true
      }
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.maskFormat),
      expression: "maskFormat"
    }],
    ref: "ssnInput",
    staticClass: "form-control animated",
    class: _vm.getValidationClassName(),
    attrs: {
      "type": "text",
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "title": _vm.questionData.text,
      "placeholder": _vm.placeholder,
      "required": _vm.isRequired,
      "minlength": _vm.minlength,
      "maxlength": _vm.maxlength,
      "pattern": _vm.pattern,
      "tabindex": _vm.questionData.tabIndex,
      "readonly": _vm.readonly,
      "aria-describedby": _vm.questionData.questionKey + '_Error'
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "blur": [function($event) {
        return _vm.blurHandler($event)
      }, function($event) {
        return _vm.$forceUpdate()
      }],
      "focus": _vm.focusHandler,
      "keypress": function($event) {
        return _vm.keypressHandler($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), (_vm.questionData.allowToggle) ? _c('span', {
    staticClass: "glyphicon ssn-toggle-icon",
    class: {
      'glyphicon-eye-open': _vm.ssnMasked, 'glyphicon-eye-close': !_vm.ssnMasked
    },
    attrs: {
      "title": _vm.buttonTitle,
      "aria-label": _vm.buttonTitle,
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.ssnMaskToggleHandler($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isNotEmpty(_vm.questionData.helpText)) ? _c('small', {
    staticClass: "form-text text-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.questionData.helpText)
    }
  }) : _vm._e()]), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.requiredMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "minlength"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.minlengthMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "maxlength"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.maxlengthMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "pattern"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.patternMessage) + "\n            ")]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d7566492", module.exports)
  }
}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "smart-form-app",
    staticStyle: {
      "width": "100% !important"
    },
    attrs: {
      "id": "appId"
    }
  }, [(_vm.calculator) ? _c('CalculatorPage', {
    attrs: {
      "formSchemaUrl": _vm.formSchemaUrl
    }
  }) : (_vm.interactive) ? _c('InteractiveForm', {
    attrs: {
      "formSchemaUrl": _vm.formSchemaUrl,
      "formConfigKey": _vm.formConfigKey,
      "extraData": _vm.extraData
    }
  }) : _c('SmartForm', {
    attrs: {
      "formSchemaUrl": _vm.formSchemaUrl,
      "formConfigKey": _vm.formConfigKey,
      "extraData": _vm.extraData
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dbaef410", module.exports)
  }
}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "online-quotes-results"
  }, [_c('div', {
    staticClass: "quote-block"
  }, [_c('div', {
    staticClass: "quote-premium"
  }, [_c('sup', [_vm._v("$")]), _vm._v(_vm._s(_vm.monthlyPremiumDollar)), _c('sup', [_vm._v(_vm._s(_vm.monthlyPremiumCents))])]), _vm._v(" "), _c('div', {
    staticClass: "frequency"
  }, [_vm._v("per month")]), _vm._v(" "), (!_vm.editing) ? _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "title": "Get Started Now",
      "id": "btnSubmit"
    },
    on: {
      "click": _vm.submitQuoteHandler
    }
  }, [_vm._v("\n                    Submit\n                ")])]), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button",
      "title": "Edit Your Quote",
      "id": "editquotebtn"
    },
    on: {
      "click": _vm.editQuoteHandler
    }
  }, [_vm._v("\n                    Edit Your Quote\n                ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "quote-editor"
  }, [_c('div', {
    staticClass: "modalEditQuote"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('formComponent', {
    attrs: {
      "questionGroups": _vm.quoteEditor.fields,
      "state": _vm.quoteEditor.formState,
      "dataBag": _vm.editorFormData,
      "config": _vm.quoteEditor.uiConfig,
      "onSubmit": _vm.updateQuoteHandler,
      "onCancel": _vm.cancelQuoteUpdateHandler
    }
  })], 1)])]), _vm._v(" "), (_vm.editError) ? _c('div', {
    staticClass: "editQuoteError"
  }, [_vm._m(1)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "quote-details"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "quote-sub-text"
  }, [_c('span', [_vm._v("Coverage:")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.quote.coverageAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "quote-sub-text"
  }, [_c('span', [_vm._v("Term Length:")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.quote.termLength) + " Years")])]), _vm._v(" "), _c('div', {
    staticClass: "quote-sub-text"
  }, [_c('span', [_vm._v("Rate Class:")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.quote.rateClass))])]), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row modalEditQuote-header"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n                        Edit Your Quote\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "editQuoteErrorImg"
  }, [_c('img', {
    staticClass: "lazyload",
    attrs: {
      "data-src": "/Content/images/error_edit_quote.jpg",
      "alt": "Error Edit Quote"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "editQuoteErrorTxt"
  }, [_c('b', [_vm._v("NOTE:")]), _vm._v("\n                            We were not able to retrieve a quote based on the values you entered above.  Please edit your entries and try again.\n                        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quote-sub-text"
  }, [_c('span', [_vm._v("Product:")]), _vm._v(" "), _c('strong', [_vm._v("Term Life Insurance")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3"
  }, [_c('img', {
    staticClass: "img-responsive lazyloaded",
    attrs: {
      "src": "/Content/images/cbd/BrandLogo.jpg",
      "alt": "Corebridge Logo",
      "data-src": "/Content/images/cbd/BrandLogo.jpg"
    }
  })])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f160186e", module.exports)
  }
}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "declined-policy-detail-component"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "col-sm-12 form-col"
  }, [(_vm.policies && _vm.policies.length > 0) ? _c('table', {
    staticClass: "table details-list-table table-condensed"
  }, [_c('tbody', _vm._l((_vm.policies), function(policy, index) {
    return _c('tr', [_c('td', [_c('table', {
      staticClass: "table"
    }, [_c('tr', [_c('td', {
      attrs: {
        "colspan": "6"
      }
    }, [_c('span', {
      staticClass: "details-list-title"
    }, [_vm._v("Existing Policy " + _vm._s(index + 1))])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_c('span', {
      staticClass: "details-list-name"
    }, [_vm._v("Company")]), _vm._v(" "), _c('span', {
      staticClass: "details-list-value"
    }, [_vm._v(_vm._s(policy.Company))])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_c('span', {
      staticClass: "details-list-name"
    }, [_vm._v("Product")]), _vm._v(" "), _c('span', {
      staticClass: "details-list-value"
    }, [_vm._v(_vm._s(policy.Product))])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_c('span', {
      staticClass: "details-list-name"
    }, [_vm._v("Amount")]), _vm._v(" "), _c('span', {
      staticClass: "details-list-value"
    }, [_vm._v(_vm._s(policy.Amount))])]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_c('span', {
      staticClass: "details-list-name"
    }, [_vm._v("Year")]), _vm._v(" "), _c('span', {
      staticClass: "details-list-value"
    }, [_vm._v(_vm._s(policy.Year))])]), _vm._v(" "), (_vm.dataKeyObject.showReplaceOption) ? _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_c('span', {
      staticClass: "details-list-name"
    }, [_vm._v("Plan to replace")]), _vm._v(" "), _c('span', {
      staticClass: "details-list-value"
    }, [_vm._v(_vm._s(policy.Replace))])]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_c('button', {
      staticClass: "remove-list-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deletePolicyDetail(policy)
        }
      }
    }, [_c('i', {
      staticClass: "glyphicon glyphicon glyphicon-remove"
    }), _vm._v(" Remove\n                                        ")])])])])])])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 form-col"
  }, [(_vm.showPolicyForm) ? _c('div', {
    staticClass: "clearfix"
  }, [((_vm.policies && _vm.policies.length == 0) && _vm.componentErrorCount == 0) ? _c('div', {
    staticClass: "validation-error-container"
  }, [_c('sub-form-validator', {
    attrs: {
      "state": _vm.state,
      "message": 'Please add at least one insurance policy detail.'
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.componentErrorCount > 0) ? _c('div', {
    staticClass: "validation-messages-sub-form"
  }, [_c('small', {}, [_vm._v("\n                        " + _vm._s(_vm.cancelCompleteFormMessage) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.isNotEmpty(_vm.dynamicData.existingPolicyNoteHtml)) ? _c('div', {
    staticClass: "note-message",
    domProps: {
      "innerHTML": _vm._s(_vm.dynamicData.existingPolicyNoteHtml)
    }
  }) : _vm._e(), _vm._v(" "), _c('vue-form', {
    attrs: {
      "state": _vm.componentState
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, _vm._l((_vm.formGroups), function(group) {
    return _c('group-view', {
      key: group.key,
      attrs: {
        "groupData": group,
        "state": _vm.componentState,
        "dataBag": _vm.componentDataBag
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix button-group custom-btn-group"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onSave($event)
      }
    }
  }, [_vm._v("\n                            Save\n                        ")]), _vm._v(" "), (_vm.policies.length > 0) ? _c('button', {
    staticClass: "btn btn-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onCancel($event)
      }
    }
  }, [_vm._v("\n                            Cancel\n                        ")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), (!_vm.showPolicyForm) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.policies.length == 0) ? _c('button', {
    staticClass: "btn btn-secondary add-question-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onAddPolicyDetail($event)
      }
    }
  }, [_vm._v("\n                        Add Policy\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.policies.length > 0) ? _c('button', {
    staticClass: "btn btn-secondary add-question-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.onAddPolicyDetail($event)
      }
    }
  }, [_vm._v("\n                        Add Another Policy\n                    ")]) : _vm._e()])]) : _vm._e()])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f67d0268", module.exports)
  }
}

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('validate', {
    staticClass: "form-group",
    class: _vm.getValidationClassName(),
    attrs: {
      "tag": "div",
      "custom": {
        date: _vm.validateDate,
        dateRange: _vm.validateDateRange,
        invalidMonthDays: _vm.validateInvalidMonthDays
      }
    }
  }, [_c('div', {
    staticClass: "floating-label-control",
    class: {
      'datepicker ': !_vm.questionData.disableCalender, 'read-mode': _vm.readMode, 'btn-trigger': _vm.buttonTrigger
    }
  }, [(_vm.isNotEmpty(_vm.questionData.text)) ? _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": _vm.questionData.questionKey
    }
  }, [_vm._v(_vm._s(_vm.questionData.text))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.dataBag[_vm.questionData.questionKey]),
      expression: "dataBag[questionData.questionKey]",
      modifiers: {
        "trim": true
      }
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.maskFormat),
      expression: "maskFormat"
    }],
    ref: "dateInput",
    staticClass: "form-control animated",
    class: _vm.getValidationClassName(),
    attrs: {
      "type": "tel",
      "id": _vm.questionData.questionKey,
      "name": _vm.questionData.questionKey,
      "title": _vm.questionData.text,
      "placeholder": _vm.placeholder,
      "required": _vm.isRequired,
      "pattern": _vm.pattern,
      "tabindex": _vm.questionData.tabIndex,
      "readonly": _vm.readonly,
      "aria-describedby": _vm.questionData.questionKey + '_Error'
    },
    domProps: {
      "value": (_vm.dataBag[_vm.questionData.questionKey])
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterKeyHandler($event)
      },
      "blur": [_vm.blurHandler, function($event) {
        return _vm.$forceUpdate()
      }],
      "focus": _vm.focusHandler,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dataBag, _vm.questionData.questionKey, $event.target.value.trim())
      }
    }
  }), _vm._v(" "), (_vm.isNotEmpty(_vm.questionData.helpText)) ? _c('small', {
    staticClass: "form-text text-muted",
    domProps: {
      "innerHTML": _vm._s(_vm.questionData.helpText)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.questionData.disableCalender && !_vm.buttonTrigger) ? _c('span', {
    staticClass: "datepicker-trigger"
  }) : _vm._e()]), _vm._v(" "), (_vm.isNotEmpty(_vm.questionData.helpText)) ? _c('div', {
    staticClass: "form-control-help-text"
  }, [(_vm.isNotEmpty(_vm.questionData.helpText)) ? _c('span', {
    staticClass: "help-bubble",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.questionData.helpText) + "\n        ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.readMode) ? _c('read-view', {
    attrs: {
      "questionData": _vm.questionData,
      "state": _vm.state,
      "dataBag": _vm.dataBag
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    staticClass: "validation-messages",
    attrs: {
      "tag": "div",
      "name": _vm.questionData.questionKey,
      "id": _vm.questionData.questionKey + '_Error'
    }
  }, [_c('template', {
    staticClass: "help-block",
    slot: "required"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.requiredMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "pattern"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.patternMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "date"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.dateMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "dateRange"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.dateRangeMessage) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('template', {
    staticClass: "help-block",
    slot: "invalidMonthDays"
  }, [(_vm.fieldStateTouched || _vm.submitTried) ? _c('div', [_vm._v("\n                " + _vm._s(_vm.invalidMonthDaysMessage) + "\n            ")]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f89c1a4a", module.exports)
  }
}

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if ("dev" !== 'production' && !condition) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (true) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "dev" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (true) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (true) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (true) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if ("dev" !== 'production' && !matchAs) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (true) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (true) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (true) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (true) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (true) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (true) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (true) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (true) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "dev" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (true) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "dev" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.VueSelect=t():e.VueSelect=t()}("undefined"!=typeof self?self:this,(function(){return(()=>{var e={646:e=>{e.exports=function(e){if(Array.isArray(e)){for(var t=0,n=new Array(e.length);t<e.length;t++)n[t]=e[t];return n}}},713:e=>{e.exports=function(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}},860:e=>{e.exports=function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}},206:e=>{e.exports=function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}},319:(e,t,n)=>{var o=n(646),i=n(860),s=n(206);e.exports=function(e){return o(e)||i(e)||s()}},8:e=>{function t(n){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?e.exports=t=function(e){return typeof e}:e.exports=t=function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},t(n)}e.exports=t}},t={};function n(o){var i=t[o];if(void 0!==i)return i.exports;var s=t[o]={exports:{}};return e[o](s,s.exports,n),s.exports}n.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return n.d(t,{a:t}),t},n.d=(e,t)=>{for(var o in t)n.o(t,o)&&!n.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:t[o]})},n.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),n.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var o={};return(()=>{"use strict";n.r(o),n.d(o,{VueSelect:()=>m,default:()=>O,mixins:()=>_});var e=n(319),t=n.n(e),i=n(8),s=n.n(i),r=n(713),a=n.n(r);const l={props:{autoscroll:{type:Boolean,default:!0}},watch:{typeAheadPointer:function(){this.autoscroll&&this.maybeAdjustScroll()},open:function(e){var t=this;this.autoscroll&&e&&this.$nextTick((function(){return t.maybeAdjustScroll()}))}},methods:{maybeAdjustScroll:function(){var e,t=(null===(e=this.$refs.dropdownMenu)||void 0===e?void 0:e.children[this.typeAheadPointer])||!1;if(t){var n=this.getDropdownViewport(),o=t.getBoundingClientRect(),i=o.top,s=o.bottom,r=o.height;if(i<n.top)return this.$refs.dropdownMenu.scrollTop=t.offsetTop;if(s>n.bottom)return this.$refs.dropdownMenu.scrollTop=t.offsetTop-(n.height-r)}},getDropdownViewport:function(){return this.$refs.dropdownMenu?this.$refs.dropdownMenu.getBoundingClientRect():{height:0,top:0,bottom:0}}}},c={data:function(){return{typeAheadPointer:-1}},watch:{filteredOptions:function(){for(var e=0;e<this.filteredOptions.length;e++)if(this.selectable(this.filteredOptions[e])){this.typeAheadPointer=e;break}},open:function(e){e&&this.typeAheadToLastSelected()},selectedValue:function(){this.open&&this.typeAheadToLastSelected()}},methods:{typeAheadUp:function(){for(var e=this.typeAheadPointer-1;e>=0;e--)if(this.selectable(this.filteredOptions[e])){this.typeAheadPointer=e;break}},typeAheadDown:function(){for(var e=this.typeAheadPointer+1;e<this.filteredOptions.length;e++)if(this.selectable(this.filteredOptions[e])){this.typeAheadPointer=e;break}},typeAheadSelect:function(){var e=this.filteredOptions[this.typeAheadPointer];e&&this.selectable(e)&&this.select(e)},typeAheadToLastSelected:function(){var e=0!==this.selectedValue.length?this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length-1]):-1;-1!==e&&(this.typeAheadPointer=e)}}},u={props:{loading:{type:Boolean,default:!1}},data:function(){return{mutableLoading:!1}},watch:{search:function(){this.$emit("search",this.search,this.toggleLoading)},loading:function(e){this.mutableLoading=e}},methods:{toggleLoading:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return this.mutableLoading=null==e?!this.mutableLoading:e}}};function p(e,t,n,o,i,s,r,a){var l,c="function"==typeof e?e.options:e;if(t&&(c.render=t,c.staticRenderFns=n,c._compiled=!0),o&&(c.functional=!0),s&&(c._scopeId="data-v-"+s),r?(l=function(e){(e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext)||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),i&&i.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(r)},c._ssrRegister=l):i&&(l=a?function(){i.call(this,(c.functional?this.parent:this).$root.$options.shadowRoot)}:i),l)if(c.functional){c._injectStyles=l;var u=c.render;c.render=function(e,t){return l.call(t),u(e,t)}}else{var p=c.beforeCreate;c.beforeCreate=p?[].concat(p,l):[l]}return{exports:e,options:c}}const h={Deselect:p({},(function(){var e=this.$createElement,t=this._self._c||e;return t("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"10",height:"10"}},[t("path",{attrs:{d:"M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"}})])}),[],!1,null,null,null).exports,OpenIndicator:p({},(function(){var e=this.$createElement,t=this._self._c||e;return t("svg",{attrs:{xmlns:"http://www.w3.org/2000/svg",width:"14",height:"10"}},[t("path",{attrs:{d:"M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"}})])}),[],!1,null,null,null).exports},d={inserted:function(e,t,n){var o=n.context;if(o.appendToBody){var i=o.$refs.toggle.getBoundingClientRect(),s=i.height,r=i.top,a=i.left,l=i.width,c=window.scrollX||window.pageXOffset,u=window.scrollY||window.pageYOffset;e.unbindPosition=o.calculatePosition(e,o,{width:l+"px",left:c+a+"px",top:u+r+s+"px"}),document.body.appendChild(e)}},unbind:function(e,t,n){n.context.appendToBody&&(e.unbindPosition&&"function"==typeof e.unbindPosition&&e.unbindPosition(),e.parentNode&&e.parentNode.removeChild(e))}};const f=function(e){var t={};return Object.keys(e).sort().forEach((function(n){t[n]=e[n]})),JSON.stringify(t)};var y=0;const g=function(){return++y};function b(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,o)}return n}function v(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?b(Object(n),!0).forEach((function(t){a()(e,t,n[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):b(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))}))}return e}const m=p({components:v({},h),directives:{appendToBody:d},mixins:[l,c,u],props:{value:{},components:{type:Object,default:function(){return{}}},options:{type:Array,default:function(){return[]}},disabled:{type:Boolean,default:!1},clearable:{type:Boolean,default:!0},deselectFromDropdown:{type:Boolean,default:!1},searchable:{type:Boolean,default:!0},multiple:{type:Boolean,default:!1},placeholder:{type:String,default:""},transition:{type:String,default:"vs__fade"},clearSearchOnSelect:{type:Boolean,default:!0},closeOnSelect:{type:Boolean,default:!0},label:{type:String,default:"label"},autocomplete:{type:String,default:"off"},reduce:{type:Function,default:function(e){return e}},selectable:{type:Function,default:function(e){return!0}},getOptionLabel:{type:Function,default:function(e){return"object"===s()(e)?e.hasOwnProperty(this.label)?e[this.label]:console.warn('[vue-select warn]: Label key "option.'.concat(this.label,'" does not')+" exist in options object ".concat(JSON.stringify(e),".\n")+"https://vue-select.org/api/props.html#getoptionlabel"):e}},getOptionKey:{type:Function,default:function(e){if("object"!==s()(e))return e;try{return e.hasOwnProperty("id")?e.id:f(e)}catch(t){return console.warn("[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey",e,t)}}},onTab:{type:Function,default:function(){this.selectOnTab&&!this.isComposing&&this.typeAheadSelect()}},taggable:{type:Boolean,default:!1},tabindex:{type:Number,default:null},pushTags:{type:Boolean,default:!1},filterable:{type:Boolean,default:!0},filterBy:{type:Function,default:function(e,t,n){return(t||"").toLocaleLowerCase().indexOf(n.toLocaleLowerCase())>-1}},filter:{type:Function,default:function(e,t){var n=this;return e.filter((function(e){var o=n.getOptionLabel(e);return"number"==typeof o&&(o=o.toString()),n.filterBy(e,o,t)}))}},createOption:{type:Function,default:function(e){return"object"===s()(this.optionList[0])?a()({},this.label,e):e}},resetOnOptionsChange:{default:!1,validator:function(e){return["function","boolean"].includes(s()(e))}},clearSearchOnBlur:{type:Function,default:function(e){var t=e.clearSearchOnSelect,n=e.multiple;return t&&!n}},noDrop:{type:Boolean,default:!1},inputId:{type:String},dir:{type:String,default:"auto"},selectOnTab:{type:Boolean,default:!1},selectOnKeyCodes:{type:Array,default:function(){return[13]}},searchInputQuerySelector:{type:String,default:"[type=search]"},mapKeydown:{type:Function,default:function(e,t){return e}},appendToBody:{type:Boolean,default:!1},calculatePosition:{type:Function,default:function(e,t,n){var o=n.width,i=n.top,s=n.left;e.style.top=i,e.style.left=s,e.style.width=o}},dropdownShouldOpen:{type:Function,default:function(e){var t=e.noDrop,n=e.open,o=e.mutableLoading;return!t&&(n&&!o)}},uid:{type:[String,Number],default:function(){return g()}}},data:function(){return{search:"",open:!1,isComposing:!1,pushedTags:[],_value:[]}},computed:{isTrackingValues:function(){return void 0===this.value||this.$options.propsData.hasOwnProperty("reduce")},selectedValue:function(){var e=this.value;return this.isTrackingValues&&(e=this.$data._value),null!=e&&""!==e?[].concat(e):[]},optionList:function(){return this.options.concat(this.pushTags?this.pushedTags:[])},searchEl:function(){return this.$scopedSlots.search?this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector):this.$refs.search},scope:function(){var e=this,t={search:this.search,loading:this.loading,searching:this.searching,filteredOptions:this.filteredOptions};return{search:{attributes:v({disabled:this.disabled,placeholder:this.searchPlaceholder,tabindex:this.tabindex,readonly:!this.searchable,id:this.inputId,"aria-autocomplete":"list","aria-labelledby":"vs".concat(this.uid,"__combobox"),"aria-controls":"vs".concat(this.uid,"__listbox"),ref:"search",type:"search",autocomplete:this.autocomplete,value:this.search},this.dropdownOpen&&this.filteredOptions[this.typeAheadPointer]?{"aria-activedescendant":"vs".concat(this.uid,"__option-").concat(this.typeAheadPointer)}:{}),events:{compositionstart:function(){return e.isComposing=!0},compositionend:function(){return e.isComposing=!1},keydown:this.onSearchKeyDown,keypress:this.onSearchKeyPress,blur:this.onSearchBlur,focus:this.onSearchFocus,input:function(t){return e.search=t.target.value}}},spinner:{loading:this.mutableLoading},noOptions:{search:this.search,loading:this.mutableLoading,searching:this.searching},openIndicator:{attributes:{ref:"openIndicator",role:"presentation",class:"vs__open-indicator"}},listHeader:t,listFooter:t,header:v({},t,{deselect:this.deselect}),footer:v({},t,{deselect:this.deselect})}},childComponents:function(){return v({},h,{},this.components)},stateClasses:function(){return{"vs--open":this.dropdownOpen,"vs--single":!this.multiple,"vs--multiple":this.multiple,"vs--searching":this.searching&&!this.noDrop,"vs--searchable":this.searchable&&!this.noDrop,"vs--unsearchable":!this.searchable,"vs--loading":this.mutableLoading,"vs--disabled":this.disabled}},searching:function(){return!!this.search},dropdownOpen:function(){return this.dropdownShouldOpen(this)},searchPlaceholder:function(){return this.isValueEmpty&&this.placeholder?this.placeholder:void 0},filteredOptions:function(){var e=[].concat(this.optionList);if(!this.filterable&&!this.taggable)return e;var t=this.search.length?this.filter(e,this.search,this):e;if(this.taggable&&this.search.length){var n=this.createOption(this.search);this.optionExists(n)||t.unshift(n)}return t},isValueEmpty:function(){return 0===this.selectedValue.length},showClearButton:function(){return!this.multiple&&this.clearable&&!this.open&&!this.isValueEmpty}},watch:{options:function(e,t){var n=this;!this.taggable&&("function"==typeof n.resetOnOptionsChange?n.resetOnOptionsChange(e,t,n.selectedValue):n.resetOnOptionsChange)&&this.clearSelection(),this.value&&this.isTrackingValues&&this.setInternalValueFromOptions(this.value)},value:{immediate:!0,handler:function(e){this.isTrackingValues&&this.setInternalValueFromOptions(e)}},multiple:function(){this.clearSelection()},open:function(e){this.$emit(e?"open":"close")},search:function(e){e.length&&(this.open=!0)}},created:function(){this.mutableLoading=this.loading,this.$on("option:created",this.pushTag)},methods:{setInternalValueFromOptions:function(e){var t=this;Array.isArray(e)?this.$data._value=e.map((function(e){return t.findOptionFromReducedValue(e)})):this.$data._value=this.findOptionFromReducedValue(e)},select:function(e){this.$emit("option:selecting",e),this.isOptionSelected(e)?this.deselectFromDropdown&&(this.clearable||this.multiple&&this.selectedValue.length>1)&&this.deselect(e):(this.taggable&&!this.optionExists(e)&&this.$emit("option:created",e),this.multiple&&(e=this.selectedValue.concat(e)),this.updateValue(e),this.$emit("option:selected",e)),this.onAfterSelect(e)},deselect:function(e){var t=this;this.$emit("option:deselecting",e),this.updateValue(this.selectedValue.filter((function(n){return!t.optionComparator(n,e)}))),this.$emit("option:deselected",e)},clearSelection:function(){this.updateValue(this.multiple?[]:null)},onAfterSelect:function(e){var t=this;this.closeOnSelect&&(this.open=!this.open),this.clearSearchOnSelect&&(this.search=""),this.noDrop&&this.multiple&&this.$nextTick((function(){return t.$refs.search.focus()}))},updateValue:function(e){var t=this;void 0===this.value&&(this.$data._value=e),null!==e&&(e=Array.isArray(e)?e.map((function(e){return t.reduce(e)})):this.reduce(e)),this.$emit("input",e)},toggleDropdown:function(e){var n=e.target!==this.searchEl;n&&e.preventDefault();var o=[].concat(t()(this.$refs.deselectButtons||[]),t()([this.$refs.clearButton]||0));void 0===this.searchEl||o.filter(Boolean).some((function(t){return t.contains(e.target)||t===e.target}))?e.preventDefault():this.open&&n?this.searchEl.blur():this.disabled||(this.open=!0,this.searchEl.focus())},isOptionSelected:function(e){var t=this;return this.selectedValue.some((function(n){return t.optionComparator(n,e)}))},isOptionDeselectable:function(e){return this.isOptionSelected(e)&&this.deselectFromDropdown},optionComparator:function(e,t){return this.getOptionKey(e)===this.getOptionKey(t)},findOptionFromReducedValue:function(e){var n=this,o=[].concat(t()(this.options),t()(this.pushedTags)).filter((function(t){return JSON.stringify(n.reduce(t))===JSON.stringify(e)}));return 1===o.length?o[0]:o.find((function(e){return n.optionComparator(e,n.$data._value)}))||e},closeSearchOptions:function(){this.open=!1,this.$emit("search:blur")},maybeDeleteValue:function(){if(!this.searchEl.value.length&&this.selectedValue&&this.selectedValue.length&&this.clearable){var e=null;this.multiple&&(e=t()(this.selectedValue.slice(0,this.selectedValue.length-1))),this.updateValue(e)}},optionExists:function(e){var t=this;return this.optionList.some((function(n){return t.optionComparator(n,e)}))},normalizeOptionForSlot:function(e){return"object"===s()(e)?e:a()({},this.label,e)},pushTag:function(e){this.pushedTags.push(e)},onEscape:function(){this.search.length?this.search="":this.open=!1},onSearchBlur:function(){if(!this.mousedown||this.searching){var e=this.clearSearchOnSelect,t=this.multiple;return this.clearSearchOnBlur({clearSearchOnSelect:e,multiple:t})&&(this.search=""),void this.closeSearchOptions()}this.mousedown=!1,0!==this.search.length||0!==this.options.length||this.closeSearchOptions()},onSearchFocus:function(){this.open=!0,this.$emit("search:focus")},onMousedown:function(){this.mousedown=!0},onMouseUp:function(){this.mousedown=!1},onSearchKeyDown:function(e){var t=this,n=function(e){return e.preventDefault(),!t.isComposing&&t.typeAheadSelect()},o={8:function(e){return t.maybeDeleteValue()},9:function(e){return t.onTab()},27:function(e){return t.onEscape()},38:function(e){if(e.preventDefault(),t.open)return t.typeAheadUp();t.open=!0},40:function(e){if(e.preventDefault(),t.open)return t.typeAheadDown();t.open=!0}};this.selectOnKeyCodes.forEach((function(e){return o[e]=n}));var i=this.mapKeydown(o,this);if("function"==typeof i[e.keyCode])return i[e.keyCode](e)},onSearchKeyPress:function(e){this.open||32!==e.keyCode||(e.preventDefault(),this.open=!0)}}},(function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("div",{staticClass:"v-select",class:e.stateClasses,attrs:{dir:e.dir}},[e._t("header",null,null,e.scope.header),e._v(" "),n("div",{ref:"toggle",staticClass:"vs__dropdown-toggle",attrs:{id:"vs"+e.uid+"__combobox",role:"combobox","aria-expanded":e.dropdownOpen.toString(),"aria-owns":"vs"+e.uid+"__listbox","aria-label":"Search for option"},on:{mousedown:function(t){return e.toggleDropdown(t)}}},[n("div",{ref:"selectedOptions",staticClass:"vs__selected-options"},[e._l(e.selectedValue,(function(t){return e._t("selected-option-container",[n("span",{key:e.getOptionKey(t),staticClass:"vs__selected"},[e._t("selected-option",[e._v("\n            "+e._s(e.getOptionLabel(t))+"\n          ")],null,e.normalizeOptionForSlot(t)),e._v(" "),e.multiple?n("button",{ref:"deselectButtons",refInFor:!0,staticClass:"vs__deselect",attrs:{disabled:e.disabled,type:"button",title:"Deselect "+e.getOptionLabel(t),"aria-label":"Deselect "+e.getOptionLabel(t)},on:{click:function(n){return e.deselect(t)}}},[n(e.childComponents.Deselect,{tag:"component"})],1):e._e()],2)],{option:e.normalizeOptionForSlot(t),deselect:e.deselect,multiple:e.multiple,disabled:e.disabled})})),e._v(" "),e._t("search",[n("input",e._g(e._b({staticClass:"vs__search"},"input",e.scope.search.attributes,!1),e.scope.search.events))],null,e.scope.search)],2),e._v(" "),n("div",{ref:"actions",staticClass:"vs__actions"},[n("button",{directives:[{name:"show",rawName:"v-show",value:e.showClearButton,expression:"showClearButton"}],ref:"clearButton",staticClass:"vs__clear",attrs:{disabled:e.disabled,type:"button",title:"Clear Selected","aria-label":"Clear Selected"},on:{click:e.clearSelection}},[n(e.childComponents.Deselect,{tag:"component"})],1),e._v(" "),e._t("open-indicator",[e.noDrop?e._e():n(e.childComponents.OpenIndicator,e._b({tag:"component"},"component",e.scope.openIndicator.attributes,!1))],null,e.scope.openIndicator),e._v(" "),e._t("spinner",[n("div",{directives:[{name:"show",rawName:"v-show",value:e.mutableLoading,expression:"mutableLoading"}],staticClass:"vs__spinner"},[e._v("Loading...")])],null,e.scope.spinner)],2)]),e._v(" "),n("transition",{attrs:{name:e.transition}},[e.dropdownOpen?n("ul",{directives:[{name:"append-to-body",rawName:"v-append-to-body"}],key:"vs"+e.uid+"__listbox",ref:"dropdownMenu",staticClass:"vs__dropdown-menu",attrs:{id:"vs"+e.uid+"__listbox",role:"listbox",tabindex:"-1"},on:{mousedown:function(t){return t.preventDefault(),e.onMousedown(t)},mouseup:e.onMouseUp}},[e._t("list-header",null,null,e.scope.listHeader),e._v(" "),e._l(e.filteredOptions,(function(t,o){return n("li",{key:e.getOptionKey(t),staticClass:"vs__dropdown-option",class:{"vs__dropdown-option--deselect":e.isOptionDeselectable(t)&&o===e.typeAheadPointer,"vs__dropdown-option--selected":e.isOptionSelected(t),"vs__dropdown-option--highlight":o===e.typeAheadPointer,"vs__dropdown-option--disabled":!e.selectable(t)},attrs:{id:"vs"+e.uid+"__option-"+o,role:"option","aria-selected":o===e.typeAheadPointer||null},on:{mouseover:function(n){e.selectable(t)&&(e.typeAheadPointer=o)},click:function(n){n.preventDefault(),n.stopPropagation(),e.selectable(t)&&e.select(t)}}},[e._t("option",[e._v("\n          "+e._s(e.getOptionLabel(t))+"\n        ")],null,e.normalizeOptionForSlot(t))],2)})),e._v(" "),0===e.filteredOptions.length?n("li",{staticClass:"vs__no-options"},[e._t("no-options",[e._v("\n          Sorry, no matching options.\n        ")],null,e.scope.noOptions)],2):e._e(),e._v(" "),e._t("list-footer",null,null,e.scope.listFooter)],2):n("ul",{staticStyle:{display:"none",visibility:"hidden"},attrs:{id:"vs"+e.uid+"__listbox",role:"listbox"}})]),e._v(" "),e._t("footer",null,null,e.scope.footer)],2)}),[],!1,null,null,null).exports,_={ajax:u,pointer:c,pointerScroll:l},O=m})(),o})()}));
//# sourceMappingURL=vue-select.js.map

/***/ })
/******/ ]);